var Yp = Object.defineProperty;
var Xp = (e, t, r) => t in e ? Yp(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var $ = (e, t, r) => Xp(e, typeof t != "symbol" ? t + "" : t, r);
import Ps, { ref as nn, computed as Qt, unref as Jp, getCurrentScope as Kp, onScopeDispose as Qp, watchEffect as Zp, getCurrentInstance as eh, onMounted as th } from "vue";
import rh, { isAxiosError as nh } from "axios";
function tw(e = 0) {
  const t = nn(Math.max(0, e)), r = nn(null), n = nn(null), a = () => {
    r.value !== null && (clearInterval(r.value), r.value = null, n.value = null);
  }, u = (o = t.value) => {
    r.value || (t.value = Math.max(0, o), n.value = Date.now() + t.value * 1e3, r.value = window.setInterval(() => {
      t.value = Math.max(0, Math.round((n.value - Date.now()) / 1e3)), t.value === 0 && a();
    }, 100));
  }, i = () => {
    a(), t.value = Math.max(0, e);
  }, s = Qt(() => r.value !== null);
  return {
    timeLeft: t,
    startTimer: u,
    stopTimer: a,
    resetTimer: i,
    isRunning: s
  };
}
var qe = /* @__PURE__ */ ((e) => (e.Mobile = "mobile", e.Tablet = "tablet", e.Desktop = "desktop", e))(qe || {});
Ps.util.warn;
function ah(e) {
  return Kp() ? (Qp(e), !0) : !1;
}
function Vi(e) {
  return typeof e == "function" ? e() : Jp(e);
}
const uh = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
function ih(e, t) {
  var r;
  if (typeof e == "number")
    return e + t;
  const n = ((r = e.match(/^-?\d+\.?\d*/)) == null ? void 0 : r[0]) || "", a = e.slice(n.length), u = Number.parseFloat(n) + t;
  return Number.isNaN(u) ? e : u + a;
}
Ps.util.warn;
const z0 = uh ? window : void 0;
function sh() {
  const e = nn(!1);
  return eh() && th(() => {
    e.value = !0;
  }, void 0), e;
}
function oh(e) {
  const t = sh();
  return Qt(() => (t.value, !!e()));
}
function Kr(e, t = {}) {
  const { window: r = z0 } = t, n = oh(() => r && "matchMedia" in r && typeof r.matchMedia == "function");
  let a;
  const u = nn(!1), i = (c) => {
    u.value = c.matches;
  }, s = () => {
    a && ("removeEventListener" in a ? a.removeEventListener("change", i) : a.removeListener(i));
  }, o = Zp(() => {
    n.value && (s(), a = r.matchMedia(Vi(e)), "addEventListener" in a ? a.addEventListener("change", i) : a.addListener(i), u.value = a.matches);
  });
  return ah(() => {
    o(), s(), a = void 0;
  }), u;
}
function ch(e, t = {}) {
  function r(f, g) {
    let p = Vi(e[Vi(f)]);
    return g != null && (p = ih(p, g)), typeof p == "number" && (p = `${p}px`), p;
  }
  const { window: n = z0, strategy: a = "min-width" } = t;
  function u(f) {
    return n ? n.matchMedia(f).matches : !1;
  }
  const i = (f) => Kr(() => `(min-width: ${r(f)})`, t), s = (f) => Kr(() => `(max-width: ${r(f)})`, t), o = Object.keys(e).reduce((f, g) => (Object.defineProperty(f, g, {
    get: () => a === "min-width" ? i(g) : s(g),
    enumerable: !0,
    configurable: !0
  }), f), {});
  function c() {
    const f = Object.keys(e).map((g) => [g, i(g)]);
    return Qt(() => f.filter(([, g]) => g.value).map(([g]) => g));
  }
  return Object.assign(o, {
    greaterOrEqual: i,
    smallerOrEqual: s,
    greater(f) {
      return Kr(() => `(min-width: ${r(f, 0.1)})`, t);
    },
    smaller(f) {
      return Kr(() => `(max-width: ${r(f, -0.1)})`, t);
    },
    between(f, g) {
      return Kr(() => `(min-width: ${r(f)}) and (max-width: ${r(g, -0.1)})`, t);
    },
    isGreater(f) {
      return u(`(min-width: ${r(f, 0.1)})`);
    },
    isGreaterOrEqual(f) {
      return u(`(min-width: ${r(f)})`);
    },
    isSmaller(f) {
      return u(`(max-width: ${r(f, -0.1)})`);
    },
    isSmallerOrEqual(f) {
      return u(`(max-width: ${r(f)})`);
    },
    isInBetween(f, g) {
      return u(`(min-width: ${r(f)}) and (max-width: ${r(g, -0.1)})`);
    },
    current: c,
    active() {
      const f = c();
      return Qt(() => f.value.length === 0 ? "" : f.value.at(-1));
    }
  });
}
const vu = {
  [qe.Desktop]: 1280,
  [qe.Tablet]: 780,
  [qe.Mobile]: 0
}, rw = () => {
  const e = ch({
    [qe.Mobile]: vu[qe.Mobile],
    [qe.Tablet]: vu[qe.Tablet],
    [qe.Desktop]: vu[qe.Desktop]
  }), t = () => e.active(), r = (g) => t().value === g, n = (g) => e.smaller(g), a = (g) => e.smallerOrEqual(g), u = (g, p) => e.between(g, p), i = (g) => e.greater(g), s = (g) => e.greaterOrEqual(g), o = Qt(() => r(qe.Mobile)), c = Qt(() => r(qe.Tablet)), f = Qt(() => r(qe.Desktop));
  return {
    getCurrent: t,
    isActive: r,
    isSmaller: n,
    isSmallerOrEqual: a,
    isInBetween: u,
    isGreater: i,
    isGreaterOrEqual: s,
    isMobile: o,
    isTablet: c,
    isDesktop: f
  };
}, Yi = " ";
class La extends Error {
  constructor(t) {
    super(t), Error.captureStackTrace && Error.captureStackTrace(this, new.target);
  }
}
class jn extends La {
  constructor(r = "Request was aborted") {
    super(r);
    $(this, "name", "AbortError");
  }
}
class Ao extends La {
  constructor(r, { status: n, data: a, config: u = {} } = {}) {
    super(r);
    $(this, "name", "NetworkError");
    $(this, "status");
    $(this, "data");
    $(this, "config");
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.status = n, this.data = a, this.config = u;
  }
}
class dh extends La {
  constructor(r = "Request timed out") {
    super(r);
    $(this, "name", "TimeoutError");
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
  }
}
class nw extends La {
  constructor(r, n, a = {}) {
    super(n);
    $(this, "name", "VueRenderError");
    $(this, "componentName");
    $(this, "propsData");
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.componentName = r, this.propsData = a;
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      component: this.componentName,
      props: this.propsData,
      stack: this.stack
    };
  }
}
function fh(e) {
  var n, a, u, i;
  const t = e instanceof Error ? e.stack : void 0;
  if (e instanceof jn)
    return e;
  if (e instanceof DOMException && e.name === jn.prototype.name) {
    const s = new jn(e.message);
    return s.stack = t, s;
  }
  if (nh(e) || e != null && e.isAxiosError) {
    const s = e.code === "ECONNABORTED";
    if (e.code === "ERR_CANCELED" || ((a = (n = e.message) == null ? void 0 : n.toLowerCase()) == null ? void 0 : a.includes("canceled"))) {
      const f = new jn(e.message || "Request was cancelled");
      return f.stack = t, f;
    }
    if (s) {
      const f = new dh(e.message || "Request timed out");
      return f.stack = t, f;
    }
    const c = new Ao(e.message || "An error occurred", {
      status: (u = e.response) == null ? void 0 : u.status,
      data: (i = e.response) == null ? void 0 : i.data,
      config: e.config
    });
    return c.stack = t, c;
  }
  const r = new Ao("Unknown network error occurred");
  return r.stack = t, r;
}
class aw {
  constructor(t) {
    $(this, "axiosInstance");
    $(this, "requestCallbacks", []);
    $(this, "requestInterceptors", /* @__PURE__ */ new Map());
    $(this, "responseInterceptors", /* @__PURE__ */ new Map());
    this.axiosInstance = rh.create({
      baseURL: t,
      withCredentials: !0,
      timeout: 1e4
    });
  }
  async request({
    method: t,
    url: r,
    data: n,
    config: a = {}
  }) {
    const u = new Error(`API request: ${t.toUpperCase()} ${r}`).stack;
    try {
      return this.requestCallbacks.forEach((s) => s({ method: t, url: r, data: n, config: a })), (await this.axiosInstance.request({
        method: t,
        url: r,
        data: n,
        ...a
      })).data;
    } catch (i) {
      throw i instanceof Error && (i.stack = u), fh(i);
    }
  }
  async get(t, r) {
    return this.request({ method: "get", url: t, config: r });
  }
  async post(t, r, n) {
    return this.request({ method: "post", url: t, data: r, config: n });
  }
  async put(t, r, n) {
    return this.request({ method: "put", url: t, data: r, config: n });
  }
  async delete(t, r, n) {
    return this.request({ method: "delete", url: t, data: r, config: n });
  }
  async patch(t, r, n) {
    return this.request({ method: "patch", url: t, data: r, config: n });
  }
  async head(t, r) {
    return this.request({ method: "head", url: t, config: r });
  }
  async options(t, r) {
    return this.request({ method: "options", url: t, config: r });
  }
  setHeader(t, r) {
    this.axiosInstance.defaults.headers.common[t] = r;
  }
  removeHeader(t) {
    delete this.axiosInstance.defaults.headers.common[t];
  }
  addRequestCallback(t) {
    return this.requestCallbacks.push(t), this.requestCallbacks.length - 1;
  }
  removeRequestCallback(t) {
    this.requestCallbacks.splice(t, 1);
  }
  addRequestInterceptor(t, r) {
    const n = this.axiosInstance.interceptors.request.use(t, r);
    return this.requestInterceptors.set(n, n), n;
  }
  removeRequestInterceptor(t) {
    this.axiosInstance.interceptors.request.eject(t), this.requestInterceptors.delete(t);
  }
  addResponseInterceptor(t, r) {
    const n = this.axiosInstance.interceptors.response.use(t, r);
    return this.responseInterceptors.set(n, n), n;
  }
  removeResponseInterceptor(t) {
    this.axiosInstance.interceptors.response.eject(t), this.responseInterceptors.delete(t);
  }
}
class dn extends Error {
  constructor(r, { serviceName: n, providerName: a, eventData: u, cause: i } = {}) {
    super(r, { cause: i });
    $(this, "serviceName");
    $(this, "providerName");
    $(this, "eventData");
    $(this, "cause");
    this.name = "AnalyticsError", this.serviceName = n, this.providerName = a, this.eventData = u, this.cause = i, i instanceof Error && (this.stack = i.stack), Object.setPrototypeOf(this, new.target.prototype);
  }
}
var Ue = /* @__PURE__ */ ((e) => (e.ADRIVER = "adriver", e.TRACKER = "tracker", e.ERROR_LOGGER = "errorLogger", e.VK = "vk", e))(Ue || {});
class Fa {
  constructor() {
    $(this, "isStartedInit", !1);
    $(this, "queue", []);
    $(this, "isInitialized", !1);
    $(this, "initTimeoutId", null);
    $(this, "startedAt", null);
    $(this, "timeoutMS", Wd);
  }
  createQueue() {
    return [];
  }
  baseInit(t) {
    this.isStartedInit = !0, !this.isInitialized && (this.timeoutMS = t ?? Wd, this.queue = this.createQueue(), this.startedAt = Date.now(), this.install(), this.waitForInitialization());
  }
  waitForInitialization() {
    if (this.initTimeoutId && clearTimeout(this.initTimeoutId), this.isInstalled()) {
      this.isInitialized = !0, this.flushQueue(), this.clearQueue();
      return;
    }
    this.isTooLongInit || (this.initTimeoutId = setTimeout(this.waitForInitialization.bind(this), E3));
  }
  flushQueue() {
    this.isInitialized && this.queue.forEach((t) => t == null ? void 0 : t());
  }
  clearQueue() {
    this.queue = this.createQueue();
  }
  get isTooLongInit() {
    return !!this.startedAt && Date.now() - this.startedAt >= this.timeoutMS;
  }
  enqueueOrExecute(t) {
    this.isInitialized ? t() : this.queue.push(t);
  }
}
const V0 = 6048e5, lh = 864e5, $a = 6e4, Bs = 36e5, Oo = Symbol.for("constructDateFrom");
function Se(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Oo in e ? e[Oo](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function H(e, t) {
  return Se(t || e, e);
}
function Or(e, t, r) {
  const n = H(e, r == null ? void 0 : r.in);
  return isNaN(t) ? Se(e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function Ua(e, t, r) {
  const n = H(e, r == null ? void 0 : r.in);
  if (isNaN(t)) return Se(e, NaN);
  if (!t)
    return n;
  const a = n.getDate(), u = Se(e, n.getTime());
  u.setMonth(n.getMonth() + t + 1, 0);
  const i = u.getDate();
  return a >= i ? u : (n.setFullYear(
    u.getFullYear(),
    u.getMonth(),
    a
  ), n);
}
function _r(e, t, r) {
  const {
    years: n = 0,
    months: a = 0,
    weeks: u = 0,
    days: i = 0,
    hours: s = 0,
    minutes: o = 0,
    seconds: c = 0
  } = t, f = H(e, r == null ? void 0 : r.in), g = a || n ? Ua(f, a + n * 12) : f, p = i || u ? Or(g, i + u * 7) : g, h = o + s * 60, S = (c + h * 60) * 1e3;
  return Se(e, +p + S);
}
let ph = {};
function Sn() {
  return ph;
}
function nr(e, t) {
  var s, o, c, f;
  const r = Sn(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((o = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : o.weekStartsOn) ?? r.weekStartsOn ?? ((f = (c = r.locale) == null ? void 0 : c.options) == null ? void 0 : f.weekStartsOn) ?? 0, a = H(e, t == null ? void 0 : t.in), u = a.getDay(), i = (u < n ? 7 : 0) + u - n;
  return a.setDate(a.getDate() - i), a.setHours(0, 0, 0, 0), a;
}
function ma(e, t) {
  return nr(e, { ...t, weekStartsOn: 1 });
}
function Y0(e, t) {
  const r = H(e, t == null ? void 0 : t.in), n = r.getFullYear(), a = Se(r, 0);
  a.setFullYear(n + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const u = ma(a), i = Se(r, 0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  const s = ma(i);
  return r.getTime() >= u.getTime() ? n + 1 : r.getTime() >= s.getTime() ? n : n - 1;
}
function Io(e) {
  const t = H(e), r = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return r.setUTCFullYear(t.getFullYear()), +e - +r;
}
function et(e, ...t) {
  const r = Se.bind(
    null,
    e || t.find((n) => typeof n == "object")
  );
  return t.map(r);
}
function fn(e, t) {
  const r = H(e, t == null ? void 0 : t.in);
  return r.setHours(0, 0, 0, 0), r;
}
function X0(e, t, r) {
  const [n, a] = et(
    r == null ? void 0 : r.in,
    e,
    t
  ), u = fn(n), i = fn(a), s = +u - Io(u), o = +i - Io(i);
  return Math.round((s - o) / lh);
}
function hh(e, t) {
  const r = Y0(e, t), n = Se(e, 0);
  return n.setFullYear(r, 0, 4), n.setHours(0, 0, 0, 0), ma(n);
}
function mh(e, t, r) {
  const n = H(e, r == null ? void 0 : r.in);
  return n.setTime(n.getTime() + t * $a), n;
}
function gh(e, t, r) {
  return Ua(e, t * 12, r);
}
function an(e, t) {
  const r = +H(e) - +H(t);
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function yh(e, t, r) {
  const [n, a] = et(
    r == null ? void 0 : r.in,
    e,
    t
  );
  return +fn(n) == +fn(a);
}
function vh(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Er(e) {
  return !(!vh(e) && typeof e != "number" || isNaN(+H(e)));
}
function bh(e, t, r) {
  const [n, a] = et(
    r == null ? void 0 : r.in,
    e,
    t
  ), u = n.getFullYear() - a.getFullYear(), i = n.getMonth() - a.getMonth();
  return u * 12 + i;
}
function _h(e, t, r) {
  const [n, a] = et(
    r == null ? void 0 : r.in,
    e,
    t
  );
  return n.getFullYear() - a.getFullYear();
}
function J0(e, t, r) {
  const [n, a] = et(
    r == null ? void 0 : r.in,
    e,
    t
  ), u = Po(n, a), i = Math.abs(
    X0(n, a)
  );
  n.setDate(n.getDate() - u * i);
  const s = +(Po(n, a) === -u), o = u * (i - s);
  return o === 0 ? 0 : o;
}
function Po(e, t) {
  const r = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function Ns(e) {
  return (t) => {
    const n = (e ? Math[e] : Math.trunc)(t);
    return n === 0 ? 0 : n;
  };
}
function K0(e, t, r) {
  const [n, a] = et(
    r == null ? void 0 : r.in,
    e,
    t
  ), u = (+n - +a) / Bs;
  return Ns(r == null ? void 0 : r.roundingMethod)(u);
}
function Ds(e, t) {
  return +H(e) - +H(t);
}
function Q0(e, t, r) {
  const n = Ds(e, t) / $a;
  return Ns(r == null ? void 0 : r.roundingMethod)(n);
}
function Z0(e, t) {
  const r = H(e, t == null ? void 0 : t.in);
  return r.setHours(23, 59, 59, 999), r;
}
function el(e, t) {
  const r = H(e, t == null ? void 0 : t.in), n = r.getMonth();
  return r.setFullYear(r.getFullYear(), n + 1, 0), r.setHours(23, 59, 59, 999), r;
}
function Sh(e, t) {
  const r = H(e, t == null ? void 0 : t.in);
  return +Z0(r, t) == +el(r, t);
}
function tl(e, t, r) {
  const [n, a, u] = et(
    r == null ? void 0 : r.in,
    e,
    e,
    t
  ), i = an(a, u), s = Math.abs(
    bh(a, u)
  );
  if (s < 1) return 0;
  a.getMonth() === 1 && a.getDate() > 27 && a.setDate(30), a.setMonth(a.getMonth() - i * s);
  let o = an(a, u) === -i;
  Sh(n) && s === 1 && an(n, u) === 1 && (o = !1);
  const c = i * (s - +o);
  return c === 0 ? 0 : c;
}
function rl(e, t, r) {
  const n = Ds(e, t) / 1e3;
  return Ns(r == null ? void 0 : r.roundingMethod)(n);
}
function nl(e, t, r) {
  const [n, a] = et(
    r == null ? void 0 : r.in,
    e,
    t
  ), u = an(n, a), i = Math.abs(_h(n, a));
  n.setFullYear(1584), a.setFullYear(1584);
  const s = an(n, a) === -u, o = u * (i - +s);
  return o === 0 ? 0 : o;
}
function al(e, t) {
  const [r, n] = et(e, t.start, t.end);
  return { start: r, end: n };
}
function wh(e, t) {
  const { start: r, end: n } = al(t == null ? void 0 : t.in, e);
  let a = +r > +n;
  const u = a ? +r : +n, i = a ? n : r;
  i.setHours(0, 0, 0, 0);
  let s = 1;
  const o = [];
  for (; +i <= u; )
    o.push(Se(r, i)), i.setDate(i.getDate() + s), i.setHours(0, 0, 0, 0);
  return a ? o.reverse() : o;
}
function ul(e, t) {
  const r = H(e, t == null ? void 0 : t.in);
  return r.setDate(1), r.setHours(0, 0, 0, 0), r;
}
function Eh(e, t) {
  const r = H(e, t == null ? void 0 : t.in);
  return r.setFullYear(r.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
const Ch = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Th = (e, t, r) => {
  let n;
  const a = Ch[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
function Ir(e) {
  return (t = {}) => {
    const r = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
const kh = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Ah = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Oh = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Ih = {
  date: Ir({
    formats: kh,
    defaultWidth: "full"
  }),
  time: Ir({
    formats: Ah,
    defaultWidth: "full"
  }),
  dateTime: Ir({
    formats: Oh,
    defaultWidth: "full"
  })
}, Ph = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Bh = (e, t, r, n) => Ph[e];
function dt(e) {
  return (t, r) => {
    const n = r != null && r.context ? String(r.context) : "standalone";
    let a;
    if (n === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = r != null && r.width ? String(r.width) : i;
      a = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = r != null && r.width ? String(r.width) : e.defaultWidth;
      a = e.values[s] || e.values[i];
    }
    const u = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[u];
  };
}
const Nh = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Dh = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Rh = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, xh = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, jh = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Mh = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Lh = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, Fh = {
  ordinalNumber: Lh,
  era: dt({
    values: Nh,
    defaultWidth: "wide"
  }),
  quarter: dt({
    values: Dh,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: dt({
    values: Rh,
    defaultWidth: "wide"
  }),
  day: dt({
    values: xh,
    defaultWidth: "wide"
  }),
  dayPeriod: dt({
    values: jh,
    defaultWidth: "wide",
    formattingValues: Mh,
    defaultFormattingWidth: "wide"
  })
};
function ft(e) {
  return (t, r = {}) => {
    const n = r.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], u = t.match(a);
    if (!u)
      return null;
    const i = u[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], o = Array.isArray(s) ? Uh(s, (g) => g.test(i)) : (
      // [TODO] -- I challenge you to fix the type
      $h(s, (g) => g.test(i))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(o) : o, c = r.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      r.valueCallback(c)
    ) : c;
    const f = t.slice(i.length);
    return { value: c, rest: f };
  };
}
function $h(e, t) {
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
      return r;
}
function Uh(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function il(e) {
  return (t, r = {}) => {
    const n = t.match(e.matchPattern);
    if (!n) return null;
    const a = n[0], u = t.match(e.parsePattern);
    if (!u) return null;
    let i = e.valueCallback ? e.valueCallback(u[0]) : u[0];
    i = r.valueCallback ? r.valueCallback(i) : i;
    const s = t.slice(a.length);
    return { value: i, rest: s };
  };
}
const Hh = /^(\d+)(th|st|nd|rd)?/i, Gh = /\d+/i, Wh = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, qh = {
  any: [/^b/i, /^(a|c)/i]
}, zh = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Vh = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Yh = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Xh = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Jh = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Kh = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Qh = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Zh = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, e2 = {
  ordinalNumber: il({
    matchPattern: Hh,
    parsePattern: Gh,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ft({
    matchPatterns: Wh,
    defaultMatchWidth: "wide",
    parsePatterns: qh,
    defaultParseWidth: "any"
  }),
  quarter: ft({
    matchPatterns: zh,
    defaultMatchWidth: "wide",
    parsePatterns: Vh,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ft({
    matchPatterns: Yh,
    defaultMatchWidth: "wide",
    parsePatterns: Xh,
    defaultParseWidth: "any"
  }),
  day: ft({
    matchPatterns: Jh,
    defaultMatchWidth: "wide",
    parsePatterns: Kh,
    defaultParseWidth: "any"
  }),
  dayPeriod: ft({
    matchPatterns: Qh,
    defaultMatchWidth: "any",
    parsePatterns: Zh,
    defaultParseWidth: "any"
  })
}, t2 = {
  code: "en-US",
  formatDistance: Th,
  formatLong: Ih,
  formatRelative: Bh,
  localize: Fh,
  match: e2,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function r2(e, t) {
  const r = H(e, t == null ? void 0 : t.in);
  return X0(r, Eh(r)) + 1;
}
function n2(e, t) {
  const r = H(e, t == null ? void 0 : t.in), n = +ma(r) - +hh(r);
  return Math.round(n / V0) + 1;
}
function sl(e, t) {
  var f, g, p, h;
  const r = H(e, t == null ? void 0 : t.in), n = r.getFullYear(), a = Sn(), u = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((g = (f = t == null ? void 0 : t.locale) == null ? void 0 : f.options) == null ? void 0 : g.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((h = (p = a.locale) == null ? void 0 : p.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = Se((t == null ? void 0 : t.in) || e, 0);
  i.setFullYear(n + 1, 0, u), i.setHours(0, 0, 0, 0);
  const s = nr(i, t), o = Se((t == null ? void 0 : t.in) || e, 0);
  o.setFullYear(n, 0, u), o.setHours(0, 0, 0, 0);
  const c = nr(o, t);
  return +r >= +s ? n + 1 : +r >= +c ? n : n - 1;
}
function a2(e, t) {
  var s, o, c, f;
  const r = Sn(), n = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((o = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : o.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((f = (c = r.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, a = sl(e, t), u = Se((t == null ? void 0 : t.in) || e, 0);
  return u.setFullYear(a, 0, n), u.setHours(0, 0, 0, 0), nr(u, t);
}
function u2(e, t) {
  const r = H(e, t == null ? void 0 : t.in), n = +nr(r, t) - +a2(r, t);
  return Math.round(n / V0) + 1;
}
function q(e, t) {
  const r = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
  return r + n;
}
const Nt = {
  // Year
  y(e, t) {
    const r = e.getFullYear(), n = r > 0 ? r : 1 - r;
    return q(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M(e, t) {
    const r = e.getMonth();
    return t === "M" ? String(r + 1) : q(r + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return q(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return q(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return q(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return q(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return q(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const r = t.length, n = e.getMilliseconds(), a = Math.trunc(
      n * Math.pow(10, r - 3)
    );
    return q(a, t.length);
  }
}, mr = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Bo = {
  // Era
  G: function(e, t, r) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" });
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      const n = e.getFullYear(), a = n > 0 ? n : 1 - n;
      return r.ordinalNumber(a, { unit: "year" });
    }
    return Nt.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, n) {
    const a = sl(e, n), u = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const i = u % 100;
      return q(i, 2);
    }
    return t === "Yo" ? r.ordinalNumber(u, { unit: "year" }) : q(u, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const r = Y0(e);
    return q(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const r = e.getFullYear();
    return q(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(n);
      case "QQ":
        return q(n, 2);
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(n);
      case "qq":
        return q(n, 2);
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Nt.M(e, t);
      case "Mo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "L":
        return String(n + 1);
      case "LL":
        return q(n + 1, 2);
      case "Lo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, r, n) {
    const a = u2(e, n);
    return t === "wo" ? r.ordinalNumber(a, { unit: "week" }) : q(a, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    const n = n2(e);
    return t === "Io" ? r.ordinalNumber(n, { unit: "week" }) : q(n, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : Nt.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    const n = r2(e);
    return t === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : q(n, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    const n = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, n) {
    const a = e.getDay(), u = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(u);
      case "ee":
        return q(u, 2);
      case "eo":
        return r.ordinalNumber(u, { unit: "day" });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, n) {
    const a = e.getDay(), u = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(u);
      case "cc":
        return q(u, t.length);
      case "co":
        return r.ordinalNumber(u, { unit: "day" });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    const n = e.getDay(), a = n === 0 ? 7 : n;
    switch (t) {
      case "i":
        return String(a);
      case "ii":
        return q(a, t.length);
      case "io":
        return r.ordinalNumber(a, { unit: "day" });
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n === 12 ? a = mr.noon : n === 0 ? a = mr.midnight : a = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n >= 17 ? a = mr.evening : n >= 12 ? a = mr.afternoon : n >= 4 ? a = mr.morning : a = mr.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
    }
    return Nt.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : Nt.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    const n = e.getHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : q(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    let n = e.getHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : q(n, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Nt.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : Nt.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Nt.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      case "X":
        return Do(n);
      case "XXXX":
      case "XX":
        return Xt(n);
      case "XXXXX":
      case "XXX":
      default:
        return Xt(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return Do(n);
      case "xxxx":
      case "xx":
        return Xt(n);
      case "xxxxx":
      case "xxx":
      default:
        return Xt(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + No(n, ":");
      case "OOOO":
      default:
        return "GMT" + Xt(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + No(n, ":");
      case "zzzz":
      default:
        return "GMT" + Xt(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r) {
    const n = Math.trunc(+e / 1e3);
    return q(n, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r) {
    return q(+e, t.length);
  }
};
function No(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.trunc(n / 60), u = n % 60;
  return u === 0 ? r + String(a) : r + String(a) + t + q(u, 2);
}
function Do(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + q(Math.abs(e) / 60, 2) : Xt(e, t);
}
function Xt(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = q(Math.trunc(n / 60), 2), u = q(n % 60, 2);
  return r + a + t + u;
}
const Ro = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, ol = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, i2 = (e, t) => {
  const r = e.match(/(P+)(p+)?/) || [], n = r[1], a = r[2];
  if (!a)
    return Ro(e, t);
  let u;
  switch (n) {
    case "P":
      u = t.dateTime({ width: "short" });
      break;
    case "PP":
      u = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      u = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      u = t.dateTime({ width: "full" });
      break;
  }
  return u.replace("{{date}}", Ro(n, t)).replace("{{time}}", ol(a, t));
}, s2 = {
  p: ol,
  P: i2
}, o2 = /^D+$/, c2 = /^Y+$/, d2 = ["D", "DD", "YY", "YYYY"];
function f2(e) {
  return o2.test(e);
}
function l2(e) {
  return c2.test(e);
}
function p2(e, t, r) {
  const n = h2(e, t, r);
  if (console.warn(n), d2.includes(e)) throw new RangeError(n);
}
function h2(e, t, r) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const m2 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, g2 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, y2 = /^'([^]*?)'?$/, v2 = /''/g, b2 = /[a-zA-Z]/;
function cl(e, t, r) {
  var f, g, p, h, v, S, E, d;
  const n = Sn(), a = (r == null ? void 0 : r.locale) ?? n.locale ?? t2, u = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((g = (f = r == null ? void 0 : r.locale) == null ? void 0 : f.options) == null ? void 0 : g.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((h = (p = n.locale) == null ? void 0 : p.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = (r == null ? void 0 : r.weekStartsOn) ?? ((S = (v = r == null ? void 0 : r.locale) == null ? void 0 : v.options) == null ? void 0 : S.weekStartsOn) ?? n.weekStartsOn ?? ((d = (E = n.locale) == null ? void 0 : E.options) == null ? void 0 : d.weekStartsOn) ?? 0, s = H(e, r == null ? void 0 : r.in);
  if (!Er(s))
    throw new RangeError("Invalid time value");
  let o = t.match(g2).map((m) => {
    const l = m[0];
    if (l === "p" || l === "P") {
      const y = s2[l];
      return y(m, a.formatLong);
    }
    return m;
  }).join("").match(m2).map((m) => {
    if (m === "''")
      return { isToken: !1, value: "'" };
    const l = m[0];
    if (l === "'")
      return { isToken: !1, value: _2(m) };
    if (Bo[l])
      return { isToken: !0, value: m };
    if (l.match(b2))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + l + "`"
      );
    return { isToken: !1, value: m };
  });
  a.localize.preprocessor && (o = a.localize.preprocessor(s, o));
  const c = {
    firstWeekContainsDate: u,
    weekStartsOn: i,
    locale: a
  };
  return o.map((m) => {
    if (!m.isToken) return m.value;
    const l = m.value;
    (!(r != null && r.useAdditionalWeekYearTokens) && l2(l) || !(r != null && r.useAdditionalDayOfYearTokens) && f2(l)) && p2(l, t, String(e));
    const y = Bo[l[0]];
    return y(s, l, a.localize, c);
  }).join("");
}
function _2(e) {
  const t = e.match(y2);
  return t ? t[1].replace(v2, "'") : e;
}
function S2(e, t) {
  const r = H(e, t == null ? void 0 : t.in);
  if (isNaN(+r))
    throw new RangeError("Invalid time value");
  let n = "", a = "";
  const u = "-", i = ":";
  {
    const s = q(r.getDate(), 2), o = q(r.getMonth() + 1, 2);
    n = `${q(r.getFullYear(), 4)}${u}${o}${u}${s}`;
  }
  {
    const s = r.getTimezoneOffset();
    if (s !== 0) {
      const h = Math.abs(s), v = q(Math.trunc(h / 60), 2), S = q(h % 60, 2);
      a = `${s < 0 ? "+" : "-"}${v}:${S}`;
    } else
      a = "Z";
    const o = q(r.getHours(), 2), c = q(r.getMinutes(), 2), f = q(r.getSeconds(), 2), g = n === "" ? "" : "T", p = [o, c, f].join(i);
    n = `${n}${g}${p}${a}`;
  }
  return n;
}
function xo(e, t) {
  return H(e, t == null ? void 0 : t.in).getDay();
}
function w2(e, t) {
  const r = H(e, t == null ? void 0 : t.in), n = r.getFullYear(), a = r.getMonth(), u = Se(r, 0);
  return u.setFullYear(n, a + 1, 0), u.setHours(0, 0, 0, 0), u.getDate();
}
function E2() {
  return Object.assign({}, Sn());
}
function C2(e, t) {
  return H(e, t == null ? void 0 : t.in).getMonth();
}
function T2(e, t) {
  const r = H(e, t == null ? void 0 : t.in), n = r.getMonth();
  return r.setFullYear(r.getFullYear(), n + 1, 0), r.setHours(0, 0, 0, 0), H(r, t == null ? void 0 : t.in);
}
function k2(e, t) {
  const { start: r, end: n } = al(t == null ? void 0 : t.in, e), a = {}, u = nl(n, r);
  u && (a.years = u);
  const i = _r(r, { years: a.years }), s = tl(n, i);
  s && (a.months = s);
  const o = _r(i, { months: a.months }), c = J0(n, o);
  c && (a.days = c);
  const f = _r(o, { days: a.days }), g = K0(n, f);
  g && (a.hours = g);
  const p = _r(f, { hours: a.hours }), h = Q0(n, p);
  h && (a.minutes = h);
  const v = _r(p, { minutes: a.minutes }), S = rl(n, v);
  return S && (a.seconds = S), a;
}
function A2(e, t) {
  return +H(e) > +H(t);
}
function O2(e, t) {
  return +H(e) < +H(t);
}
function I2(e, t) {
  return +H(e) == +H(t);
}
function P2(e, t, r) {
  const n = new Date(e, t, r);
  return n.getFullYear() === e && n.getMonth() === t && n.getDate() === r;
}
function jo(e, t, r) {
  const [n, a] = et(
    r == null ? void 0 : r.in,
    e,
    t
  );
  return +nr(n, r) == +nr(a, r);
}
function B2(e, t, r) {
  const [n, a] = et(
    r == null ? void 0 : r.in,
    e,
    t
  );
  return n.getFullYear() === a.getFullYear() && n.getMonth() === a.getMonth();
}
function N2(e, t, r) {
  const [n, a] = et(
    r == null ? void 0 : r.in,
    e,
    t
  );
  return n.getFullYear() === a.getFullYear();
}
function D2(e, t, r) {
  const n = +H(e, r == null ? void 0 : r.in), [a, u] = [
    +H(t.start, r == null ? void 0 : r.in),
    +H(t.end, r == null ? void 0 : r.in)
  ].sort((i, s) => i - s);
  return n >= a && n <= u;
}
function R2(e, t, r) {
  return Or(e, -t, r);
}
function Rs(e, t) {
  const r = () => Se(t == null ? void 0 : t.in, NaN), a = L2(e);
  let u;
  if (a.date) {
    const c = F2(a.date, 2);
    u = $2(c.restDateString, c.year);
  }
  if (!u || isNaN(+u)) return r();
  const i = +u;
  let s = 0, o;
  if (a.time && (s = U2(a.time), isNaN(s)))
    return r();
  if (a.timezone) {
    if (o = H2(a.timezone), isNaN(o)) return r();
  } else {
    const c = new Date(i + s), f = H(0, t == null ? void 0 : t.in);
    return f.setFullYear(
      c.getUTCFullYear(),
      c.getUTCMonth(),
      c.getUTCDate()
    ), f.setHours(
      c.getUTCHours(),
      c.getUTCMinutes(),
      c.getUTCSeconds(),
      c.getUTCMilliseconds()
    ), f;
  }
  return H(i + s + o, t == null ? void 0 : t.in);
}
const Mn = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, x2 = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, j2 = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, M2 = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function L2(e) {
  const t = {}, r = e.split(Mn.dateTimeDelimiter);
  let n;
  if (r.length > 2)
    return t;
  if (/:/.test(r[0]) ? n = r[0] : (t.date = r[0], n = r[1], Mn.timeZoneDelimiter.test(t.date) && (t.date = e.split(Mn.timeZoneDelimiter)[0], n = e.substr(
    t.date.length,
    e.length
  ))), n) {
    const a = Mn.timezone.exec(n);
    a ? (t.time = n.replace(a[1], ""), t.timezone = a[1]) : t.time = n;
  }
  return t;
}
function F2(e, t) {
  const r = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), n = e.match(r);
  if (!n) return { year: NaN, restDateString: "" };
  const a = n[1] ? parseInt(n[1]) : null, u = n[2] ? parseInt(n[2]) : null;
  return {
    year: u === null ? a : u * 100,
    restDateString: e.slice((n[1] || n[2]).length)
  };
}
function $2(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  const r = e.match(x2);
  if (!r) return /* @__PURE__ */ new Date(NaN);
  const n = !!r[4], a = Qr(r[1]), u = Qr(r[2]) - 1, i = Qr(r[3]), s = Qr(r[4]), o = Qr(r[5]) - 1;
  if (n)
    return V2(t, s, o) ? G2(t, s, o) : /* @__PURE__ */ new Date(NaN);
  {
    const c = /* @__PURE__ */ new Date(0);
    return !q2(t, u, i) || !z2(t, a) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(t, u, Math.max(a, i)), c);
  }
}
function Qr(e) {
  return e ? parseInt(e) : 1;
}
function U2(e) {
  const t = e.match(j2);
  if (!t) return NaN;
  const r = bu(t[1]), n = bu(t[2]), a = bu(t[3]);
  return Y2(r, n, a) ? r * Bs + n * $a + a * 1e3 : NaN;
}
function bu(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function H2(e) {
  if (e === "Z") return 0;
  const t = e.match(M2);
  if (!t) return 0;
  const r = t[1] === "+" ? -1 : 1, n = parseInt(t[2]), a = t[3] && parseInt(t[3]) || 0;
  return X2(n, a) ? r * (n * Bs + a * $a) : NaN;
}
function G2(e, t, r) {
  const n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  const a = n.getUTCDay() || 7, u = (t - 1) * 7 + r + 1 - a;
  return n.setUTCDate(n.getUTCDate() + u), n;
}
const W2 = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function dl(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function q2(e, t, r) {
  return t >= 0 && t <= 11 && r >= 1 && r <= (W2[t] || (dl(e) ? 29 : 28));
}
function z2(e, t) {
  return t >= 1 && t <= (dl(e) ? 366 : 365);
}
function V2(e, t, r) {
  return t >= 1 && t <= 53 && r >= 0 && r <= 6;
}
function Y2(e, t, r) {
  return e === 24 ? t === 0 && r === 0 : r >= 0 && r < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function X2(e, t) {
  return t >= 0 && t <= 59;
}
function fl(e, t, r) {
  const n = H(e, r == null ? void 0 : r.in), a = n.getFullYear(), u = n.getDate(), i = Se(e, 0);
  i.setFullYear(a, t, 15), i.setHours(0, 0, 0, 0);
  const s = w2(i);
  return n.setMonth(t, Math.min(u, s)), n;
}
function J2(e, t, r) {
  let n = H(e, r == null ? void 0 : r.in);
  return isNaN(+n) ? Se(e, NaN) : (t.year != null && n.setFullYear(t.year), t.month != null && (n = fl(n, t.month)), t.date != null && n.setDate(t.date), t.hours != null && n.setHours(t.hours), t.minutes != null && n.setMinutes(t.minutes), t.seconds != null && n.setSeconds(t.seconds), t.milliseconds != null && n.setMilliseconds(t.milliseconds), n);
}
function K2(e, t, r) {
  const n = H(e, r == null ? void 0 : r.in);
  return isNaN(+n) ? Se(e, NaN) : (n.setFullYear(t), n);
}
function Q2(e, t, r) {
  return Ua(e, -t, r);
}
function Z2(e, t, r) {
  const {
    years: n = 0,
    months: a = 0,
    weeks: u = 0,
    days: i = 0,
    hours: s = 0,
    minutes: o = 0,
    seconds: c = 0
  } = t, f = Q2(e, a + n * 12, r), g = R2(f, i + u * 7, r), p = o + s * 60, v = (c + p * 60) * 1e3;
  return Se(e, +g - v);
}
function Zr(e, t) {
  if (e.one !== void 0 && t === 1)
    return e.one;
  const r = t % 10, n = t % 100;
  return r === 1 && n !== 11 ? e.singularNominative.replace("{{count}}", String(t)) : r >= 2 && r <= 4 && (n < 10 || n > 20) ? e.singularGenitive.replace("{{count}}", String(t)) : e.pluralGenitive.replace("{{count}}", String(t));
}
function Re(e) {
  return (t, r) => r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? e.future ? Zr(e.future, t) : "через " + Zr(e.regular, t) : e.past ? Zr(e.past, t) : Zr(e.regular, t) + " назад" : Zr(e.regular, t);
}
const em = {
  lessThanXSeconds: Re({
    regular: {
      one: "меньше секунды",
      singularNominative: "меньше {{count}} секунды",
      singularGenitive: "меньше {{count}} секунд",
      pluralGenitive: "меньше {{count}} секунд"
    },
    future: {
      one: "меньше, чем через секунду",
      singularNominative: "меньше, чем через {{count}} секунду",
      singularGenitive: "меньше, чем через {{count}} секунды",
      pluralGenitive: "меньше, чем через {{count}} секунд"
    }
  }),
  xSeconds: Re({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду назад",
      singularGenitive: "{{count}} секунды назад",
      pluralGenitive: "{{count}} секунд назад"
    },
    future: {
      singularNominative: "через {{count}} секунду",
      singularGenitive: "через {{count}} секунды",
      pluralGenitive: "через {{count}} секунд"
    }
  }),
  halfAMinute: (e, t) => t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "через полминуты" : "полминуты назад" : "полминуты",
  lessThanXMinutes: Re({
    regular: {
      one: "меньше минуты",
      singularNominative: "меньше {{count}} минуты",
      singularGenitive: "меньше {{count}} минут",
      pluralGenitive: "меньше {{count}} минут"
    },
    future: {
      one: "меньше, чем через минуту",
      singularNominative: "меньше, чем через {{count}} минуту",
      singularGenitive: "меньше, чем через {{count}} минуты",
      pluralGenitive: "меньше, чем через {{count}} минут"
    }
  }),
  xMinutes: Re({
    regular: {
      singularNominative: "{{count}} минута",
      singularGenitive: "{{count}} минуты",
      pluralGenitive: "{{count}} минут"
    },
    past: {
      singularNominative: "{{count}} минуту назад",
      singularGenitive: "{{count}} минуты назад",
      pluralGenitive: "{{count}} минут назад"
    },
    future: {
      singularNominative: "через {{count}} минуту",
      singularGenitive: "через {{count}} минуты",
      pluralGenitive: "через {{count}} минут"
    }
  }),
  aboutXHours: Re({
    regular: {
      singularNominative: "около {{count}} часа",
      singularGenitive: "около {{count}} часов",
      pluralGenitive: "около {{count}} часов"
    },
    future: {
      singularNominative: "приблизительно через {{count}} час",
      singularGenitive: "приблизительно через {{count}} часа",
      pluralGenitive: "приблизительно через {{count}} часов"
    }
  }),
  xHours: Re({
    regular: {
      singularNominative: "{{count}} час",
      singularGenitive: "{{count}} часа",
      pluralGenitive: "{{count}} часов"
    }
  }),
  xDays: Re({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} дня",
      pluralGenitive: "{{count}} дней"
    }
  }),
  aboutXWeeks: Re({
    regular: {
      singularNominative: "около {{count}} недели",
      singularGenitive: "около {{count}} недель",
      pluralGenitive: "около {{count}} недель"
    },
    future: {
      singularNominative: "приблизительно через {{count}} неделю",
      singularGenitive: "приблизительно через {{count}} недели",
      pluralGenitive: "приблизительно через {{count}} недель"
    }
  }),
  xWeeks: Re({
    regular: {
      singularNominative: "{{count}} неделя",
      singularGenitive: "{{count}} недели",
      pluralGenitive: "{{count}} недель"
    }
  }),
  aboutXMonths: Re({
    regular: {
      singularNominative: "около {{count}} месяца",
      singularGenitive: "около {{count}} месяцев",
      pluralGenitive: "около {{count}} месяцев"
    },
    future: {
      singularNominative: "приблизительно через {{count}} месяц",
      singularGenitive: "приблизительно через {{count}} месяца",
      pluralGenitive: "приблизительно через {{count}} месяцев"
    }
  }),
  xMonths: Re({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяца",
      pluralGenitive: "{{count}} месяцев"
    }
  }),
  aboutXYears: Re({
    regular: {
      singularNominative: "около {{count}} года",
      singularGenitive: "около {{count}} лет",
      pluralGenitive: "около {{count}} лет"
    },
    future: {
      singularNominative: "приблизительно через {{count}} год",
      singularGenitive: "приблизительно через {{count}} года",
      pluralGenitive: "приблизительно через {{count}} лет"
    }
  }),
  xYears: Re({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} года",
      pluralGenitive: "{{count}} лет"
    }
  }),
  overXYears: Re({
    regular: {
      singularNominative: "больше {{count}} года",
      singularGenitive: "больше {{count}} лет",
      pluralGenitive: "больше {{count}} лет"
    },
    future: {
      singularNominative: "больше, чем через {{count}} год",
      singularGenitive: "больше, чем через {{count}} года",
      pluralGenitive: "больше, чем через {{count}} лет"
    }
  }),
  almostXYears: Re({
    regular: {
      singularNominative: "почти {{count}} год",
      singularGenitive: "почти {{count}} года",
      pluralGenitive: "почти {{count}} лет"
    },
    future: {
      singularNominative: "почти через {{count}} год",
      singularGenitive: "почти через {{count}} года",
      pluralGenitive: "почти через {{count}} лет"
    }
  })
}, tm = (e, t, r) => em[e](t, r), rm = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y"
}, nm = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, am = {
  any: "{{date}}, {{time}}"
}, um = {
  date: Ir({
    formats: rm,
    defaultWidth: "full"
  }),
  time: Ir({
    formats: nm,
    defaultWidth: "full"
  }),
  dateTime: Ir({
    formats: am,
    defaultWidth: "any"
  })
}, xs = [
  "воскресенье",
  "понедельник",
  "вторник",
  "среду",
  "четверг",
  "пятницу",
  "субботу"
];
function im(e) {
  const t = xs[e];
  switch (e) {
    case 0:
      return "'в прошлое " + t + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в прошлый " + t + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в прошлую " + t + " в' p";
  }
}
function Mo(e) {
  const t = xs[e];
  return e === 2 ? "'во " + t + " в' p" : "'в " + t + " в' p";
}
function sm(e) {
  const t = xs[e];
  switch (e) {
    case 0:
      return "'в следующее " + t + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в следующий " + t + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в следующую " + t + " в' p";
  }
}
const om = {
  lastWeek: (e, t, r) => {
    const n = e.getDay();
    return jo(e, t, r) ? Mo(n) : im(n);
  },
  yesterday: "'вчера в' p",
  today: "'сегодня в' p",
  tomorrow: "'завтра в' p",
  nextWeek: (e, t, r) => {
    const n = e.getDay();
    return jo(e, t, r) ? Mo(n) : sm(n);
  },
  other: "P"
}, cm = (e, t, r, n) => {
  const a = om[e];
  return typeof a == "function" ? a(t, r, n) : a;
}, dm = {
  narrow: ["до н.э.", "н.э."],
  abbreviated: ["до н. э.", "н. э."],
  wide: ["до нашей эры", "нашей эры"]
}, fm = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"]
}, lm = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв.",
    "фев.",
    "март",
    "апр.",
    "май",
    "июнь",
    "июль",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек."
  ],
  wide: [
    "январь",
    "февраль",
    "март",
    "апрель",
    "май",
    "июнь",
    "июль",
    "август",
    "сентябрь",
    "октябрь",
    "ноябрь",
    "декабрь"
  ]
}, pm = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв.",
    "фев.",
    "мар.",
    "апр.",
    "мая",
    "июн.",
    "июл.",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек."
  ],
  wide: [
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря"
  ]
}, hm = {
  narrow: ["В", "П", "В", "С", "Ч", "П", "С"],
  short: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["вск", "пнд", "втр", "срд", "чтв", "птн", "суб"],
  wide: [
    "воскресенье",
    "понедельник",
    "вторник",
    "среда",
    "четверг",
    "пятница",
    "суббота"
  ]
}, mm = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утро",
    afternoon: "день",
    evening: "вечер",
    night: "ночь"
  }
}, gm = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утра",
    afternoon: "дня",
    evening: "вечера",
    night: "ночи"
  }
}, ym = (e, t) => {
  const r = Number(e), n = t == null ? void 0 : t.unit;
  let a;
  return n === "date" ? a = "-е" : n === "week" || n === "minute" || n === "second" ? a = "-я" : a = "-й", r + a;
}, vm = {
  ordinalNumber: ym,
  era: dt({
    values: dm,
    defaultWidth: "wide"
  }),
  quarter: dt({
    values: fm,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: dt({
    values: lm,
    defaultWidth: "wide",
    formattingValues: pm,
    defaultFormattingWidth: "wide"
  }),
  day: dt({
    values: hm,
    defaultWidth: "wide"
  }),
  dayPeriod: dt({
    values: mm,
    defaultWidth: "any",
    formattingValues: gm,
    defaultFormattingWidth: "wide"
  })
}, bm = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i, _m = /\d+/i, Sm = {
  narrow: /^((до )?н\.?\s?э\.?)/i,
  abbreviated: /^((до )?н\.?\s?э\.?)/i,
  wide: /^(до нашей эры|нашей эры|наша эра)/i
}, wm = {
  any: [/^д/i, /^н/i]
}, Em = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
  wide: /^[1234](-?[ыои]?й?)? квартал/i
}, Cm = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Tm = {
  narrow: /^[яфмаисонд]/i,
  abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
}, km = {
  narrow: [
    /^я/i,
    /^ф/i,
    /^м/i,
    /^а/i,
    /^м/i,
    /^и/i,
    /^и/i,
    /^а/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^я/i
  ],
  any: [
    /^я/i,
    /^ф/i,
    /^мар/i,
    /^ап/i,
    /^ма[йя]/i,
    /^июн/i,
    /^июл/i,
    /^ав/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^д/i
  ]
}, Am = {
  narrow: /^[впсч]/i,
  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
}, Om = {
  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
}, Im = {
  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
}, Pm = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^полн/i,
    noon: /^полд/i,
    morning: /^у/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, Bm = {
  ordinalNumber: il({
    matchPattern: bm,
    parsePattern: _m,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ft({
    matchPatterns: Sm,
    defaultMatchWidth: "wide",
    parsePatterns: wm,
    defaultParseWidth: "any"
  }),
  quarter: ft({
    matchPatterns: Em,
    defaultMatchWidth: "wide",
    parsePatterns: Cm,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ft({
    matchPatterns: Tm,
    defaultMatchWidth: "wide",
    parsePatterns: km,
    defaultParseWidth: "any"
  }),
  day: ft({
    matchPatterns: Am,
    defaultMatchWidth: "wide",
    parsePatterns: Om,
    defaultParseWidth: "any"
  }),
  dayPeriod: ft({
    matchPatterns: Im,
    defaultMatchWidth: "wide",
    parsePatterns: Pm,
    defaultParseWidth: "any"
  })
}, ll = {
  code: "ru",
  formatDistance: tm,
  formatLong: um,
  formatRelative: cm,
  localize: vm,
  match: Bm,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
function Lo(e, t, r) {
  const n = E2(), a = Rm(e, r.timeZone, r.locale ?? n.locale);
  return "formatToParts" in a ? Nm(a, t) : Dm(a, t);
}
function Nm(e, t) {
  const r = e.formatToParts(t);
  for (let n = r.length - 1; n >= 0; --n)
    if (r[n].type === "timeZoneName")
      return r[n].value;
}
function Dm(e, t) {
  const r = e.format(t).replace(/\u200E/g, ""), n = / [\w-+ ]+$/.exec(r);
  return n ? n[0].substr(1) : "";
}
function Rm(e, t, r) {
  return new Intl.DateTimeFormat(r ? [r.code, "en-US"] : void 0, {
    timeZone: t,
    timeZoneName: e
  });
}
function xm(e, t) {
  const r = $m(t);
  return "formatToParts" in r ? Mm(r, e) : Lm(r, e);
}
const jm = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function Mm(e, t) {
  try {
    const r = e.formatToParts(t), n = [];
    for (let a = 0; a < r.length; a++) {
      const u = jm[r[a].type];
      u !== void 0 && (n[u] = parseInt(r[a].value, 10));
    }
    return n;
  } catch (r) {
    if (r instanceof RangeError)
      return [NaN];
    throw r;
  }
}
function Lm(e, t) {
  const r = e.format(t), n = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(r);
  return [
    parseInt(n[3], 10),
    parseInt(n[1], 10),
    parseInt(n[2], 10),
    parseInt(n[4], 10),
    parseInt(n[5], 10),
    parseInt(n[6], 10)
  ];
}
const _u = {}, Fo = new Intl.DateTimeFormat("en-US", {
  hourCycle: "h23",
  timeZone: "America/New_York",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), Fm = Fo === "06/25/2014, 00:00:00" || Fo === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
function $m(e) {
  return _u[e] || (_u[e] = Fm ? new Intl.DateTimeFormat("en-US", {
    hourCycle: "h23",
    timeZone: e,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }) : new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  })), _u[e];
}
function pl(e, t, r, n, a, u, i) {
  const s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(e, t, r), s.setUTCHours(n, a, u, i), s;
}
const $o = 36e5, Um = 6e4, Su = {
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function js(e, t, r) {
  if (!e)
    return 0;
  let n = Su.timezoneZ.exec(e);
  if (n)
    return 0;
  let a, u;
  if (n = Su.timezoneHH.exec(e), n)
    return a = parseInt(n[1], 10), Uo(a) ? -(a * $o) : NaN;
  if (n = Su.timezoneHHMM.exec(e), n) {
    a = parseInt(n[2], 10);
    const i = parseInt(n[3], 10);
    return Uo(a, i) ? (u = Math.abs(a) * $o + i * Um, n[1] === "+" ? -u : u) : NaN;
  }
  if (Wm(e)) {
    t = new Date(t || Date.now());
    const i = r ? t : Hm(t), s = Xi(i, e);
    return -(r ? s : Gm(t, s, e));
  }
  return NaN;
}
function Hm(e) {
  return pl(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds());
}
function Xi(e, t) {
  const r = xm(e, t), n = pl(r[0], r[1] - 1, r[2], r[3] % 24, r[4], r[5], 0).getTime();
  let a = e.getTime();
  const u = a % 1e3;
  return a -= u >= 0 ? u : 1e3 + u, n - a;
}
function Gm(e, t, r) {
  let a = e.getTime() - t;
  const u = Xi(new Date(a), r);
  if (t === u)
    return t;
  a -= u - t;
  const i = Xi(new Date(a), r);
  return u === i ? u : Math.max(u, i);
}
function Uo(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
const Ho = {};
function Wm(e) {
  if (Ho[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), Ho[e] = !0, !0;
  } catch {
    return !1;
  }
}
const qm = 60 * 1e3, zm = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const n = wu(r.timeZone, e);
    if (n === 0)
      return "Z";
    switch (t) {
      case "X":
        return Go(n);
      case "XXXX":
      case "XX":
        return Sr(n);
      case "XXXXX":
      case "XXX":
      default:
        return Sr(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const n = wu(r.timeZone, e);
    switch (t) {
      case "x":
        return Go(n);
      case "xxxx":
      case "xx":
        return Sr(n);
      case "xxxxx":
      case "xxx":
      default:
        return Sr(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const n = wu(r.timeZone, e);
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Vm(n, ":");
      case "OOOO":
      default:
        return "GMT" + Sr(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return Lo("short", e, r);
      case "zzzz":
      default:
        return Lo("long", e, r);
    }
  }
};
function wu(e, t) {
  const r = e ? js(e, t, !0) / qm : (t == null ? void 0 : t.getTimezoneOffset()) ?? 0;
  if (Number.isNaN(r))
    throw new RangeError("Invalid time zone specified: " + e);
  return r;
}
function ga(e, t) {
  const r = e < 0 ? "-" : "";
  let n = Math.abs(e).toString();
  for (; n.length < t; )
    n = "0" + n;
  return r + n;
}
function Sr(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = ga(Math.floor(n / 60), 2), u = ga(Math.floor(n % 60), 2);
  return r + a + t + u;
}
function Go(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + ga(Math.abs(e) / 60, 2) : Sr(e, t);
}
function Vm(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.floor(n / 60), u = n % 60;
  return u === 0 ? r + String(a) : r + String(a) + t + ga(u, 2);
}
function Wo(e) {
  const t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), +e - +t;
}
const Ym = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, Eu = 36e5, qo = 6e4, Xm = 2, Me = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: Ym
};
function hl(e, t = {}) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  const r = t.additionalDigits == null ? Xm : Number(t.additionalDigits);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (Object.prototype.toString.call(e) !== "[object String]")
    return /* @__PURE__ */ new Date(NaN);
  const n = Jm(e), { year: a, restDateString: u } = Km(n.date, r), i = Qm(u, a);
  if (i === null || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  if (i) {
    const s = i.getTime();
    let o = 0, c;
    if (n.time && (o = Zm(n.time), o === null || isNaN(o)))
      return /* @__PURE__ */ new Date(NaN);
    if (n.timeZone || t.timeZone) {
      if (c = js(n.timeZone || t.timeZone, new Date(s + o)), isNaN(c))
        return /* @__PURE__ */ new Date(NaN);
    } else
      c = Wo(new Date(s + o)), c = Wo(new Date(s + o + c));
    return new Date(s + o + c);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function Jm(e) {
  const t = {};
  let r = Me.dateTimePattern.exec(e), n;
  if (r ? (t.date = r[1], n = r[3]) : (r = Me.datePattern.exec(e), r ? (t.date = r[1], n = r[2]) : (t.date = null, n = e)), n) {
    const a = Me.timeZone.exec(n);
    a ? (t.time = n.replace(a[1], ""), t.timeZone = a[1].trim()) : t.time = n;
  }
  return t;
}
function Km(e, t) {
  if (e) {
    const r = Me.YYY[t], n = Me.YYYYY[t];
    let a = Me.YYYY.exec(e) || n.exec(e);
    if (a) {
      const u = a[1];
      return {
        year: parseInt(u, 10),
        restDateString: e.slice(u.length)
      };
    }
    if (a = Me.YY.exec(e) || r.exec(e), a) {
      const u = a[1];
      return {
        year: parseInt(u, 10) * 100,
        restDateString: e.slice(u.length)
      };
    }
  }
  return {
    year: null
  };
}
function Qm(e, t) {
  if (t === null)
    return null;
  let r, n, a;
  if (!e || !e.length)
    return r = /* @__PURE__ */ new Date(0), r.setUTCFullYear(t), r;
  let u = Me.MM.exec(e);
  if (u)
    return r = /* @__PURE__ */ new Date(0), n = parseInt(u[1], 10) - 1, Vo(t, n) ? (r.setUTCFullYear(t, n), r) : /* @__PURE__ */ new Date(NaN);
  if (u = Me.DDD.exec(e), u) {
    r = /* @__PURE__ */ new Date(0);
    const i = parseInt(u[1], 10);
    return rg(t, i) ? (r.setUTCFullYear(t, 0, i), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (u = Me.MMDD.exec(e), u) {
    r = /* @__PURE__ */ new Date(0), n = parseInt(u[1], 10) - 1;
    const i = parseInt(u[2], 10);
    return Vo(t, n, i) ? (r.setUTCFullYear(t, n, i), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (u = Me.Www.exec(e), u)
    return a = parseInt(u[1], 10) - 1, Yo(a) ? zo(t, a) : /* @__PURE__ */ new Date(NaN);
  if (u = Me.WwwD.exec(e), u) {
    a = parseInt(u[1], 10) - 1;
    const i = parseInt(u[2], 10) - 1;
    return Yo(a, i) ? zo(t, a, i) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function Zm(e) {
  let t, r, n = Me.HH.exec(e);
  if (n)
    return t = parseFloat(n[1].replace(",", ".")), Cu(t) ? t % 24 * Eu : NaN;
  if (n = Me.HHMM.exec(e), n)
    return t = parseInt(n[1], 10), r = parseFloat(n[2].replace(",", ".")), Cu(t, r) ? t % 24 * Eu + r * qo : NaN;
  if (n = Me.HHMMSS.exec(e), n) {
    t = parseInt(n[1], 10), r = parseInt(n[2], 10);
    const a = parseFloat(n[3].replace(",", "."));
    return Cu(t, r, a) ? t % 24 * Eu + r * qo + a * 1e3 : NaN;
  }
  return null;
}
function zo(e, t, r) {
  t = t || 0, r = r || 0;
  const n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  const a = n.getUTCDay() || 7, u = t * 7 + r + 1 - a;
  return n.setUTCDate(n.getUTCDate() + u), n;
}
const eg = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], tg = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function ml(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Vo(e, t, r) {
  if (t < 0 || t > 11)
    return !1;
  if (r != null) {
    if (r < 1)
      return !1;
    const n = ml(e);
    if (n && r > tg[t] || !n && r > eg[t])
      return !1;
  }
  return !0;
}
function rg(e, t) {
  if (t < 1)
    return !1;
  const r = ml(e);
  return !(r && t > 366 || !r && t > 365);
}
function Yo(e, t) {
  return !(e < 0 || e > 52 || t != null && (t < 0 || t > 6));
}
function Cu(e, t, r) {
  return !(e < 0 || e >= 25 || t != null && (t < 0 || t >= 60) || r != null && (r < 0 || r >= 60));
}
const ng = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function ag(e, t, r = {}) {
  t = String(t);
  const n = t.match(ng);
  if (n) {
    const a = hl(r.originalDate || e, r);
    t = n.reduce(function(u, i) {
      if (i[0] === "'")
        return u;
      const s = u.indexOf(i), o = u[s - 1] === "'", c = u.replace(i, "'" + zm[i[0]](a, i, r) + "'");
      return o ? c.substring(0, s - 1) + c.substring(s + 1) : c;
    }, t);
  }
  return cl(e, t, r);
}
function ug(e, t, r) {
  e = hl(e, r);
  const n = js(t, e, !0), a = new Date(e.getTime() - n), u = /* @__PURE__ */ new Date(0);
  return u.setFullYear(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()), u.setHours(a.getUTCHours(), a.getUTCMinutes(), a.getUTCSeconds(), a.getUTCMilliseconds()), u;
}
function ig(e, t, r, n) {
  return n = {
    ...n,
    timeZone: t,
    originalDate: e
  }, ag(ug(e, t, { timeZone: n.timeZone }), r, n);
}
const Xo = 7, sg = /(\d{1,2})[./-](\d{1,2})[./-](\d{4})/, og = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|([+-]\d{2}:\d{2})))?$/, uw = (e) => {
  let t = ul(e), r = T2(e);
  const n = xo(Or(t, -1)), a = (Xo - xo(r)) % Xo;
  return t = Or(t, -n), r = Or(r, a), wh({ start: t, end: r }).map((u) => u.getTime());
}, iw = (e) => fn(e).getTime(), sw = (e) => Z0(e).getTime(), ow = (e) => ul(e).getTime(), cw = (e) => el(e).getTime(), dw = (e) => S2(e), fw = (e, t) => Or(e, t), lw = (e, t) => Ua(e, t), pw = (e, t) => gh(e, t), hw = (e, t) => cl(e, t, {
  locale: ll,
  firstWeekContainsDate: 1,
  weekStartsOn: 1
}), mw = (e) => C2(e), gw = (e, t) => yh(e, t), yw = (e, t) => B2(e, t), vw = (e, t) => N2(e, t), bw = (e, t) => fl(e, t), _w = (e, t) => K2(e, t), Sw = (e) => {
  if (e instanceof Date)
    return Er(e) ? e : null;
  if (typeof e == "number") {
    const r = new Date(e);
    return Er(r) ? r : null;
  }
  const t = e.match(sg);
  if (t) {
    const r = Number(t[1]), n = Number(t[2]), a = Number(t[3]);
    if (P2(a, n - 1, r))
      return new Date(a, n - 1, r);
    const u = e.replaceAll(".", "/"), i = new Date(u);
    return Er(i) ? i : null;
  }
  if (og.test(e)) {
    const r = Rs(e);
    return Er(r) ? r : null;
  }
  return null;
}, ww = (e, t, r = "days", n = !0) => {
  const u = {
    days: J0,
    months: tl,
    years: nl,
    hours: K0,
    minutes: Q0,
    seconds: rl,
    milliseconds: Ds
  }[r](e, t);
  return n ? Math.abs(u) : u;
}, Ew = (e) => {
  const t = /* @__PURE__ */ new Date(0), r = mh(t, e), n = k2({ start: t, end: r });
  return {
    days: n.days || 0,
    hours: n.hours || 0,
    minutes: n.minutes || 0
  };
};
function Cw(e, t, r) {
  return D2(e, { start: t, end: r });
}
function Tw(e, t) {
  return _r(e, t);
}
function kw(e, t) {
  return Z2(e, t);
}
function Aw(e, t) {
  return A2(e, t);
}
function Ow(e, t) {
  return O2(e, t);
}
function Iw(e, t) {
  return I2(e, t);
}
function Pw(e) {
  const t = Rs(e);
  return Er(t);
}
function Bw(e, t) {
  return J2(e, t);
}
function Nw(e, t, r) {
  const n = typeof e == "string" ? Rs(e) : e;
  return ig(n, t, r, {
    locale: ll
  });
}
function Dw() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
const Rw = (e) => {
  const t = document.querySelector("body");
  t && (t.style.overflow = e);
}, gl = (e, {
  async: t = !0,
  type: r = "text/javascript",
  onload: n = null
} = {}) => {
  const a = new URL(e, location.origin).href;
  if (document.querySelector(`script[src="${a}"]`))
    return;
  const u = Object.assign(document.createElement("script"), {
    type: r,
    async: t,
    src: a,
    onload: n
  });
  document.head.insertBefore(u, document.head.querySelector("script") || null);
};
function xw(e, t = "RUB") {
  const r = {
    style: "decimal",
    maximumFractionDigits: 0
  };
  return t && (r.style = "currency", r.currency = t), new Intl.NumberFormat("ru-RU", r).format(e).replaceAll(/\s/g, Yi);
}
function jw(e) {
  const r = e.replaceAll(/\D/g, "").match(/^[78]?(\d{3})(\d{3})(\d{2})(\d{2})$/);
  return r ? `+7${Yi}(${r[1]})${Yi}${r[2]}-${r[3]}-${r[4]}` : e;
}
function Mw(e, t, r = !0) {
  const n = t % 100 > 4 && t % 100 < 20 ? 2 : [2, 0, 1, 1, 1, 2][t % 10 < 5 ? Math.abs(t) % 10 : 5];
  return r ? `${t} ${e[n]}` : e[n];
}
const Lw = "Enter", Fw = "Escape", $w = " ", Uw = "Tab", Hw = (e, t) => {
  let r = null;
  return (...n) => {
    r && clearTimeout(r), r = setTimeout(() => e(...n), t);
  };
}, Gw = (e, t) => {
  let r = !1;
  return (...n) => {
    r || (e(...n), r = !0, setTimeout(() => {
      r = !1;
    }, t));
  };
}, cg = (e) => {
  setTimeout(e, 0);
}, Ww = (e) => e ? e.some((t) => t.isComment || Array.isArray(t.children) && t.children.length === 0 ? !1 : t.tag !== void 0 || t.text && t.text.replaceAll(/\s+/g, "").trim().length > 0) : !1;
class dg extends Fa {
  constructor() {
    super(...arguments);
    $(this, "id");
    $(this, "bannerTypeId");
  }
  init(r) {
    this.isStartedInit || (this.id = r.id, this.bannerTypeId = r.bannerTypeId, this.baseInit(r.timeoutMS));
  }
  install() {
    if (!this.id || !this.bannerTypeId)
      throw new dn("AdriverAnalyticsProvider requires a id and bannerTypeId parameters", {
        serviceName: Ue.ADRIVER
      });
    window.adrCounterStorage || (window.adrCounterStorage = []), gl(C3);
  }
  isInstalled() {
    return typeof window.AdriverCounterJS == "function";
  }
  track(r, n) {
    this.enqueueOrExecute(
      () => window.adrCounterStorage.push(
        () => new window.AdriverCounterJS(
          { sid: this.id, bt: this.bannerTypeId, ...(n == null ? void 0 : n.segment) && { sz: n.segment } },
          r
        )
      )
    );
  }
}
var fg = Object.defineProperty, lg = (e, t, r) => t in e ? fg(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Et = (e, t, r) => lg(e, typeof t != "symbol" ? t + "" : t, r), Jo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function yl(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function pg(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Ko = { exports: {} };
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
var Qo;
function hg() {
  return Qo || (Qo = 1, function(e, t) {
    (function(r) {
      var n;
      if (e.exports = r(), n = !0, !n) {
        var a = window.Cookies, u = window.Cookies = r();
        u.noConflict = function() {
          return window.Cookies = a, u;
        };
      }
    })(function() {
      function r() {
        for (var u = 0, i = {}; u < arguments.length; u++) {
          var s = arguments[u];
          for (var o in s)
            i[o] = s[o];
        }
        return i;
      }
      function n(u) {
        return u.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
      }
      function a(u) {
        function i() {
        }
        function s(c, f, g) {
          if (!(typeof document > "u")) {
            g = r({
              path: "/"
            }, i.defaults, g), typeof g.expires == "number" && (g.expires = new Date(/* @__PURE__ */ new Date() * 1 + g.expires * 864e5)), g.expires = g.expires ? g.expires.toUTCString() : "";
            try {
              var p = JSON.stringify(f);
              /^[\{\[]/.test(p) && (f = p);
            } catch {
            }
            f = u.write ? u.write(f, c) : encodeURIComponent(String(f)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), c = encodeURIComponent(String(c)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var h = "";
            for (var v in g)
              g[v] && (h += "; " + v, g[v] !== !0 && (h += "=" + g[v].split(";")[0]));
            return document.cookie = c + "=" + f + h;
          }
        }
        function o(c, f) {
          if (!(typeof document > "u")) {
            for (var g = {}, p = document.cookie ? document.cookie.split("; ") : [], h = 0; h < p.length; h++) {
              var v = p[h].split("="), S = v.slice(1).join("=");
              !f && S.charAt(0) === '"' && (S = S.slice(1, -1));
              try {
                var E = n(v[0]);
                if (S = (u.read || u)(S, E) || n(S), f)
                  try {
                    S = JSON.parse(S);
                  } catch {
                  }
                if (g[E] = S, c === E)
                  break;
              } catch {
              }
            }
            return c ? g[c] : g;
          }
        }
        return i.set = s, i.get = function(c) {
          return o(
            c,
            !1
            /* read as raw */
          );
        }, i.getJSON = function(c) {
          return o(
            c,
            !0
            /* read as json */
          );
        }, i.remove = function(c, f) {
          s(c, "", r(f, {
            expires: -1
          }));
        }, i.defaults = {}, i.withConverter = a, i;
      }
      return a(function() {
      });
    });
  }(Ko)), Ko.exports;
}
var mg = hg();
const Tu = /* @__PURE__ */ yl(mg);
class Cr {
  constructor(t = {}) {
    Et(this, "_clientUuid"), Et(this, "clientUuid"), Et(this, "api"), Et(this, "wasSend");
    const { api: r, clientUuid: n } = t;
    if (this._clientUuid = n, this.clientUuid = this.getOurClientUuid(), this.api = r, this.initWasSendAnalyticsCookies(), this.clientUuid)
      this.getAnalyticsData();
    else
      throw new Error("the cookie — clientUuid is not found");
  }
  initWasSendAnalyticsCookies() {
    this.wasSend = {
      yaIdCookiesName: "_Tr_ym_uid_w_send",
      gaIdCookiesName: "_Tr_ga_w_send"
    };
  }
  getAnalyticsData() {
    let t = Cr.getMetrikaId(), r = Cr.getGAId(), n = 120, a = 0;
    if (this.confirmCookies(t, r), !this.wasSend.yaId || !this.wasSend.gaId) {
      const u = setInterval(() => {
        if (t || (t = Cr.getMetrikaId()), r || (r = Cr.getGAId()), this.confirmCookies(t, r), this.wasSend.yaId && this.wasSend.gaId)
          clearInterval(u);
        else if (a > n)
          throw clearInterval(u), new Error(`no_cookies_found; navigator.cookieEnabled: ${navigator && navigator.cookieEnabled}`);
        a++;
      }, 1e3);
    }
  }
  confirmCookies(t, r) {
    t && !this.wasSend.yaId && r && !this.wasSend.gaId ? (this.setAnalytics({ yaId: t, gaId: r }), this.wasSend.yaId = t, this.wasSend.gaId = r) : t && !this.wasSend.yaId ? (this.setAnalytics({ yaId: t }), this.wasSend.yaId = t) : r && !this.wasSend.gaId && (this.setAnalytics({ gaId: r }), this.wasSend.gaId = r);
  }
  setAnalytics({ yaId: t, gaId: r }) {
    const n = this.clientUuid;
    if (this.api && this.api.setAnalytics)
      this.api.setAnalytics({ yaId: t, gaId: r, clientUuid: n });
    else
      throw new Error("no correct api provided");
  }
  getOurClientUuid() {
    return this._clientUuid || Tu.get("clientUuid");
  }
  static getMetrikaId() {
    return Tu.get("_ym_uid");
  }
  static getGAId() {
    return Tu.get("_ga");
  }
  getClientUuid() {
    return this.clientUuid;
  }
}
var Zo, ec;
function Lr() {
  return ec || (ec = 1, Zo = TypeError), Zo;
}
const gg = {}, yg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gg
}, Symbol.toStringTag, { value: "Module" })), vg = /* @__PURE__ */ pg(yg);
var ku, tc;
function Ha() {
  if (tc) return ku;
  tc = 1;
  var e = typeof Map == "function" && Map.prototype, t = Object.getOwnPropertyDescriptor && e ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, r = e && t && typeof t.get == "function" ? t.get : null, n = e && Map.prototype.forEach, a = typeof Set == "function" && Set.prototype, u = Object.getOwnPropertyDescriptor && a ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, i = a && u && typeof u.get == "function" ? u.get : null, s = a && Set.prototype.forEach, o = typeof WeakMap == "function" && WeakMap.prototype, c = o ? WeakMap.prototype.has : null, f = typeof WeakSet == "function" && WeakSet.prototype, g = f ? WeakSet.prototype.has : null, p = typeof WeakRef == "function" && WeakRef.prototype, h = p ? WeakRef.prototype.deref : null, v = Boolean.prototype.valueOf, S = Object.prototype.toString, E = Function.prototype.toString, d = String.prototype.match, m = String.prototype.slice, l = String.prototype.replace, y = String.prototype.toUpperCase, b = String.prototype.toLowerCase, w = RegExp.prototype.test, _ = Array.prototype.concat, k = Array.prototype.join, O = Array.prototype.slice, D = Math.floor, A = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, P = Object.getOwnPropertySymbols, j = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, F = typeof Symbol == "function" && typeof Symbol.iterator == "object", z = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === F || !0) ? Symbol.toStringTag : null, ee = Object.prototype.propertyIsEnumerable, ie = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(C) {
    return C.__proto__;
  } : null);
  function M(C, T) {
    if (C === 1 / 0 || C === -1 / 0 || C !== C || C && C > -1e3 && C < 1e3 || w.call(/e/, T))
      return T;
    var J = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof C == "number") {
      var ne = C < 0 ? -D(-C) : D(C);
      if (ne !== C) {
        var ue = String(ne), G = m.call(T, ue.length + 1);
        return l.call(ue, J, "$&_") + "." + l.call(l.call(G, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return l.call(T, J, "$&_");
  }
  var ae = vg, me = ae.custom, te = Ne(me) ? me : null, le = {
    __proto__: null,
    double: '"',
    single: "'"
  }, ke = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  ku = function C(T, J, ne, ue) {
    var G = J || {};
    if (Ie(G, "quoteStyle") && !Ie(le, G.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (Ie(G, "maxStringLength") && (typeof G.maxStringLength == "number" ? G.maxStringLength < 0 && G.maxStringLength !== 1 / 0 : G.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var Pt = Ie(G, "customInspect") ? G.customInspect : !0;
    if (typeof Pt != "boolean" && Pt !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (Ie(G, "indent") && G.indent !== null && G.indent !== "	" && !(parseInt(G.indent, 10) === G.indent && G.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (Ie(G, "numericSeparator") && typeof G.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var Yt = G.numericSeparator;
    if (typeof T > "u")
      return "undefined";
    if (T === null)
      return "null";
    if (typeof T == "boolean")
      return T ? "true" : "false";
    if (typeof T == "string")
      return yo(T, G);
    if (typeof T == "number") {
      if (T === 0)
        return 1 / 0 / T > 0 ? "0" : "-0";
      var Ge = String(T);
      return Yt ? M(T, Ge) : Ge;
    }
    if (typeof T == "bigint") {
      var Bt = String(T) + "n";
      return Yt ? M(T, Bt) : Bt;
    }
    var fu = typeof G.depth > "u" ? 5 : G.depth;
    if (typeof ne > "u" && (ne = 0), ne >= fu && fu > 0 && typeof T == "object")
      return Ae(T) ? "[Array]" : "[Object]";
    var pr = qp(G, ne);
    if (typeof ue > "u")
      ue = [];
    else if (De(ue, T) >= 0)
      return "[Circular]";
    function nt(hr, xn, Vp) {
      if (xn && (ue = O.call(ue), ue.push(xn)), Vp) {
        var ko = {
          depth: G.depth
        };
        return Ie(G, "quoteStyle") && (ko.quoteStyle = G.quoteStyle), C(hr, ko, ne + 1, ue);
      }
      return C(hr, G, ne + 1, ue);
    }
    if (typeof T == "function" && !W(T)) {
      var bo = rt(T), _o = Dn(T, nt);
      return "[Function" + (bo ? ": " + bo : " (anonymous)") + "]" + (_o.length > 0 ? " { " + k.call(_o, ", ") + " }" : "");
    }
    if (Ne(T)) {
      var So = F ? l.call(String(T), /^(Symbol\(.*\))_[^)]*$/, "$1") : j.call(T);
      return typeof T == "object" && !F ? Xr(So) : So;
    }
    if (gt(T)) {
      for (var Jr = "<" + b.call(String(T.nodeName)), lu = T.attributes || [], Rn = 0; Rn < lu.length; Rn++)
        Jr += " " + lu[Rn].name + "=" + we(ve(lu[Rn].value), "double", G);
      return Jr += ">", T.childNodes && T.childNodes.length && (Jr += "..."), Jr += "</" + b.call(String(T.nodeName)) + ">", Jr;
    }
    if (Ae(T)) {
      if (T.length === 0)
        return "[]";
      var pu = Dn(T, nt);
      return pr && !Wp(pu) ? "[" + du(pu, pr) + "]" : "[ " + k.call(pu, ", ") + " ]";
    }
    if (Q(T)) {
      var hu = Dn(T, nt);
      return !("cause" in Error.prototype) && "cause" in T && !ee.call(T, "cause") ? "{ [" + String(T) + "] " + k.call(_.call("[cause]: " + nt(T.cause), hu), ", ") + " }" : hu.length === 0 ? "[" + String(T) + "]" : "{ [" + String(T) + "] " + k.call(hu, ", ") + " }";
    }
    if (typeof T == "object" && Pt) {
      if (te && typeof T[te] == "function" && ae)
        return ae(T, {
          depth: fu - ne
        });
      if (Pt !== "symbol" && typeof T.inspect == "function")
        return T.inspect();
    }
    if (ht(T)) {
      var wo = [];
      return n && n.call(T, function(hr, xn) {
        wo.push(nt(xn, T, !0) + " => " + nt(hr, T));
      }), vo("Map", r.call(T), wo, pr);
    }
    if (Yr(T)) {
      var Eo = [];
      return s && s.call(T, function(hr) {
        Eo.push(nt(hr, T));
      }), vo("Set", i.call(T), Eo, pr);
    }
    if (st(T))
      return cu("WeakMap");
    if (ou(T))
      return cu("WeakSet");
    if (mt(T))
      return cu("WeakRef");
    if (se(T))
      return Xr(nt(Number(T)));
    if (oe(T))
      return Xr(nt(A.call(T)));
    if (pe(T))
      return Xr(v.call(T));
    if (Y(T))
      return Xr(nt(String(T)));
    if (typeof window < "u" && T === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && T === globalThis || typeof Jo < "u" && T === Jo)
      return "{ [object globalThis] }";
    if (!Be(T) && !W(T)) {
      var mu = Dn(T, nt), Co = ie ? ie(T) === Object.prototype : T instanceof Object || T.constructor === Object, gu = T instanceof Object ? "" : "null prototype", To = !Co && z && Object(T) === T && z in T ? m.call(be(T), 8, -1) : gu ? "Object" : "", zp = Co || typeof T.constructor != "function" ? "" : T.constructor.name ? T.constructor.name + " " : "", yu = zp + (To || gu ? "[" + k.call(_.call([], To || [], gu || []), ": ") + "] " : "");
      return mu.length === 0 ? yu + "{}" : pr ? yu + "{" + du(mu, pr) + "}" : yu + "{ " + k.call(mu, ", ") + " }";
    }
    return String(T);
  };
  function we(C, T, J) {
    var ne = J.quoteStyle || T, ue = le[ne];
    return ue + C + ue;
  }
  function ve(C) {
    return l.call(String(C), /"/g, "&quot;");
  }
  function fe(C) {
    return !z || !(typeof C == "object" && (z in C || typeof C[z] < "u"));
  }
  function Ae(C) {
    return be(C) === "[object Array]" && fe(C);
  }
  function Be(C) {
    return be(C) === "[object Date]" && fe(C);
  }
  function W(C) {
    return be(C) === "[object RegExp]" && fe(C);
  }
  function Q(C) {
    return be(C) === "[object Error]" && fe(C);
  }
  function Y(C) {
    return be(C) === "[object String]" && fe(C);
  }
  function se(C) {
    return be(C) === "[object Number]" && fe(C);
  }
  function pe(C) {
    return be(C) === "[object Boolean]" && fe(C);
  }
  function Ne(C) {
    if (F)
      return C && typeof C == "object" && C instanceof Symbol;
    if (typeof C == "symbol")
      return !0;
    if (!C || typeof C != "object" || !j)
      return !1;
    try {
      return j.call(C), !0;
    } catch {
    }
    return !1;
  }
  function oe(C) {
    if (!C || typeof C != "object" || !A)
      return !1;
    try {
      return A.call(C), !0;
    } catch {
    }
    return !1;
  }
  var it = Object.prototype.hasOwnProperty || function(C) {
    return C in this;
  };
  function Ie(C, T) {
    return it.call(C, T);
  }
  function be(C) {
    return S.call(C);
  }
  function rt(C) {
    if (C.name)
      return C.name;
    var T = d.call(E.call(C), /^function\s*([\w$]+)/);
    return T ? T[1] : null;
  }
  function De(C, T) {
    if (C.indexOf)
      return C.indexOf(T);
    for (var J = 0, ne = C.length; J < ne; J++)
      if (C[J] === T)
        return J;
    return -1;
  }
  function ht(C) {
    if (!r || !C || typeof C != "object")
      return !1;
    try {
      r.call(C);
      try {
        i.call(C);
      } catch {
        return !0;
      }
      return C instanceof Map;
    } catch {
    }
    return !1;
  }
  function st(C) {
    if (!c || !C || typeof C != "object")
      return !1;
    try {
      c.call(C, c);
      try {
        g.call(C, g);
      } catch {
        return !0;
      }
      return C instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function mt(C) {
    if (!h || !C || typeof C != "object")
      return !1;
    try {
      return h.call(C), !0;
    } catch {
    }
    return !1;
  }
  function Yr(C) {
    if (!i || !C || typeof C != "object")
      return !1;
    try {
      i.call(C);
      try {
        r.call(C);
      } catch {
        return !0;
      }
      return C instanceof Set;
    } catch {
    }
    return !1;
  }
  function ou(C) {
    if (!g || !C || typeof C != "object")
      return !1;
    try {
      g.call(C, g);
      try {
        c.call(C, c);
      } catch {
        return !0;
      }
      return C instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function gt(C) {
    return !C || typeof C != "object" ? !1 : typeof HTMLElement < "u" && C instanceof HTMLElement ? !0 : typeof C.nodeName == "string" && typeof C.getAttribute == "function";
  }
  function yo(C, T) {
    if (C.length > T.maxStringLength) {
      var J = C.length - T.maxStringLength, ne = "... " + J + " more character" + (J > 1 ? "s" : "");
      return yo(m.call(C, 0, T.maxStringLength), T) + ne;
    }
    var ue = ke[T.quoteStyle || "single"];
    ue.lastIndex = 0;
    var G = l.call(l.call(C, ue, "\\$1"), /[\x00-\x1f]/g, Gp);
    return we(G, "single", T);
  }
  function Gp(C) {
    var T = C.charCodeAt(0), J = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[T];
    return J ? "\\" + J : "\\x" + (T < 16 ? "0" : "") + y.call(T.toString(16));
  }
  function Xr(C) {
    return "Object(" + C + ")";
  }
  function cu(C) {
    return C + " { ? }";
  }
  function vo(C, T, J, ne) {
    var ue = ne ? du(J, ne) : k.call(J, ", ");
    return C + " (" + T + ") {" + ue + "}";
  }
  function Wp(C) {
    for (var T = 0; T < C.length; T++)
      if (De(C[T], `
`) >= 0)
        return !1;
    return !0;
  }
  function qp(C, T) {
    var J;
    if (C.indent === "	")
      J = "	";
    else if (typeof C.indent == "number" && C.indent > 0)
      J = k.call(Array(C.indent + 1), " ");
    else
      return null;
    return {
      base: J,
      prev: k.call(Array(T + 1), J)
    };
  }
  function du(C, T) {
    if (C.length === 0)
      return "";
    var J = `
` + T.prev + T.base;
    return J + k.call(C, "," + J) + `
` + T.prev;
  }
  function Dn(C, T) {
    var J = Ae(C), ne = [];
    if (J) {
      ne.length = C.length;
      for (var ue = 0; ue < C.length; ue++)
        ne[ue] = Ie(C, ue) ? T(C[ue], C) : "";
    }
    var G = typeof P == "function" ? P(C) : [], Pt;
    if (F) {
      Pt = {};
      for (var Yt = 0; Yt < G.length; Yt++)
        Pt["$" + G[Yt]] = G[Yt];
    }
    for (var Ge in C)
      Ie(C, Ge) && (J && String(Number(Ge)) === Ge && Ge < C.length || F && Pt["$" + Ge] instanceof Symbol || (w.call(/[^\w$]/, Ge) ? ne.push(T(Ge, C) + ": " + T(C[Ge], C)) : ne.push(Ge + ": " + T(C[Ge], C))));
    if (typeof P == "function")
      for (var Bt = 0; Bt < G.length; Bt++)
        ee.call(C, G[Bt]) && ne.push("[" + T(G[Bt]) + "]: " + T(C[G[Bt]], C));
    return ne;
  }
  return ku;
}
var Au, rc;
function bg() {
  if (rc) return Au;
  rc = 1;
  var e = /* @__PURE__ */ Ha(), t = /* @__PURE__ */ Lr(), r = function(s, o, c) {
    for (var f = s, g; (g = f.next) != null; f = g)
      if (g.key === o)
        return f.next = g.next, c || (g.next = /** @type {NonNullable<typeof list.next>} */
        s.next, s.next = g), g;
  }, n = function(s, o) {
    if (s) {
      var c = r(s, o);
      return c && c.value;
    }
  }, a = function(s, o, c) {
    var f = r(s, o);
    f ? f.value = c : s.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: o,
      next: s.next,
      value: c
    };
  }, u = function(s, o) {
    return s ? !!r(s, o) : !1;
  }, i = function(s, o) {
    if (s)
      return r(s, o, !0);
  };
  return Au = function() {
    var s, o = {
      assert: function(c) {
        if (!o.has(c))
          throw new t("Side channel does not contain " + e(c));
      },
      delete: function(c) {
        var f = s && s.next, g = i(s, c);
        return g && f && f === g && (s = void 0), !!g;
      },
      get: function(c) {
        return n(s, c);
      },
      has: function(c) {
        return u(s, c);
      },
      set: function(c, f) {
        s || (s = {
          next: void 0
        }), a(
          /** @type {NonNullable<typeof $o>} */
          s,
          c,
          f
        );
      }
    };
    return o;
  }, Au;
}
var nc, ac;
function vl() {
  return ac || (ac = 1, nc = Object), nc;
}
var uc, ic;
function _g() {
  return ic || (ic = 1, uc = Error), uc;
}
var sc, oc;
function Sg() {
  return oc || (oc = 1, sc = EvalError), sc;
}
var cc, dc;
function wg() {
  return dc || (dc = 1, cc = RangeError), cc;
}
var fc, lc;
function Eg() {
  return lc || (lc = 1, fc = ReferenceError), fc;
}
var pc, hc;
function Cg() {
  return hc || (hc = 1, pc = SyntaxError), pc;
}
var mc, gc;
function Tg() {
  return gc || (gc = 1, mc = URIError), mc;
}
var yc, vc;
function kg() {
  return vc || (vc = 1, yc = Math.abs), yc;
}
var bc, _c;
function Ag() {
  return _c || (_c = 1, bc = Math.floor), bc;
}
var Sc, wc;
function Og() {
  return wc || (wc = 1, Sc = Math.max), Sc;
}
var Ec, Cc;
function Ig() {
  return Cc || (Cc = 1, Ec = Math.min), Ec;
}
var Tc, kc;
function Pg() {
  return kc || (kc = 1, Tc = Math.pow), Tc;
}
var Ac, Oc;
function Bg() {
  return Oc || (Oc = 1, Ac = Math.round), Ac;
}
var Ic, Pc;
function Ng() {
  return Pc || (Pc = 1, Ic = Number.isNaN || function(e) {
    return e !== e;
  }), Ic;
}
var Ou, Bc;
function Dg() {
  if (Bc) return Ou;
  Bc = 1;
  var e = /* @__PURE__ */ Ng();
  return Ou = function(t) {
    return e(t) || t === 0 ? t : t < 0 ? -1 : 1;
  }, Ou;
}
var Nc, Dc;
function Rg() {
  return Dc || (Dc = 1, Nc = Object.getOwnPropertyDescriptor), Nc;
}
var Iu, Rc;
function bl() {
  if (Rc) return Iu;
  Rc = 1;
  var e = /* @__PURE__ */ Rg();
  if (e)
    try {
      e([], "length");
    } catch {
      e = null;
    }
  return Iu = e, Iu;
}
var Pu, xc;
function xg() {
  if (xc) return Pu;
  xc = 1;
  var e = Object.defineProperty || !1;
  if (e)
    try {
      e({}, "a", {
        value: 1
      });
    } catch {
      e = !1;
    }
  return Pu = e, Pu;
}
var jc, Mc;
function jg() {
  return Mc || (Mc = 1, jc = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var e = {}, t = Symbol("test"), r = Object(t);
    if (typeof t == "string" || Object.prototype.toString.call(t) !== "[object Symbol]" || Object.prototype.toString.call(r) !== "[object Symbol]")
      return !1;
    var n = 42;
    e[t] = n;
    for (var a in e)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
      return !1;
    var u = Object.getOwnPropertySymbols(e);
    if (u.length !== 1 || u[0] !== t || !Object.prototype.propertyIsEnumerable.call(e, t))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var i = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(e, t)
      );
      if (i.value !== n || i.enumerable !== !0)
        return !1;
    }
    return !0;
  }), jc;
}
var Bu, Lc;
function Mg() {
  if (Lc) return Bu;
  Lc = 1;
  var e = typeof Symbol < "u" && Symbol, t = jg();
  return Bu = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, Bu;
}
var Fc, $c;
function _l() {
  return $c || ($c = 1, Fc = typeof Reflect < "u" && Reflect.getPrototypeOf || null), Fc;
}
var Nu, Uc;
function Sl() {
  if (Uc) return Nu;
  Uc = 1;
  var e = /* @__PURE__ */ vl();
  return Nu = e.getPrototypeOf || null, Nu;
}
var Du, Hc;
function Lg() {
  if (Hc) return Du;
  Hc = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, r = Math.max, n = "[object Function]", a = function(s, o) {
    for (var c = [], f = 0; f < s.length; f += 1)
      c[f] = s[f];
    for (var g = 0; g < o.length; g += 1)
      c[g + s.length] = o[g];
    return c;
  }, u = function(s, o) {
    for (var c = [], f = o, g = 0; f < s.length; f += 1, g += 1)
      c[g] = s[f];
    return c;
  }, i = function(s, o) {
    for (var c = "", f = 0; f < s.length; f += 1)
      c += s[f], f + 1 < s.length && (c += o);
    return c;
  };
  return Du = function(s) {
    var o = this;
    if (typeof o != "function" || t.apply(o) !== n)
      throw new TypeError(e + o);
    for (var c = u(arguments, 1), f, g = function() {
      if (this instanceof f) {
        var E = o.apply(this, a(c, arguments));
        return Object(E) === E ? E : this;
      }
      return o.apply(s, a(c, arguments));
    }, p = r(0, o.length - c.length), h = [], v = 0; v < p; v++)
      h[v] = "$" + v;
    if (f = Function("binder", "return function (" + i(h, ",") + "){ return binder.apply(this,arguments); }")(g), o.prototype) {
      var S = function() {
      };
      S.prototype = o.prototype, f.prototype = new S(), S.prototype = null;
    }
    return f;
  }, Du;
}
var Ru, Gc;
function Ga() {
  if (Gc) return Ru;
  Gc = 1;
  var e = Lg();
  return Ru = Function.prototype.bind || e, Ru;
}
var Wc, qc;
function Ms() {
  return qc || (qc = 1, Wc = Function.prototype.call), Wc;
}
var zc, Vc;
function wl() {
  return Vc || (Vc = 1, zc = Function.prototype.apply), zc;
}
var Yc, Xc;
function Fg() {
  return Xc || (Xc = 1, Yc = typeof Reflect < "u" && Reflect && Reflect.apply), Yc;
}
var xu, Jc;
function $g() {
  if (Jc) return xu;
  Jc = 1;
  var e = Ga(), t = wl(), r = Ms(), n = Fg();
  return xu = n || e.call(r, t), xu;
}
var ju, Kc;
function El() {
  if (Kc) return ju;
  Kc = 1;
  var e = Ga(), t = /* @__PURE__ */ Lr(), r = Ms(), n = $g();
  return ju = function(a) {
    if (a.length < 1 || typeof a[0] != "function")
      throw new t("a function is required");
    return n(e, r, a);
  }, ju;
}
var Mu, Qc;
function Ug() {
  if (Qc) return Mu;
  Qc = 1;
  var e = El(), t = /* @__PURE__ */ bl(), r;
  try {
    r = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (i) {
    if (!i || typeof i != "object" || !("code" in i) || i.code !== "ERR_PROTO_ACCESS")
      throw i;
  }
  var n = !!r && t && t(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), a = Object, u = a.getPrototypeOf;
  return Mu = n && typeof n.get == "function" ? e([n.get]) : typeof u == "function" ? (
    /** @type {import('./get')} */
    function(i) {
      return u(i == null ? i : a(i));
    }
  ) : !1, Mu;
}
var Lu, Zc;
function Hg() {
  if (Zc) return Lu;
  Zc = 1;
  var e = _l(), t = Sl(), r = /* @__PURE__ */ Ug();
  return Lu = e ? function(n) {
    return e(n);
  } : t ? function(n) {
    if (!n || typeof n != "object" && typeof n != "function")
      throw new TypeError("getProto: not an object");
    return t(n);
  } : r ? function(n) {
    return r(n);
  } : null, Lu;
}
var Fu, ed;
function Gg() {
  if (ed) return Fu;
  ed = 1;
  var e = Function.prototype.call, t = Object.prototype.hasOwnProperty, r = Ga();
  return Fu = r.call(e, t), Fu;
}
var $u, td;
function Ls() {
  if (td) return $u;
  td = 1;
  var e, t = /* @__PURE__ */ vl(), r = /* @__PURE__ */ _g(), n = /* @__PURE__ */ Sg(), a = /* @__PURE__ */ wg(), u = /* @__PURE__ */ Eg(), i = /* @__PURE__ */ Cg(), s = /* @__PURE__ */ Lr(), o = /* @__PURE__ */ Tg(), c = /* @__PURE__ */ kg(), f = /* @__PURE__ */ Ag(), g = /* @__PURE__ */ Og(), p = /* @__PURE__ */ Ig(), h = /* @__PURE__ */ Pg(), v = /* @__PURE__ */ Bg(), S = /* @__PURE__ */ Dg(), E = Function, d = function(W) {
    try {
      return E('"use strict"; return (' + W + ").constructor;")();
    } catch {
    }
  }, m = /* @__PURE__ */ bl(), l = /* @__PURE__ */ xg(), y = function() {
    throw new s();
  }, b = m ? function() {
    try {
      return arguments.callee, y;
    } catch {
      try {
        return m(arguments, "callee").get;
      } catch {
        return y;
      }
    }
  }() : y, w = Mg()(), _ = Hg(), k = Sl(), O = _l(), D = wl(), A = Ms(), P = {}, j = typeof Uint8Array > "u" || !_ ? e : _(Uint8Array), F = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
    "%ArrayIteratorPrototype%": w && _ ? _([][Symbol.iterator]()) : e,
    "%AsyncFromSyncIteratorPrototype%": e,
    "%AsyncFunction%": P,
    "%AsyncGenerator%": P,
    "%AsyncGeneratorFunction%": P,
    "%AsyncIteratorPrototype%": P,
    "%Atomics%": typeof Atomics > "u" ? e : Atomics,
    "%BigInt%": typeof BigInt > "u" ? e : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? e : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? e : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? e : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": r,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": n,
    "%Float16Array%": typeof Float16Array > "u" ? e : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
    "%Function%": E,
    "%GeneratorFunction%": P,
    "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": w && _ ? _(_([][Symbol.iterator]())) : e,
    "%JSON%": typeof JSON == "object" ? JSON : e,
    "%Map%": typeof Map > "u" ? e : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !w || !_ ? e : _((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": t,
    "%Object.getOwnPropertyDescriptor%": m,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? e : Promise,
    "%Proxy%": typeof Proxy > "u" ? e : Proxy,
    "%RangeError%": a,
    "%ReferenceError%": u,
    "%Reflect%": typeof Reflect > "u" ? e : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? e : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !w || !_ ? e : _((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": w && _ ? _(""[Symbol.iterator]()) : e,
    "%Symbol%": w ? Symbol : e,
    "%SyntaxError%": i,
    "%ThrowTypeError%": b,
    "%TypedArray%": j,
    "%TypeError%": s,
    "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
    "%URIError%": o,
    "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet,
    "%Function.prototype.call%": A,
    "%Function.prototype.apply%": D,
    "%Object.defineProperty%": l,
    "%Object.getPrototypeOf%": k,
    "%Math.abs%": c,
    "%Math.floor%": f,
    "%Math.max%": g,
    "%Math.min%": p,
    "%Math.pow%": h,
    "%Math.round%": v,
    "%Math.sign%": S,
    "%Reflect.getPrototypeOf%": O
  };
  if (_)
    try {
      null.error;
    } catch (W) {
      var z = _(_(W));
      F["%Error.prototype%"] = z;
    }
  var ee = function W(Q) {
    var Y;
    if (Q === "%AsyncFunction%")
      Y = d("async function () {}");
    else if (Q === "%GeneratorFunction%")
      Y = d("function* () {}");
    else if (Q === "%AsyncGeneratorFunction%")
      Y = d("async function* () {}");
    else if (Q === "%AsyncGenerator%") {
      var se = W("%AsyncGeneratorFunction%");
      se && (Y = se.prototype);
    } else if (Q === "%AsyncIteratorPrototype%") {
      var pe = W("%AsyncGenerator%");
      pe && _ && (Y = _(pe.prototype));
    }
    return F[Q] = Y, Y;
  }, ie = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, M = Ga(), ae = /* @__PURE__ */ Gg(), me = M.call(A, Array.prototype.concat), te = M.call(D, Array.prototype.splice), le = M.call(A, String.prototype.replace), ke = M.call(A, String.prototype.slice), we = M.call(A, RegExp.prototype.exec), ve = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, fe = /\\(\\)?/g, Ae = function(W) {
    var Q = ke(W, 0, 1), Y = ke(W, -1);
    if (Q === "%" && Y !== "%")
      throw new i("invalid intrinsic syntax, expected closing `%`");
    if (Y === "%" && Q !== "%")
      throw new i("invalid intrinsic syntax, expected opening `%`");
    var se = [];
    return le(W, ve, function(pe, Ne, oe, it) {
      se[se.length] = oe ? le(it, fe, "$1") : Ne || pe;
    }), se;
  }, Be = function(W, Q) {
    var Y = W, se;
    if (ae(ie, Y) && (se = ie[Y], Y = "%" + se[0] + "%"), ae(F, Y)) {
      var pe = F[Y];
      if (pe === P && (pe = ee(Y)), typeof pe > "u" && !Q)
        throw new s("intrinsic " + W + " exists, but is not available. Please file an issue!");
      return {
        alias: se,
        name: Y,
        value: pe
      };
    }
    throw new i("intrinsic " + W + " does not exist!");
  };
  return $u = function(W, Q) {
    if (typeof W != "string" || W.length === 0)
      throw new s("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof Q != "boolean")
      throw new s('"allowMissing" argument must be a boolean');
    if (we(/^%?[^%]*%?$/, W) === null)
      throw new i("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var Y = Ae(W), se = Y.length > 0 ? Y[0] : "", pe = Be("%" + se + "%", Q), Ne = pe.name, oe = pe.value, it = !1, Ie = pe.alias;
    Ie && (se = Ie[0], te(Y, me([0, 1], Ie)));
    for (var be = 1, rt = !0; be < Y.length; be += 1) {
      var De = Y[be], ht = ke(De, 0, 1), st = ke(De, -1);
      if ((ht === '"' || ht === "'" || ht === "`" || st === '"' || st === "'" || st === "`") && ht !== st)
        throw new i("property names with quotes must have matching quotes");
      if ((De === "constructor" || !rt) && (it = !0), se += "." + De, Ne = "%" + se + "%", ae(F, Ne))
        oe = F[Ne];
      else if (oe != null) {
        if (!(De in oe)) {
          if (!Q)
            throw new s("base intrinsic for " + W + " exists, but the property is not available.");
          return;
        }
        if (m && be + 1 >= Y.length) {
          var mt = m(oe, De);
          rt = !!mt, rt && "get" in mt && !("originalValue" in mt.get) ? oe = mt.get : oe = oe[De];
        } else
          rt = ae(oe, De), oe = oe[De];
        rt && !it && (F[Ne] = oe);
      }
    }
    return oe;
  }, $u;
}
var Uu, rd;
function Cl() {
  if (rd) return Uu;
  rd = 1;
  var e = /* @__PURE__ */ Ls(), t = El(), r = t([e("%String.prototype.indexOf%")]);
  return Uu = function(n, a) {
    var u = (
      /** @type {Parameters<typeof callBindBasic>[0][0]} */
      e(n, !!a)
    );
    return typeof u == "function" && r(n, ".prototype.") > -1 ? t([u]) : u;
  }, Uu;
}
var Hu, nd;
function Tl() {
  if (nd) return Hu;
  nd = 1;
  var e = /* @__PURE__ */ Ls(), t = /* @__PURE__ */ Cl(), r = /* @__PURE__ */ Ha(), n = /* @__PURE__ */ Lr(), a = e("%Map%", !0), u = t("Map.prototype.get", !0), i = t("Map.prototype.set", !0), s = t("Map.prototype.has", !0), o = t("Map.prototype.delete", !0), c = t("Map.prototype.size", !0);
  return Hu = !!a && /** @type {Exclude<import('.'), false>} */
  function() {
    var f, g = {
      assert: function(p) {
        if (!g.has(p))
          throw new n("Side channel does not contain " + r(p));
      },
      delete: function(p) {
        if (f) {
          var h = o(f, p);
          return c(f) === 0 && (f = void 0), h;
        }
        return !1;
      },
      get: function(p) {
        if (f)
          return u(f, p);
      },
      has: function(p) {
        return f ? s(f, p) : !1;
      },
      set: function(p, h) {
        f || (f = new a()), i(f, p, h);
      }
    };
    return g;
  }, Hu;
}
var Gu, ad;
function Wg() {
  if (ad) return Gu;
  ad = 1;
  var e = /* @__PURE__ */ Ls(), t = /* @__PURE__ */ Cl(), r = /* @__PURE__ */ Ha(), n = Tl(), a = /* @__PURE__ */ Lr(), u = e("%WeakMap%", !0), i = t("WeakMap.prototype.get", !0), s = t("WeakMap.prototype.set", !0), o = t("WeakMap.prototype.has", !0), c = t("WeakMap.prototype.delete", !0);
  return Gu = u ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var f, g, p = {
        assert: function(h) {
          if (!p.has(h))
            throw new a("Side channel does not contain " + r(h));
        },
        delete: function(h) {
          if (u && h && (typeof h == "object" || typeof h == "function")) {
            if (f)
              return c(f, h);
          } else if (n && g)
            return g.delete(h);
          return !1;
        },
        get: function(h) {
          return u && h && (typeof h == "object" || typeof h == "function") && f ? i(f, h) : g && g.get(h);
        },
        has: function(h) {
          return u && h && (typeof h == "object" || typeof h == "function") && f ? o(f, h) : !!g && g.has(h);
        },
        set: function(h, v) {
          u && h && (typeof h == "object" || typeof h == "function") ? (f || (f = new u()), s(f, h, v)) : n && (g || (g = n()), g.set(h, v));
        }
      };
      return p;
    }
  ) : n, Gu;
}
var Wu, ud;
function qg() {
  if (ud) return Wu;
  ud = 1;
  var e = /* @__PURE__ */ Lr(), t = /* @__PURE__ */ Ha(), r = bg(), n = Tl(), a = Wg(), u = a || n || r;
  return Wu = function() {
    var i, s = {
      assert: function(o) {
        if (!s.has(o))
          throw new e("Side channel does not contain " + t(o));
      },
      delete: function(o) {
        return !!i && i.delete(o);
      },
      get: function(o) {
        return i && i.get(o);
      },
      has: function(o) {
        return !!i && i.has(o);
      },
      set: function(o, c) {
        i || (i = u()), i.set(o, c);
      }
    };
    return s;
  }, Wu;
}
var qu, id;
function Fs() {
  if (id) return qu;
  id = 1;
  var e = String.prototype.replace, t = /%20/g, r = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return qu = {
    default: r.RFC3986,
    formatters: {
      RFC1738: function(n) {
        return e.call(n, t, "+");
      },
      RFC3986: function(n) {
        return String(n);
      }
    },
    RFC1738: r.RFC1738,
    RFC3986: r.RFC3986
  }, qu;
}
var zu, sd;
function kl() {
  if (sd) return zu;
  sd = 1;
  var e = /* @__PURE__ */ Fs(), t = Object.prototype.hasOwnProperty, r = Array.isArray, n = function() {
    for (var E = [], d = 0; d < 256; ++d)
      E.push("%" + ((d < 16 ? "0" : "") + d.toString(16)).toUpperCase());
    return E;
  }(), a = function(E) {
    for (; E.length > 1; ) {
      var d = E.pop(), m = d.obj[d.prop];
      if (r(m)) {
        for (var l = [], y = 0; y < m.length; ++y)
          typeof m[y] < "u" && l.push(m[y]);
        d.obj[d.prop] = l;
      }
    }
  }, u = function(E, d) {
    for (var m = d && d.plainObjects ? {
      __proto__: null
    } : {}, l = 0; l < E.length; ++l)
      typeof E[l] < "u" && (m[l] = E[l]);
    return m;
  }, i = function E(d, m, l) {
    if (!m)
      return d;
    if (typeof m != "object" && typeof m != "function") {
      if (r(d))
        d.push(m);
      else if (d && typeof d == "object")
        (l && (l.plainObjects || l.allowPrototypes) || !t.call(Object.prototype, m)) && (d[m] = !0);
      else
        return [d, m];
      return d;
    }
    if (!d || typeof d != "object")
      return [d].concat(m);
    var y = d;
    return r(d) && !r(m) && (y = u(d, l)), r(d) && r(m) ? (m.forEach(function(b, w) {
      if (t.call(d, w)) {
        var _ = d[w];
        _ && typeof _ == "object" && b && typeof b == "object" ? d[w] = E(_, b, l) : d.push(b);
      } else
        d[w] = b;
    }), d) : Object.keys(m).reduce(function(b, w) {
      var _ = m[w];
      return t.call(b, w) ? b[w] = E(b[w], _, l) : b[w] = _, b;
    }, y);
  }, s = function(E, d) {
    return Object.keys(d).reduce(function(m, l) {
      return m[l] = d[l], m;
    }, E);
  }, o = function(E, d, m) {
    var l = E.replace(/\+/g, " ");
    if (m === "iso-8859-1")
      return l.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(l);
    } catch {
      return l;
    }
  }, c = 1024, f = function(E, d, m, l, y) {
    if (E.length === 0)
      return E;
    var b = E;
    if (typeof E == "symbol" ? b = Symbol.prototype.toString.call(E) : typeof E != "string" && (b = String(E)), m === "iso-8859-1")
      return escape(b).replace(/%u[0-9a-f]{4}/gi, function(P) {
        return "%26%23" + parseInt(P.slice(2), 16) + "%3B";
      });
    for (var w = "", _ = 0; _ < b.length; _ += c) {
      for (var k = b.length >= c ? b.slice(_, _ + c) : b, O = [], D = 0; D < k.length; ++D) {
        var A = k.charCodeAt(D);
        if (A === 45 || A === 46 || A === 95 || A === 126 || A >= 48 && A <= 57 || A >= 65 && A <= 90 || A >= 97 && A <= 122 || y === e.RFC1738 && (A === 40 || A === 41)) {
          O[O.length] = k.charAt(D);
          continue;
        }
        if (A < 128) {
          O[O.length] = n[A];
          continue;
        }
        if (A < 2048) {
          O[O.length] = n[192 | A >> 6] + n[128 | A & 63];
          continue;
        }
        if (A < 55296 || A >= 57344) {
          O[O.length] = n[224 | A >> 12] + n[128 | A >> 6 & 63] + n[128 | A & 63];
          continue;
        }
        D += 1, A = 65536 + ((A & 1023) << 10 | k.charCodeAt(D) & 1023), O[O.length] = n[240 | A >> 18] + n[128 | A >> 12 & 63] + n[128 | A >> 6 & 63] + n[128 | A & 63];
      }
      w += O.join("");
    }
    return w;
  }, g = function(E) {
    for (var d = [{
      obj: {
        o: E
      },
      prop: "o"
    }], m = [], l = 0; l < d.length; ++l)
      for (var y = d[l], b = y.obj[y.prop], w = Object.keys(b), _ = 0; _ < w.length; ++_) {
        var k = w[_], O = b[k];
        typeof O == "object" && O !== null && m.indexOf(O) === -1 && (d.push({
          obj: b,
          prop: k
        }), m.push(O));
      }
    return a(d), E;
  }, p = function(E) {
    return Object.prototype.toString.call(E) === "[object RegExp]";
  }, h = function(E) {
    return !E || typeof E != "object" ? !1 : !!(E.constructor && E.constructor.isBuffer && E.constructor.isBuffer(E));
  }, v = function(E, d) {
    return [].concat(E, d);
  }, S = function(E, d) {
    if (r(E)) {
      for (var m = [], l = 0; l < E.length; l += 1)
        m.push(d(E[l]));
      return m;
    }
    return d(E);
  };
  return zu = {
    arrayToObject: u,
    assign: s,
    combine: v,
    compact: g,
    decode: o,
    encode: f,
    isBuffer: h,
    isRegExp: p,
    maybeMap: S,
    merge: i
  }, zu;
}
var Vu, od;
function zg() {
  if (od) return Vu;
  od = 1;
  var e = qg(), t = /* @__PURE__ */ kl(), r = /* @__PURE__ */ Fs(), n = Object.prototype.hasOwnProperty, a = {
    brackets: function(S) {
      return S + "[]";
    },
    comma: "comma",
    indices: function(S, E) {
      return S + "[" + E + "]";
    },
    repeat: function(S) {
      return S;
    }
  }, u = Array.isArray, i = Array.prototype.push, s = function(S, E) {
    i.apply(S, u(E) ? E : [E]);
  }, o = Date.prototype.toISOString, c = r.default, f = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: t.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: c,
    formatter: r.formatters[c],
    // deprecated
    indices: !1,
    serializeDate: function(S) {
      return o.call(S);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, g = function(S) {
    return typeof S == "string" || typeof S == "number" || typeof S == "boolean" || typeof S == "symbol" || typeof S == "bigint";
  }, p = {}, h = function S(E, d, m, l, y, b, w, _, k, O, D, A, P, j, F, z, ee, ie) {
    for (var M = E, ae = ie, me = 0, te = !1; (ae = ae.get(p)) !== void 0 && !te; ) {
      var le = ae.get(E);
      if (me += 1, typeof le < "u") {
        if (le === me)
          throw new RangeError("Cyclic object value");
        te = !0;
      }
      typeof ae.get(p) > "u" && (me = 0);
    }
    if (typeof O == "function" ? M = O(d, M) : M instanceof Date ? M = P(M) : m === "comma" && u(M) && (M = t.maybeMap(M, function(oe) {
      return oe instanceof Date ? P(oe) : oe;
    })), M === null) {
      if (b)
        return k && !z ? k(d, f.encoder, ee, "key", j) : d;
      M = "";
    }
    if (g(M) || t.isBuffer(M)) {
      if (k) {
        var ke = z ? d : k(d, f.encoder, ee, "key", j);
        return [F(ke) + "=" + F(k(M, f.encoder, ee, "value", j))];
      }
      return [F(d) + "=" + F(String(M))];
    }
    var we = [];
    if (typeof M > "u")
      return we;
    var ve;
    if (m === "comma" && u(M))
      z && k && (M = t.maybeMap(M, k)), ve = [{
        value: M.length > 0 ? M.join(",") || null : void 0
      }];
    else if (u(O))
      ve = O;
    else {
      var fe = Object.keys(M);
      ve = D ? fe.sort(D) : fe;
    }
    var Ae = _ ? String(d).replace(/\./g, "%2E") : String(d), Be = l && u(M) && M.length === 1 ? Ae + "[]" : Ae;
    if (y && u(M) && M.length === 0)
      return Be + "[]";
    for (var W = 0; W < ve.length; ++W) {
      var Q = ve[W], Y = typeof Q == "object" && Q && typeof Q.value < "u" ? Q.value : M[Q];
      if (!(w && Y === null)) {
        var se = A && _ ? String(Q).replace(/\./g, "%2E") : String(Q), pe = u(M) ? typeof m == "function" ? m(Be, se) : Be : Be + (A ? "." + se : "[" + se + "]");
        ie.set(E, me);
        var Ne = e();
        Ne.set(p, ie), s(we, S(Y, pe, m, l, y, b, w, _, m === "comma" && z && u(M) ? null : k, O, D, A, P, j, F, z, ee, Ne));
      }
    }
    return we;
  }, v = function(S) {
    if (!S)
      return f;
    if (typeof S.allowEmptyArrays < "u" && typeof S.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof S.encodeDotInKeys < "u" && typeof S.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (S.encoder !== null && typeof S.encoder < "u" && typeof S.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var E = S.charset || f.charset;
    if (typeof S.charset < "u" && S.charset !== "utf-8" && S.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var d = r.default;
    if (typeof S.format < "u") {
      if (!n.call(r.formatters, S.format))
        throw new TypeError("Unknown format option provided.");
      d = S.format;
    }
    var m = r.formatters[d], l = f.filter;
    (typeof S.filter == "function" || u(S.filter)) && (l = S.filter);
    var y;
    if (S.arrayFormat in a ? y = S.arrayFormat : "indices" in S ? y = S.indices ? "indices" : "repeat" : y = f.arrayFormat, "commaRoundTrip" in S && typeof S.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var b = typeof S.allowDots > "u" ? S.encodeDotInKeys === !0 ? !0 : f.allowDots : !!S.allowDots;
    return {
      addQueryPrefix: typeof S.addQueryPrefix == "boolean" ? S.addQueryPrefix : f.addQueryPrefix,
      allowDots: b,
      allowEmptyArrays: typeof S.allowEmptyArrays == "boolean" ? !!S.allowEmptyArrays : f.allowEmptyArrays,
      arrayFormat: y,
      charset: E,
      charsetSentinel: typeof S.charsetSentinel == "boolean" ? S.charsetSentinel : f.charsetSentinel,
      commaRoundTrip: !!S.commaRoundTrip,
      delimiter: typeof S.delimiter > "u" ? f.delimiter : S.delimiter,
      encode: typeof S.encode == "boolean" ? S.encode : f.encode,
      encodeDotInKeys: typeof S.encodeDotInKeys == "boolean" ? S.encodeDotInKeys : f.encodeDotInKeys,
      encoder: typeof S.encoder == "function" ? S.encoder : f.encoder,
      encodeValuesOnly: typeof S.encodeValuesOnly == "boolean" ? S.encodeValuesOnly : f.encodeValuesOnly,
      filter: l,
      format: d,
      formatter: m,
      serializeDate: typeof S.serializeDate == "function" ? S.serializeDate : f.serializeDate,
      skipNulls: typeof S.skipNulls == "boolean" ? S.skipNulls : f.skipNulls,
      sort: typeof S.sort == "function" ? S.sort : null,
      strictNullHandling: typeof S.strictNullHandling == "boolean" ? S.strictNullHandling : f.strictNullHandling
    };
  };
  return Vu = function(S, E) {
    var d = S, m = v(E), l, y;
    typeof m.filter == "function" ? (y = m.filter, d = y("", d)) : u(m.filter) && (y = m.filter, l = y);
    var b = [];
    if (typeof d != "object" || d === null)
      return "";
    var w = a[m.arrayFormat], _ = w === "comma" && m.commaRoundTrip;
    l || (l = Object.keys(d)), m.sort && l.sort(m.sort);
    for (var k = e(), O = 0; O < l.length; ++O) {
      var D = l[O], A = d[D];
      m.skipNulls && A === null || s(b, h(A, D, w, _, m.allowEmptyArrays, m.strictNullHandling, m.skipNulls, m.encodeDotInKeys, m.encode ? m.encoder : null, m.filter, m.sort, m.allowDots, m.serializeDate, m.format, m.formatter, m.encodeValuesOnly, m.charset, k));
    }
    var P = b.join(m.delimiter), j = m.addQueryPrefix === !0 ? "?" : "";
    return m.charsetSentinel && (m.charset === "iso-8859-1" ? j += "utf8=%26%2310003%3B&" : j += "utf8=%E2%9C%93&"), P.length > 0 ? j + P : "";
  }, Vu;
}
var Yu, cd;
function Vg() {
  if (cd) return Yu;
  cd = 1;
  var e = /* @__PURE__ */ kl(), t = Object.prototype.hasOwnProperty, r = Array.isArray, n = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: e.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1,
    throwOnLimitExceeded: !1
  }, a = function(p) {
    return p.replace(/&#(\d+);/g, function(h, v) {
      return String.fromCharCode(parseInt(v, 10));
    });
  }, u = function(p, h, v) {
    if (p && typeof p == "string" && h.comma && p.indexOf(",") > -1)
      return p.split(",");
    if (h.throwOnLimitExceeded && v >= h.arrayLimit)
      throw new RangeError("Array limit exceeded. Only " + h.arrayLimit + " element" + (h.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
    return p;
  }, i = "utf8=%26%2310003%3B", s = "utf8=%E2%9C%93", o = function(p, h) {
    var v = {
      __proto__: null
    }, S = h.ignoreQueryPrefix ? p.replace(/^\?/, "") : p;
    S = S.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var E = h.parameterLimit === 1 / 0 ? void 0 : h.parameterLimit, d = S.split(h.delimiter, h.throwOnLimitExceeded ? E + 1 : E);
    if (h.throwOnLimitExceeded && d.length > E)
      throw new RangeError("Parameter limit exceeded. Only " + E + " parameter" + (E === 1 ? "" : "s") + " allowed.");
    var m = -1, l, y = h.charset;
    if (h.charsetSentinel)
      for (l = 0; l < d.length; ++l)
        d[l].indexOf("utf8=") === 0 && (d[l] === s ? y = "utf-8" : d[l] === i && (y = "iso-8859-1"), m = l, l = d.length);
    for (l = 0; l < d.length; ++l)
      if (l !== m) {
        var b = d[l], w = b.indexOf("]="), _ = w === -1 ? b.indexOf("=") : w + 1, k, O;
        _ === -1 ? (k = h.decoder(b, n.decoder, y, "key"), O = h.strictNullHandling ? null : "") : (k = h.decoder(b.slice(0, _), n.decoder, y, "key"), O = e.maybeMap(u(b.slice(_ + 1), h, r(v[k]) ? v[k].length : 0), function(A) {
          return h.decoder(A, n.decoder, y, "value");
        })), O && h.interpretNumericEntities && y === "iso-8859-1" && (O = a(String(O))), b.indexOf("[]=") > -1 && (O = r(O) ? [O] : O);
        var D = t.call(v, k);
        D && h.duplicates === "combine" ? v[k] = e.combine(v[k], O) : (!D || h.duplicates === "last") && (v[k] = O);
      }
    return v;
  }, c = function(p, h, v, S) {
    var E = 0;
    if (p.length > 0 && p[p.length - 1] === "[]") {
      var d = p.slice(0, -1).join("");
      E = Array.isArray(h) && h[d] ? h[d].length : 0;
    }
    for (var m = S ? h : u(h, v, E), l = p.length - 1; l >= 0; --l) {
      var y, b = p[l];
      if (b === "[]" && v.parseArrays)
        y = v.allowEmptyArrays && (m === "" || v.strictNullHandling && m === null) ? [] : e.combine([], m);
      else {
        y = v.plainObjects ? {
          __proto__: null
        } : {};
        var w = b.charAt(0) === "[" && b.charAt(b.length - 1) === "]" ? b.slice(1, -1) : b, _ = v.decodeDotInKeys ? w.replace(/%2E/g, ".") : w, k = parseInt(_, 10);
        !v.parseArrays && _ === "" ? y = {
          0: m
        } : !isNaN(k) && b !== _ && String(k) === _ && k >= 0 && v.parseArrays && k <= v.arrayLimit ? (y = [], y[k] = m) : _ !== "__proto__" && (y[_] = m);
      }
      m = y;
    }
    return m;
  }, f = function(p, h, v, S) {
    if (p) {
      var E = v.allowDots ? p.replace(/\.([^.[]+)/g, "[$1]") : p, d = /(\[[^[\]]*])/, m = /(\[[^[\]]*])/g, l = v.depth > 0 && d.exec(E), y = l ? E.slice(0, l.index) : E, b = [];
      if (y) {
        if (!v.plainObjects && t.call(Object.prototype, y) && !v.allowPrototypes)
          return;
        b.push(y);
      }
      for (var w = 0; v.depth > 0 && (l = m.exec(E)) !== null && w < v.depth; ) {
        if (w += 1, !v.plainObjects && t.call(Object.prototype, l[1].slice(1, -1)) && !v.allowPrototypes)
          return;
        b.push(l[1]);
      }
      if (l) {
        if (v.strictDepth === !0)
          throw new RangeError("Input depth exceeded depth option of " + v.depth + " and strictDepth is true");
        b.push("[" + E.slice(l.index) + "]");
      }
      return c(b, h, v, S);
    }
  }, g = function(p) {
    if (!p)
      return n;
    if (typeof p.allowEmptyArrays < "u" && typeof p.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof p.decodeDotInKeys < "u" && typeof p.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (p.decoder !== null && typeof p.decoder < "u" && typeof p.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof p.charset < "u" && p.charset !== "utf-8" && p.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    if (typeof p.throwOnLimitExceeded < "u" && typeof p.throwOnLimitExceeded != "boolean")
      throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
    var h = typeof p.charset > "u" ? n.charset : p.charset, v = typeof p.duplicates > "u" ? n.duplicates : p.duplicates;
    if (v !== "combine" && v !== "first" && v !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var S = typeof p.allowDots > "u" ? p.decodeDotInKeys === !0 ? !0 : n.allowDots : !!p.allowDots;
    return {
      allowDots: S,
      allowEmptyArrays: typeof p.allowEmptyArrays == "boolean" ? !!p.allowEmptyArrays : n.allowEmptyArrays,
      allowPrototypes: typeof p.allowPrototypes == "boolean" ? p.allowPrototypes : n.allowPrototypes,
      allowSparse: typeof p.allowSparse == "boolean" ? p.allowSparse : n.allowSparse,
      arrayLimit: typeof p.arrayLimit == "number" ? p.arrayLimit : n.arrayLimit,
      charset: h,
      charsetSentinel: typeof p.charsetSentinel == "boolean" ? p.charsetSentinel : n.charsetSentinel,
      comma: typeof p.comma == "boolean" ? p.comma : n.comma,
      decodeDotInKeys: typeof p.decodeDotInKeys == "boolean" ? p.decodeDotInKeys : n.decodeDotInKeys,
      decoder: typeof p.decoder == "function" ? p.decoder : n.decoder,
      delimiter: typeof p.delimiter == "string" || e.isRegExp(p.delimiter) ? p.delimiter : n.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof p.depth == "number" || p.depth === !1 ? +p.depth : n.depth,
      duplicates: v,
      ignoreQueryPrefix: p.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof p.interpretNumericEntities == "boolean" ? p.interpretNumericEntities : n.interpretNumericEntities,
      parameterLimit: typeof p.parameterLimit == "number" ? p.parameterLimit : n.parameterLimit,
      parseArrays: p.parseArrays !== !1,
      plainObjects: typeof p.plainObjects == "boolean" ? p.plainObjects : n.plainObjects,
      strictDepth: typeof p.strictDepth == "boolean" ? !!p.strictDepth : n.strictDepth,
      strictNullHandling: typeof p.strictNullHandling == "boolean" ? p.strictNullHandling : n.strictNullHandling,
      throwOnLimitExceeded: typeof p.throwOnLimitExceeded == "boolean" ? p.throwOnLimitExceeded : !1
    };
  };
  return Yu = function(p, h) {
    var v = g(h);
    if (p === "" || p === null || typeof p > "u")
      return v.plainObjects ? {
        __proto__: null
      } : {};
    for (var S = typeof p == "string" ? o(p, v) : p, E = v.plainObjects ? {
      __proto__: null
    } : {}, d = Object.keys(S), m = 0; m < d.length; ++m) {
      var l = d[m], y = f(l, S[l], v, typeof p == "string");
      E = e.merge(E, y, v);
    }
    return v.allowSparse === !0 ? E : e.compact(E);
  }, Yu;
}
var Xu, dd;
function Yg() {
  if (dd) return Xu;
  dd = 1;
  var e = /* @__PURE__ */ zg(), t = /* @__PURE__ */ Vg(), r = /* @__PURE__ */ Fs();
  return Xu = {
    formats: r,
    parse: t,
    stringify: e
  }, Xu;
}
var Xg = /* @__PURE__ */ Yg(), Ln = { exports: {} }, fd, ld;
function Al() {
  return ld || (ld = 1, fd = function(e, t) {
    return function() {
      for (var r = new Array(arguments.length), n = 0; n < r.length; n++)
        r[n] = arguments[n];
      return e.apply(t, r);
    };
  }), fd;
}
var Ju, pd;
function Xe() {
  if (pd) return Ju;
  pd = 1;
  var e = Al(), t = Object.prototype.toString;
  function r(_) {
    return t.call(_) === "[object Array]";
  }
  function n(_) {
    return typeof _ > "u";
  }
  function a(_) {
    return _ !== null && !n(_) && _.constructor !== null && !n(_.constructor) && typeof _.constructor.isBuffer == "function" && _.constructor.isBuffer(_);
  }
  function u(_) {
    return t.call(_) === "[object ArrayBuffer]";
  }
  function i(_) {
    return typeof FormData < "u" && _ instanceof FormData;
  }
  function s(_) {
    var k;
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? k = ArrayBuffer.isView(_) : k = _ && _.buffer && _.buffer instanceof ArrayBuffer, k;
  }
  function o(_) {
    return typeof _ == "string";
  }
  function c(_) {
    return typeof _ == "number";
  }
  function f(_) {
    return _ !== null && typeof _ == "object";
  }
  function g(_) {
    return t.call(_) === "[object Date]";
  }
  function p(_) {
    return t.call(_) === "[object File]";
  }
  function h(_) {
    return t.call(_) === "[object Blob]";
  }
  function v(_) {
    return t.call(_) === "[object Function]";
  }
  function S(_) {
    return f(_) && v(_.pipe);
  }
  function E(_) {
    return typeof URLSearchParams < "u" && _ instanceof URLSearchParams;
  }
  function d(_) {
    return _.replace(/^\s*/, "").replace(/\s*$/, "");
  }
  function m() {
    return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
  }
  function l(_, k) {
    if (!(_ === null || typeof _ > "u"))
      if (typeof _ != "object" && (_ = [_]), r(_))
        for (var O = 0, D = _.length; O < D; O++)
          k.call(null, _[O], O, _);
      else
        for (var A in _)
          Object.prototype.hasOwnProperty.call(_, A) && k.call(null, _[A], A, _);
  }
  function y() {
    var _ = {};
    function k(A, P) {
      typeof _[P] == "object" && typeof A == "object" ? _[P] = y(_[P], A) : _[P] = A;
    }
    for (var O = 0, D = arguments.length; O < D; O++)
      l(arguments[O], k);
    return _;
  }
  function b() {
    var _ = {};
    function k(A, P) {
      typeof _[P] == "object" && typeof A == "object" ? _[P] = b(_[P], A) : typeof A == "object" ? _[P] = b({}, A) : _[P] = A;
    }
    for (var O = 0, D = arguments.length; O < D; O++)
      l(arguments[O], k);
    return _;
  }
  function w(_, k, O) {
    return l(k, function(D, A) {
      O && typeof D == "function" ? _[A] = e(D, O) : _[A] = D;
    }), _;
  }
  return Ju = {
    isArray: r,
    isArrayBuffer: u,
    isBuffer: a,
    isFormData: i,
    isArrayBufferView: s,
    isString: o,
    isNumber: c,
    isObject: f,
    isUndefined: n,
    isDate: g,
    isFile: p,
    isBlob: h,
    isFunction: v,
    isStream: S,
    isURLSearchParams: E,
    isStandardBrowserEnv: m,
    forEach: l,
    merge: y,
    deepMerge: b,
    extend: w,
    trim: d
  }, Ju;
}
var Ku, hd;
function Ol() {
  if (hd) return Ku;
  hd = 1;
  var e = Xe();
  function t(r) {
    return encodeURIComponent(r).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  }
  return Ku = function(r, n, a) {
    if (!n)
      return r;
    var u;
    if (a)
      u = a(n);
    else if (e.isURLSearchParams(n))
      u = n.toString();
    else {
      var i = [];
      e.forEach(n, function(o, c) {
        o === null || typeof o > "u" || (e.isArray(o) ? c = c + "[]" : o = [o], e.forEach(o, function(f) {
          e.isDate(f) ? f = f.toISOString() : e.isObject(f) && (f = JSON.stringify(f)), i.push(t(c) + "=" + t(f));
        }));
      }), u = i.join("&");
    }
    if (u) {
      var s = r.indexOf("#");
      s !== -1 && (r = r.slice(0, s)), r += (r.indexOf("?") === -1 ? "?" : "&") + u;
    }
    return r;
  }, Ku;
}
var Qu, md;
function Jg() {
  if (md) return Qu;
  md = 1;
  var e = Xe();
  function t() {
    this.handlers = [];
  }
  return t.prototype.use = function(r, n) {
    return this.handlers.push({
      fulfilled: r,
      rejected: n
    }), this.handlers.length - 1;
  }, t.prototype.eject = function(r) {
    this.handlers[r] && (this.handlers[r] = null);
  }, t.prototype.forEach = function(r) {
    e.forEach(this.handlers, function(n) {
      n !== null && r(n);
    });
  }, Qu = t, Qu;
}
var Zu, gd;
function Kg() {
  if (gd) return Zu;
  gd = 1;
  var e = Xe();
  return Zu = function(t, r, n) {
    return e.forEach(n, function(a) {
      t = a(t, r);
    }), t;
  }, Zu;
}
var yd, vd;
function Il() {
  return vd || (vd = 1, yd = function(e) {
    return !!(e && e.__CANCEL__);
  }), yd;
}
var ei, bd;
function Qg() {
  if (bd) return ei;
  bd = 1;
  var e = Xe();
  return ei = function(t, r) {
    e.forEach(t, function(n, a) {
      a !== r && a.toUpperCase() === r.toUpperCase() && (t[r] = n, delete t[a]);
    });
  }, ei;
}
var _d, Sd;
function Zg() {
  return Sd || (Sd = 1, _d = function(e, t, r, n, a) {
    return e.config = t, r && (e.code = r), e.request = n, e.response = a, e.isAxiosError = !0, e.toJSON = function() {
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: this.config,
        code: this.code
      };
    }, e;
  }), _d;
}
var ti, wd;
function Pl() {
  if (wd) return ti;
  wd = 1;
  var e = Zg();
  return ti = function(t, r, n, a, u) {
    var i = new Error(t);
    return e(i, r, n, a, u);
  }, ti;
}
var ri, Ed;
function e3() {
  if (Ed) return ri;
  Ed = 1;
  var e = Pl();
  return ri = function(t, r, n) {
    var a = n.config.validateStatus;
    !a || a(n.status) ? t(n) : r(e("Request failed with status code " + n.status, n.config, null, n.request, n));
  }, ri;
}
var Cd, Td;
function t3() {
  return Td || (Td = 1, Cd = function(e) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
  }), Cd;
}
var kd, Ad;
function r3() {
  return Ad || (Ad = 1, kd = function(e, t) {
    return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
  }), kd;
}
var ni, Od;
function n3() {
  if (Od) return ni;
  Od = 1;
  var e = t3(), t = r3();
  return ni = function(r, n) {
    return r && !e(n) ? t(r, n) : n;
  }, ni;
}
var ai, Id;
function a3() {
  if (Id) return ai;
  Id = 1;
  var e = Xe(), t = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];
  return ai = function(r) {
    var n = {}, a, u, i;
    return r && e.forEach(r.split(`
`), function(s) {
      if (i = s.indexOf(":"), a = e.trim(s.substr(0, i)).toLowerCase(), u = e.trim(s.substr(i + 1)), a) {
        if (n[a] && t.indexOf(a) >= 0)
          return;
        a === "set-cookie" ? n[a] = (n[a] ? n[a] : []).concat([u]) : n[a] = n[a] ? n[a] + ", " + u : u;
      }
    }), n;
  }, ai;
}
var ui, Pd;
function u3() {
  if (Pd) return ui;
  Pd = 1;
  var e = Xe();
  return ui = e.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var t = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a"), n;
      function a(u) {
        var i = u;
        return t && (r.setAttribute("href", i), i = r.href), r.setAttribute("href", i), {
          href: r.href,
          protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
          host: r.host,
          search: r.search ? r.search.replace(/^\?/, "") : "",
          hash: r.hash ? r.hash.replace(/^#/, "") : "",
          hostname: r.hostname,
          port: r.port,
          pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
        };
      }
      return n = a(window.location.href), function(u) {
        var i = e.isString(u) ? a(u) : u;
        return i.protocol === n.protocol && i.host === n.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return function() {
        return !0;
      };
    }()
  ), ui;
}
var ii, Bd;
function i3() {
  if (Bd) return ii;
  Bd = 1;
  var e = Xe();
  return ii = e.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ function() {
      return {
        write: function(t, r, n, a, u, i) {
          var s = [];
          s.push(t + "=" + encodeURIComponent(r)), e.isNumber(n) && s.push("expires=" + new Date(n).toGMTString()), e.isString(a) && s.push("path=" + a), e.isString(u) && s.push("domain=" + u), i === !0 && s.push("secure"), document.cookie = s.join("; ");
        },
        read: function(t) {
          var r = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
          return r ? decodeURIComponent(r[3]) : null;
        },
        remove: function(t) {
          this.write(t, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), ii;
}
var si, Nd;
function s3() {
  if (Nd) return si;
  Nd = 1;
  var e = Xe(), t = e3(), r = Ol(), n = n3(), a = a3(), u = u3(), i = Pl();
  return si = function(s) {
    return new Promise(function(o, c) {
      var f = s.data, g = s.headers;
      e.isFormData(f) && delete g["Content-Type"];
      var p = new XMLHttpRequest();
      if (s.auth) {
        var h = s.auth.username || "", v = s.auth.password || "";
        g.Authorization = "Basic " + btoa(h + ":" + v);
      }
      var S = n(s.baseURL, s.url);
      if (p.open(s.method.toUpperCase(), r(S, s.params, s.paramsSerializer), !0), p.timeout = s.timeout, p.onreadystatechange = function() {
        if (!(!p || p.readyState !== 4) && !(p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0))) {
          var m = "getAllResponseHeaders" in p ? a(p.getAllResponseHeaders()) : null, l = !s.responseType || s.responseType === "text" ? p.responseText : p.response, y = {
            data: l,
            status: p.status,
            statusText: p.statusText,
            headers: m,
            config: s,
            request: p
          };
          t(o, c, y), p = null;
        }
      }, p.onabort = function() {
        p && (c(i("Request aborted", s, "ECONNABORTED", p)), p = null);
      }, p.onerror = function() {
        c(i("Network Error", s, null, p)), p = null;
      }, p.ontimeout = function() {
        var m = "timeout of " + s.timeout + "ms exceeded";
        s.timeoutErrorMessage && (m = s.timeoutErrorMessage), c(i(m, s, "ECONNABORTED", p)), p = null;
      }, e.isStandardBrowserEnv()) {
        var E = i3(), d = (s.withCredentials || u(S)) && s.xsrfCookieName ? E.read(s.xsrfCookieName) : void 0;
        d && (g[s.xsrfHeaderName] = d);
      }
      if ("setRequestHeader" in p && e.forEach(g, function(m, l) {
        typeof f > "u" && l.toLowerCase() === "content-type" ? delete g[l] : p.setRequestHeader(l, m);
      }), e.isUndefined(s.withCredentials) || (p.withCredentials = !!s.withCredentials), s.responseType)
        try {
          p.responseType = s.responseType;
        } catch (m) {
          if (s.responseType !== "json")
            throw m;
        }
      typeof s.onDownloadProgress == "function" && p.addEventListener("progress", s.onDownloadProgress), typeof s.onUploadProgress == "function" && p.upload && p.upload.addEventListener("progress", s.onUploadProgress), s.cancelToken && s.cancelToken.promise.then(function(m) {
        p && (p.abort(), c(m), p = null);
      }), f === void 0 && (f = null), p.send(f);
    });
  }, si;
}
var oi, Dd;
function Bl() {
  if (Dd) return oi;
  Dd = 1;
  var e = Xe(), t = Qg(), r = {
    "Content-Type": "application/x-www-form-urlencoded"
  };
  function n(i, s) {
    !e.isUndefined(i) && e.isUndefined(i["Content-Type"]) && (i["Content-Type"] = s);
  }
  function a() {
    var i;
    return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (i = s3()), i;
  }
  var u = {
    adapter: a(),
    transformRequest: [function(i, s) {
      return t(s, "Accept"), t(s, "Content-Type"), e.isFormData(i) || e.isArrayBuffer(i) || e.isBuffer(i) || e.isStream(i) || e.isFile(i) || e.isBlob(i) ? i : e.isArrayBufferView(i) ? i.buffer : e.isURLSearchParams(i) ? (n(s, "application/x-www-form-urlencoded;charset=utf-8"), i.toString()) : e.isObject(i) ? (n(s, "application/json;charset=utf-8"), JSON.stringify(i)) : i;
    }],
    transformResponse: [function(i) {
      if (typeof i == "string")
        try {
          i = JSON.parse(i);
        } catch {
        }
      return i;
    }],
    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    validateStatus: function(i) {
      return i >= 200 && i < 300;
    }
  };
  return u.headers = {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }, e.forEach(["delete", "get", "head"], function(i) {
    u.headers[i] = {};
  }), e.forEach(["post", "put", "patch"], function(i) {
    u.headers[i] = e.merge(r);
  }), oi = u, oi;
}
var ci, Rd;
function o3() {
  if (Rd) return ci;
  Rd = 1;
  var e = Xe(), t = Kg(), r = Il(), n = Bl();
  function a(u) {
    u.cancelToken && u.cancelToken.throwIfRequested();
  }
  return ci = function(u) {
    a(u), u.headers = u.headers || {}, u.data = t(u.data, u.headers, u.transformRequest), u.headers = e.merge(u.headers.common || {}, u.headers[u.method] || {}, u.headers), e.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function(s) {
      delete u.headers[s];
    });
    var i = u.adapter || n.adapter;
    return i(u).then(function(s) {
      return a(u), s.data = t(s.data, s.headers, u.transformResponse), s;
    }, function(s) {
      return r(s) || (a(u), s && s.response && (s.response.data = t(s.response.data, s.response.headers, u.transformResponse))), Promise.reject(s);
    });
  }, ci;
}
var di, xd;
function Nl() {
  if (xd) return di;
  xd = 1;
  var e = Xe();
  return di = function(t, r) {
    r = r || {};
    var n = {}, a = ["url", "method", "params", "data"], u = ["headers", "auth", "proxy"], i = ["baseURL", "url", "transformRequest", "transformResponse", "paramsSerializer", "timeout", "withCredentials", "adapter", "responseType", "xsrfCookieName", "xsrfHeaderName", "onUploadProgress", "onDownloadProgress", "maxContentLength", "validateStatus", "maxRedirects", "httpAgent", "httpsAgent", "cancelToken", "socketPath"];
    e.forEach(a, function(c) {
      typeof r[c] < "u" && (n[c] = r[c]);
    }), e.forEach(u, function(c) {
      e.isObject(r[c]) ? n[c] = e.deepMerge(t[c], r[c]) : typeof r[c] < "u" ? n[c] = r[c] : e.isObject(t[c]) ? n[c] = e.deepMerge(t[c]) : typeof t[c] < "u" && (n[c] = t[c]);
    }), e.forEach(i, function(c) {
      typeof r[c] < "u" ? n[c] = r[c] : typeof t[c] < "u" && (n[c] = t[c]);
    });
    var s = a.concat(u).concat(i), o = Object.keys(r).filter(function(c) {
      return s.indexOf(c) === -1;
    });
    return e.forEach(o, function(c) {
      typeof r[c] < "u" ? n[c] = r[c] : typeof t[c] < "u" && (n[c] = t[c]);
    }), n;
  }, di;
}
var fi, jd;
function c3() {
  if (jd) return fi;
  jd = 1;
  var e = Xe(), t = Ol(), r = Jg(), n = o3(), a = Nl();
  function u(i) {
    this.defaults = i, this.interceptors = {
      request: new r(),
      response: new r()
    };
  }
  return u.prototype.request = function(i) {
    typeof i == "string" ? (i = arguments[1] || {}, i.url = arguments[0]) : i = i || {}, i = a(this.defaults, i), i.method ? i.method = i.method.toLowerCase() : this.defaults.method ? i.method = this.defaults.method.toLowerCase() : i.method = "get";
    var s = [n, void 0], o = Promise.resolve(i);
    for (this.interceptors.request.forEach(function(c) {
      s.unshift(c.fulfilled, c.rejected);
    }), this.interceptors.response.forEach(function(c) {
      s.push(c.fulfilled, c.rejected);
    }); s.length; )
      o = o.then(s.shift(), s.shift());
    return o;
  }, u.prototype.getUri = function(i) {
    return i = a(this.defaults, i), t(i.url, i.params, i.paramsSerializer).replace(/^\?/, "");
  }, e.forEach(["delete", "get", "head", "options"], function(i) {
    u.prototype[i] = function(s, o) {
      return this.request(e.merge(o || {}, {
        method: i,
        url: s
      }));
    };
  }), e.forEach(["post", "put", "patch"], function(i) {
    u.prototype[i] = function(s, o, c) {
      return this.request(e.merge(c || {}, {
        method: i,
        url: s,
        data: o
      }));
    };
  }), fi = u, fi;
}
var li, Md;
function Dl() {
  if (Md) return li;
  Md = 1;
  function e(t) {
    this.message = t;
  }
  return e.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, e.prototype.__CANCEL__ = !0, li = e, li;
}
var pi, Ld;
function d3() {
  if (Ld) return pi;
  Ld = 1;
  var e = Dl();
  function t(r) {
    if (typeof r != "function")
      throw new TypeError("executor must be a function.");
    var n;
    this.promise = new Promise(function(u) {
      n = u;
    });
    var a = this;
    r(function(u) {
      a.reason || (a.reason = new e(u), n(a.reason));
    });
  }
  return t.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, t.source = function() {
    var r, n = new t(function(a) {
      r = a;
    });
    return {
      token: n,
      cancel: r
    };
  }, pi = t, pi;
}
var Fd, $d;
function f3() {
  return $d || ($d = 1, Fd = function(e) {
    return function(t) {
      return e.apply(null, t);
    };
  }), Fd;
}
var Ud;
function l3() {
  if (Ud) return Ln.exports;
  Ud = 1;
  var e = Xe(), t = Al(), r = c3(), n = Nl(), a = Bl();
  function u(s) {
    var o = new r(s), c = t(r.prototype.request, o);
    return e.extend(c, r.prototype, o), e.extend(c, o), c;
  }
  var i = u(a);
  return i.Axios = r, i.create = function(s) {
    return u(n(i.defaults, s));
  }, i.Cancel = Dl(), i.CancelToken = d3(), i.isCancel = Il(), i.all = function(s) {
    return Promise.all(s);
  }, i.spread = f3(), Ln.exports = i, Ln.exports.default = i, Ln.exports;
}
var Hd, Gd;
function p3() {
  return Gd || (Gd = 1, Hd = l3()), Hd;
}
var h3 = p3();
const m3 = /* @__PURE__ */ yl(h3);
class ge {
  constructor({ url: t, data: r }) {
    return ge.getData({ url: t, data: r });
  }
  static async getData({ url: t, data: r }) {
    try {
      const n = await m3.post(t, Xg.stringify(r), {
        headers: {
          Accept: "*/*",
          "Content-type": "application/x-www-form-urlencoded"
        },
        withCredentials: !0
      });
      if (n.status === 200)
        return n.data.data;
      throw new Error(`Error code ${n.status}`);
    } catch (n) {
      throw new Error(`${n}
 ${t}
 ${JSON.stringify(r)}`);
    }
  }
}
const g3 = {
  apiGatewayUrl: "//api-gateway.test-01.travellata.ru"
};
class y3 {
  constructor(t) {
    Et(this, "apiGatewayTrackingPath");
    const { apiGatewayUrl: r } = t;
    if (!r)
      throw new Error("No apiGatewayUrl!");
    this.apiGatewayTrackingPath = `${r}/frontend/tracking/`;
  }
  setAnalytics(t) {
    return new ge({
      url: this.apiGatewayTrackingPath + "analytics",
      data: t
    });
  }
  addHotelView(t) {
    return new ge({
      url: this.apiGatewayTrackingPath + "hotelView",
      data: t
    });
  }
  trackCoreWebVitals(t) {
    return new ge({
      url: this.apiGatewayTrackingPath + "coreWebVitals",
      data: t
    });
  }
  trackVisit(t) {
    return new ge({
      url: this.apiGatewayTrackingPath + "visit",
      data: t
    });
  }
  trackCalendar(t) {
    return new ge({
      url: this.apiGatewayTrackingPath + "calendar",
      data: t
    });
  }
  trackIntelligentSearch(t) {
    return new ge({
      url: this.apiGatewayTrackingPath + "intelligentSearch",
      data: t
    });
  }
  trackSearchStart(t) {
    return new ge({
      url: this.apiGatewayTrackingPath + "serpStartSearch",
      data: t
    });
  }
  trackEmptySearchStart(t) {
    return new ge({
      url: this.apiGatewayTrackingPath + "serpStartEmptySearch",
      data: t
    });
  }
  trackSearch(t) {
    return new ge({
      url: this.apiGatewayTrackingPath + "serpSearchResults",
      data: t
    });
  }
  trackSearchAgency(t) {
    return new ge({
      url: this.apiGatewayTrackingPath + "agencySerpSearchResults",
      data: t
    });
  }
  trackSearchFilters(t) {
    return new ge({
      url: this.apiGatewayTrackingPath + "serpSearchFilters",
      data: t
    });
  }
  trackSerpHotelPosition(t) {
    return new ge({
      url: this.apiGatewayTrackingPath + "serpHotelPositions",
      data: t
    });
  }
  trackTourHunters(t) {
    return new ge({
      url: this.apiGatewayTrackingPath + "serpTourHunters",
      data: t
    });
  }
  trackHotelPage(t) {
    return new ge({
      url: this.apiGatewayTrackingPath + "hotelPageSearchResults",
      data: t
    });
  }
  trackAgencyHotelPage(t) {
    return new ge({
      url: this.apiGatewayTrackingPath + "agencyHotelPageSearchResults",
      data: t
    });
  }
  trackHotelPageRoomCategories(t) {
    return new ge({
      url: this.apiGatewayTrackingPath + "hotelPageRoomCategories",
      data: t
    });
  }
  trackTourPage(t) {
    return new ge({
      url: this.apiGatewayTrackingPath + "tourPageActualizationResults",
      data: t
    });
  }
  trackAgencyTourPageSearchResults(t) {
    return new ge({
      url: this.apiGatewayTrackingPath + "agencyTourPageActualizationResults",
      data: t
    });
  }
}
class v3 {
  constructor(t = {}) {
    Et(this, "config"), Et(this, "api"), Et(this, "trClient"), Et(this, "customerUuid");
    const { config: r = {}, clientUuid: n } = t;
    this.config = Object.assign({}, g3, r);
    const a = new y3({ apiGatewayUrl: this.config.apiGatewayUrl });
    this.api = a, this.trClient = new Cr({ api: a, clientUuid: n });
  }
  getClientUuid() {
    return this.trClient.getClientUuid();
  }
  setCustomerUuid(t) {
    this.customerUuid = t;
  }
  getCustomerUuid() {
    return this.customerUuid || null;
  }
  track(t) {
    const { type: r, data: n } = t;
    if (r && n)
      switch (r) {
        case "addHotelView":
        case "trackSearch":
        case "trackSearchAgency":
        case "trackSearchStart":
        case "trackEmptySearchStart":
        case "trackSearchFilters":
        case "trackHotelPage":
        case "trackAgencyHotelPage":
        case "trackTourPage":
        case "trackAgencyTourPageSearchResults":
        case "trackVisit":
        case "trackCalendar":
        case "trackIntelligentSearch":
        case "trackXtravelTour":
        case "trackXtravelInterest":
        case "trackHotelPageRoomCategories":
        case "trackSerpHotelPosition":
        case "trackCoreWebVitals":
        case "trackTourHunters":
          this._process({ type: r, data: n });
          break;
        default:
          console.warn("Unknown action type");
      }
    else console.warn(r ? `No Data for action ${r}` : "No Action type");
  }
  _process({ type: t, data: r }) {
    try {
      this.api[t]({
        data: r,
        clientUuid: this.getClientUuid(),
        customerUuid: this.getCustomerUuid()
      });
    } catch (n) {
      throw new Error(`Fetch error: ${n}`);
    }
  }
}
class b3 extends Fa {
  constructor() {
    super(...arguments);
    $(this, "client", null);
    $(this, "url");
    $(this, "clientUuid");
  }
  init(r) {
    this.isStartedInit || (this.url = r.url, this.clientUuid = r.clientUuid, this.baseInit(r.timeoutMS));
  }
  install() {
    if (!this.url)
      throw new dn("TrackerAnalyticsProvider requires a url parameter", {
        serviceName: Ue.TRACKER
      });
    try {
      this.client = new v3({
        config: {
          apiGatewayUrl: this.url
        },
        clientUuid: this.clientUuid || void 0
      });
    } catch (r) {
      throw new dn("TrackerAnalyticsProvider initialization failed", {
        serviceName: Ue.TRACKER,
        cause: r
      });
    }
  }
  isInstalled() {
    return this.client !== null;
  }
  track(r) {
    this.enqueueOrExecute(() => this.client.track(r));
  }
  setCustomerUuid(r) {
    this.enqueueOrExecute(() => this.client.setCustomerUuid(r));
  }
}
//! TrackJS JavaScript error monitoring agent.
//! COPYRIGHT (c) 2023 ALL RIGHTS RESERVED
//! See License at https://trackjs.com/terms/
var en = function(e, t, r) {
  "use awesome";
  var n = function(d, m) {
    this.config = d, this.onError = m, d.enabled && this.watch();
  };
  n.prototype = { watch: function() {
    h.forEach(["EventTarget", "Node", "XMLHttpRequest"], function(d) {
      h.has(e, d + ".prototype.addEventListener") && h.hasOwn(e[d].prototype, "addEventListener") && this.wrapEventTarget(e[d].prototype);
    }, this), this.wrapTimer("setTimeout"), this.wrapTimer("setInterval");
  }, wrap: function(d) {
    function m() {
      try {
        return d.apply(this, arguments);
      } catch (_) {
        throw l.onError("catch", _, { bindTime: y, bindStack: b }), h.wrapError(_);
      }
    }
    var l = this;
    try {
      if (!h.isFunction(d) || h.hasOwn(d, "__trackjs__")) return d;
      if (h.hasOwn(d, "__trackjs_state__")) return d.__trackjs_state__;
    } catch {
      return d;
    }
    var y, b;
    if (l.config.bindStack) try {
      throw Error();
    } catch (_) {
      b = _.stack, y = h.isoNow();
    }
    for (var w in d) h.hasOwn(d, w) && (m[w] = d[w]);
    return m.prototype = d.prototype, m.__trackjs__ = !0, d.__trackjs_state__ = m;
  }, wrapEventTarget: function(d) {
    var m = this;
    h.has(d, "addEventListener.call") && h.has(d, "removeEventListener.call") && (h.patch(
      d,
      "addEventListener",
      function(l) {
        return function(y, b, w, _) {
          try {
            h.has(b, "handleEvent") && (b.handleEvent = m.wrap(b.handleEvent));
          } catch {
          }
          return l.call(this, y, m.wrap(b), w, _);
        };
      }
    ), h.patch(d, "removeEventListener", function(l) {
      return function(y, b, w, _) {
        try {
          b = b && (b.__trackjs_state__ || b);
        } catch {
        }
        return l.call(this, y, b, w, _);
      };
    }));
  }, wrapTimer: function(d) {
    var m = this;
    h.patch(e, d, function(l) {
      return function(y, b) {
        var w = Array.prototype.slice.call(arguments), _ = w[0];
        return h.isFunction(_) && (w[0] = m.wrap(_)), h.has(l, "apply") ? l.apply(this, w) : l(w[0], w[1]);
      };
    });
  } };
  var a = function(d) {
    this.initCurrent(d) || console.warn("[TrackJS] invalid config");
  };
  a.prototype = { current: {}, initOnly: { application: !0, cookie: !0, enabled: !0, token: !0, callback: { enabled: !0 }, console: { enabled: !0 }, navigation: { enabled: !0 }, network: { enabled: !0, fetch: !0 }, visitor: { enabled: !0 }, window: { enabled: !0, promise: !0 } }, defaults: {
    application: "",
    cookie: !1,
    dedupe: !0,
    dependencies: !0,
    enabled: !0,
    forwardingDomain: "",
    errorURL: "https://capture.trackjs.com/capture",
    errorNoSSLURL: "http://capture.trackjs.com/capture",
    faultURL: "https://usage.trackjs.com/fault.gif",
    usageURL: "https://usage.trackjs.com/usage.gif",
    onError: function() {
      return !0;
    },
    serialize: function(d) {
      function m(b) {
        var w = "<" + b.tagName.toLowerCase();
        b = b.attributes || [];
        for (var _ = 0; _ < b.length; _++) w += " " + b[_].name + '="' + b[_].value + '"';
        return w + ">";
      }
      if (d === "") return "Empty String";
      if (d === r) return "undefined";
      if (h.isString(d) || h.isNumber(d) || h.isBoolean(d) || h.isFunction(d)) return "" + d;
      if (h.isElement(d)) return m(d);
      if (typeof d == "symbol") return Symbol.prototype.toString.call(d);
      var l;
      try {
        l = JSON.stringify(d, function(b, w) {
          return w === r ? "undefined" : h.isNumber(w) && isNaN(w) ? "NaN" : h.isError(w) ? { name: w.name, message: w.message, stack: w.stack } : h.isElement(w) ? m(w) : w;
        });
      } catch {
        l = "";
        for (var y in d) if (d.hasOwnProperty(y)) try {
          l += ',"' + y + '":"' + d[y] + '"';
        } catch {
        }
        l = l ? "{" + l.replace(",", "") + "}" : "Unserializable Object";
      }
      return l.replace(/"undefined"/g, "undefined").replace(/"NaN"/g, "NaN");
    },
    sessionId: "",
    token: "",
    userId: "",
    version: "",
    callback: { enabled: !0, bindStack: !1 },
    console: {
      enabled: !0,
      display: !0,
      error: !0,
      warn: !1,
      watch: ["log", "debug", "info", "warn", "error"]
    },
    navigation: { enabled: !0 },
    network: { enabled: !0, error: !0, fetch: !0 },
    visitor: { enabled: !0 },
    window: { enabled: !0, promise: !0 }
  }, initCurrent: function(d) {
    return this.removeEmpty(d), this.validate(d, this.defaults, "[TrackJS] config", {}) ? (this.current = h.defaultsDeep({}, d, this.defaults), !0) : (this.current = h.defaultsDeep({}, this.defaults), !1);
  }, setCurrent: function(d) {
    return this.validate(d, this.defaults, "[TrackJS] config", this.initOnly) ? (this.current = h.defaultsDeep(
      {},
      d,
      this.current
    ), !0) : !1;
  }, removeEmpty: function(d) {
    for (var m in d) d.hasOwnProperty(m) && d[m] === r && delete d[m];
  }, validate: function(d, m, l, y) {
    var b = !0;
    l = l || "", y = y || {};
    for (var w in d) if (d.hasOwnProperty(w)) if (m.hasOwnProperty(w)) {
      var _ = typeof m[w];
      _ !== typeof d[w] ? (console.warn(l + "." + w + ": property must be type " + _ + "."), b = !1) : Object.prototype.toString.call(d[w]) !== "[object Array]" || this.validateArray(d[w], m[w], l + "." + w) ? Object.prototype.toString.call(d[w]) === "[object Object]" ? b = this.validate(d[w], m[w], l + "." + w, y[w]) : y.hasOwnProperty(w) && (console.warn(l + "." + w + ": property cannot be set after load."), b = !1) : b = !1;
    } else console.warn(l + "." + w + ": property not supported."), b = !1;
    return b;
  }, validateArray: function(d, m, l) {
    var y = !0;
    l = l || "";
    for (var b = 0; b < d.length; b++) h.contains(m, d[b]) || (console.warn(l + "[" + b + "]: invalid value: " + d[b] + "."), y = !1);
    return y;
  } };
  var u = function(d, m, l, y, b, w, _) {
    this.util = d, this.log = m, this.onError = l, this.onFault = y, this.serialize = b, _.enabled && (w.console = this.wrapConsoleObject(w.console, _));
  };
  u.prototype = { wrapConsoleObject: function(d, m) {
    d = d || {};
    var l = d.log || function() {
    }, y = this, b;
    for (b = 0; b < m.watch.length; b++) (function(w) {
      var _ = d[w] || l;
      d[w] = function() {
        try {
          var k = Array.prototype.slice.call(arguments);
          if (y.log.add("c", { timestamp: y.util.isoNow(), severity: w, message: y.serialize(k.length === 1 ? k[0] : k) }), m[w]) if (h.isError(k[0]) && k.length === 1) y.onError("console", k[0]);
          else try {
            throw Error(y.serialize(k.length === 1 ? k[0] : k));
          } catch (O) {
            y.onError("console", O);
          }
          m.display && (y.util.hasFunction(_, "apply") ? _.apply(d, k) : _(k[0]));
        } catch (O) {
          y.onFault(O);
        }
      };
    })(m.watch[b]);
    return d;
  }, report: function() {
    return this.log.all("c");
  } };
  var i = function(d, m, l, y, b) {
    this.config = d, this.util = m, this.log = l, this.window = y, this.document = b, this.correlationId = this.token = null, this.initialize();
  };
  i.prototype = { initialize: function() {
    this.token = this.getCustomerToken(), this.correlationId = this.getCorrelationId();
  }, getCustomerToken: function() {
    if (this.config.current.token) return this.config.current.token;
    var d = this.document.getElementsByTagName("script");
    return d[d.length - 1].getAttribute("data-token");
  }, getCorrelationId: function() {
    var d;
    if (!this.config.current.cookie) return this.util.uuid();
    try {
      d = this.document.cookie.replace(/(?:(?:^|.*;\s*)TrackJS\s*\=\s*([^;]*).*$)|^.*$/, "$1"), d || (d = this.util.uuid(), this.document.cookie = "TrackJS=" + d + "; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/");
    } catch {
      d = this.util.uuid();
    }
    return d;
  }, report: function() {
    return {
      application: this.config.current.application,
      correlationId: this.correlationId,
      sessionId: this.config.current.sessionId,
      token: this.token,
      userId: this.config.current.userId,
      version: this.config.current.version
    };
  } };
  var s = function(d) {
    this.config = d, this.loadedOn = (/* @__PURE__ */ new Date()).getTime(), this.originalUrl = h.getLocation(), this.referrer = h.isBrowser ? t.referrer : "";
  };
  s.prototype = { discoverDependencies: function() {
    var d = { TrackJS: "3.10.4" };
    e.jQuery && e.jQuery.fn && e.jQuery.fn.jquery && (d.jQuery = e.jQuery.fn.jquery), e.jQuery && e.jQuery.ui && e.jQuery.ui.version && (d.jQueryUI = e.jQuery.ui.version), e.angular && e.angular.version && e.angular.version.full && (d.angular = e.angular.version.full);
    for (var m in e) if (m !== "_trackJs" && m !== "_trackJS" && m !== "_trackjs" && m !== "webkitStorageInfo" && m !== "webkitIndexedDB" && m !== "top" && m !== "parent" && m !== "frameElement") try {
      if (e[m]) {
        var l = e[m].version || e[m].Version || e[m].VERSION;
        typeof l == "string" && (d[m] = l);
      }
    } catch {
    }
    return d.TrackJS && d.trackJs && delete d.trackJs, d;
  }, report: function() {
    return {
      age: (/* @__PURE__ */ new Date()).getTime() - this.loadedOn,
      dependencies: this.config.current.dependencies ? this.discoverDependencies() : { trackJs: "3.10.4" },
      originalUrl: this.originalUrl,
      referrer: this.referrer,
      userAgent: e.navigator.userAgent,
      viewportHeight: h.isBrowser ? e.document.documentElement.clientHeight : 0,
      viewportWidth: h.isBrowser ? e.document.documentElement.clientWidth : 0
    };
  } };
  var o = function(d) {
    this.util = d, this.appender = [], this.maxLength = 30;
  };
  o.prototype = { all: function(d) {
    var m = [], l, y;
    for (y = 0; y < this.appender.length; y++) (l = this.appender[y]) && l.category === d && m.push(l.value);
    return m;
  }, clear: function() {
    this.appender.length = 0;
  }, truncate: function() {
    this.appender.length > this.maxLength && (this.appender = this.appender.slice(Math.max(this.appender.length - this.maxLength, 0)));
  }, add: function(d, m) {
    var l = this.util.uuid();
    return this.appender.push({ key: l, category: d, value: m }), this.truncate(), l;
  }, get: function(d, m) {
    var l, y;
    for (y = 0; y < this.appender.length; y++) if (l = this.appender[y], l.category === d && l.key === m) return l.value;
    return !1;
  } };
  var c = function(d) {
    var m = {};
    return { addMetadata: function(l, y) {
      m[l] = y;
    }, removeMetadata: function(l) {
      delete m[l];
    }, report: function() {
      var l = [], y;
      for (y in m) m.hasOwnProperty(y) && l.push({
        key: y,
        value: d(m[y])
      });
      return l;
    }, store: m };
  }, f = function(d, m) {
    this.log = d, this.options = m, m.enabled && this.watch();
  };
  f.prototype = { isCompatible: function(d) {
    return d = d || e, !h.has(d, "chrome.app.runtime") && h.has(d, "addEventListener") && h.has(d, "history.pushState");
  }, record: function(d, m, l) {
    this.log.add("h", { type: d, from: h.truncate(m, 250), to: h.truncate(l, 250), on: h.isoNow() });
  }, report: function() {
    return this.log.all("h");
  }, watch: function() {
    if (this.isCompatible()) {
      var d = this, m = h.getLocationURL().relative;
      e.addEventListener(
        "popstate",
        function() {
          var l = h.getLocationURL().relative;
          d.record("popState", m, l), m = l;
        },
        !0
      ), h.forEach(["pushState", "replaceState"], function(l) {
        h.patch(history, l, function(y) {
          return function() {
            m = h.getLocationURL().relative;
            var b = y.apply(this, arguments), w = h.getLocationURL().relative;
            return d.record(l, m, w), m = w, b;
          };
        });
      });
    }
  } };
  var g = function(d, m, l, y, b, w) {
    this.util = d, this.log = m, this.onError = l, this.onFault = y, this.window = b, this.options = w, w.enabled && this.initialize(b);
  };
  g.prototype = { initialize: function(d) {
    d.XMLHttpRequest && this.util.hasFunction(
      d.XMLHttpRequest.prototype.open,
      "apply"
    ) && this.watchNetworkObject(d.XMLHttpRequest), d.XDomainRequest && this.util.hasFunction(d.XDomainRequest.prototype.open, "apply") && this.watchNetworkObject(d.XDomainRequest), this.options.fetch && h.isWrappableFunction(d.fetch) && this.watchFetch();
  }, escapeUrl: function(d) {
    return ("" + d).replace(/ /gi, "%20").replace(/\t/gi, "%09");
  }, watchFetch: function() {
    var d = this, m = this.log, l = this.options, y = this.onError;
    h.patch(e, "fetch", function(b) {
      return function(w, _) {
        if (_ && _.__trackjs__) return b.apply(e, arguments);
        var k;
        try {
          throw Error();
        } catch (P) {
          k = P.stack;
        }
        var D = w instanceof Request ? w.url : w, O = w instanceof Request ? w.method : (_ || {}).method || "GET", D = d.escapeUrl(D), A = b.apply(e, arguments);
        return A.__trackjs_state__ = m.add("n", { type: "fetch", startedOn: h.isoNow(), method: O, url: h.truncate(D, 2e3) }), A.then(function(P) {
          var j = m.get("n", A.__trackjs_state__);
          if (j) {
            h.defaults(j, { completedOn: h.isoNow(), statusCode: P.status, statusText: P.statusText });
            var F = P.headers.get("trackjs-correlation-id");
            F && (j.requestCorrelationId = F), l.error && 400 <= P.status && (j = Error(j.statusCode + " : " + j.method + " " + j.url), j.stack = k, y("ajax", j));
          }
          return P;
        }).catch(function(P) {
          P = P || {};
          var j = m.get("n", A.__trackjs_state__);
          throw j && (h.defaults(j, { completedOn: h.isoNow(), statusCode: 0, statusText: P.toString() }), l.error && (y("ajax", { name: P.name, message: (P.message || "Failed") + ": " + j.method + " " + j.url, stack: P.stack || k }), P.__trackjs_state__ = !0)), P;
        });
      };
    });
  }, watchNetworkObject: function(d) {
    var m = this, l = d.prototype.open, y = d.prototype.send;
    return d.prototype.open = function(b, w) {
      var _ = (w || "").toString();
      return 0 > _.indexOf("localhost:0") && (_ = m.escapeUrl(_), this._trackJs = { method: b, url: _ }), l.apply(this, arguments);
    }, d.prototype.send = function() {
      if (!this._trackJs) try {
        return y.apply(this, arguments);
      } catch (b) {
        m.onError("ajax", b);
        return;
      }
      try {
        this._trackJs.logId = m.log.add("n", { type: "xhr", startedOn: m.util.isoNow(), method: this._trackJs.method, url: h.truncate(this._trackJs.url, 2e3) }), m.listenForNetworkComplete(this);
      } catch (b) {
        m.onFault(b);
      }
      return y.apply(this, arguments);
    }, d;
  }, listenForNetworkComplete: function(d) {
    var m = this;
    m.window.ProgressEvent && d.addEventListener && d.addEventListener("readystatechange", function() {
      d.readyState === 4 && m.finalizeNetworkEvent(d);
    }, !0), d.addEventListener ? d.addEventListener("load", function() {
      m.finalizeNetworkEvent(d), m.checkNetworkFault(d);
    }, !0) : setTimeout(function() {
      try {
        var l = d.onload;
        d.onload = function() {
          m.finalizeNetworkEvent(d), m.checkNetworkFault(d), typeof l == "function" && m.util.hasFunction(l, "apply") && l.apply(d, arguments);
        };
        var y = d.onerror;
        d.onerror = function() {
          m.finalizeNetworkEvent(d), m.checkNetworkFault(d), typeof oldOnError == "function" && y.apply(d, arguments);
        };
      } catch (b) {
        m.onFault(b);
      }
    }, 0);
  }, finalizeNetworkEvent: function(d) {
    if (d._trackJs) {
      var m = this.log.get("n", d._trackJs.logId);
      m && (m.completedOn = this.util.isoNow(), d.getAllResponseHeaders && d.getResponseHeader && 0 <= (d.getAllResponseHeaders() || "").toLowerCase().indexOf("trackjs-correlation-id") && (m.requestCorrelationId = d.getResponseHeader("trackjs-correlation-id")), m.statusCode = d.status == 1223 ? 204 : d.status, m.statusText = d.status == 1223 ? "No Content" : d.statusText);
    }
  }, checkNetworkFault: function(d) {
    if (this.options.error && 400 <= d.status && d.status != 1223) {
      var m = d._trackJs || {};
      this.onError("ajax", d.status + " : " + m.method + " " + m.url);
    }
  }, report: function() {
    return this.log.all("n");
  } };
  var p = function(d, m) {
    this.util = d, this.config = m, this.disabled = !1, this.throttleStats = { attemptCount: 0, throttledCount: 0, lastAttempt: (/* @__PURE__ */ new Date()).getTime() }, e.JSON && e.JSON.stringify || (this.disabled = !0);
  };
  p.prototype = { errorEndpoint: function(d) {
    var m = this.config.current, l = m.errorURL;
    return h.isBrowser && !h.testCrossdomainXhr() && e.location.protocol.indexOf("https") === -1 ? l = m.errorNoSSLURL : m.forwardingDomain && (l = "https://" + m.forwardingDomain + "/capture"), l + "?token=" + d + "&v=3.10.4";
  }, usageEndpoint: function(d) {
    var m = this.config.current, l = m.usageURL;
    return m.forwardingDomain && (l = "https://" + m.forwardingDomain + "/usage.gif"), this.appendObjectAsQuery(d, l);
  }, trackerFaultEndpoint: function(d) {
    var m = (this.config || {}).current || a.prototype.defaults, l = m.faultURL;
    return m.forwardingDomain && (l = "https://" + m.forwardingDomain + "/fault.gif"), this.appendObjectAsQuery(d, l);
  }, appendObjectAsQuery: function(d, m) {
    m += "?";
    for (var l in d) d.hasOwnProperty(l) && (m += encodeURIComponent(l) + "=" + encodeURIComponent(d[l]) + "&");
    return m;
  }, getCORSRequest: function(d, m) {
    var l;
    return this.util.testCrossdomainXhr() ? (l = new e.XMLHttpRequest(), l.open(d, m), l.setRequestHeader("Content-Type", "text/plain")) : typeof e.XDomainRequest < "u" ? (l = new e.XDomainRequest(), l.open(d, m)) : l = null, l;
  }, sendTrackerFault: function(d) {
    this.throttle(d) || (h.isBrowser ? t.createElement("img").src = this.trackerFaultEndpoint(d) : fetch(this.trackerFaultEndpoint(d), { mode: "no-cors", __trackjs__: !0 }));
  }, sendUsage: function(d) {
    h.isBrowser ? t.createElement("img").src = this.usageEndpoint(d) : fetch(this.usageEndpoint(d), { mode: "no-cors", __trackjs__: !0 });
  }, sendError: function(d, m) {
    var l = this;
    if (!this.disabled && !this.throttle(d)) try {
      if (h.isBrowser) {
        var y = this.getCORSRequest("POST", this.errorEndpoint(m));
        y.onreadystatechange = function() {
          y.readyState !== 4 || h.contains(
            [200, 202],
            y.status
          ) || (l.disabled = !0);
        }, y._trackJs = r, y.send(e.JSON.stringify(d));
      } else if (h.isWorker) {
        var b = { method: "POST", mode: "cors", body: e.JSON.stringify(d), __trackjs__: 1 };
        fetch(this.errorEndpoint(m), b).then(function(w) {
          w.ok || (l.disabled = !0);
        }).catch(function(w) {
          l.disabled = !0;
        });
      }
    } catch (w) {
      throw this.disabled = !0, w;
    }
  }, throttle: function(d) {
    var m = (/* @__PURE__ */ new Date()).getTime();
    if (this.throttleStats.attemptCount++, this.throttleStats.lastAttempt + 1e3 >= m) {
      if (this.throttleStats.lastAttempt = m, 10 < this.throttleStats.attemptCount) return this.throttleStats.throttledCount++, !0;
    } else d.throttled = this.throttleStats.throttledCount, this.throttleStats.attemptCount = 0, this.throttleStats.lastAttempt = m, this.throttleStats.throttledCount = 0;
    return !1;
  } };
  var h = function() {
    function d(l, y, b, w) {
      return b = b || !1, w = w || 0, h.forEach(y, function(_) {
        h.forEach(h.keys(_), function(k) {
          _[k] === null || _[k] === r ? l[k] = _[k] : b && 10 > w && m(_[k]) === "[object Object]" ? (l[k] = l[k] || {}, d(l[k], [_[k]], b, w + 1)) : l.hasOwnProperty(k) || (l[k] = _[k]);
        });
      }), l;
    }
    function m(l) {
      return Object.prototype.toString.call(l);
    }
    return {
      isBrowser: typeof e < "u" && typeof e.document < "u",
      isWorker: typeof self == "object" && self.constructor && 0 <= (self.constructor.name || "").indexOf("WorkerGlobalScope"),
      isNode: typeof process < "u" && process.versions != null && process.versions.node != null,
      addEventListenerSafe: function(l, y, b, w) {
        l.addEventListener ? l.addEventListener(y, b, w) : l.attachEvent && l.attachEvent("on" + y, b);
      },
      afterDocumentLoad: function(l) {
        if (h.isWorker) h.defer(l);
        else {
          var y = !1;
          t.readyState === "complete" ? h.defer(l) : (h.addEventListenerSafe(
            t,
            "readystatechange",
            function() {
              t.readyState !== "complete" || y || (h.defer(l), y = !0);
            }
          ), setTimeout(function() {
            y || (h.defer(l), y = !0);
          }, 1e4));
        }
      },
      bind: function(l, y) {
        return function() {
          return l.apply(y, Array.prototype.slice.call(arguments));
        };
      },
      contains: function(l, y) {
        return 0 <= l.indexOf(y);
      },
      defaults: function(l) {
        return d(l, Array.prototype.slice.call(arguments, 1), !1);
      },
      defaultsDeep: function(l) {
        return d(l, Array.prototype.slice.call(arguments, 1), !0);
      },
      defer: function(l, y) {
        setTimeout(function() {
          l.apply(y);
        });
      },
      forEach: function(l, y, b) {
        if (h.isArray(l)) {
          if (l.forEach) return l.forEach(
            y,
            b
          );
          for (var w = 0; w < l.length; ) y.call(b, l[w], w, l), w++;
        }
      },
      getLocation: function() {
        return e.location.toString().replace(/ /g, "%20");
      },
      getLocationURL: function() {
        return h.parseURL(h.getLocation());
      },
      has: function(l, y) {
        try {
          for (var b = y.split("."), w = l, _ = 0; _ < b.length; _++) if (w[b[_]]) w = w[b[_]];
          else return !1;
          return !0;
        } catch {
          return !1;
        }
      },
      hasFunction: function(l, y) {
        try {
          return !!l[y];
        } catch {
          return !1;
        }
      },
      hasOwn: function(l, y) {
        return Object.prototype.hasOwnProperty.call(l, y);
      },
      isArray: function(l) {
        return m(l) === "[object Array]";
      },
      isBoolean: function(l) {
        return typeof l == "boolean" || h.isObject(l) && m(l) === "[object Boolean]";
      },
      isBrowserIE: function(l) {
        l = l || e.navigator.userAgent;
        var y = l.match(/Trident\/([\d.]+)/);
        return y && y[1] === "7.0" ? 11 : (l = l.match(/MSIE ([\d.]+)/)) ? parseInt(l[1], 10) : !1;
      },
      isBrowserSupported: function() {
        var l = this.isBrowserIE();
        return !l || 8 <= l;
      },
      isError: function(l) {
        if (!h.isObject(l)) return !1;
        var y = m(l);
        return y === "[object Error]" || y === "[object DOMException]" || h.isString(l.name) && h.isString(l.message);
      },
      isElement: function(l) {
        return h.isObject(l) && l.nodeType === 1;
      },
      isFunction: function(l) {
        return !(!l || typeof l != "function");
      },
      isNumber: function(l) {
        return typeof l == "number" || h.isObject(l) && m(l) === "[object Number]";
      },
      isObject: function(l) {
        return !(!l || typeof l != "object");
      },
      isString: function(l) {
        return typeof l == "string" || !h.isArray(l) && h.isObject(l) && m(l) === "[object String]";
      },
      isWrappableFunction: function(l) {
        return this.isFunction(l) && this.hasFunction(l, "apply");
      },
      isoNow: function() {
        var l = /* @__PURE__ */ new Date();
        return l.toISOString ? l.toISOString() : l.getUTCFullYear() + "-" + this.pad(l.getUTCMonth() + 1) + "-" + this.pad(l.getUTCDate()) + "T" + this.pad(l.getUTCHours()) + ":" + this.pad(l.getUTCMinutes()) + ":" + this.pad(l.getUTCSeconds()) + "." + String((l.getUTCMilliseconds() / 1e3).toFixed(3)).slice(2, 5) + "Z";
      },
      keys: function(l) {
        if (!h.isObject(l)) return [];
        var y = [], b;
        for (b in l) l.hasOwnProperty(b) && y.push(b);
        return y;
      },
      noop: function() {
      },
      pad: function(l) {
        return l = String(l), l.length === 1 && (l = "0" + l), l;
      },
      parseURL: function(l) {
        var y = l.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
        return y ? (y = { protocol: y[2], host: y[4], path: y[5], query: y[6], hash: y[8] }, y.origin = (y.protocol || "") + "://" + (y.host || ""), y.relative = (y.path || "") + (y.query || "") + (y.hash || ""), y.href = l, y) : {};
      },
      patch: function(l, y, b) {
        l[y] = b(l[y] || h.noop);
      },
      testCrossdomainXhr: function() {
        return h.isBrowser && "withCredentials" in new XMLHttpRequest();
      },
      truncate: function(l, y) {
        if (l = "" + l, l.length <= y) return l;
        var b = l.length - y;
        return l.substr(0, y) + "...{" + b + "}";
      },
      tryGet: function(l, y) {
        try {
          return l[y];
        } catch {
        }
      },
      uuid: function() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          function(l) {
            var y = 16 * Math.random() | 0;
            return (l == "x" ? y : y & 3 | 8).toString(16);
          }
        );
      },
      wrapError: function(l) {
        var y = l || Object.prototype.toString.call(l);
        if (y && y.innerError) return l;
        var b = Error("TrackJS Caught: " + (y.message || y));
        return b.description = "TrackJS Caught: " + y.description, b.file = y.file, b.line = y.line || y.lineNumber, b.column = y.column || y.columnNumber, b.stack = y.stack, b.innerError = l, b;
      }
    };
  }(), v = function(d, m, l, y, b, w) {
    this.util = d, this.log = m, this.onError = l, this.onFault = y, this.options = w, this.document = b, d.isBrowser && w.enabled && this.initialize(b);
  };
  v.prototype = { initialize: function(d) {
    var m = this.util.bind(this.onDocumentClicked, this), l = this.util.bind(this.onInputChanged, this);
    d.addEventListener ? (d.addEventListener("click", m, !0), d.addEventListener("blur", l, !0)) : d.attachEvent && (d.attachEvent("onclick", m), d.attachEvent("onfocusout", l));
  }, onDocumentClicked: function(d) {
    try {
      var m = this.getElementFromEvent(d);
      m && m.tagName && (this.isDescribedElement(m, "a") || this.isDescribedElement(m, "button") || this.isDescribedElement(
        m,
        "input",
        ["button", "submit"]
      ) ? this.writeVisitorEvent(m, "click") : this.isDescribedElement(m, "input", ["checkbox", "radio"]) && this.writeVisitorEvent(m, "input", m.value, m.checked));
    } catch (l) {
      this.onFault(l);
    }
  }, onInputChanged: function(d) {
    try {
      var m = this.getElementFromEvent(d);
      m && m.tagName && (this.isDescribedElement(m, "textarea") ? this.writeVisitorEvent(m, "input", m.value) : this.isDescribedElement(m, "select") && m.options && m.options.length ? this.onSelectInputChanged(m) : this.isDescribedElement(m, "input") && !this.isDescribedElement(
        m,
        "input",
        ["button", "submit", "hidden", "checkbox", "radio"]
      ) && this.writeVisitorEvent(m, "input", m.value));
    } catch (l) {
      this.onFault(l);
    }
  }, onSelectInputChanged: function(d) {
    if (d.multiple) for (var m = 0; m < d.options.length; m++) d.options[m].selected && this.writeVisitorEvent(d, "input", d.options[m].value);
    else 0 <= d.selectedIndex && d.options[d.selectedIndex] && this.writeVisitorEvent(d, "input", d.options[d.selectedIndex].value);
  }, writeVisitorEvent: function(d, m, l, y) {
    this.getElementType(d) === "password" && (l = r);
    var b = this.getElementAttributes(d);
    d.innerText && (b.__trackjs_element_text = this.util.truncate(d.innerText, 500)), this.log.add("v", { timestamp: this.util.isoNow(), action: m, element: { tag: d.tagName.toLowerCase(), attributes: b, value: this.getMetaValue(l, y) } });
  }, getElementFromEvent: function(d) {
    return d.target || t.elementFromPoint(d.clientX, d.clientY);
  }, isDescribedElement: function(d, m, l) {
    if (d.tagName.toLowerCase() !== m.toLowerCase()) return !1;
    if (!l) return !0;
    for (d = this.getElementType(d), m = 0; m < l.length; m++) if (l[m] === d) return !0;
    return !1;
  }, getElementType: function(d) {
    return (d.getAttribute("type") || "").toLowerCase();
  }, getElementAttributes: function(d) {
    for (var m = {}, l = Math.min(d.attributes.length, 10), y = 0; y < l; y++) {
      var b = d.attributes[y];
      h.contains(["data-value", "value"], b.name.toLowerCase()) || (m[b.name] = h.truncate(b.value, 100));
    }
    return m;
  }, getMetaValue: function(d, m) {
    return d === r ? r : { length: d.length, pattern: this.matchInputPattern(d), checked: m };
  }, matchInputPattern: function(d) {
    return d === "" ? "empty" : /^[a-z0-9!#$%&'*+=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(d) ? "email" : /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/.test(d) || /^(\d{4}[\/\-](0?[1-9]|1[012])[\/\-]0?[1-9]|[12][0-9]|3[01])$/.test(d) ? "date" : /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/.test(d) ? "usphone" : /^\s*$/.test(d) ? "whitespace" : /^\d*$/.test(d) ? "numeric" : /^[a-zA-Z]*$/.test(d) ? "alpha" : /^[a-zA-Z0-9]*$/.test(d) ? "alphanumeric" : "characters";
  }, report: function() {
    return this.log.all("v");
  } };
  var S = function(d, m, l, y, b) {
    this.onError = d, this.onFault = m, this.serialize = l, b.enabled && this.watchWindowErrors(y), b.promise && this.watchPromiseErrors(y);
  };
  S.prototype = { watchPromiseErrors: function(d) {
    var m = this;
    d.addEventListener ? d.addEventListener("unhandledrejection", function(l) {
      try {
        l = l || {};
        var y = l.detail ? h.tryGet(l.detail, "reason") : h.tryGet(l, "reason");
        if (y !== r && y !== null && !y.__trackjs_state__) {
          if (!h.isError(y)) try {
            throw Error(m.serialize(y));
          } catch (b) {
            y = b;
          }
          m.onError("promise", y);
        }
      } catch (b) {
        m.onFault(b);
      }
    }) : h.patch(d, "onunhandledrejection", function(l) {
      return function(y) {
        m.onError("promise", y), l.apply(this, arguments);
      };
    });
  }, watchWindowErrors: function(d) {
    var m = this;
    h.patch(d, "onerror", function(l) {
      return function(y, b, w, _, k) {
        try {
          if (h.isError(k)) {
            m.onError("window", k), l.apply(this, arguments);
            return;
          }
          k = k || {};
          var O = { message: k.message || m.serialize(y), name: k.name || "Error", line: k.line || parseInt(w, 10) || null, column: k.column || parseInt(_, 10) || null, stack: k.stack || null };
          Object.prototype.toString.call(y) !== "[object Event]" || b ? O.file = k.file || m.serialize(b) : O.file = (y.target || {}).src, m.onError("window", O);
        } catch (D) {
          m.onFault(D);
        }
        l.apply(this, arguments);
      };
    });
  } };
  var E = function() {
    this.hasInstalled = !1, this.hasEnabled = !0, this.window = e, this.document = t, this.util = h, this.install = h.bind(this.install, this), this.onError = h.bind(this.onError, this), this.onFault = h.bind(this.onFault, this), this.serialize = h.bind(this.serialize, this), this.log = new o(h), this.metadata = new c(this.serialize);
    var d = e && (e._trackJs || e._trackJS || e._trackjs);
    d && this.install(d);
  };
  return E.prototype = {
    install: function(d) {
      try {
        if (h.isNode) return this.warn("monitoring disabled in node"), !1;
        if (!h.has(d, "token")) return this.warn("missing token"), !1;
        if (this.hasInstalled) return this.warn("already installed"), !1;
        if (this.config = new a(d), this.transmitter = new p(this.util, this.config), this.environment = new s(this.config), this.customer = new i(this.config, this.util, this.log, this.window, this.document), !this.config.current.enabled) return this.hasEnabled = !1;
        if (this.windowConsoleWatcher = new u(this.util, this.log, this.onError, this.onFault, this.serialize, this.window, this.config.current.console), !this.util.isBrowserSupported()) return !1;
        this.callbackWatcher = new n(this.config.current.callback, this.onError, this.onFault), this.visitorWatcher = new v(this.util, this.log, this.onError, this.onFault, this.document, this.config.current.visitor), this.navigationWatcher = new f(this.log, this.config.current.navigation), this.networkWatcher = new g(
          this.util,
          this.log,
          this.onError,
          this.onFault,
          this.window,
          this.config.current.network
        ), this.windowWatcher = new S(this.onError, this.onFault, this.serialize, this.window, this.config.current.window);
        var m = this;
        return h.afterDocumentLoad(function() {
          m.transmitter.sendUsage({ token: m.customer.token, correlationId: m.customer.correlationId, application: m.config.current.application, x: m.util.uuid() });
        }), this.hasInstalled = !0;
      } catch (l) {
        return this.onFault(l), !1;
      }
    },
    pub: function() {
      var d = this, m = { addMetadata: this.metadata.addMetadata, attempt: function(l, y) {
        try {
          var b = Array.prototype.slice.call(arguments, 2);
          return l.apply(y || this, b);
        } catch (w) {
          throw d.onError("catch", w), h.wrapError(w);
        }
      }, configure: function(l) {
        return !d.hasInstalled && d.hasEnabled ? (d.warn("agent must be installed"), !1) : d.config.setCurrent(l);
      }, hash: "ee2d3930f78cfd8bb97c23558688dedfac2d12ce", isInstalled: function() {
        return d.hasInstalled;
      }, install: this.install, removeMetadata: this.metadata.removeMetadata, track: function(l) {
        if (!d.hasInstalled && d.hasEnabled) d.warn("agent must be installed");
        else {
          var y = h.isError(l) ? l.message : d.serialize(l);
          if (l = l || {}, !l.stack) try {
            throw Error(y);
          } catch (b) {
            l = b;
          }
          d.onError("direct", l);
        }
      }, version: "3.10.4", watch: function(l, y) {
        return function() {
          try {
            var b = Array.prototype.slice.call(arguments, 0);
            return l.apply(y || this, b);
          } catch (w) {
            throw d.onError("catch", w), h.wrapError(w);
          }
        };
      }, watchAll: function(l) {
        var y = Array.prototype.slice.call(arguments, 1), b;
        for (b in l) typeof l[b] != "function" || h.contains(y, b) || (l[b] = this.watch(l[b], l));
        return l;
      } };
      return new u(
        h,
        d.log,
        d.onError,
        d.onFault,
        d.serialize,
        m,
        a.prototype.defaults.console
      ), m;
    },
    onError: /* @__PURE__ */ function() {
      var d, m = !1;
      return function(l, y, b) {
        if (this.hasInstalled && this.hasEnabled && h.isBrowserSupported()) try {
          if (b = b || { bindStack: null, bindTime: null, force: !1 }, y && h.isError(y) || (y = { name: "Error", message: this.serialize(y, b.force) }), y.message.indexOf("TrackJS Caught") === -1) if (m && y.message.indexOf("Script error") !== -1) m = !1;
          else {
            var w = h.defaultsDeep({}, { agentPlatform: h.isBrowser ? "browser" : "worker", bindStack: b.bindStack, bindTime: b.bindTime, column: y.column || y.columnNumber, console: this.windowConsoleWatcher.report(), customer: this.customer.report(), entry: l, environment: this.environment.report(), file: y.file || y.fileName, line: y.line || y.lineNumber, message: y.message, metadata: this.metadata.report(), nav: this.navigationWatcher.report(), network: this.networkWatcher.report(), url: (e.location || "").toString(), stack: y.stack, timestamp: this.util.isoNow(), visitor: this.visitorWatcher.report(), version: "3.10.4" });
            if (!b.force) try {
              if (!this.config.current.onError(w, y)) return;
            } catch (O) {
              w.console.push({
                timestamp: this.util.isoNow(),
                severity: "error",
                message: O.message
              });
              var _ = this;
              setTimeout(function() {
                _.onError("catch", O, { force: !0 });
              }, 0);
            }
            if (this.config.current.dedupe) {
              var k = (w.message + w.stack).substr(0, 1e4);
              if (k === d) return;
              d = k;
            }
            (function() {
              function O() {
                var A = 0;
                return h.forEach(w.console, function(P) {
                  A += (P.message || "").length;
                }), 8e4 <= A;
              }
              for (var D = 0; O() && D < w.console.length; ) w.console[D].message = h.truncate(w.console[D].message, 1e3), D++;
            })(), this.log.clear(), setTimeout(function() {
              m = !1;
            }), m = !0, this.transmitter.sendError(w, this.customer.token);
          }
        } catch (O) {
          this.onFault(O);
        }
      };
    }(),
    onFault: function(d) {
      var m = this.transmitter || new p();
      d = d || {}, d = { token: (this.customer || {}).token, file: d.file || d.fileName, msg: d.message || "unknown", stack: (d.stack || "unknown").substr(0, 1e3), url: this.window.location, v: "3.10.4", h: "ee2d3930f78cfd8bb97c23558688dedfac2d12ce", x: this.util.uuid() }, m.sendTrackerFault(d);
    },
    serialize: function(d, m) {
      if (this.hasInstalled && this.config.current.serialize && !m) try {
        return this.config.current.serialize(d);
      } catch (l) {
        this.onError("catch", l, { force: !0 });
      }
      return a.prototype.defaults.serialize(d);
    },
    warn: function(d) {
      h.has(e, "console.warn") && e.console.warn("TrackJS: " + d);
    }
  }, new E().pub();
}(typeof self > "u" ? void 0 : self, typeof document > "u" ? void 0 : document);
class _3 extends Fa {
  constructor() {
    super(...arguments);
    $(this, "token");
    $(this, "application");
    $(this, "network");
    $(this, "visitor");
  }
  init(r) {
    this.isStartedInit || (this.token = r.token, r.application && (this.application = r.application), r.network && (this.network = r.network), r.visitor && (this.visitor = r.visitor), this.baseInit(r.timeoutMS));
  }
  install() {
    if (!this.token)
      throw new dn("ErrorLogger requires a token parameter", {
        serviceName: Ue.ERROR_LOGGER
      });
    en.install({
      token: this.token,
      application: this.application,
      ...this.network && { network: this.network },
      ...this.visitor && { visitor: this.visitor }
    });
  }
  isInstalled() {
    return en.isInstalled();
  }
  track(r) {
    this.enqueueOrExecute(() => en.track(r));
  }
  log(r, ...n) {
    this.enqueueOrExecute(() => en.console[r](...n));
  }
  addMeta(r, n) {
    this.enqueueOrExecute(() => en.addMetadata(r, n));
  }
}
var Ji = /* @__PURE__ */ ((e) => (e.PageView = "pageView", e.ReachGoal = "reachGoal", e))(Ji || {});
class S3 extends Fa {
  constructor() {
    super(...arguments);
    $(this, "counterId");
  }
  init(r) {
    this.isStartedInit || (this.counterId = r.id, this.baseInit(r.timeoutMS));
  }
  install() {
    if (!this.counterId)
      throw new dn("VkAnalyticsProvider requires a counterId parameter", {
        serviceName: Ue.VK
      });
    gl(T3, {
      onload: () => {
        window._tmr = window._tmr || [];
      }
    }), this.addCounterImageToBody();
  }
  addCounterImageToBody() {
    const r = document.createElement("noscript"), n = document.createElement("div"), a = Object.assign(document.createElement("img"), {
      src: `${k3}?id=${this.counterId};js=na`,
      style: "border:0;position:absolute;left:-9999px;",
      alt: "Top.Mail.Ru"
    });
    n.append(a), r.append(n), document.body.append(r);
  }
  isInstalled() {
    return !!window._tmr;
  }
  hit(r) {
    this.enqueueOrExecute(
      () => window._tmr.push({
        id: this.counterId,
        type: Ji.PageView,
        ...r
      })
    );
  }
  reachGoal(r, n) {
    this.enqueueOrExecute(
      () => window._tmr.push({
        id: this.counterId,
        type: Ji.ReachGoal,
        goal: r,
        ...n
      })
    );
  }
}
const w3 = {
  [Ue.ADRIVER]: dg,
  [Ue.TRACKER]: b3,
  [Ue.ERROR_LOGGER]: _3,
  [Ue.VK]: S3
}, Wd = 6e4, E3 = 3e3, C3 = "https://content.adriver.ru/AdRiverFPS.js", T3 = "https://top-fwz1.mail.ru/js/code.js", k3 = "https://top-fwz1.mail.ru/counter";
var H0, G0, W0, q0;
q0 = Ue.ADRIVER, W0 = Ue.TRACKER, G0 = Ue.ERROR_LOGGER, H0 = Ue.VK;
class qw {
  constructor(t) {
    $(this, q0);
    $(this, W0);
    $(this, G0);
    $(this, H0);
    Object.entries(w3).forEach(([r, n]) => {
      cg(() => {
        t[r] && (this[r] = new n(), this[r].init(t[r]));
      });
    });
  }
}
var tn = {}, qd;
function A3() {
  if (qd) return tn;
  qd = 1, Object.defineProperty(tn, "__esModule", { value: !0 }), tn.parse = i, tn.serialize = c;
  const e = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/, t = /^[\u0021-\u003A\u003C-\u007E]*$/, r = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i, n = /^[\u0020-\u003A\u003D-\u007E]*$/, a = Object.prototype.toString, u = /* @__PURE__ */ (() => {
    const p = function() {
    };
    return p.prototype = /* @__PURE__ */ Object.create(null), p;
  })();
  function i(p, h) {
    const v = new u(), S = p.length;
    if (S < 2)
      return v;
    const E = (h == null ? void 0 : h.decode) || f;
    let d = 0;
    do {
      const m = p.indexOf("=", d);
      if (m === -1)
        break;
      const l = p.indexOf(";", d), y = l === -1 ? S : l;
      if (m > y) {
        d = p.lastIndexOf(";", m - 1) + 1;
        continue;
      }
      const b = s(p, d, m), w = o(p, m, b), _ = p.slice(b, w);
      if (v[_] === void 0) {
        let k = s(p, m + 1, y), O = o(p, y, k);
        const D = E(p.slice(k, O));
        v[_] = D;
      }
      d = y + 1;
    } while (d < S);
    return v;
  }
  function s(p, h, v) {
    do {
      const S = p.charCodeAt(h);
      if (S !== 32 && S !== 9)
        return h;
    } while (++h < v);
    return v;
  }
  function o(p, h, v) {
    for (; h > v; ) {
      const S = p.charCodeAt(--h);
      if (S !== 32 && S !== 9)
        return h + 1;
    }
    return v;
  }
  function c(p, h, v) {
    const S = (v == null ? void 0 : v.encode) || encodeURIComponent;
    if (!e.test(p))
      throw new TypeError(`argument name is invalid: ${p}`);
    const E = S(h);
    if (!t.test(E))
      throw new TypeError(`argument val is invalid: ${h}`);
    let d = p + "=" + E;
    if (!v)
      return d;
    if (v.maxAge !== void 0) {
      if (!Number.isInteger(v.maxAge))
        throw new TypeError(`option maxAge is invalid: ${v.maxAge}`);
      d += "; Max-Age=" + v.maxAge;
    }
    if (v.domain) {
      if (!r.test(v.domain))
        throw new TypeError(`option domain is invalid: ${v.domain}`);
      d += "; Domain=" + v.domain;
    }
    if (v.path) {
      if (!n.test(v.path))
        throw new TypeError(`option path is invalid: ${v.path}`);
      d += "; Path=" + v.path;
    }
    if (v.expires) {
      if (!g(v.expires) || !Number.isFinite(v.expires.valueOf()))
        throw new TypeError(`option expires is invalid: ${v.expires}`);
      d += "; Expires=" + v.expires.toUTCString();
    }
    if (v.httpOnly && (d += "; HttpOnly"), v.secure && (d += "; Secure"), v.partitioned && (d += "; Partitioned"), v.priority)
      switch (typeof v.priority == "string" ? v.priority.toLowerCase() : void 0) {
        case "low":
          d += "; Priority=Low";
          break;
        case "medium":
          d += "; Priority=Medium";
          break;
        case "high":
          d += "; Priority=High";
          break;
        default:
          throw new TypeError(`option priority is invalid: ${v.priority}`);
      }
    if (v.sameSite)
      switch (typeof v.sameSite == "string" ? v.sameSite.toLowerCase() : v.sameSite) {
        case !0:
        case "strict":
          d += "; SameSite=Strict";
          break;
        case "lax":
          d += "; SameSite=Lax";
          break;
        case "none":
          d += "; SameSite=None";
          break;
        default:
          throw new TypeError(`option sameSite is invalid: ${v.sameSite}`);
      }
    return d;
  }
  function f(p) {
    if (p.indexOf("%") === -1)
      return p;
    try {
      return decodeURIComponent(p);
    } catch {
      return p;
    }
  }
  function g(p) {
    return a.call(p) === "[object Date]";
  }
  return tn;
}
var ua = A3();
function O3() {
  const e = typeof global > "u" ? void 0 : global.TEST_HAS_DOCUMENT_COOKIE;
  return typeof e == "boolean" ? e : typeof document == "object" && typeof document.cookie == "string";
}
function I3(e) {
  return typeof e == "string" ? ua.parse(e) : typeof e == "object" && e !== null ? e : {};
}
function hi(e, t = {}) {
  const r = P3(e);
  if (!t.doNotParse)
    try {
      return JSON.parse(r);
    } catch {
    }
  return e;
}
function P3(e) {
  return e && e[0] === "j" && e[1] === ":" ? e.substr(2) : e;
}
class B3 {
  constructor(t, r = {}) {
    this.changeListeners = [], this.HAS_DOCUMENT_COOKIE = !1, this.update = () => {
      if (!this.HAS_DOCUMENT_COOKIE)
        return;
      const a = this.cookies;
      this.cookies = ua.parse(document.cookie), this._checkChanges(a);
    };
    const n = typeof document > "u" ? "" : document.cookie;
    this.cookies = I3(t || n), this.defaultSetOptions = r, this.HAS_DOCUMENT_COOKIE = O3();
  }
  _emitChange(t) {
    for (let r = 0; r < this.changeListeners.length; ++r)
      this.changeListeners[r](t);
  }
  _checkChanges(t) {
    new Set(Object.keys(t).concat(Object.keys(this.cookies))).forEach((n) => {
      t[n] !== this.cookies[n] && this._emitChange({
        name: n,
        value: hi(this.cookies[n])
      });
    });
  }
  _startPolling() {
    this.pollingInterval = setInterval(this.update, 300);
  }
  _stopPolling() {
    this.pollingInterval && clearInterval(this.pollingInterval);
  }
  get(t, r = {}) {
    return r.doNotUpdate || this.update(), hi(this.cookies[t], r);
  }
  getAll(t = {}) {
    t.doNotUpdate || this.update();
    const r = {};
    for (let n in this.cookies)
      r[n] = hi(this.cookies[n], t);
    return r;
  }
  set(t, r, n) {
    n ? n = Object.assign(Object.assign({}, this.defaultSetOptions), n) : n = this.defaultSetOptions;
    const a = typeof r == "string" ? r : JSON.stringify(r);
    this.cookies = Object.assign(Object.assign({}, this.cookies), { [t]: a }), this.HAS_DOCUMENT_COOKIE && (document.cookie = ua.serialize(t, a, n)), this._emitChange({ name: t, value: r, options: n });
  }
  remove(t, r) {
    const n = r = Object.assign(Object.assign(Object.assign({}, this.defaultSetOptions), r), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 });
    this.cookies = Object.assign({}, this.cookies), delete this.cookies[t], this.HAS_DOCUMENT_COOKIE && (document.cookie = ua.serialize(t, "", n)), this._emitChange({ name: t, value: void 0, options: r });
  }
  addChangeListener(t) {
    this.changeListeners.push(t), this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 1 && (typeof window == "object" && "cookieStore" in window ? window.cookieStore.addEventListener("change", this.update) : this._startPolling());
  }
  removeChangeListener(t) {
    const r = this.changeListeners.indexOf(t);
    r >= 0 && this.changeListeners.splice(r, 1), this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 0 && (typeof window == "object" && "cookieStore" in window ? window.cookieStore.removeEventListener("change", this.update) : this._stopPolling());
  }
  removeAllChangeListeners() {
    for (; this.changeListeners.length > 0; )
      this.removeChangeListener(this.changeListeners[0]);
  }
}
class zw {
  constructor() {
    $(this, "cookies");
    this.cookies = new B3();
  }
  set(t, r, n) {
    this.cookies.set(t, r, n);
  }
  get(t) {
    return this.cookies.get(t);
  }
  remove(t, r) {
    this.cookies.remove(t, r);
  }
  has(t) {
    return this.cookies.get(t) !== void 0;
  }
  getAll() {
    return this.cookies.getAll();
  }
}
var N3 = function(e, t, r, n) {
  function a(u) {
    return u instanceof r ? u : new r(function(i) {
      i(u);
    });
  }
  return new (r || (r = Promise))(function(u, i) {
    function s(f) {
      try {
        c(n.next(f));
      } catch (g) {
        i(g);
      }
    }
    function o(f) {
      try {
        c(n.throw(f));
      } catch (g) {
        i(g);
      }
    }
    function c(f) {
      f.done ? u(f.value) : a(f.value).then(s, o);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, D3 = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
let mi = class {
  static insertMetrika(t) {
    var r;
    window.ym = window.ym || function() {
      (window.ym.a = window.ym.a || []).push(arguments);
    }, window.ym.l = (/* @__PURE__ */ new Date()).getTime();
    const n = document.getElementsByTagName("script")[0], a = document.createElement("script");
    a.type = "text/javascript", a.src = t ?? "https://mc.yandex.ru/metrika/tag.js", a.async = !0, (r = n == null ? void 0 : n.parentNode) === null || r === void 0 || r.insertBefore(a, n);
  }
  /**
   * Initializes the Yandex Metrika counter with the provided configurations.
   */
  static initMetrika(t) {
    for (let r of t) {
      const { id: n } = r, a = D3(r, ["id"]);
      window.ym(n, "init", a);
    }
  }
  /**
   * Constructs a new MetrikaService instance.
   * @param counterId - The default counter ID to use.
   */
  constructor(t) {
    this.defaultCounterId = t;
  }
  /**
   * Adds file extensions to track as downloadable files.
   * @param extensions - A string or array of strings representing file extensions.
   * @param counterId - Optional counter ID. Defaults to the default counter ID.
   * @see https://yandex.ru/support/metrica/objects/addfileextension.html
   */
  addFileExtension(t, r) {
    window.ym(r ?? this.defaultCounterId, "addFileExtension", t);
  }
  /**
   * Tracks an external link click.
   * @param url - The URL of the external link.
   * @param options - Options for the external link tracking.
   * @param counterId - Optional counter ID. Defaults to the default counter ID.
   * @returns A promise that resolves when the link is tracked.
   * @see https://yandex.ru/support/metrica/objects/extlink.html
   */
  extLink(t, r = {}, n) {
    const a = this.getCallbackPromise(r);
    return window.ym(n ?? this.defaultCounterId, "extLink", t, r), a;
  }
  /**
   * Tracks a file download.
   * @param url - The URL of the file.
   * @param options - Options for the file download tracking.
   * @param counterId - Optional counter ID. Defaults to the default counter ID.
   * @returns A promise that resolves when the file is tracked.
   * @see https://yandex.ru/support/metrica/objects/file.html
   */
  file(t, r = {}, n) {
    const a = this.getCallbackPromise(r);
    return window.ym(n ?? this.defaultCounterId, "file", t, r), a;
  }
  /**
   * Retrieves the client ID.
   * @param counterId - Optional counter ID. Defaults to the default counter ID.
   * @returns A promise that resolves with the client ID.
   * @see https://yandex.ru/support/metrica/objects/get-client-id.html
   */
  getClientID(t) {
    return new Promise((r) => {
      window.ym(t ?? this.defaultCounterId, "getClientID", r);
    });
  }
  /**
   * Sets the user ID.
   * @param userId - The user ID to set.
   * @param counterId - Optional counter ID. Defaults to the default counter ID.
   * @see https://yandex.ru/support/metrica/objects/set-user-id.html
   */
  setUserID(t, r) {
    window.ym(r ?? this.defaultCounterId, "setUserID", t);
  }
  /**
   * Sets user parameters.
   * @param parameters - The user parameters to set.
   * @param counterId - Optional counter ID. Defaults to the default counter ID.
   * @see https://yandex.ru/support/metrica/objects/user-params.html
   */
  userParams(t, r) {
    window.ym(r ?? this.defaultCounterId, "userParams", t);
  }
  /**
   * Sets visit parameters.
   * @param parameters - The visit parameters to set.
   * @param counterId - Optional counter ID. Defaults to the default counter ID.
   * @see https://yandex.ru/support/metrica/objects/params-method.html
   */
  params(t, r) {
    window.ym(r ?? this.defaultCounterId, "params", t);
  }
  /**
   * Marks the user interaction as not a bounce.
   * @param options - Options for the not bounce event.
   * @param counterId - Optional counter ID. Defaults to the default counter ID.
   * @returns A promise that resolves when the event is tracked.
   */
  notBounce(t, r) {
    return N3(this, void 0, void 0, function* () {
      const n = this.getCallbackPromise(t);
      return window.ym(r ?? this.defaultCounterId, "notBounce", t), n;
    });
  }
  /**
   * Tracks a goal achievement.
   * @param target - The name of the goal.
   * @param params - Optional parameters associated with the goal.
   * @param callback - Optional callback to execute when the event is tracked.
   * @param ctx - Optional context for the callback.
   * @param counterId - Optional counter ID. Defaults to the default counter ID.
   * @returns A promise that resolves when the goal is tracked.
   * @see https://yandex.ru/support/metrica/objects/reachgoal.html
   */
  reachGoal(t, r, n, a, u) {
    const i = { callback: n, ctx: a }, s = this.getCallbackPromise(i);
    return window.ym(u ?? this.defaultCounterId, "reachGoal", t, r, i.callback, i.ctx), s;
  }
  /**
   * Tracks a page view (hit).
   * @param url - The URL of the page.
   * @param options - Options for the page view tracking.
   * @param counterId - Optional counter ID. Defaults to the default counter ID.
   * @returns A promise that resolves when the hit is tracked.
   * @see https://yandex.ru/support/metrica/objects/hit.html
   */
  hit(t, r = {}, n) {
    const a = this.getCallbackPromise(r);
    return window.ym(n ?? this.defaultCounterId, "hit", t, r), a;
  }
  /**
   * Helper method to create a promise for callback-based events.
   * @param options - Options containing a callback function.
   * @returns A promise that resolves when the callback is executed.
   */
  getCallbackPromise(t) {
    return new Promise((r) => {
      const n = t.callback;
      t.callback = function() {
        n && n.call(this), r(this);
      };
    });
  }
};
const Rt = class Rt {
  constructor(t) {
    $(this, "service");
    this.service = new mi(t.id), Rt.initialized || (mi.insertMetrika(), Rt.initialized = !0), Rt.counters.push(t), mi.initMetrika(Rt.counters);
  }
  reachGoal(t, r) {
    this.service.reachGoal(t, r);
  }
  hit(t, r) {
    this.service.hit(t, r);
  }
  params(t) {
    this.service.params(t);
  }
  userParams(t) {
    this.service.userParams(t);
  }
  addFileExtension(t) {
    this.service.addFileExtension(t);
  }
  extLink(t, r) {
    this.service.extLink(t, r);
  }
  file(t, r) {
    this.service.file(t, r);
  }
  notBounce(t) {
    this.service.notBounce(t);
  }
};
$(Rt, "initialized", !1), $(Rt, "counters", []);
let zd = Rt;
var Ki = /* @__PURE__ */ ((e) => (e.Warning = "warning", e.Error = "error", e.Info = "info", e))(Ki || {}), R3 = /* @__PURE__ */ ((e) => (e.Development = "development", e.Production = "production", e))(R3 || {});
const L = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, V = globalThis, Zt = "9.32.0";
function dr() {
  return Wa(V), V;
}
function Wa(e) {
  const t = e.__SENTRY__ = e.__SENTRY__ || {};
  return t.version = t.version || Zt, t[Zt] = t[Zt] || {};
}
function qa(e, t, r = V) {
  const n = r.__SENTRY__ = r.__SENTRY__ || {}, a = n[Zt] = n[Zt] || {};
  return a[e] || (a[e] = t());
}
const x3 = "Sentry Logger ", ya = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], va = {};
function Wt(e) {
  if (!("console" in V))
    return e();
  const t = V.console, r = {}, n = Object.keys(va);
  n.forEach((a) => {
    const u = va[a];
    r[a] = t[a], t[a] = u;
  });
  try {
    return e();
  } finally {
    n.forEach((a) => {
      t[a] = r[a];
    });
  }
}
function j3() {
  let e = !1;
  const t = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return L ? ya.forEach((r) => {
    t[r] = (...n) => {
      e && Wt(() => {
        V.console[r](`${x3}[${r}]:`, ...n);
      });
    };
  }) : ya.forEach((r) => {
    t[r] = () => {
    };
  }), t;
}
const B = qa("logger", j3), Rl = 50, ar = "?", Vd = /\(error: (.*)\)/, Yd = /captureMessage|captureException/;
function xl(...e) {
  const t = e.sort((r, n) => r[0] - n[0]).map((r) => r[1]);
  return (r, n = 0, a = 0) => {
    const u = [], i = r.split(`
`);
    for (let s = n; s < i.length; s++) {
      const o = i[s];
      if (o.length > 1024)
        continue;
      const c = Vd.test(o) ? o.replace(Vd, "$1") : o;
      if (!c.match(/\S*Error: /)) {
        for (const f of t) {
          const g = f(c);
          if (g) {
            u.push(g);
            break;
          }
        }
        if (u.length >= Rl + a)
          break;
      }
    }
    return L3(u.slice(a));
  };
}
function M3(e) {
  return Array.isArray(e) ? xl(...e) : e;
}
function L3(e) {
  if (!e.length)
    return [];
  const t = Array.from(e);
  return /sentryWrapped/.test(Fn(t).function || "") && t.pop(), t.reverse(), Yd.test(Fn(t).function || "") && (t.pop(), Yd.test(Fn(t).function || "") && t.pop()), t.slice(0, Rl).map((r) => ({
    ...r,
    filename: r.filename || Fn(t).filename,
    function: r.function || ar
  }));
}
function Fn(e) {
  return e[e.length - 1] || {};
}
const gi = "<anonymous>";
function kt(e) {
  try {
    return !e || typeof e != "function" ? gi : e.name || gi;
  } catch {
    return gi;
  }
}
function Xd(e) {
  const t = e.exception;
  if (t) {
    const r = [];
    try {
      return t.values.forEach((n) => {
        n.stacktrace.frames && r.push(...n.stacktrace.frames);
      }), r;
    } catch {
      return;
    }
  }
}
const ia = {}, Jd = {};
function qt(e, t) {
  ia[e] = ia[e] || [], ia[e].push(t);
}
function zt(e, t) {
  if (!Jd[e]) {
    Jd[e] = !0;
    try {
      t();
    } catch (r) {
      L && B.error(`Error while instrumenting ${e}`, r);
    }
  }
}
function Ke(e, t) {
  const r = e && ia[e];
  if (r)
    for (const n of r)
      try {
        n(t);
      } catch (a) {
        L && B.error(
          `Error while triggering instrumentation handler.
Type: ${e}
Name: ${kt(n)}
Error:`,
          a
        );
      }
}
let yi = null;
function jl(e) {
  const t = "error";
  qt(t, e), zt(t, F3);
}
function F3() {
  yi = V.onerror, V.onerror = function(e, t, r, n, a) {
    return Ke("error", {
      column: n,
      error: a,
      line: r,
      msg: e,
      url: t
    }), yi ? yi.apply(this, arguments) : !1;
  }, V.onerror.__SENTRY_INSTRUMENTED__ = !0;
}
let vi = null;
function Ml(e) {
  const t = "unhandledrejection";
  qt(t, e), zt(t, $3);
}
function $3() {
  vi = V.onunhandledrejection, V.onunhandledrejection = function(e) {
    return Ke("unhandledrejection", e), vi ? vi.apply(this, arguments) : !0;
  }, V.onunhandledrejection.__SENTRY_INSTRUMENTED__ = !0;
}
const Ll = Object.prototype.toString;
function $s(e) {
  switch (Ll.call(e)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
    case "[object WebAssembly.Exception]":
      return !0;
    default:
      return At(e, Error);
  }
}
function Fr(e, t) {
  return Ll.call(e) === `[object ${t}]`;
}
function Fl(e) {
  return Fr(e, "ErrorEvent");
}
function Kd(e) {
  return Fr(e, "DOMError");
}
function U3(e) {
  return Fr(e, "DOMException");
}
function Tt(e) {
  return Fr(e, "String");
}
function Us(e) {
  return typeof e == "object" && e !== null && "__sentry_template_string__" in e && "__sentry_template_values__" in e;
}
function ln(e) {
  return e === null || Us(e) || typeof e != "object" && typeof e != "function";
}
function pn(e) {
  return Fr(e, "Object");
}
function za(e) {
  return typeof Event < "u" && At(e, Event);
}
function H3(e) {
  return typeof Element < "u" && At(e, Element);
}
function G3(e) {
  return Fr(e, "RegExp");
}
function Va(e) {
  return !!(e != null && e.then && typeof e.then == "function");
}
function W3(e) {
  return pn(e) && "nativeEvent" in e && "preventDefault" in e && "stopPropagation" in e;
}
function At(e, t) {
  try {
    return e instanceof t;
  } catch {
    return !1;
  }
}
function $l(e) {
  return !!(typeof e == "object" && e !== null && (e.__isVue || e._isVue));
}
function Ul(e) {
  return typeof Request < "u" && At(e, Request);
}
const Hs = V, q3 = 80;
function Lt(e, t = {}) {
  if (!e)
    return "<unknown>";
  try {
    let r = e;
    const n = 5, a = [];
    let u = 0, i = 0;
    const s = " > ", o = s.length;
    let c;
    const f = Array.isArray(t) ? t : t.keyAttrs, g = !Array.isArray(t) && t.maxStringLength || q3;
    for (; r && u++ < n && (c = z3(r, f), !(c === "html" || u > 1 && i + a.length * o + c.length >= g)); )
      a.push(c), i += c.length, r = r.parentNode;
    return a.reverse().join(s);
  } catch {
    return "<unknown>";
  }
}
function z3(e, t) {
  const r = e, n = [];
  if (!(r != null && r.tagName))
    return "";
  if (Hs.HTMLElement && r instanceof HTMLElement && r.dataset) {
    if (r.dataset.sentryComponent)
      return r.dataset.sentryComponent;
    if (r.dataset.sentryElement)
      return r.dataset.sentryElement;
  }
  n.push(r.tagName.toLowerCase());
  const a = t != null && t.length ? t.filter((i) => r.getAttribute(i)).map((i) => [i, r.getAttribute(i)]) : null;
  if (a != null && a.length)
    a.forEach((i) => {
      n.push(`[${i[0]}="${i[1]}"]`);
    });
  else {
    r.id && n.push(`#${r.id}`);
    const i = r.className;
    if (i && Tt(i)) {
      const s = i.split(/\s+/);
      for (const o of s)
        n.push(`.${o}`);
    }
  }
  const u = ["aria-label", "type", "name", "title", "alt"];
  for (const i of u) {
    const s = r.getAttribute(i);
    s && n.push(`[${i}="${s}"]`);
  }
  return n.join("");
}
function wn() {
  try {
    return Hs.document.location.href;
  } catch {
    return "";
  }
}
function Hl(e) {
  if (!Hs.HTMLElement)
    return null;
  let t = e;
  const r = 5;
  for (let n = 0; n < r; n++) {
    if (!t)
      return null;
    if (t instanceof HTMLElement) {
      if (t.dataset.sentryComponent)
        return t.dataset.sentryComponent;
      if (t.dataset.sentryElement)
        return t.dataset.sentryElement;
    }
    t = t.parentNode;
  }
  return null;
}
function ba(e, t = 0) {
  return typeof e != "string" || t === 0 || e.length <= t ? e : `${e.slice(0, t)}...`;
}
function _a(e, t) {
  if (!Array.isArray(e))
    return "";
  const r = [];
  for (let n = 0; n < e.length; n++) {
    const a = e[n];
    try {
      $l(a) ? r.push("[VueViewModel]") : r.push(String(a));
    } catch {
      r.push("[value cannot be serialized]");
    }
  }
  return r.join(t);
}
function V3(e, t, r = !1) {
  return Tt(e) ? G3(t) ? t.test(e) : Tt(t) ? r ? e === t : e.includes(t) : !1 : !1;
}
function Mt(e, t = [], r = !1) {
  return t.some((n) => V3(e, n, r));
}
function Ve(e, t, r) {
  if (!(t in e))
    return;
  const n = e[t];
  if (typeof n != "function")
    return;
  const a = r(n);
  typeof a == "function" && Gl(a, n);
  try {
    e[t] = a;
  } catch {
    L && B.log(`Failed to replace method "${t}" in object`, e);
  }
}
function Ye(e, t, r) {
  try {
    Object.defineProperty(e, t, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    L && B.log(`Failed to add non-enumerable property "${t}" to object`, e);
  }
}
function Gl(e, t) {
  try {
    const r = t.prototype || {};
    e.prototype = t.prototype = r, Ye(e, "__sentry_original__", t);
  } catch {
  }
}
function Gs(e) {
  return e.__sentry_original__;
}
function Wl(e) {
  if ($s(e))
    return {
      message: e.message,
      name: e.name,
      stack: e.stack,
      ...Zd(e)
    };
  if (za(e)) {
    const t = {
      type: e.type,
      target: Qd(e.target),
      currentTarget: Qd(e.currentTarget),
      ...Zd(e)
    };
    return typeof CustomEvent < "u" && At(e, CustomEvent) && (t.detail = e.detail), t;
  } else
    return e;
}
function Qd(e) {
  try {
    return H3(e) ? Lt(e) : Object.prototype.toString.call(e);
  } catch {
    return "<unknown>";
  }
}
function Zd(e) {
  if (typeof e == "object" && e !== null) {
    const t = {};
    for (const r in e)
      Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    return t;
  } else
    return {};
}
function Y3(e, t = 40) {
  const r = Object.keys(Wl(e));
  r.sort();
  const n = r[0];
  if (!n)
    return "[object has no keys]";
  if (n.length >= t)
    return ba(n, t);
  for (let a = r.length; a > 0; a--) {
    const u = r.slice(0, a).join(", ");
    if (!(u.length > t))
      return a === r.length ? u : ba(u, t);
  }
  return "";
}
function X3() {
  const e = V;
  return e.crypto || e.msCrypto;
}
function Qe(e = X3()) {
  let t = () => Math.random() * 16;
  try {
    if (e != null && e.randomUUID)
      return e.randomUUID().replace(/-/g, "");
    e != null && e.getRandomValues && (t = () => {
      const r = new Uint8Array(1);
      return e.getRandomValues(r), r[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (r) => (
      // eslint-disable-next-line no-bitwise
      (r ^ (t() & 15) >> r / 4).toString(16)
    )
  );
}
function ql(e) {
  var t, r;
  return (r = (t = e.exception) == null ? void 0 : t.values) == null ? void 0 : r[0];
}
function Jt(e) {
  const { message: t, event_id: r } = e;
  if (t)
    return t;
  const n = ql(e);
  return n ? n.type && n.value ? `${n.type}: ${n.value}` : n.type || n.value || r || "<unknown>" : r || "<unknown>";
}
function Qi(e, t, r) {
  const n = e.exception = e.exception || {}, a = n.values = n.values || [], u = a[0] = a[0] || {};
  u.value || (u.value = t || ""), u.type || (u.type = "Error");
}
function ur(e, t) {
  const r = ql(e);
  if (!r)
    return;
  const n = { type: "generic", handled: !0 }, a = r.mechanism;
  if (r.mechanism = { ...n, ...a, ...t }, t && "data" in t) {
    const u = { ...a == null ? void 0 : a.data, ...t.data };
    r.mechanism.data = u;
  }
}
function ef(e) {
  if (J3(e))
    return !0;
  try {
    Ye(e, "__sentry_captured__", !0);
  } catch {
  }
  return !1;
}
function J3(e) {
  try {
    return e.__sentry_captured__;
  } catch {
  }
}
const zl = 1e3;
function En() {
  return Date.now() / zl;
}
function K3() {
  const { performance: e } = V;
  if (!(e != null && e.now))
    return En;
  const t = Date.now() - e.now(), r = e.timeOrigin == null ? t : e.timeOrigin;
  return () => (r + e.now()) / zl;
}
const Te = K3();
let bi;
function Q3() {
  var f;
  const { performance: e } = V;
  if (!(e != null && e.now))
    return [void 0, "none"];
  const t = 3600 * 1e3, r = e.now(), n = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - n) : t, u = a < t, i = (f = e.timing) == null ? void 0 : f.navigationStart, o = typeof i == "number" ? Math.abs(i + r - n) : t, c = o < t;
  return u || c ? a <= o ? [e.timeOrigin, "timeOrigin"] : [i, "navigationStart"] : [n, "dateNow"];
}
function tt() {
  return bi || (bi = Q3()), bi[0];
}
function Z3(e) {
  const t = Te(), r = {
    sid: Qe(),
    init: !0,
    timestamp: t,
    started: t,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: !1,
    toJSON: () => ty(r)
  };
  return e && Dr(r, e), r;
}
function Dr(e, t = {}) {
  if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || Te(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : Qe()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof t.duration == "number")
    e.duration = t.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
function ey(e, t) {
  let r = {};
  e.status === "ok" && (r = { status: "exited" }), Dr(e, r);
}
function ty(e) {
  return {
    sid: `${e.sid}`,
    init: e.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(e.started * 1e3).toISOString(),
    timestamp: new Date(e.timestamp * 1e3).toISOString(),
    status: e.status,
    errors: e.errors,
    did: typeof e.did == "number" || typeof e.did == "string" ? `${e.did}` : void 0,
    duration: e.duration,
    abnormal_mechanism: e.abnormal_mechanism,
    attrs: {
      release: e.release,
      environment: e.environment,
      ip_address: e.ipAddress,
      user_agent: e.userAgent
    }
  };
}
function Cn(e, t, r = 2) {
  if (!t || typeof t != "object" || r <= 0)
    return t;
  if (e && Object.keys(t).length === 0)
    return e;
  const n = { ...e };
  for (const a in t)
    Object.prototype.hasOwnProperty.call(t, a) && (n[a] = Cn(n[a], t[a], r - 1));
  return n;
}
function Ft() {
  return Qe();
}
function Tn() {
  return Qe().substring(16);
}
const Zi = "_sentrySpan";
function hn(e, t) {
  t ? Ye(e, Zi, t) : delete e[Zi];
}
function Sa(e) {
  return e[Zi];
}
const ry = 100;
class lt {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = {
      traceId: Ft(),
      sampleRand: Math.random()
    };
  }
  /**
   * Clone all data from this scope into a new scope.
   */
  clone() {
    const t = new lt();
    return t._breadcrumbs = [...this._breadcrumbs], t._tags = { ...this._tags }, t._extra = { ...this._extra }, t._contexts = { ...this._contexts }, this._contexts.flags && (t._contexts.flags = {
      values: [...this._contexts.flags.values]
    }), t._user = this._user, t._level = this._level, t._session = this._session, t._transactionName = this._transactionName, t._fingerprint = this._fingerprint, t._eventProcessors = [...this._eventProcessors], t._attachments = [...this._attachments], t._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, t._propagationContext = { ...this._propagationContext }, t._client = this._client, t._lastEventId = this._lastEventId, hn(t, Sa(this)), t;
  }
  /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */
  setClient(t) {
    this._client = t;
  }
  /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */
  setLastEventId(t) {
    this._lastEventId = t;
  }
  /**
   * Get the client assigned to this scope.
   */
  getClient() {
    return this._client;
  }
  /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(t) {
    this._scopeListeners.push(t);
  }
  /**
   * Add an event processor that will be called before an event is sent.
   */
  addEventProcessor(t) {
    return this._eventProcessors.push(t), this;
  }
  /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */
  setUser(t) {
    return this._user = t || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && Dr(this._session, { user: t }), this._notifyScopeListeners(), this;
  }
  /**
   * Get the user from this scope.
   */
  getUser() {
    return this._user;
  }
  /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */
  setTags(t) {
    return this._tags = {
      ...this._tags,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * Set a single tag that will be sent as tags data with the event.
   */
  setTag(t, r) {
    return this._tags = { ...this._tags, [t]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */
  setExtras(t) {
    return this._extra = {
      ...this._extra,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */
  setExtra(t, r) {
    return this._extra = { ...this._extra, [t]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */
  setFingerprint(t) {
    return this._fingerprint = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the level on the scope for future events.
   */
  setLevel(t) {
    return this._level = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */
  setTransactionName(t) {
    return this._transactionName = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */
  setContext(t, r) {
    return r === null ? delete this._contexts[t] : this._contexts[t] = r, this._notifyScopeListeners(), this;
  }
  /**
   * Set the session for the scope.
   */
  setSession(t) {
    return t ? this._session = t : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * Get the session from the scope.
   */
  getSession() {
    return this._session;
  }
  /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */
  update(t) {
    if (!t)
      return this;
    const r = typeof t == "function" ? t(this) : t, n = r instanceof lt ? r.getScopeData() : pn(r) ? t : void 0, { tags: a, extra: u, user: i, contexts: s, level: o, fingerprint: c = [], propagationContext: f } = n || {};
    return this._tags = { ...this._tags, ...a }, this._extra = { ...this._extra, ...u }, this._contexts = { ...this._contexts, ...s }, i && Object.keys(i).length && (this._user = i), o && (this._level = o), c.length && (this._fingerprint = c), f && (this._propagationContext = f), this;
  }
  /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._session = void 0, hn(this, void 0), this._attachments = [], this.setPropagationContext({ traceId: Ft(), sampleRand: Math.random() }), this._notifyScopeListeners(), this;
  }
  /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */
  addBreadcrumb(t, r) {
    var u;
    const n = typeof r == "number" ? r : ry;
    if (n <= 0)
      return this;
    const a = {
      timestamp: En(),
      ...t,
      // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
      message: t.message ? ba(t.message, 2048) : t.message
    };
    return this._breadcrumbs.push(a), this._breadcrumbs.length > n && (this._breadcrumbs = this._breadcrumbs.slice(-n), (u = this._client) == null || u.recordDroppedEvent("buffer_overflow", "log_item")), this._notifyScopeListeners(), this;
  }
  /**
   * Get the last breadcrumb of the scope.
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * Clear all breadcrumbs from the scope.
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * Add an attachment to the scope.
   */
  addAttachment(t) {
    return this._attachments.push(t), this;
  }
  /**
   * Clear all attachments from the scope.
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /**
   * Get the data of this scope, which should be applied to an event during processing.
   */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Sa(this)
    };
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */
  setSDKProcessingMetadata(t) {
    return this._sdkProcessingMetadata = Cn(this._sdkProcessingMetadata, t, 2), this;
  }
  /**
   * Add propagation context to the scope, used for distributed tracing
   */
  setPropagationContext(t) {
    return this._propagationContext = t, this;
  }
  /**
   * Get propagation context from the scope, used for distributed tracing
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */
  captureException(t, r) {
    const n = (r == null ? void 0 : r.event_id) || Qe();
    if (!this._client)
      return B.warn("No client configured on scope - will not capture exception!"), n;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      t,
      {
        originalException: t,
        syntheticException: a,
        ...r,
        event_id: n
      },
      this
    ), n;
  }
  /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */
  captureMessage(t, r, n) {
    const a = (n == null ? void 0 : n.event_id) || Qe();
    if (!this._client)
      return B.warn("No client configured on scope - will not capture message!"), a;
    const u = new Error(t);
    return this._client.captureMessage(
      t,
      r,
      {
        originalException: t,
        syntheticException: u,
        ...n,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */
  captureEvent(t, r) {
    const n = (r == null ? void 0 : r.event_id) || Qe();
    return this._client ? (this._client.captureEvent(t, { ...r, event_id: n }, this), n) : (B.warn("No client configured on scope - will not capture event!"), n);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((t) => {
      t(this);
    }), this._notifyingListeners = !1);
  }
}
function ny() {
  return qa("defaultCurrentScope", () => new lt());
}
function ay() {
  return qa("defaultIsolationScope", () => new lt());
}
class uy {
  constructor(t, r) {
    let n;
    t ? n = t : n = new lt();
    let a;
    r ? a = r : a = new lt(), this._stack = [{ scope: n }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(t) {
    const r = this._pushScope();
    let n;
    try {
      n = t(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return Va(n) ? n.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), n);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const t = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: t
    }), t;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Rr() {
  const e = dr(), t = Wa(e);
  return t.stack = t.stack || new uy(ny(), ay());
}
function iy(e) {
  return Rr().withScope(e);
}
function sy(e, t) {
  const r = Rr();
  return r.withScope(() => (r.getStackTop().scope = e, t(e)));
}
function tf(e) {
  return Rr().withScope(() => e(Rr().getIsolationScope()));
}
function oy() {
  return {
    withIsolationScope: tf,
    withScope: iy,
    withSetScope: sy,
    withSetIsolationScope: (e, t) => tf(t),
    getCurrentScope: () => Rr().getScope(),
    getIsolationScope: () => Rr().getIsolationScope()
  };
}
function $r(e) {
  const t = Wa(e);
  return t.acs ? t.acs : oy();
}
function re() {
  const e = dr();
  return $r(e).getCurrentScope();
}
function Vt() {
  const e = dr();
  return $r(e).getIsolationScope();
}
function cy() {
  return qa("globalScope", () => new lt());
}
function kn(...e) {
  const t = dr(), r = $r(t);
  if (e.length === 2) {
    const [n, a] = e;
    return n ? r.withSetScope(n, a) : r.withScope(a);
  }
  return r.withScope(e[0]);
}
function K() {
  return re().getClient();
}
function dy(e) {
  const t = e.getPropagationContext(), { traceId: r, parentSpanId: n, propagationSpanId: a } = t, u = {
    trace_id: r,
    span_id: a || Tn()
  };
  return n && (u.parent_span_id = n), u;
}
const Je = "sentry.source", Ws = "sentry.sample_rate", Vl = "sentry.previous_trace_sample_rate", ir = "sentry.op", de = "sentry.origin", wa = "sentry.idle_span_finish_reason", Ya = "sentry.measurement_unit", Xa = "sentry.measurement_value", rf = "sentry.custom_span_name", qs = "sentry.profile_id", An = "sentry.exclusive_time", fy = "sentry.link.type", ly = 0, Yl = 1, Ee = 2;
function py(e) {
  if (e < 400 && e >= 100)
    return { code: Yl };
  if (e >= 400 && e < 500)
    switch (e) {
      case 401:
        return { code: Ee, message: "unauthenticated" };
      case 403:
        return { code: Ee, message: "permission_denied" };
      case 404:
        return { code: Ee, message: "not_found" };
      case 409:
        return { code: Ee, message: "already_exists" };
      case 413:
        return { code: Ee, message: "failed_precondition" };
      case 429:
        return { code: Ee, message: "resource_exhausted" };
      case 499:
        return { code: Ee, message: "cancelled" };
      default:
        return { code: Ee, message: "invalid_argument" };
    }
  if (e >= 500 && e < 600)
    switch (e) {
      case 501:
        return { code: Ee, message: "unimplemented" };
      case 503:
        return { code: Ee, message: "unavailable" };
      case 504:
        return { code: Ee, message: "deadline_exceeded" };
      default:
        return { code: Ee, message: "internal_error" };
    }
  return { code: Ee, message: "unknown_error" };
}
function Xl(e, t) {
  e.setAttribute("http.response.status_code", t);
  const r = py(t);
  r.message !== "unknown_error" && e.setStatus(r);
}
const Jl = "_sentryScope", Kl = "_sentryIsolationScope";
function hy(e, t, r) {
  e && (Ye(e, Kl, r), Ye(e, Jl, t));
}
function Ea(e) {
  return {
    scope: e[Jl],
    isolationScope: e[Kl]
  };
}
const zs = "sentry-", my = /^sentry-/, gy = 8192;
function Ql(e) {
  const t = vy(e);
  if (!t)
    return;
  const r = Object.entries(t).reduce((n, [a, u]) => {
    if (a.match(my)) {
      const i = a.slice(zs.length);
      n[i] = u;
    }
    return n;
  }, {});
  if (Object.keys(r).length > 0)
    return r;
}
function yy(e) {
  if (!e)
    return;
  const t = Object.entries(e).reduce(
    (r, [n, a]) => (a && (r[`${zs}${n}`] = a), r),
    {}
  );
  return by(t);
}
function vy(e) {
  if (!(!e || !Tt(e) && !Array.isArray(e)))
    return Array.isArray(e) ? e.reduce((t, r) => {
      const n = nf(r);
      return Object.entries(n).forEach(([a, u]) => {
        t[a] = u;
      }), t;
    }, {}) : nf(e);
}
function nf(e) {
  return e.split(",").map(
    (t) => t.split("=").map((r) => {
      try {
        return decodeURIComponent(r.trim());
      } catch {
        return;
      }
    })
  ).reduce((t, [r, n]) => (r && n && (t[r] = n), t), {});
}
function by(e) {
  if (Object.keys(e).length !== 0)
    return Object.entries(e).reduce((t, [r, n], a) => {
      const u = `${encodeURIComponent(r)}=${encodeURIComponent(n)}`, i = a === 0 ? u : `${t},${u}`;
      return i.length > gy ? (L && B.warn(
        `Not adding key: ${r} with val: ${n} to baggage header due to exceeding baggage size limits.`
      ), t) : i;
    }, "");
}
function mn(e) {
  if (typeof e == "boolean")
    return Number(e);
  const t = typeof e == "string" ? parseFloat(e) : e;
  if (!(typeof t != "number" || isNaN(t) || t < 0 || t > 1))
    return t;
}
const Zl = new RegExp(
  "^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$"
  // whitespace
);
function _y(e) {
  if (!e)
    return;
  const t = e.match(Zl);
  if (!t)
    return;
  let r;
  return t[3] === "1" ? r = !0 : t[3] === "0" && (r = !1), {
    traceId: t[1],
    parentSampled: r,
    parentSpanId: t[2]
  };
}
function Sy(e, t) {
  const r = _y(e), n = Ql(t);
  if (!(r != null && r.traceId))
    return {
      traceId: Ft(),
      sampleRand: Math.random()
    };
  const a = wy(r, n);
  n && (n.sample_rand = a.toString());
  const { traceId: u, parentSpanId: i, parentSampled: s } = r;
  return {
    traceId: u,
    parentSpanId: i,
    sampled: s,
    dsc: n || {},
    // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
    sampleRand: a
  };
}
function e1(e = Ft(), t = Tn(), r) {
  let n = "";
  return r !== void 0 && (n = r ? "-1" : "-0"), `${e}-${t}${n}`;
}
function wy(e, t) {
  const r = mn(t == null ? void 0 : t.sample_rand);
  if (r !== void 0)
    return r;
  const n = mn(t == null ? void 0 : t.sample_rate);
  return n && (e == null ? void 0 : e.parentSampled) !== void 0 ? e.parentSampled ? (
    // Returns a sample rand with positive sampling decision [0, sampleRate)
    Math.random() * n
  ) : (
    // Returns a sample rand with negative sampling decision [sampleRate, 1)
    n + Math.random() * (1 - n)
  ) : Math.random();
}
const t1 = 0, Vs = 1;
let af = !1;
function Ey(e) {
  const { spanId: t, traceId: r } = e.spanContext(), { data: n, op: a, parent_span_id: u, status: i, origin: s, links: o } = Z(e);
  return {
    parent_span_id: u,
    span_id: t,
    trace_id: r,
    data: n,
    op: a,
    status: i,
    origin: s,
    links: o
  };
}
function Cy(e) {
  const { spanId: t, traceId: r, isRemote: n } = e.spanContext(), a = n ? t : Z(e).parent_span_id, u = Ea(e).scope, i = n ? (u == null ? void 0 : u.getPropagationContext().propagationSpanId) || Tn() : t;
  return {
    parent_span_id: a,
    span_id: i,
    trace_id: r
  };
}
function Ty(e) {
  const { traceId: t, spanId: r } = e.spanContext(), n = fr(e);
  return e1(t, r, n);
}
function r1(e) {
  if (e && e.length > 0)
    return e.map(({ context: { spanId: t, traceId: r, traceFlags: n, ...a }, attributes: u }) => ({
      span_id: t,
      trace_id: r,
      sampled: n === Vs,
      attributes: u,
      ...a
    }));
}
function er(e) {
  return typeof e == "number" ? uf(e) : Array.isArray(e) ? e[0] + e[1] / 1e9 : e instanceof Date ? uf(e.getTime()) : Te();
}
function uf(e) {
  return e > 9999999999 ? e / 1e3 : e;
}
function Z(e) {
  var n;
  if (Ay(e))
    return e.getSpanJSON();
  const { spanId: t, traceId: r } = e.spanContext();
  if (ky(e)) {
    const { attributes: a, startTime: u, name: i, endTime: s, status: o, links: c } = e, f = "parentSpanId" in e ? e.parentSpanId : "parentSpanContext" in e ? (n = e.parentSpanContext) == null ? void 0 : n.spanId : void 0;
    return {
      span_id: t,
      trace_id: r,
      data: a,
      description: i,
      parent_span_id: f,
      start_timestamp: er(u),
      // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
      timestamp: er(s) || void 0,
      status: n1(o),
      op: a[ir],
      origin: a[de],
      links: r1(c)
    };
  }
  return {
    span_id: t,
    trace_id: r,
    start_timestamp: 0,
    data: {}
  };
}
function ky(e) {
  const t = e;
  return !!t.attributes && !!t.startTime && !!t.name && !!t.endTime && !!t.status;
}
function Ay(e) {
  return typeof e.getSpanJSON == "function";
}
function fr(e) {
  const { traceFlags: t } = e.spanContext();
  return t === Vs;
}
function n1(e) {
  if (!(!e || e.code === ly))
    return e.code === Yl ? "ok" : e.message || "unknown_error";
}
const tr = "_sentryChildSpans", es = "_sentryRootSpan";
function a1(e, t) {
  const r = e[es] || e;
  Ye(t, es, r), e[tr] ? e[tr].add(t) : Ye(e, tr, /* @__PURE__ */ new Set([t]));
}
function Oy(e, t) {
  e[tr] && e[tr].delete(t);
}
function sa(e) {
  const t = /* @__PURE__ */ new Set();
  function r(n) {
    if (!t.has(n) && fr(n)) {
      t.add(n);
      const a = n[tr] ? Array.from(n[tr]) : [];
      for (const u of a)
        r(u);
    }
  }
  return r(e), Array.from(t);
}
function Pe(e) {
  return e[es] || e;
}
function Le() {
  const e = dr(), t = $r(e);
  return t.getActiveSpan ? t.getActiveSpan() : Sa(re());
}
function ts() {
  af || (Wt(() => {
    console.warn(
      "[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly."
    );
  }), af = !0);
}
let sf = !1;
function Iy() {
  sf || (sf = !0, jl(rs), Ml(rs));
}
function rs() {
  const e = Le(), t = e && Pe(e);
  if (t) {
    const r = "internal_error";
    L && B.log(`[Tracing] Root span: ${r} -> Global error occurred`), t.setStatus({ code: Ee, message: r });
  }
}
rs.tag = "sentry_tracingErrorCallback";
function Ot(e) {
  var r;
  if (typeof __SENTRY_TRACING__ == "boolean" && !__SENTRY_TRACING__)
    return !1;
  const t = e || ((r = K()) == null ? void 0 : r.getOptions());
  return !!t && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
  (t.tracesSampleRate != null || !!t.tracesSampler);
}
const Ys = "production", Py = /^o(\d+)\./, By = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function Ny(e) {
  return e === "http" || e === "https";
}
function On(e, t = !1) {
  const { host: r, path: n, pass: a, port: u, projectId: i, protocol: s, publicKey: o } = e;
  return `${s}://${o}${t && a ? `:${a}` : ""}@${r}${u ? `:${u}` : ""}/${n && `${n}/`}${i}`;
}
function Dy(e) {
  const t = By.exec(e);
  if (!t) {
    Wt(() => {
      console.error(`Invalid Sentry Dsn: ${e}`);
    });
    return;
  }
  const [r, n, a = "", u = "", i = "", s = ""] = t.slice(1);
  let o = "", c = s;
  const f = c.split("/");
  if (f.length > 1 && (o = f.slice(0, -1).join("/"), c = f.pop()), c) {
    const g = c.match(/^\d+/);
    g && (c = g[0]);
  }
  return u1({ host: u, pass: a, path: o, projectId: c, port: i, protocol: r, publicKey: n });
}
function u1(e) {
  return {
    protocol: e.protocol,
    publicKey: e.publicKey || "",
    pass: e.pass || "",
    host: e.host,
    port: e.port || "",
    path: e.path || "",
    projectId: e.projectId
  };
}
function Ry(e) {
  if (!L)
    return !0;
  const { port: t, projectId: r, protocol: n } = e;
  return ["protocol", "publicKey", "host", "projectId"].find((i) => e[i] ? !1 : (B.error(`Invalid Sentry Dsn: ${i} missing`), !0)) ? !1 : r.match(/^\d+$/) ? Ny(n) ? t && isNaN(parseInt(t, 10)) ? (B.error(`Invalid Sentry Dsn: Invalid port ${t}`), !1) : !0 : (B.error(`Invalid Sentry Dsn: Invalid protocol ${n}`), !1) : (B.error(`Invalid Sentry Dsn: Invalid projectId ${r}`), !1);
}
function xy(e) {
  const t = e.match(Py);
  return t == null ? void 0 : t[1];
}
function jy(e) {
  const t = typeof e == "string" ? Dy(e) : u1(e);
  if (!(!t || !Ry(t)))
    return t;
}
const i1 = "_frozenDsc";
function oa(e, t) {
  Ye(e, i1, t);
}
function s1(e, t) {
  const r = t.getOptions(), { publicKey: n, host: a } = t.getDsn() || {};
  let u;
  r.orgId ? u = String(r.orgId) : a && (u = xy(a));
  const i = {
    environment: r.environment || Ys,
    release: r.release,
    public_key: n,
    trace_id: e,
    org_id: u
  };
  return t.emit("createDsc", i), i;
}
function o1(e, t) {
  const r = t.getPropagationContext();
  return r.dsc || s1(r.traceId, e);
}
function $t(e) {
  var v;
  const t = K();
  if (!t)
    return {};
  const r = Pe(e), n = Z(r), a = n.data, u = r.spanContext().traceState, i = (u == null ? void 0 : u.get("sentry.sample_rate")) ?? a[Ws] ?? a[Vl];
  function s(S) {
    return (typeof i == "number" || typeof i == "string") && (S.sample_rate = `${i}`), S;
  }
  const o = r[i1];
  if (o)
    return s(o);
  const c = u == null ? void 0 : u.get("sentry.dsc"), f = c && Ql(c);
  if (f)
    return s(f);
  const g = s1(e.spanContext().traceId, t), p = a[Je], h = n.description;
  return p !== "url" && h && (g.transaction = h), Ot() && (g.sampled = String(fr(r)), g.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
  // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
  (u == null ? void 0 : u.get("sentry.sample_rand")) ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
  ((v = Ea(r).scope) == null ? void 0 : v.getPropagationContext().sampleRand.toString())), s(g), t.emit("createDsc", g, r), g;
}
class sr {
  constructor(t = {}) {
    this._traceId = t.traceId || Ft(), this._spanId = t.spanId || Tn();
  }
  /** @inheritdoc */
  spanContext() {
    return {
      spanId: this._spanId,
      traceId: this._traceId,
      traceFlags: t1
    };
  }
  /** @inheritdoc */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  end(t) {
  }
  /** @inheritdoc */
  setAttribute(t, r) {
    return this;
  }
  /** @inheritdoc */
  setAttributes(t) {
    return this;
  }
  /** @inheritdoc */
  setStatus(t) {
    return this;
  }
  /** @inheritdoc */
  updateName(t) {
    return this;
  }
  /** @inheritdoc */
  isRecording() {
    return !1;
  }
  /** @inheritdoc */
  addEvent(t, r, n) {
    return this;
  }
  /** @inheritDoc */
  addLink(t) {
    return this;
  }
  /** @inheritDoc */
  addLinks(t) {
    return this;
  }
  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  recordException(t, r) {
  }
}
function My(e) {
  if (!L) return;
  const { description: t = "< unknown name >", op: r = "< unknown op >", parent_span_id: n } = Z(e), { spanId: a } = e.spanContext(), u = fr(e), i = Pe(e), s = i === e, o = `[Tracing] Starting ${u ? "sampled" : "unsampled"} ${s ? "root " : ""}span`, c = [`op: ${r}`, `name: ${t}`, `ID: ${a}`];
  if (n && c.push(`parent ID: ${n}`), !s) {
    const { op: f, description: g } = Z(i);
    c.push(`root ID: ${i.spanContext().spanId}`), f && c.push(`root op: ${f}`), g && c.push(`root description: ${g}`);
  }
  B.log(`${o}
  ${c.join(`
  `)}`);
}
function Ly(e) {
  if (!L) return;
  const { description: t = "< unknown name >", op: r = "< unknown op >" } = Z(e), { spanId: n } = e.spanContext(), u = Pe(e) === e, i = `[Tracing] Finishing "${r}" ${u ? "root " : ""}span "${t}" with ID ${n}`;
  B.log(i);
}
function Fy(e, t, r) {
  if (!Ot(e))
    return [!1];
  let n, a;
  typeof e.tracesSampler == "function" ? (a = e.tracesSampler({
    ...t,
    inheritOrSampleWith: (s) => typeof t.parentSampleRate == "number" ? t.parentSampleRate : typeof t.parentSampled == "boolean" ? Number(t.parentSampled) : s
  }), n = !0) : t.parentSampled !== void 0 ? a = t.parentSampled : typeof e.tracesSampleRate < "u" && (a = e.tracesSampleRate, n = !0);
  const u = mn(a);
  if (u === void 0)
    return L && B.warn(
      `[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
        a
      )} of type ${JSON.stringify(typeof a)}.`
    ), [!1];
  if (!u)
    return L && B.log(
      `[Tracing] Discarding transaction because ${typeof e.tracesSampler == "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`
    ), [!1, u, n];
  const i = r < u;
  return i || L && B.log(
    `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
      a
    )})`
  ), [i, u, n];
}
function vt(e, t = 100, r = 1 / 0) {
  try {
    return ns("", e, t, r);
  } catch (n) {
    return { ERROR: `**non-serializable** (${n})` };
  }
}
function c1(e, t = 3, r = 100 * 1024) {
  const n = vt(e, t);
  return Gy(n) > r ? c1(e, t - 1, r) : n;
}
function ns(e, t, r = 1 / 0, n = 1 / 0, a = Wy()) {
  const [u, i] = a;
  if (t == null || // this matches null and undefined -> eqeq not eqeqeq
  ["boolean", "string"].includes(typeof t) || typeof t == "number" && Number.isFinite(t))
    return t;
  const s = $y(e, t);
  if (!s.startsWith("[object "))
    return s;
  if (t.__sentry_skip_normalization__)
    return t;
  const o = typeof t.__sentry_override_normalization_depth__ == "number" ? t.__sentry_override_normalization_depth__ : r;
  if (o === 0)
    return s.replace("object ", "");
  if (u(t))
    return "[Circular ~]";
  const c = t;
  if (c && typeof c.toJSON == "function")
    try {
      const h = c.toJSON();
      return ns("", h, o - 1, n, a);
    } catch {
    }
  const f = Array.isArray(t) ? [] : {};
  let g = 0;
  const p = Wl(t);
  for (const h in p) {
    if (!Object.prototype.hasOwnProperty.call(p, h))
      continue;
    if (g >= n) {
      f[h] = "[MaxProperties ~]";
      break;
    }
    const v = p[h];
    f[h] = ns(h, v, o - 1, n, a), g++;
  }
  return i(t), f;
}
function $y(e, t) {
  try {
    if (e === "domain" && t && typeof t == "object" && t._events)
      return "[Domain]";
    if (e === "domainEmitter")
      return "[DomainEmitter]";
    if (typeof global < "u" && t === global)
      return "[Global]";
    if (typeof window < "u" && t === window)
      return "[Window]";
    if (typeof document < "u" && t === document)
      return "[Document]";
    if ($l(t))
      return "[VueViewModel]";
    if (W3(t))
      return "[SyntheticEvent]";
    if (typeof t == "number" && !Number.isFinite(t))
      return `[${t}]`;
    if (typeof t == "function")
      return `[Function: ${kt(t)}]`;
    if (typeof t == "symbol")
      return `[${String(t)}]`;
    if (typeof t == "bigint")
      return `[BigInt: ${String(t)}]`;
    const r = Uy(t);
    return /^HTML(\w*)Element$/.test(r) ? `[HTMLElement: ${r}]` : `[object ${r}]`;
  } catch (r) {
    return `**non-serializable** (${r})`;
  }
}
function Uy(e) {
  const t = Object.getPrototypeOf(e);
  return t != null && t.constructor ? t.constructor.name : "null prototype";
}
function Hy(e) {
  return ~-encodeURI(e).split(/%..|./).length;
}
function Gy(e) {
  return Hy(JSON.stringify(e));
}
function Wy() {
  const e = /* @__PURE__ */ new WeakSet();
  function t(n) {
    return e.has(n) ? !0 : (e.add(n), !1);
  }
  function r(n) {
    e.delete(n);
  }
  return [t, r];
}
function Ur(e, t = []) {
  return [e, t];
}
function qy(e, t) {
  const [r, n] = e;
  return [r, [...n, t]];
}
function of(e, t) {
  const r = e[1];
  for (const n of r) {
    const a = n[0].type;
    if (t(n, a))
      return !0;
  }
  return !1;
}
function as(e) {
  const t = Wa(V);
  return t.encodePolyfill ? t.encodePolyfill(e) : new TextEncoder().encode(e);
}
function zy(e) {
  const [t, r] = e;
  let n = JSON.stringify(t);
  function a(u) {
    typeof n == "string" ? n = typeof u == "string" ? n + u : [as(n), u] : n.push(typeof u == "string" ? as(u) : u);
  }
  for (const u of r) {
    const [i, s] = u;
    if (a(`
${JSON.stringify(i)}
`), typeof s == "string" || s instanceof Uint8Array)
      a(s);
    else {
      let o;
      try {
        o = JSON.stringify(s);
      } catch {
        o = JSON.stringify(vt(s));
      }
      a(o);
    }
  }
  return typeof n == "string" ? n : Vy(n);
}
function Vy(e) {
  const t = e.reduce((a, u) => a + u.length, 0), r = new Uint8Array(t);
  let n = 0;
  for (const a of e)
    r.set(a, n), n += a.length;
  return r;
}
function Yy(e) {
  return [{
    type: "span"
  }, e];
}
function Xy(e) {
  const t = typeof e.data == "string" ? as(e.data) : e.data;
  return [
    {
      type: "attachment",
      length: t.length,
      filename: e.filename,
      content_type: e.contentType,
      attachment_type: e.attachmentType
    },
    t
  ];
}
const Jy = {
  session: "session",
  sessions: "session",
  attachment: "attachment",
  transaction: "transaction",
  event: "error",
  client_report: "internal",
  user_report: "default",
  profile: "profile",
  profile_chunk: "profile",
  replay_event: "replay",
  replay_recording: "replay",
  check_in: "monitor",
  feedback: "feedback",
  span: "span",
  raw_security: "security",
  log: "log_item"
};
function cf(e) {
  return Jy[e];
}
function d1(e) {
  if (!(e != null && e.sdk))
    return;
  const { name: t, version: r } = e.sdk;
  return { name: t, version: r };
}
function Ky(e, t, r, n) {
  var u;
  const a = (u = e.sdkProcessingMetadata) == null ? void 0 : u.dynamicSamplingContext;
  return {
    event_id: e.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...t && { sdk: t },
    ...!!r && n && { dsn: On(n) },
    ...a && {
      trace: a
    }
  };
}
function Qy(e, t) {
  return t && (e.sdk = e.sdk || {}, e.sdk.name = e.sdk.name || t.name, e.sdk.version = e.sdk.version || t.version, e.sdk.integrations = [...e.sdk.integrations || [], ...t.integrations || []], e.sdk.packages = [...e.sdk.packages || [], ...t.packages || []]), e;
}
function Zy(e, t, r, n) {
  const a = d1(r), u = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...a && { sdk: a },
    ...!!n && t && { dsn: On(t) }
  }, i = "aggregates" in e ? [{ type: "sessions" }, e] : [{ type: "session" }, e.toJSON()];
  return Ur(u, [i]);
}
function ev(e, t, r, n) {
  const a = d1(r), u = e.type && e.type !== "replay_event" ? e.type : "event";
  Qy(e, r == null ? void 0 : r.sdk);
  const i = Ky(e, a, n, t);
  return delete e.sdkProcessingMetadata, Ur(i, [[{ type: u }, e]]);
}
function tv(e, t) {
  function r(f) {
    return !!f.trace_id && !!f.public_key;
  }
  const n = $t(e[0]), a = t == null ? void 0 : t.getDsn(), u = t == null ? void 0 : t.getOptions().tunnel, i = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...r(n) && { trace: n },
    ...!!u && a && { dsn: On(a) }
  }, s = t == null ? void 0 : t.getOptions().beforeSendSpan, o = s ? (f) => {
    const g = Z(f), p = s(g);
    return p || (ts(), g);
  } : Z, c = [];
  for (const f of e) {
    const g = o(f);
    g && c.push(Yy(g));
  }
  return Ur(i, c);
}
function rv(e, t, r, n = Le()) {
  const a = n && Pe(n);
  a && (L && B.log(`[Measurement] Setting measurement on root span: ${e} = ${t} ${r}`), a.addEvent(e, {
    [Xa]: t,
    [Ya]: r
  }));
}
function df(e) {
  if (!e || e.length === 0)
    return;
  const t = {};
  return e.forEach((r) => {
    const n = r.attributes || {}, a = n[Ya], u = n[Xa];
    typeof a == "string" && typeof u == "number" && (t[r.name] = { value: u, unit: a });
  }), t;
}
const ff = 1e3;
class Xs {
  /** Epoch timestamp in seconds when the span started. */
  /** Epoch timestamp in seconds when the span ended. */
  /** Internal keeper of the status */
  /** The timed events added to this span. */
  /** if true, treat span as a standalone span (not part of a transaction) */
  /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */
  constructor(t = {}) {
    this._traceId = t.traceId || Ft(), this._spanId = t.spanId || Tn(), this._startTime = t.startTimestamp || Te(), this._links = t.links, this._attributes = {}, this.setAttributes({
      [de]: "manual",
      [ir]: t.op,
      ...t.attributes
    }), this._name = t.name, t.parentSpanId && (this._parentSpanId = t.parentSpanId), "sampled" in t && (this._sampled = t.sampled), t.endTimestamp && (this._endTime = t.endTimestamp), this._events = [], this._isStandaloneSpan = t.isStandalone, this._endTime && this._onSpanEnded();
  }
  /** @inheritDoc */
  addLink(t) {
    return this._links ? this._links.push(t) : this._links = [t], this;
  }
  /** @inheritDoc */
  addLinks(t) {
    return this._links ? this._links.push(...t) : this._links = t, this;
  }
  /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  recordException(t, r) {
  }
  /** @inheritdoc */
  spanContext() {
    const { _spanId: t, _traceId: r, _sampled: n } = this;
    return {
      spanId: t,
      traceId: r,
      traceFlags: n ? Vs : t1
    };
  }
  /** @inheritdoc */
  setAttribute(t, r) {
    return r === void 0 ? delete this._attributes[t] : this._attributes[t] = r, this;
  }
  /** @inheritdoc */
  setAttributes(t) {
    return Object.keys(t).forEach((r) => this.setAttribute(r, t[r])), this;
  }
  /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */
  updateStartTime(t) {
    this._startTime = er(t);
  }
  /**
   * @inheritDoc
   */
  setStatus(t) {
    return this._status = t, this;
  }
  /**
   * @inheritDoc
   */
  updateName(t) {
    return this._name = t, this.setAttribute(Je, "custom"), this;
  }
  /** @inheritdoc */
  end(t) {
    this._endTime || (this._endTime = er(t), Ly(this), this._onSpanEnded());
  }
  /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */
  getSpanJSON() {
    return {
      data: this._attributes,
      description: this._name,
      op: this._attributes[ir],
      parent_span_id: this._parentSpanId,
      span_id: this._spanId,
      start_timestamp: this._startTime,
      status: n1(this._status),
      timestamp: this._endTime,
      trace_id: this._traceId,
      origin: this._attributes[de],
      profile_id: this._attributes[qs],
      exclusive_time: this._attributes[An],
      measurements: df(this._events),
      is_segment: this._isStandaloneSpan && Pe(this) === this || void 0,
      segment_id: this._isStandaloneSpan ? Pe(this).spanContext().spanId : void 0,
      links: r1(this._links)
    };
  }
  /** @inheritdoc */
  isRecording() {
    return !this._endTime && !!this._sampled;
  }
  /**
   * @inheritdoc
   */
  addEvent(t, r, n) {
    L && B.log("[Tracing] Adding an event to span:", t);
    const a = lf(r) ? r : n || Te(), u = lf(r) ? {} : r || {}, i = {
      name: t,
      time: er(a),
      attributes: u
    };
    return this._events.push(i), this;
  }
  /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */
  isStandaloneSpan() {
    return !!this._isStandaloneSpan;
  }
  /** Emit `spanEnd` when the span is ended. */
  _onSpanEnded() {
    const t = K();
    if (t && t.emit("spanEnd", this), !(this._isStandaloneSpan || this === Pe(this)))
      return;
    if (this._isStandaloneSpan) {
      this._sampled ? av(tv([this], t)) : (L && B.log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled."), t && t.recordDroppedEvent("sample_rate", "span"));
      return;
    }
    const n = this._convertSpanToTransaction();
    n && (Ea(this).scope || re()).captureEvent(n);
  }
  /**
   * Finish the transaction & prepare the event to send to Sentry.
   */
  _convertSpanToTransaction() {
    var f;
    if (!pf(Z(this)))
      return;
    this._name || (L && B.warn("Transaction has no name, falling back to `<unlabeled transaction>`."), this._name = "<unlabeled transaction>");
    const { scope: t, isolationScope: r } = Ea(this), n = (f = t == null ? void 0 : t.getScopeData().sdkProcessingMetadata) == null ? void 0 : f.normalizedRequest;
    if (this._sampled !== !0)
      return;
    const u = sa(this).filter((g) => g !== this && !nv(g)).map((g) => Z(g)).filter(pf), i = this._attributes[Je];
    delete this._attributes[rf], u.forEach((g) => {
      delete g.data[rf];
    });
    const s = {
      contexts: {
        trace: Ey(this)
      },
      spans: (
        // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
        // we do not use spans anymore after this point
        u.length > ff ? u.sort((g, p) => g.start_timestamp - p.start_timestamp).slice(0, ff) : u
      ),
      start_timestamp: this._startTime,
      timestamp: this._endTime,
      transaction: this._name,
      type: "transaction",
      sdkProcessingMetadata: {
        capturedSpanScope: t,
        capturedSpanIsolationScope: r,
        dynamicSamplingContext: $t(this)
      },
      request: n,
      ...i && {
        transaction_info: {
          source: i
        }
      }
    }, o = df(this._events);
    return o && Object.keys(o).length && (L && B.log(
      "[Measurements] Adding measurements to transaction event",
      JSON.stringify(o, void 0, 2)
    ), s.measurements = o), s;
  }
}
function lf(e) {
  return e && typeof e == "number" || e instanceof Date || Array.isArray(e);
}
function pf(e) {
  return !!e.start_timestamp && !!e.timestamp && !!e.span_id && !!e.trace_id;
}
function nv(e) {
  return e instanceof Xs && e.isStandaloneSpan();
}
function av(e) {
  const t = K();
  if (!t)
    return;
  const r = e[1];
  if (!r || r.length === 0) {
    t.recordDroppedEvent("before_send", "span");
    return;
  }
  t.sendEnvelope(e);
}
const f1 = "__SENTRY_SUPPRESS_TRACING__";
function or(e) {
  const t = p1();
  if (t.startInactiveSpan)
    return t.startInactiveSpan(e);
  const r = iv(e), { forceTransaction: n, parentSpan: a } = e;
  return (e.scope ? (i) => kn(e.scope, i) : a !== void 0 ? (i) => l1(a, i) : (i) => i())(() => {
    const i = re(), s = ov(i);
    return e.onlyIfParent && !s ? new sr() : uv({
      parentSpan: s,
      spanArguments: r,
      forceTransaction: n,
      scope: i
    });
  });
}
function l1(e, t) {
  const r = p1();
  return r.withActiveSpan ? r.withActiveSpan(e, t) : kn((n) => (hn(n, e || void 0), t(n)));
}
function uv({
  parentSpan: e,
  spanArguments: t,
  forceTransaction: r,
  scope: n
}) {
  if (!Ot()) {
    const i = new sr();
    if (r || !e) {
      const s = {
        sampled: "false",
        sample_rate: "0",
        transaction: t.name,
        ...$t(i)
      };
      oa(i, s);
    }
    return i;
  }
  const a = Vt();
  let u;
  if (e && !r)
    u = sv(e, n, t), a1(e, u);
  else if (e) {
    const i = $t(e), { traceId: s, spanId: o } = e.spanContext(), c = fr(e);
    u = hf(
      {
        traceId: s,
        parentSpanId: o,
        ...t
      },
      n,
      c
    ), oa(u, i);
  } else {
    const {
      traceId: i,
      dsc: s,
      parentSpanId: o,
      sampled: c
    } = {
      ...a.getPropagationContext(),
      ...n.getPropagationContext()
    };
    u = hf(
      {
        traceId: i,
        parentSpanId: o,
        ...t
      },
      n,
      c
    ), s && oa(u, s);
  }
  return My(u), hy(u, n, a), u;
}
function iv(e) {
  const r = {
    isStandalone: (e.experimental || {}).standalone,
    ...e
  };
  if (e.startTime) {
    const n = { ...r };
    return n.startTimestamp = er(e.startTime), delete n.startTime, n;
  }
  return r;
}
function p1() {
  const e = dr();
  return $r(e);
}
function hf(e, t, r) {
  var v;
  const n = K(), a = (n == null ? void 0 : n.getOptions()) || {}, { name: u = "" } = e, i = { spanAttributes: { ...e.attributes }, spanName: u, parentSampled: r };
  n == null || n.emit("beforeSampling", i, { decision: !1 });
  const s = i.parentSampled ?? r, o = i.spanAttributes, c = t.getPropagationContext(), [f, g, p] = t.getScopeData().sdkProcessingMetadata[f1] ? [!1] : Fy(
    a,
    {
      name: u,
      parentSampled: s,
      attributes: o,
      parentSampleRate: mn((v = c.dsc) == null ? void 0 : v.sample_rate)
    },
    c.sampleRand
  ), h = new Xs({
    ...e,
    attributes: {
      [Je]: "custom",
      [Ws]: g !== void 0 && p ? g : void 0,
      ...o
    },
    sampled: f
  });
  return !f && n && (L && B.log("[Tracing] Discarding root span because its trace was not chosen to be sampled."), n.recordDroppedEvent("sample_rate", "transaction")), n && n.emit("spanStart", h), h;
}
function sv(e, t, r) {
  const { spanId: n, traceId: a } = e.spanContext(), u = t.getScopeData().sdkProcessingMetadata[f1] ? !1 : fr(e), i = u ? new Xs({
    ...r,
    parentSpanId: n,
    traceId: a,
    sampled: u
  }) : new sr({ traceId: a });
  a1(e, i);
  const s = K();
  return s && (s.emit("spanStart", i), r.endTimestamp && s.emit("spanEnd", i)), i;
}
function ov(e) {
  const t = Sa(e);
  if (!t)
    return;
  const r = K();
  return (r ? r.getOptions() : {}).parentSpanIsAlwaysRootSpan ? Pe(t) : t;
}
const ca = {
  idleTimeout: 1e3,
  finalTimeout: 3e4,
  childSpanTimeout: 15e3
}, cv = "heartbeatFailed", dv = "idleTimeout", fv = "finalTimeout", lv = "externalFinish";
function h1(e, t = {}) {
  const r = /* @__PURE__ */ new Map();
  let n = !1, a, u = lv, i = !t.disableAutoFinish;
  const s = [], {
    idleTimeout: o = ca.idleTimeout,
    finalTimeout: c = ca.finalTimeout,
    childSpanTimeout: f = ca.childSpanTimeout,
    beforeSpanEnd: g
  } = t, p = K();
  if (!p || !Ot()) {
    const w = new sr(), _ = {
      sample_rate: "0",
      sampled: "false",
      ...$t(w)
    };
    return oa(w, _), w;
  }
  const h = re(), v = Le(), S = pv(e);
  S.end = new Proxy(S.end, {
    apply(w, _, k) {
      if (g && g(S), _ instanceof sr)
        return;
      const [O, ...D] = k, A = O || Te(), P = er(A), j = sa(S).filter((M) => M !== S);
      if (!j.length)
        return b(P), Reflect.apply(w, _, [P, ...D]);
      const F = j.map((M) => Z(M).timestamp).filter((M) => !!M), z = F.length ? Math.max(...F) : void 0, ee = Z(S).start_timestamp, ie = Math.min(
        ee ? ee + c / 1e3 : 1 / 0,
        Math.max(ee || -1 / 0, Math.min(P, z || 1 / 0))
      );
      return b(ie), Reflect.apply(w, _, [ie, ...D]);
    }
  });
  function E() {
    a && (clearTimeout(a), a = void 0);
  }
  function d(w) {
    E(), a = setTimeout(() => {
      !n && r.size === 0 && i && (u = dv, S.end(w));
    }, o);
  }
  function m(w) {
    a = setTimeout(() => {
      !n && i && (u = cv, S.end(w));
    }, f);
  }
  function l(w) {
    E(), r.set(w, !0);
    const _ = Te();
    m(_ + f / 1e3);
  }
  function y(w) {
    if (r.has(w) && r.delete(w), r.size === 0) {
      const _ = Te();
      d(_ + o / 1e3);
    }
  }
  function b(w) {
    n = !0, r.clear(), s.forEach((P) => P()), hn(h, v);
    const _ = Z(S), { start_timestamp: k } = _;
    if (!k)
      return;
    _.data[wa] || S.setAttribute(wa, u), B.log(`[Tracing] Idle span "${_.op}" finished`);
    const D = sa(S).filter((P) => P !== S);
    let A = 0;
    D.forEach((P) => {
      P.isRecording() && (P.setStatus({ code: Ee, message: "cancelled" }), P.end(w), L && B.log("[Tracing] Cancelling span since span ended early", JSON.stringify(P, void 0, 2)));
      const j = Z(P), { timestamp: F = 0, start_timestamp: z = 0 } = j, ee = z <= w, ie = (c + o) / 1e3, M = F - z <= ie;
      if (L) {
        const ae = JSON.stringify(P, void 0, 2);
        ee ? M || B.log("[Tracing] Discarding span since it finished after idle span final timeout", ae) : B.log("[Tracing] Discarding span since it happened after idle span was finished", ae);
      }
      (!M || !ee) && (Oy(S, P), A++);
    }), A > 0 && S.setAttribute("sentry.idle_span_discarded_spans", A);
  }
  return s.push(
    p.on("spanStart", (w) => {
      if (n || w === S || Z(w).timestamp)
        return;
      sa(S).includes(w) && l(w.spanContext().spanId);
    })
  ), s.push(
    p.on("spanEnd", (w) => {
      n || y(w.spanContext().spanId);
    })
  ), s.push(
    p.on("idleSpanEnableAutoFinish", (w) => {
      w === S && (i = !0, d(), r.size && m());
    })
  ), t.disableAutoFinish || d(), setTimeout(() => {
    n || (S.setStatus({ code: Ee, message: "deadline_exceeded" }), u = fv, S.end());
  }, c), S;
}
function pv(e) {
  const t = or(e);
  return hn(re(), t), L && B.log("[Tracing] Started span is an idle span"), t;
}
var bt;
(function(e) {
  e[e.PENDING = 0] = "PENDING";
  const r = 1;
  e[e.RESOLVED = r] = "RESOLVED";
  const n = 2;
  e[e.REJECTED = n] = "REJECTED";
})(bt || (bt = {}));
function cr(e) {
  return new Ut((t) => {
    t(e);
  });
}
function Ca(e) {
  return new Ut((t, r) => {
    r(e);
  });
}
class Ut {
  constructor(t) {
    this._state = bt.PENDING, this._handlers = [], this._runExecutor(t);
  }
  /** @inheritdoc */
  then(t, r) {
    return new Ut((n, a) => {
      this._handlers.push([
        !1,
        (u) => {
          if (!t)
            n(u);
          else
            try {
              n(t(u));
            } catch (i) {
              a(i);
            }
        },
        (u) => {
          if (!r)
            a(u);
          else
            try {
              n(r(u));
            } catch (i) {
              a(i);
            }
        }
      ]), this._executeHandlers();
    });
  }
  /** @inheritdoc */
  catch(t) {
    return this.then((r) => r, t);
  }
  /** @inheritdoc */
  finally(t) {
    return new Ut((r, n) => {
      let a, u;
      return this.then(
        (i) => {
          u = !1, a = i, t && t();
        },
        (i) => {
          u = !0, a = i, t && t();
        }
      ).then(() => {
        if (u) {
          n(a);
          return;
        }
        r(a);
      });
    });
  }
  /** Excute the resolve/reject handlers. */
  _executeHandlers() {
    if (this._state === bt.PENDING)
      return;
    const t = this._handlers.slice();
    this._handlers = [], t.forEach((r) => {
      r[0] || (this._state === bt.RESOLVED && r[1](this._value), this._state === bt.REJECTED && r[2](this._value), r[0] = !0);
    });
  }
  /** Run the executor for the SyncPromise. */
  _runExecutor(t) {
    const r = (u, i) => {
      if (this._state === bt.PENDING) {
        if (Va(i)) {
          i.then(n, a);
          return;
        }
        this._state = u, this._value = i, this._executeHandlers();
      }
    }, n = (u) => {
      r(bt.RESOLVED, u);
    }, a = (u) => {
      r(bt.REJECTED, u);
    };
    try {
      t(n, a);
    } catch (u) {
      a(u);
    }
  }
}
function us(e, t, r, n = 0) {
  return new Ut((a, u) => {
    const i = e[n];
    if (t === null || typeof i != "function")
      a(t);
    else {
      const s = i({ ...t }, r);
      L && i.id && s === null && B.log(`Event processor "${i.id}" dropped event`), Va(s) ? s.then((o) => us(e, o, r, n + 1).then(a)).then(null, u) : us(e, s, r, n + 1).then(a).then(null, u);
    }
  });
}
function hv(e, t) {
  const { fingerprint: r, span: n, breadcrumbs: a, sdkProcessingMetadata: u } = t;
  mv(e, t), n && vv(e, n), bv(e, r), gv(e, a), yv(e, u);
}
function mf(e, t) {
  const {
    extra: r,
    tags: n,
    user: a,
    contexts: u,
    level: i,
    sdkProcessingMetadata: s,
    breadcrumbs: o,
    fingerprint: c,
    eventProcessors: f,
    attachments: g,
    propagationContext: p,
    transactionName: h,
    span: v
  } = t;
  $n(e, "extra", r), $n(e, "tags", n), $n(e, "user", a), $n(e, "contexts", u), e.sdkProcessingMetadata = Cn(e.sdkProcessingMetadata, s, 2), i && (e.level = i), h && (e.transactionName = h), v && (e.span = v), o.length && (e.breadcrumbs = [...e.breadcrumbs, ...o]), c.length && (e.fingerprint = [...e.fingerprint, ...c]), f.length && (e.eventProcessors = [...e.eventProcessors, ...f]), g.length && (e.attachments = [...e.attachments, ...g]), e.propagationContext = { ...e.propagationContext, ...p };
}
function $n(e, t, r) {
  e[t] = Cn(e[t], r, 1);
}
function mv(e, t) {
  const { extra: r, tags: n, user: a, contexts: u, level: i, transactionName: s } = t;
  Object.keys(r).length && (e.extra = { ...r, ...e.extra }), Object.keys(n).length && (e.tags = { ...n, ...e.tags }), Object.keys(a).length && (e.user = { ...a, ...e.user }), Object.keys(u).length && (e.contexts = { ...u, ...e.contexts }), i && (e.level = i), s && e.type !== "transaction" && (e.transaction = s);
}
function gv(e, t) {
  const r = [...e.breadcrumbs || [], ...t];
  e.breadcrumbs = r.length ? r : void 0;
}
function yv(e, t) {
  e.sdkProcessingMetadata = {
    ...e.sdkProcessingMetadata,
    ...t
  };
}
function vv(e, t) {
  e.contexts = {
    trace: Cy(t),
    ...e.contexts
  }, e.sdkProcessingMetadata = {
    dynamicSamplingContext: $t(t),
    ...e.sdkProcessingMetadata
  };
  const r = Pe(t), n = Z(r).description;
  n && !e.transaction && e.type === "transaction" && (e.transaction = n);
}
function bv(e, t) {
  e.fingerprint = e.fingerprint ? Array.isArray(e.fingerprint) ? e.fingerprint : [e.fingerprint] : [], t && (e.fingerprint = e.fingerprint.concat(t)), e.fingerprint.length || delete e.fingerprint;
}
let Un, gf, Hn;
function _v(e) {
  const t = V._sentryDebugIds;
  if (!t)
    return {};
  const r = Object.keys(t);
  return Hn && r.length === gf || (gf = r.length, Hn = r.reduce((n, a) => {
    Un || (Un = {});
    const u = Un[a];
    if (u)
      n[u[0]] = u[1];
    else {
      const i = e(a);
      for (let s = i.length - 1; s >= 0; s--) {
        const o = i[s], c = o == null ? void 0 : o.filename, f = t[a];
        if (c && f) {
          n[c] = f, Un[a] = [c, f];
          break;
        }
      }
    }
    return n;
  }, {})), Hn;
}
function Sv(e, t, r, n, a, u) {
  const { normalizeDepth: i = 3, normalizeMaxBreadth: s = 1e3 } = e, o = {
    ...t,
    event_id: t.event_id || r.event_id || Qe(),
    timestamp: t.timestamp || En()
  }, c = r.integrations || e.integrations.map((E) => E.name);
  wv(o, e), Tv(o, c), a && a.emit("applyFrameMetadata", t), t.type === void 0 && Ev(o, e.stackParser);
  const f = Av(n, r.captureContext);
  r.mechanism && ur(o, r.mechanism);
  const g = a ? a.getEventProcessors() : [], p = cy().getScopeData();
  if (u) {
    const E = u.getScopeData();
    mf(p, E);
  }
  if (f) {
    const E = f.getScopeData();
    mf(p, E);
  }
  const h = [...r.attachments || [], ...p.attachments];
  h.length && (r.attachments = h), hv(o, p);
  const v = [
    ...g,
    // Run scope event processors _after_ all other processors
    ...p.eventProcessors
  ];
  return us(v, o, r).then((E) => (E && Cv(E), typeof i == "number" && i > 0 ? kv(E, i, s) : E));
}
function wv(e, t) {
  const { environment: r, release: n, dist: a, maxValueLength: u = 250 } = t;
  e.environment = e.environment || r || Ys, !e.release && n && (e.release = n), !e.dist && a && (e.dist = a);
  const i = e.request;
  i != null && i.url && (i.url = ba(i.url, u));
}
function Ev(e, t) {
  var n, a;
  const r = _v(t);
  (a = (n = e.exception) == null ? void 0 : n.values) == null || a.forEach((u) => {
    var i, s;
    (s = (i = u.stacktrace) == null ? void 0 : i.frames) == null || s.forEach((o) => {
      o.filename && (o.debug_id = r[o.filename]);
    });
  });
}
function Cv(e) {
  var n, a;
  const t = {};
  if ((a = (n = e.exception) == null ? void 0 : n.values) == null || a.forEach((u) => {
    var i, s;
    (s = (i = u.stacktrace) == null ? void 0 : i.frames) == null || s.forEach((o) => {
      o.debug_id && (o.abs_path ? t[o.abs_path] = o.debug_id : o.filename && (t[o.filename] = o.debug_id), delete o.debug_id);
    });
  }), Object.keys(t).length === 0)
    return;
  e.debug_meta = e.debug_meta || {}, e.debug_meta.images = e.debug_meta.images || [];
  const r = e.debug_meta.images;
  Object.entries(t).forEach(([u, i]) => {
    r.push({
      type: "sourcemap",
      code_file: u,
      debug_id: i
    });
  });
}
function Tv(e, t) {
  t.length > 0 && (e.sdk = e.sdk || {}, e.sdk.integrations = [...e.sdk.integrations || [], ...t]);
}
function kv(e, t, r) {
  var a, u;
  if (!e)
    return null;
  const n = {
    ...e,
    ...e.breadcrumbs && {
      breadcrumbs: e.breadcrumbs.map((i) => ({
        ...i,
        ...i.data && {
          data: vt(i.data, t, r)
        }
      }))
    },
    ...e.user && {
      user: vt(e.user, t, r)
    },
    ...e.contexts && {
      contexts: vt(e.contexts, t, r)
    },
    ...e.extra && {
      extra: vt(e.extra, t, r)
    }
  };
  return (a = e.contexts) != null && a.trace && n.contexts && (n.contexts.trace = e.contexts.trace, e.contexts.trace.data && (n.contexts.trace.data = vt(e.contexts.trace.data, t, r))), e.spans && (n.spans = e.spans.map((i) => ({
    ...i,
    ...i.data && {
      data: vt(i.data, t, r)
    }
  }))), (u = e.contexts) != null && u.flags && n.contexts && (n.contexts.flags = vt(e.contexts.flags, 3, r)), n;
}
function Av(e, t) {
  if (!t)
    return e;
  const r = e ? e.clone() : new lt();
  return r.update(t), r;
}
function Ov(e) {
  if (e)
    return Iv(e) ? { captureContext: e } : Bv(e) ? {
      captureContext: e
    } : e;
}
function Iv(e) {
  return e instanceof lt || typeof e == "function";
}
const Pv = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "propagationContext"
];
function Bv(e) {
  return Object.keys(e).some((t) => Pv.includes(t));
}
function In(e, t) {
  return re().captureException(e, Ov(t));
}
function is(e, t) {
  const r = typeof t == "string" ? t : void 0, n = typeof t != "string" ? { captureContext: t } : void 0;
  return re().captureMessage(e, r, n);
}
function m1(e, t) {
  return re().captureEvent(e, t);
}
async function yf(e) {
  const t = K();
  return t ? t.flush(e) : (L && B.warn("Cannot flush events. No client defined."), Promise.resolve(!1));
}
function Nv() {
  const e = K();
  return (e == null ? void 0 : e.getOptions().enabled) !== !1 && !!(e != null && e.getTransport());
}
function Dv(e) {
  Vt().addEventProcessor(e);
}
function vf(e) {
  const t = Vt(), r = re(), { userAgent: n } = V.navigator || {}, a = Z3({
    user: r.getUser() || t.getUser(),
    ...n && { userAgent: n },
    ...e
  }), u = t.getSession();
  return (u == null ? void 0 : u.status) === "ok" && Dr(u, { status: "exited" }), g1(), t.setSession(a), a;
}
function g1() {
  const e = Vt(), r = re().getSession() || e.getSession();
  r && ey(r), y1(), e.setSession();
}
function y1() {
  const e = Vt(), t = K(), r = e.getSession();
  r && t && t.captureSession(r);
}
function bf(e = !1) {
  if (e) {
    g1();
    return;
  }
  y1();
}
const Rv = "7";
function xv(e) {
  const t = e.protocol ? `${e.protocol}:` : "", r = e.port ? `:${e.port}` : "";
  return `${t}//${e.host}${r}${e.path ? `/${e.path}` : ""}/api/`;
}
function jv(e) {
  return `${xv(e)}${e.projectId}/envelope/`;
}
function Mv(e, t) {
  const r = {
    sentry_version: Rv
  };
  return e.publicKey && (r.sentry_key = e.publicKey), t && (r.sentry_client = `${t.name}/${t.version}`), new URLSearchParams(r).toString();
}
function Lv(e, t, r) {
  return t || `${jv(e)}?${Mv(e, r)}`;
}
const _f = [];
function Fv(e) {
  const t = {};
  return e.forEach((r) => {
    const { name: n } = r, a = t[n];
    a && !a.isDefaultInstance && r.isDefaultInstance || (t[n] = r);
  }), Object.values(t);
}
function $v(e) {
  const t = e.defaultIntegrations || [], r = e.integrations;
  t.forEach((a) => {
    a.isDefaultInstance = !0;
  });
  let n;
  if (Array.isArray(r))
    n = [...t, ...r];
  else if (typeof r == "function") {
    const a = r(t);
    n = Array.isArray(a) ? a : [a];
  } else
    n = t;
  return Fv(n);
}
function Uv(e, t) {
  const r = {};
  return t.forEach((n) => {
    n && v1(e, n, r);
  }), r;
}
function Sf(e, t) {
  for (const r of t)
    r != null && r.afterAllSetup && r.afterAllSetup(e);
}
function v1(e, t, r) {
  if (r[t.name]) {
    L && B.log(`Integration skipped because it was already installed: ${t.name}`);
    return;
  }
  if (r[t.name] = t, _f.indexOf(t.name) === -1 && typeof t.setupOnce == "function" && (t.setupOnce(), _f.push(t.name)), t.setup && typeof t.setup == "function" && t.setup(e), typeof t.preprocessEvent == "function") {
    const n = t.preprocessEvent.bind(t);
    e.on("preprocessEvent", (a, u) => n(a, u, e));
  }
  if (typeof t.processEvent == "function") {
    const n = t.processEvent.bind(t), a = Object.assign((u, i) => n(u, i, e), {
      id: t.name
    });
    e.addEventProcessor(a);
  }
  L && B.log(`Integration installed: ${t.name}`);
}
function Hv(e, t, r) {
  const n = [
    { type: "client_report" },
    {
      timestamp: En(),
      discarded_events: e
    }
  ];
  return Ur(t ? { dsn: t } : {}, [n]);
}
function b1(e) {
  const t = [];
  e.message && t.push(e.message);
  try {
    const r = e.exception.values[e.exception.values.length - 1];
    r != null && r.value && (t.push(r.value), r.type && t.push(`${r.type}: ${r.value}`));
  } catch {
  }
  return t;
}
function Gv(e) {
  var o;
  const { trace_id: t, parent_span_id: r, span_id: n, status: a, origin: u, data: i, op: s } = ((o = e.contexts) == null ? void 0 : o.trace) ?? {};
  return {
    data: i ?? {},
    description: e.transaction,
    op: s,
    parent_span_id: r,
    span_id: n ?? "",
    start_timestamp: e.start_timestamp ?? 0,
    status: a,
    timestamp: e.timestamp,
    trace_id: t ?? "",
    origin: u,
    profile_id: i == null ? void 0 : i[qs],
    exclusive_time: i == null ? void 0 : i[An],
    measurements: e.measurements,
    is_segment: !0
  };
}
function Wv(e) {
  return {
    type: "transaction",
    timestamp: e.timestamp,
    start_timestamp: e.start_timestamp,
    transaction: e.description,
    contexts: {
      trace: {
        trace_id: e.trace_id,
        span_id: e.span_id,
        parent_span_id: e.parent_span_id,
        op: e.op,
        status: e.status,
        origin: e.origin,
        data: {
          ...e.data,
          ...e.profile_id && { [qs]: e.profile_id },
          ...e.exclusive_time && { [An]: e.exclusive_time }
        }
      }
    },
    measurements: e.measurements
  };
}
const wf = "Not capturing exception because it's already been captured.", Ef = "Discarded session because of missing or non-string release", _1 = Symbol.for("SentryInternalError"), S1 = Symbol.for("SentryDoNotSendEventError");
function da(e) {
  return {
    message: e,
    [_1]: !0
  };
}
function _i(e) {
  return {
    message: e,
    [S1]: !0
  };
}
function Cf(e) {
  return !!e && typeof e == "object" && _1 in e;
}
function Tf(e) {
  return !!e && typeof e == "object" && S1 in e;
}
class qv {
  /** Options passed to the SDK. */
  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */
  /** Array of set up integrations. */
  /** Number of calls being processed */
  /** Holds flushable  */
  // eslint-disable-next-line @typescript-eslint/ban-types
  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  constructor(t) {
    if (this._options = t, this._integrations = {}, this._numProcessing = 0, this._outcomes = {}, this._hooks = {}, this._eventProcessors = [], t.dsn ? this._dsn = jy(t.dsn) : L && B.warn("No DSN provided, client will not send events."), this._dsn) {
      const r = Lv(
        this._dsn,
        t.tunnel,
        t._metadata ? t._metadata.sdk : void 0
      );
      this._transport = t.transport({
        tunnel: this._options.tunnel,
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...t.transportOptions,
        url: r
      });
    }
  }
  /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureException(t, r, n) {
    const a = Qe();
    if (ef(t))
      return L && B.log(wf), a;
    const u = {
      event_id: a,
      ...r
    };
    return this._process(
      this.eventFromException(t, u).then(
        (i) => this._captureEvent(i, u, n)
      )
    ), u.event_id;
  }
  /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureMessage(t, r, n, a) {
    const u = {
      event_id: Qe(),
      ...n
    }, i = Us(t) ? t : String(t), s = ln(t) ? this.eventFromMessage(i, r, u) : this.eventFromException(t, u);
    return this._process(s.then((o) => this._captureEvent(o, u, a))), u.event_id;
  }
  /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureEvent(t, r, n) {
    const a = Qe();
    if (r != null && r.originalException && ef(r.originalException))
      return L && B.log(wf), a;
    const u = {
      event_id: a,
      ...r
    }, i = t.sdkProcessingMetadata || {}, s = i.capturedSpanScope, o = i.capturedSpanIsolationScope;
    return this._process(
      this._captureEvent(t, u, s || n, o)
    ), u.event_id;
  }
  /**
   * Captures a session.
   */
  captureSession(t) {
    this.sendSession(t), Dr(t, { init: !1 });
  }
  /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */
  /**
   * Get the current Dsn.
   */
  getDsn() {
    return this._dsn;
  }
  /**
   * Get the current options.
   */
  getOptions() {
    return this._options;
  }
  /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */
  getSdkMetadata() {
    return this._options._metadata;
  }
  /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */
  getTransport() {
    return this._transport;
  }
  /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */
  flush(t) {
    const r = this._transport;
    return r ? (this.emit("flush"), this._isClientDoneProcessing(t).then((n) => r.flush(t).then((a) => n && a))) : cr(!0);
  }
  /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */
  close(t) {
    return this.flush(t).then((r) => (this.getOptions().enabled = !1, this.emit("close"), r));
  }
  /**
   * Get all installed event processors.
   */
  getEventProcessors() {
    return this._eventProcessors;
  }
  /**
   * Adds an event processor that applies to any event processed by this client.
   */
  addEventProcessor(t) {
    this._eventProcessors.push(t);
  }
  /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */
  init() {
    (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
    // Spotlight enabled. This is particularly important for browser as we
    // don't support the `spotlight` option there and rely on the users
    // adding the `spotlightBrowserIntegration()` to their integrations which
    // wouldn't get initialized with the check below when there's no DSN set.
    this._options.integrations.some(({ name: t }) => t.startsWith("Spotlight"))) && this._setupIntegrations();
  }
  /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */
  getIntegrationByName(t) {
    return this._integrations[t];
  }
  /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */
  addIntegration(t) {
    const r = this._integrations[t.name];
    v1(this, t, this._integrations), r || Sf(this, [t]);
  }
  /**
   * Send a fully prepared event to Sentry.
   */
  sendEvent(t, r = {}) {
    this.emit("beforeSendEvent", t, r);
    let n = ev(t, this._dsn, this._options._metadata, this._options.tunnel);
    for (const u of r.attachments || [])
      n = qy(n, Xy(u));
    const a = this.sendEnvelope(n);
    a && a.then((u) => this.emit("afterSendEvent", t, u), null);
  }
  /**
   * Send a session or session aggregrates to Sentry.
   */
  sendSession(t) {
    const { release: r, environment: n = Ys } = this._options;
    if ("aggregates" in t) {
      const u = t.attrs || {};
      if (!u.release && !r) {
        L && B.warn(Ef);
        return;
      }
      u.release = u.release || r, u.environment = u.environment || n, t.attrs = u;
    } else {
      if (!t.release && !r) {
        L && B.warn(Ef);
        return;
      }
      t.release = t.release || r, t.environment = t.environment || n;
    }
    this.emit("beforeSendSession", t);
    const a = Zy(t, this._dsn, this._options._metadata, this._options.tunnel);
    this.sendEnvelope(a);
  }
  /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */
  recordDroppedEvent(t, r, n = 1) {
    if (this._options.sendClientReports) {
      const a = `${t}:${r}`;
      L && B.log(`Recording outcome: "${a}"${n > 1 ? ` (${n} times)` : ""}`), this._outcomes[a] = (this._outcomes[a] || 0) + n;
    }
  }
  /* eslint-disable @typescript-eslint/unified-signatures */
  /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */
  /**
   * Register a hook on this client.
   */
  on(t, r) {
    const n = this._hooks[t] = this._hooks[t] || [];
    return n.push(r), () => {
      const a = n.indexOf(r);
      a > -1 && n.splice(a, 1);
    };
  }
  /** Fire a hook whenever a span starts. */
  /**
   * Emit a hook that was previously registered via `on()`.
   */
  emit(t, ...r) {
    const n = this._hooks[t];
    n && n.forEach((a) => a(...r));
  }
  /**
   * Send an envelope to Sentry.
   */
  sendEnvelope(t) {
    return this.emit("beforeEnvelope", t), this._isEnabled() && this._transport ? this._transport.send(t).then(null, (r) => (L && B.error("Error while sending envelope:", r), r)) : (L && B.error("Transport disabled"), cr({}));
  }
  /* eslint-enable @typescript-eslint/unified-signatures */
  /** Setup integrations for this client. */
  _setupIntegrations() {
    const { integrations: t } = this._options;
    this._integrations = Uv(this, t), Sf(this, t);
  }
  /** Updates existing session based on the provided event */
  _updateSessionFromEvent(t, r) {
    var o;
    let n = r.level === "fatal", a = !1;
    const u = (o = r.exception) == null ? void 0 : o.values;
    if (u) {
      a = !0;
      for (const c of u) {
        const f = c.mechanism;
        if ((f == null ? void 0 : f.handled) === !1) {
          n = !0;
          break;
        }
      }
    }
    const i = t.status === "ok";
    (i && t.errors === 0 || i && n) && (Dr(t, {
      ...n && { status: "crashed" },
      errors: t.errors || Number(a || n)
    }), this.captureSession(t));
  }
  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
  _isClientDoneProcessing(t) {
    return new Ut((r) => {
      let n = 0;
      const a = 1, u = setInterval(() => {
        this._numProcessing == 0 ? (clearInterval(u), r(!0)) : (n += a, t && n >= t && (clearInterval(u), r(!1)));
      }, a);
    });
  }
  /** Determines whether this SDK is enabled and a transport is present. */
  _isEnabled() {
    return this.getOptions().enabled !== !1 && this._transport !== void 0;
  }
  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */
  _prepareEvent(t, r, n, a) {
    const u = this.getOptions(), i = Object.keys(this._integrations);
    return !r.integrations && (i != null && i.length) && (r.integrations = i), this.emit("preprocessEvent", t, r), t.type || a.setLastEventId(t.event_id || r.event_id), Sv(u, t, r, n, this, a).then((s) => {
      if (s === null)
        return s;
      this.emit("postprocessEvent", s, r), s.contexts = {
        trace: dy(n),
        ...s.contexts
      };
      const o = o1(this, n);
      return s.sdkProcessingMetadata = {
        dynamicSamplingContext: o,
        ...s.sdkProcessingMetadata
      }, s;
    });
  }
  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
  _captureEvent(t, r = {}, n = re(), a = Vt()) {
    return L && ss(t) && B.log(`Captured error event \`${b1(t)[0] || "<unknown>"}\``), this._processEvent(t, r, n, a).then(
      (u) => u.event_id,
      (u) => {
        L && (Tf(u) ? B.log(u.message) : Cf(u) ? B.warn(u.message) : B.warn(u));
      }
    );
  }
  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
  _processEvent(t, r, n, a) {
    const u = this.getOptions(), { sampleRate: i } = u, s = w1(t), o = ss(t), c = t.type || "error", f = `before send for type \`${c}\``, g = typeof i > "u" ? void 0 : mn(i);
    if (o && typeof g == "number" && Math.random() > g)
      return this.recordDroppedEvent("sample_rate", "error"), Ca(
        _i(
          `Discarding event because it's not included in the random sample (sampling rate = ${i})`
        )
      );
    const p = c === "replay_event" ? "replay" : c;
    return this._prepareEvent(t, r, n, a).then((h) => {
      if (h === null)
        throw this.recordDroppedEvent("event_processor", p), _i("An event processor returned `null`, will not send event.");
      if (r.data && r.data.__sentry__ === !0)
        return h;
      const S = Vv(this, u, h, r);
      return zv(S, f);
    }).then((h) => {
      var E;
      if (h === null) {
        if (this.recordDroppedEvent("before_send", p), s) {
          const m = 1 + (t.spans || []).length;
          this.recordDroppedEvent("before_send", "span", m);
        }
        throw _i(`${f} returned \`null\`, will not send event.`);
      }
      const v = n.getSession() || a.getSession();
      if (o && v && this._updateSessionFromEvent(v, h), s) {
        const d = ((E = h.sdkProcessingMetadata) == null ? void 0 : E.spanCountBeforeProcessing) || 0, m = h.spans ? h.spans.length : 0, l = d - m;
        l > 0 && this.recordDroppedEvent("before_send", "span", l);
      }
      const S = h.transaction_info;
      if (s && S && h.transaction !== t.transaction) {
        const d = "custom";
        h.transaction_info = {
          ...S,
          source: d
        };
      }
      return this.sendEvent(h, r), h;
    }).then(null, (h) => {
      throw Tf(h) || Cf(h) ? h : (this.captureException(h, {
        data: {
          __sentry__: !0
        },
        originalException: h
      }), da(
        `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${h}`
      ));
    });
  }
  /**
   * Occupies the client with processing and event
   */
  _process(t) {
    this._numProcessing++, t.then(
      (r) => (this._numProcessing--, r),
      (r) => (this._numProcessing--, r)
    );
  }
  /**
   * Clears outcomes on this client and returns them.
   */
  _clearOutcomes() {
    const t = this._outcomes;
    return this._outcomes = {}, Object.entries(t).map(([r, n]) => {
      const [a, u] = r.split(":");
      return {
        reason: a,
        category: u,
        quantity: n
      };
    });
  }
  /**
   * Sends client reports as an envelope.
   */
  _flushOutcomes() {
    L && B.log("Flushing outcomes...");
    const t = this._clearOutcomes();
    if (t.length === 0) {
      L && B.log("No outcomes to send");
      return;
    }
    if (!this._dsn) {
      L && B.log("No dsn provided, will not send outcomes");
      return;
    }
    L && B.log("Sending outcomes:", t);
    const r = Hv(t, this._options.tunnel && On(this._dsn));
    this.sendEnvelope(r);
  }
  /**
   * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
   */
}
function zv(e, t) {
  const r = `${t} must return \`null\` or a valid event.`;
  if (Va(e))
    return e.then(
      (n) => {
        if (!pn(n) && n !== null)
          throw da(r);
        return n;
      },
      (n) => {
        throw da(`${t} rejected with ${n}`);
      }
    );
  if (!pn(e) && e !== null)
    throw da(r);
  return e;
}
function Vv(e, t, r, n) {
  const { beforeSend: a, beforeSendTransaction: u, beforeSendSpan: i } = t;
  let s = r;
  if (ss(s) && a)
    return a(s, n);
  if (w1(s)) {
    if (i) {
      const o = i(Gv(s));
      if (o ? s = Cn(r, Wv(o)) : ts(), s.spans) {
        const c = [];
        for (const f of s.spans) {
          const g = i(f);
          g ? c.push(g) : (ts(), c.push(f));
        }
        s.spans = c;
      }
    }
    if (u) {
      if (s.spans) {
        const o = s.spans.length;
        s.sdkProcessingMetadata = {
          ...r.sdkProcessingMetadata,
          spanCountBeforeProcessing: o
        };
      }
      return u(s, n);
    }
  }
  return s;
}
function ss(e) {
  return e.type === void 0;
}
function w1(e) {
  return e.type === "transaction";
}
function Yv(e) {
  return [
    {
      type: "log",
      item_count: e.length,
      content_type: "application/vnd.sentry.items.log+json"
    },
    {
      items: e
    }
  ];
}
function Xv(e, t, r, n) {
  const a = {};
  return t != null && t.sdk && (a.sdk = {
    name: t.sdk.name,
    version: t.sdk.version
  }), r && n && (a.dsn = On(n)), Ur(a, [Yv(e)]);
}
V._sentryClientToLogBufferMap = /* @__PURE__ */ new WeakMap();
function Si(e, t) {
  var u;
  const r = Jv(e) ?? [];
  if (r.length === 0)
    return;
  const n = e.getOptions(), a = Xv(r, n._metadata, n.tunnel, e.getDsn());
  (u = V._sentryClientToLogBufferMap) == null || u.set(e, []), e.emit("flushLogs"), e.sendEnvelope(a);
}
function Jv(e) {
  var t;
  return (t = V._sentryClientToLogBufferMap) == null ? void 0 : t.get(e);
}
function Kv(e, t) {
  t.debug === !0 && (L ? B.enable() : Wt(() => {
    console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
  })), re().update(t.initialScope);
  const n = new e(t);
  return Qv(n), n.init(), n;
}
function Qv(e) {
  re().setClient(e);
}
const E1 = Symbol.for("SentryBufferFullError");
function Zv(e) {
  const t = [];
  function r() {
    return e === void 0 || t.length < e;
  }
  function n(i) {
    return t.splice(t.indexOf(i), 1)[0] || Promise.resolve(void 0);
  }
  function a(i) {
    if (!r())
      return Ca(E1);
    const s = i();
    return t.indexOf(s) === -1 && t.push(s), s.then(() => n(s)).then(
      null,
      () => n(s).then(null, () => {
      })
    ), s;
  }
  function u(i) {
    return new Ut((s, o) => {
      let c = t.length;
      if (!c)
        return s(!0);
      const f = setTimeout(() => {
        i && i > 0 && s(!1);
      }, i);
      t.forEach((g) => {
        cr(g).then(() => {
          --c || (clearTimeout(f), s(!0));
        }, o);
      });
    });
  }
  return {
    $: t,
    add: a,
    drain: u
  };
}
const e4 = 60 * 1e3;
function t4(e, t = Date.now()) {
  const r = parseInt(`${e}`, 10);
  if (!isNaN(r))
    return r * 1e3;
  const n = Date.parse(`${e}`);
  return isNaN(n) ? e4 : n - t;
}
function r4(e, t) {
  return e[t] || e.all || 0;
}
function n4(e, t, r = Date.now()) {
  return r4(e, t) > r;
}
function a4(e, { statusCode: t, headers: r }, n = Date.now()) {
  const a = {
    ...e
  }, u = r == null ? void 0 : r["x-sentry-rate-limits"], i = r == null ? void 0 : r["retry-after"];
  if (u)
    for (const s of u.trim().split(",")) {
      const [o, c, , , f] = s.split(":", 5), g = parseInt(o, 10), p = (isNaN(g) ? 60 : g) * 1e3;
      if (!c)
        a.all = n + p;
      else
        for (const h of c.split(";"))
          h === "metric_bucket" ? (!f || f.split(";").includes("custom")) && (a[h] = n + p) : a[h] = n + p;
    }
  else i ? a.all = n + t4(i, n) : t === 429 && (a.all = n + 60 * 1e3);
  return a;
}
const u4 = 64;
function i4(e, t, r = Zv(
  e.bufferSize || u4
)) {
  let n = {};
  const a = (i) => r.drain(i);
  function u(i) {
    const s = [];
    if (of(i, (g, p) => {
      const h = cf(p);
      n4(n, h) ? e.recordDroppedEvent("ratelimit_backoff", h) : s.push(g);
    }), s.length === 0)
      return cr({});
    const o = Ur(i[0], s), c = (g) => {
      of(o, (p, h) => {
        e.recordDroppedEvent(g, cf(h));
      });
    }, f = () => t({ body: zy(o) }).then(
      (g) => (g.statusCode !== void 0 && (g.statusCode < 200 || g.statusCode >= 300) && L && B.warn(`Sentry responded with status code ${g.statusCode} to sent event.`), n = a4(n, g), g),
      (g) => {
        throw c("network_error"), L && B.error("Encountered error running transport request:", g), g;
      }
    );
    return r.add(f).then(
      (g) => g,
      (g) => {
        if (g === E1)
          return L && B.error("Skipped sending event because buffer is full."), c("queue_overflow"), cr({});
        throw g;
      }
    );
  }
  return {
    send: u,
    flush: a
  };
}
function s4(e) {
  var t;
  ((t = e.user) == null ? void 0 : t.ip_address) === void 0 && (e.user = {
    ...e.user,
    ip_address: "{{auto}}"
  });
}
function o4(e) {
  var t;
  "aggregates" in e ? ((t = e.attrs) == null ? void 0 : t.ip_address) === void 0 && (e.attrs = {
    ...e.attrs,
    ip_address: "{{auto}}"
  }) : e.ipAddress === void 0 && (e.ipAddress = "{{auto}}");
}
function C1(e, t, r = [t], n = "npm") {
  const a = e._metadata || {};
  a.sdk || (a.sdk = {
    name: `sentry.javascript.${t}`,
    packages: r.map((u) => ({
      name: `${n}:@sentry/${u}`,
      version: Zt
    })),
    version: Zt
  }), e._metadata = a;
}
function T1(e = {}) {
  const t = e.client || K();
  if (!Nv() || !t)
    return {};
  const r = dr(), n = $r(r);
  if (n.getTraceData)
    return n.getTraceData(e);
  const a = e.scope || re(), u = e.span || Le(), i = u ? Ty(u) : c4(a), s = u ? $t(u) : o1(t, a), o = yy(s);
  return Zl.test(i) ? {
    "sentry-trace": i,
    baggage: o
  } : (B.warn("Invalid sentry-trace data. Cannot generate trace data"), {});
}
function c4(e) {
  const { traceId: t, sampled: r, propagationSpanId: n } = e.getPropagationContext();
  return e1(t, n, r);
}
const d4 = 100;
function Ht(e, t) {
  const r = K(), n = Vt();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: u = d4 } = r.getOptions();
  if (u <= 0) return;
  const s = { timestamp: En(), ...e }, o = a ? Wt(() => a(s, t)) : s;
  o !== null && (r.emit && r.emit("beforeAddBreadcrumb", o, t), n.addBreadcrumb(o, u));
}
let kf;
const f4 = "FunctionToString", Af = /* @__PURE__ */ new WeakMap(), l4 = () => ({
  name: f4,
  setupOnce() {
    kf = Function.prototype.toString;
    try {
      Function.prototype.toString = function(...e) {
        const t = Gs(this), r = Af.has(K()) && t !== void 0 ? t : this;
        return kf.apply(r, e);
      };
    } catch {
    }
  },
  setup(e) {
    Af.set(e, !0);
  }
}), p4 = l4, h4 = [
  /^Script error\.?$/,
  /^Javascript error: Script error\.? on line 0$/,
  /^ResizeObserver loop completed with undelivered notifications.$/,
  // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
  /^Cannot redefine property: googletag$/,
  // This is thrown when google tag manager is used in combination with an ad blocker
  /^Can't find variable: gmo$/,
  // Error from Google Search App https://issuetracker.google.com/issues/396043331
  /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
  // Random error that happens but not actionable or noticeable to end-users.
  `can't redefine non-configurable property "solana"`,
  // Probably a browser extension or custom browser (Brave) throwing this error
  "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
  // Error thrown by GTM, seemingly not affecting end-users
  "Can't find variable: _AutofillCallbackHandler",
  // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
  /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
  // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
  /^Java exception was raised during method invocation$/
  // error from Facebook Mobile browser (https://github.com/getsentry/sentry-javascript/issues/15065)
], m4 = "EventFilters", g4 = (e = {}) => {
  let t;
  return {
    name: m4,
    setup(r) {
      const n = r.getOptions();
      t = Of(e, n);
    },
    processEvent(r, n, a) {
      if (!t) {
        const u = a.getOptions();
        t = Of(e, u);
      }
      return v4(r, t) ? null : r;
    }
  };
}, y4 = (e = {}) => ({
  ...g4(e),
  name: "InboundFilters"
});
function Of(e = {}, t = {}) {
  return {
    allowUrls: [...e.allowUrls || [], ...t.allowUrls || []],
    denyUrls: [...e.denyUrls || [], ...t.denyUrls || []],
    ignoreErrors: [
      ...e.ignoreErrors || [],
      ...t.ignoreErrors || [],
      ...e.disableErrorDefaults ? [] : h4
    ],
    ignoreTransactions: [...e.ignoreTransactions || [], ...t.ignoreTransactions || []]
  };
}
function v4(e, t) {
  if (e.type) {
    if (e.type === "transaction" && _4(e, t.ignoreTransactions))
      return L && B.warn(
        `Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${Jt(e)}`
      ), !0;
  } else {
    if (b4(e, t.ignoreErrors))
      return L && B.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${Jt(e)}`
      ), !0;
    if (C4(e))
      return L && B.warn(
        `Event dropped due to not having an error message, error type or stacktrace.
Event: ${Jt(
          e
        )}`
      ), !0;
    if (S4(e, t.denyUrls))
      return L && B.warn(
        `Event dropped due to being matched by \`denyUrls\` option.
Event: ${Jt(
          e
        )}.
Url: ${Ta(e)}`
      ), !0;
    if (!w4(e, t.allowUrls))
      return L && B.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.
Event: ${Jt(
          e
        )}.
Url: ${Ta(e)}`
      ), !0;
  }
  return !1;
}
function b4(e, t) {
  return t != null && t.length ? b1(e).some((r) => Mt(r, t)) : !1;
}
function _4(e, t) {
  if (!(t != null && t.length))
    return !1;
  const r = e.transaction;
  return r ? Mt(r, t) : !1;
}
function S4(e, t) {
  if (!(t != null && t.length))
    return !1;
  const r = Ta(e);
  return r ? Mt(r, t) : !1;
}
function w4(e, t) {
  if (!(t != null && t.length))
    return !0;
  const r = Ta(e);
  return r ? Mt(r, t) : !0;
}
function E4(e = []) {
  for (let t = e.length - 1; t >= 0; t--) {
    const r = e[t];
    if (r && r.filename !== "<anonymous>" && r.filename !== "[native code]")
      return r.filename || null;
  }
  return null;
}
function Ta(e) {
  var t, r;
  try {
    const n = [...((t = e.exception) == null ? void 0 : t.values) ?? []].reverse().find((u) => {
      var i, s, o;
      return ((i = u.mechanism) == null ? void 0 : i.parent_id) === void 0 && ((o = (s = u.stacktrace) == null ? void 0 : s.frames) == null ? void 0 : o.length);
    }), a = (r = n == null ? void 0 : n.stacktrace) == null ? void 0 : r.frames;
    return a ? E4(a) : null;
  } catch {
    return L && B.error(`Cannot extract url for event ${Jt(e)}`), null;
  }
}
function C4(e) {
  var t, r;
  return (r = (t = e.exception) == null ? void 0 : t.values) != null && r.length ? (
    // No top-level message
    !e.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !e.exception.values.some((n) => n.stacktrace || n.type && n.type !== "Error" || n.value)
  ) : !1;
}
function T4(e, t, r, n, a, u) {
  var s;
  if (!((s = a.exception) != null && s.values) || !u || !At(u.originalException, Error))
    return;
  const i = a.exception.values.length > 0 ? a.exception.values[a.exception.values.length - 1] : void 0;
  i && (a.exception.values = os(
    e,
    t,
    n,
    u.originalException,
    r,
    a.exception.values,
    i,
    0
  ));
}
function os(e, t, r, n, a, u, i, s) {
  if (u.length >= r + 1)
    return u;
  let o = [...u];
  if (At(n[a], Error)) {
    If(i, s);
    const c = e(t, n[a]), f = o.length;
    Pf(c, a, f, s), o = os(
      e,
      t,
      r,
      n[a],
      a,
      [c, ...o],
      c,
      f
    );
  }
  return Array.isArray(n.errors) && n.errors.forEach((c, f) => {
    if (At(c, Error)) {
      If(i, s);
      const g = e(t, c), p = o.length;
      Pf(g, `errors[${f}]`, p, s), o = os(
        e,
        t,
        r,
        c,
        a,
        [g, ...o],
        g,
        p
      );
    }
  }), o;
}
function If(e, t) {
  e.mechanism = e.mechanism || { type: "generic", handled: !0 }, e.mechanism = {
    ...e.mechanism,
    ...e.type === "AggregateError" && { is_exception_group: !0 },
    exception_id: t
  };
}
function Pf(e, t, r, n) {
  e.mechanism = e.mechanism || { type: "generic", handled: !0 }, e.mechanism = {
    ...e.mechanism,
    type: "chained",
    source: t,
    exception_id: r,
    parent_id: n
  };
}
function k1(e) {
  const t = "console";
  qt(t, e), zt(t, k4);
}
function k4() {
  "console" in V && ya.forEach(function(e) {
    e in V.console && Ve(V.console, e, function(t) {
      return va[e] = t, function(...r) {
        Ke("console", { args: r, level: e });
        const a = va[e];
        a == null || a.apply(V.console, r);
      };
    });
  });
}
function A1(e) {
  return e === "warn" ? "warning" : ["fatal", "error", "warning", "log", "info", "debug"].includes(e) ? e : "log";
}
const A4 = "CaptureConsole", O4 = (e = {}) => {
  const t = e.levels || ya, r = e.handled ?? !0;
  return {
    name: A4,
    setup(n) {
      "console" in V && k1(({ args: a, level: u }) => {
        K() !== n || !t.includes(u) || P4(a, u, r);
      });
    }
  };
}, I4 = O4;
function P4(e, t, r) {
  const n = {
    level: A1(t),
    extra: {
      arguments: e
    }
  };
  kn((a) => {
    if (a.addEventProcessor((s) => (s.logger = "console", ur(s, {
      handled: r,
      type: "console"
    }), s)), t === "assert") {
      if (!e[0]) {
        const s = `Assertion failed: ${_a(e.slice(1), " ") || "console.assert"}`;
        a.setExtra("arguments", e.slice(1)), is(s, n);
      }
      return;
    }
    const u = e.find((s) => s instanceof Error);
    if (u) {
      In(u, n);
      return;
    }
    const i = _a(e, " ");
    is(i, n);
  });
}
const B4 = "Dedupe", N4 = () => {
  let e;
  return {
    name: B4,
    processEvent(t) {
      if (t.type)
        return t;
      try {
        if (R4(t, e))
          return L && B.warn("Event dropped due to being a duplicate of previously captured event."), null;
      } catch {
      }
      return e = t;
    }
  };
}, D4 = N4;
function R4(e, t) {
  return t ? !!(x4(e, t) || j4(e, t)) : !1;
}
function x4(e, t) {
  const r = e.message, n = t.message;
  return !(!r && !n || r && !n || !r && n || r !== n || !I1(e, t) || !O1(e, t));
}
function j4(e, t) {
  const r = Bf(t), n = Bf(e);
  return !(!r || !n || r.type !== n.type || r.value !== n.value || !I1(e, t) || !O1(e, t));
}
function O1(e, t) {
  let r = Xd(e), n = Xd(t);
  if (!r && !n)
    return !0;
  if (r && !n || !r && n || (r = r, n = n, n.length !== r.length))
    return !1;
  for (let a = 0; a < n.length; a++) {
    const u = n[a], i = r[a];
    if (u.filename !== i.filename || u.lineno !== i.lineno || u.colno !== i.colno || u.function !== i.function)
      return !1;
  }
  return !0;
}
function I1(e, t) {
  let r = e.fingerprint, n = t.fingerprint;
  if (!r && !n)
    return !0;
  if (r && !n || !r && n)
    return !1;
  r = r, n = n;
  try {
    return r.join("") === n.join("");
  } catch {
    return !1;
  }
}
function Bf(e) {
  var t;
  return ((t = e.exception) == null ? void 0 : t.values) && e.exception.values[0];
}
const M4 = "thismessage:/";
function P1(e) {
  return "isRelative" in e;
}
function B1(e, t) {
  const r = e.indexOf("://") <= 0 && e.indexOf("//") !== 0, n = r ? M4 : void 0;
  try {
    if ("canParse" in URL && !URL.canParse(e, n))
      return;
    const a = new URL(e, n);
    return r ? {
      isRelative: r,
      pathname: a.pathname,
      search: a.search,
      hash: a.hash
    } : a;
  } catch {
  }
}
function L4(e) {
  if (P1(e))
    return e.pathname;
  const t = new URL(e);
  return t.search = "", t.hash = "", ["80", "443"].includes(t.port) && (t.port = ""), t.password && (t.password = "%filtered%"), t.username && (t.username = "%filtered%"), t.toString();
}
function rr(e) {
  if (!e)
    return {};
  const t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!t)
    return {};
  const r = t[6] || "", n = t[8] || "";
  return {
    host: t[4],
    path: t[5],
    protocol: t[2],
    search: r,
    hash: n,
    relative: t[5] + r + n
    // everything minus origin
  };
}
function F4(e) {
  return e.split(/[?#]/, 1)[0];
}
function $4(e, t, r, n, a = "auto.http.browser") {
  if (!e.fetchData)
    return;
  const { method: u, url: i } = e.fetchData, s = Ot() && t(i);
  if (e.endTimestamp && s) {
    const g = e.fetchData.__span;
    if (!g) return;
    const p = n[g];
    p && (H4(p, e), delete n[g]);
    return;
  }
  const o = !!Le(), c = s && o ? or(W4(i, u, a)) : new sr();
  if (e.fetchData.__span = c.spanContext().spanId, n[c.spanContext().spanId] = c, r(e.fetchData.url)) {
    const g = e.args[0], p = e.args[1] || {}, h = U4(
      g,
      p,
      // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
      // we do not want to use the span as base for the trace headers,
      // which means that the headers will be generated from the scope and the sampling decision is deferred
      Ot() && o ? c : void 0
    );
    h && (e.args[1] = p, p.headers = h);
  }
  const f = K();
  if (f) {
    const g = {
      input: e.args,
      response: e.response,
      startTimestamp: e.startTimestamp,
      endTimestamp: e.endTimestamp
    };
    f.emit("beforeOutgoingRequestSpan", c, g);
  }
  return c;
}
function U4(e, t, r) {
  const n = T1({ span: r }), a = n["sentry-trace"], u = n.baggage;
  if (!a)
    return;
  const i = t.headers || (Ul(e) ? e.headers : void 0);
  if (i)
    if (G4(i)) {
      const s = new Headers(i);
      if (s.get("sentry-trace") || s.set("sentry-trace", a), u) {
        const o = s.get("baggage");
        o ? Gn(o) || s.set("baggage", `${o},${u}`) : s.set("baggage", u);
      }
      return s;
    } else if (Array.isArray(i)) {
      const s = [...i];
      i.find((c) => c[0] === "sentry-trace") || s.push(["sentry-trace", a]);
      const o = i.find(
        (c) => c[0] === "baggage" && Gn(c[1])
      );
      return u && !o && s.push(["baggage", u]), s;
    } else {
      const s = "sentry-trace" in i ? i["sentry-trace"] : void 0, o = "baggage" in i ? i.baggage : void 0, c = o ? Array.isArray(o) ? [...o] : [o] : [], f = o && (Array.isArray(o) ? o.find((g) => Gn(g)) : Gn(o));
      return u && !f && c.push(u), {
        ...i,
        "sentry-trace": s ?? a,
        baggage: c.length > 0 ? c.join(",") : void 0
      };
    }
  else return { ...n };
}
function H4(e, t) {
  var r;
  if (t.response) {
    Xl(e, t.response.status);
    const n = ((r = t.response) == null ? void 0 : r.headers) && t.response.headers.get("content-length");
    if (n) {
      const a = parseInt(n);
      a > 0 && e.setAttribute("http.response_content_length", a);
    }
  } else t.error && e.setStatus({ code: Ee, message: "internal_error" });
  e.end();
}
function Gn(e) {
  return e.split(",").some((t) => t.trim().startsWith(zs));
}
function G4(e) {
  return typeof Headers < "u" && At(e, Headers);
}
function W4(e, t, r) {
  const n = B1(e);
  return {
    name: n ? `${t} ${L4(n)}` : t,
    attributes: q4(e, n, t, r)
  };
}
function q4(e, t, r, n) {
  const a = {
    url: e,
    type: "fetch",
    "http.method": r,
    [de]: n,
    [ir]: "http.client"
  };
  return t && (P1(t) || (a["http.url"] = t.href, a["server.address"] = t.host), t.search && (a["http.query"] = t.search), t.hash && (a["http.fragment"] = t.hash)), a;
}
function N1(e) {
  if (e !== void 0)
    return e >= 400 && e < 500 ? "warning" : e >= 500 ? "error" : void 0;
}
const gn = V;
function z4() {
  return "history" in gn && !!gn.history;
}
function V4() {
  if (!("fetch" in gn))
    return !1;
  try {
    return new Headers(), new Request("http://www.example.com"), new Response(), !0;
  } catch {
    return !1;
  }
}
function cs(e) {
  return e && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
}
function Y4() {
  var r;
  if (typeof EdgeRuntime == "string")
    return !0;
  if (!V4())
    return !1;
  if (cs(gn.fetch))
    return !0;
  let e = !1;
  const t = gn.document;
  if (t && typeof t.createElement == "function")
    try {
      const n = t.createElement("iframe");
      n.hidden = !0, t.head.appendChild(n), (r = n.contentWindow) != null && r.fetch && (e = cs(n.contentWindow.fetch)), t.head.removeChild(n);
    } catch (n) {
      L && B.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", n);
    }
  return e;
}
function D1(e, t) {
  const r = "fetch";
  qt(r, e), zt(r, () => R1(void 0, t));
}
function X4(e) {
  const t = "fetch-body-resolved";
  qt(t, e), zt(t, () => R1(K4));
}
function R1(e, t = !1) {
  t && !Y4() || Ve(V, "fetch", function(r) {
    return function(...n) {
      const a = new Error(), { method: u, url: i } = Q4(n), s = {
        args: n,
        fetchData: {
          method: u,
          url: i
        },
        startTimestamp: Te() * 1e3,
        // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
        virtualError: a,
        headers: Z4(n)
      };
      return e || Ke("fetch", {
        ...s
      }), r.apply(V, n).then(
        async (o) => (e ? e(o) : Ke("fetch", {
          ...s,
          endTimestamp: Te() * 1e3,
          response: o
        }), o),
        (o) => {
          if (Ke("fetch", {
            ...s,
            endTimestamp: Te() * 1e3,
            error: o
          }), $s(o) && o.stack === void 0 && (o.stack = a.stack, Ye(o, "framesToPop", 1)), o instanceof TypeError && (o.message === "Failed to fetch" || o.message === "Load failed" || o.message === "NetworkError when attempting to fetch resource."))
            try {
              const c = new URL(s.fetchData.url);
              o.message = `${o.message} (${c.host})`;
            } catch {
            }
          throw o;
        }
      );
    };
  });
}
async function J4(e, t) {
  if (e != null && e.body) {
    const r = e.body, n = r.getReader(), a = setTimeout(
      () => {
        r.cancel().then(null, () => {
        });
      },
      90 * 1e3
      // 90s
    );
    let u = !0;
    for (; u; ) {
      let i;
      try {
        i = setTimeout(() => {
          r.cancel().then(null, () => {
          });
        }, 5e3);
        const { done: s } = await n.read();
        clearTimeout(i), s && (t(), u = !1);
      } catch {
        u = !1;
      } finally {
        clearTimeout(i);
      }
    }
    clearTimeout(a), n.releaseLock(), r.cancel().then(null, () => {
    });
  }
}
function K4(e) {
  let t;
  try {
    t = e.clone();
  } catch {
    return;
  }
  J4(t, () => {
    Ke("fetch-body-resolved", {
      endTimestamp: Te() * 1e3,
      response: e
    });
  });
}
function ds(e, t) {
  return !!e && typeof e == "object" && !!e[t];
}
function Nf(e) {
  return typeof e == "string" ? e : e ? ds(e, "url") ? e.url : e.toString ? e.toString() : "" : "";
}
function Q4(e) {
  if (e.length === 0)
    return { method: "GET", url: "" };
  if (e.length === 2) {
    const [r, n] = e;
    return {
      url: Nf(r),
      method: ds(n, "method") ? String(n.method).toUpperCase() : "GET"
    };
  }
  const t = e[0];
  return {
    url: Nf(t),
    method: ds(t, "method") ? String(t.method).toUpperCase() : "GET"
  };
}
function Z4(e) {
  const [t, r] = e;
  try {
    if (typeof r == "object" && r !== null && "headers" in r && r.headers)
      return new Headers(r.headers);
    if (Ul(t))
      return new Headers(t.headers);
  } catch {
  }
}
function e8() {
  return "npm";
}
const X = V;
let fs = 0;
function x1() {
  return fs > 0;
}
function t8() {
  fs++, setTimeout(() => {
    fs--;
  });
}
function xr(e, t = {}) {
  function r(a) {
    return typeof a == "function";
  }
  if (!r(e))
    return e;
  try {
    const a = e.__sentry_wrapped__;
    if (a)
      return typeof a == "function" ? a : e;
    if (Gs(e))
      return e;
  } catch {
    return e;
  }
  const n = function(...a) {
    try {
      const u = a.map((i) => xr(i, t));
      return e.apply(this, u);
    } catch (u) {
      throw t8(), kn((i) => {
        i.addEventProcessor((s) => (t.mechanism && (Qi(s, void 0), ur(s, t.mechanism)), s.extra = {
          ...s.extra,
          arguments: a
        }, s)), In(u);
      }), u;
    }
  };
  try {
    for (const a in e)
      Object.prototype.hasOwnProperty.call(e, a) && (n[a] = e[a]);
  } catch {
  }
  Gl(n, e), Ye(e, "__sentry_wrapped__", n);
  try {
    Object.getOwnPropertyDescriptor(n, "name").configurable && Object.defineProperty(n, "name", {
      get() {
        return e.name;
      }
    });
  } catch {
  }
  return n;
}
function ls() {
  const e = wn(), { referrer: t } = X.document || {}, { userAgent: r } = X.navigator || {}, n = {
    ...t && { Referer: t },
    ...r && { "User-Agent": r }
  };
  return {
    url: e,
    headers: n
  };
}
function Js(e, t) {
  const r = Ks(e, t), n = {
    type: i8(t),
    value: s8(t)
  };
  return r.length && (n.stacktrace = { frames: r }), n.type === void 0 && n.value === "" && (n.value = "Unrecoverable error caught"), n;
}
function r8(e, t, r, n) {
  const a = K(), u = a == null ? void 0 : a.getOptions().normalizeDepth, i = l8(t), s = {
    __serialized__: c1(t, u)
  };
  if (i)
    return {
      exception: {
        values: [Js(e, i)]
      },
      extra: s
    };
  const o = {
    exception: {
      values: [
        {
          type: za(t) ? t.constructor.name : n ? "UnhandledRejection" : "Error",
          value: d8(t, { isUnhandledRejection: n })
        }
      ]
    },
    extra: s
  };
  if (r) {
    const c = Ks(e, r);
    c.length && (o.exception.values[0].stacktrace = { frames: c });
  }
  return o;
}
function wi(e, t) {
  return {
    exception: {
      values: [Js(e, t)]
    }
  };
}
function Ks(e, t) {
  const r = t.stacktrace || t.stack || "", n = a8(t), a = u8(t);
  try {
    return e(r, n, a);
  } catch {
  }
  return [];
}
const n8 = /Minified React error #\d+;/i;
function a8(e) {
  return e && n8.test(e.message) ? 1 : 0;
}
function u8(e) {
  return typeof e.framesToPop == "number" ? e.framesToPop : 0;
}
function j1(e) {
  return typeof WebAssembly < "u" && typeof WebAssembly.Exception < "u" ? e instanceof WebAssembly.Exception : !1;
}
function i8(e) {
  const t = e == null ? void 0 : e.name;
  return !t && j1(e) ? e.message && Array.isArray(e.message) && e.message.length == 2 ? e.message[0] : "WebAssembly.Exception" : t;
}
function s8(e) {
  const t = e == null ? void 0 : e.message;
  return j1(e) ? Array.isArray(e.message) && e.message.length == 2 ? e.message[1] : "wasm exception" : t ? t.error && typeof t.error.message == "string" ? t.error.message : t : "No error message";
}
function o8(e, t, r, n) {
  const a = (r == null ? void 0 : r.syntheticException) || void 0, u = Qs(e, t, a, n);
  return ur(u), u.level = "error", r != null && r.event_id && (u.event_id = r.event_id), cr(u);
}
function c8(e, t, r = "info", n, a) {
  const u = (n == null ? void 0 : n.syntheticException) || void 0, i = ps(e, t, u, a);
  return i.level = r, n != null && n.event_id && (i.event_id = n.event_id), cr(i);
}
function Qs(e, t, r, n, a) {
  let u;
  if (Fl(t) && t.error)
    return wi(e, t.error);
  if (Kd(t) || U3(t)) {
    const i = t;
    if ("stack" in t)
      u = wi(e, t);
    else {
      const s = i.name || (Kd(i) ? "DOMError" : "DOMException"), o = i.message ? `${s}: ${i.message}` : s;
      u = ps(e, o, r, n), Qi(u, o);
    }
    return "code" in i && (u.tags = { ...u.tags, "DOMException.code": `${i.code}` }), u;
  }
  return $s(t) ? wi(e, t) : pn(t) || za(t) ? (u = r8(e, t, r, a), ur(u, {
    synthetic: !0
  }), u) : (u = ps(e, t, r, n), Qi(u, `${t}`), ur(u, {
    synthetic: !0
  }), u);
}
function ps(e, t, r, n) {
  const a = {};
  if (n && r) {
    const u = Ks(e, r);
    u.length && (a.exception = {
      values: [{ value: t, stacktrace: { frames: u } }]
    }), ur(a, { synthetic: !0 });
  }
  if (Us(t)) {
    const { __sentry_template_string__: u, __sentry_template_values__: i } = t;
    return a.logentry = {
      message: u,
      params: i
    }, a;
  }
  return a.message = t, a;
}
function d8(e, { isUnhandledRejection: t }) {
  const r = Y3(e), n = t ? "promise rejection" : "exception";
  return Fl(e) ? `Event \`ErrorEvent\` captured as ${n} with message \`${e.message}\`` : za(e) ? `Event \`${f8(e)}\` (type=${e.type}) captured as ${n}` : `Object captured as ${n} with keys: ${r}`;
}
function f8(e) {
  try {
    const t = Object.getPrototypeOf(e);
    return t ? t.constructor.name : void 0;
  } catch {
  }
}
function l8(e) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t)) {
      const r = e[t];
      if (r instanceof Error)
        return r;
    }
}
const p8 = 5e3;
class h8 extends qv {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  constructor(t) {
    const r = m8(t), n = X.SENTRY_SDK_SOURCE || e8();
    C1(r, "browser", ["browser"], n), super(r);
    const { sendDefaultPii: a, sendClientReports: u, _experiments: i } = this._options, s = i == null ? void 0 : i.enableLogs;
    X.document && (u || s) && X.document.addEventListener("visibilitychange", () => {
      X.document.visibilityState === "hidden" && (u && this._flushOutcomes(), s && Si(this));
    }), s && (this.on("flush", () => {
      Si(this);
    }), this.on("afterCaptureLog", () => {
      this._logFlushIdleTimeout && clearTimeout(this._logFlushIdleTimeout), this._logFlushIdleTimeout = setTimeout(() => {
        Si(this);
      }, p8);
    })), a && (this.on("postprocessEvent", s4), this.on("beforeSendSession", o4));
  }
  /**
   * @inheritDoc
   */
  eventFromException(t, r) {
    return o8(this._options.stackParser, t, r, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  eventFromMessage(t, r = "info", n) {
    return c8(this._options.stackParser, t, r, n, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  _prepareEvent(t, r, n, a) {
    return t.platform = t.platform || "javascript", super._prepareEvent(t, r, n, a);
  }
}
function m8(e) {
  var t;
  return {
    release: typeof __SENTRY_RELEASE__ == "string" ? __SENTRY_RELEASE__ : (t = X.SENTRY_RELEASE) == null ? void 0 : t.id,
    // This supports the variable that sentry-webpack-plugin injects
    sendClientReports: !0,
    // We default this to true, as it is the safer scenario
    parentSpanIsAlwaysRootSpan: !0,
    ...e
  };
}
const Zs = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, U = V, g8 = (e, t) => e > t[1] ? "poor" : e > t[0] ? "needs-improvement" : "good", Hr = (e, t, r, n) => {
  let a, u;
  return (i) => {
    t.value >= 0 && (i || n) && (u = t.value - (a ?? 0), (u || a === void 0) && (a = t.value, t.delta = u, t.rating = g8(t.value, r), e(t)));
  };
}, y8 = () => `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`, Pn = (e = !0) => {
  var r, n;
  const t = (n = (r = U.performance) == null ? void 0 : r.getEntriesByType) == null ? void 0 : n.call(r, "navigation")[0];
  if (
    // sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !e || t && t.responseStart > 0 && t.responseStart < performance.now()
  )
    return t;
}, Gr = () => {
  const e = Pn();
  return (e == null ? void 0 : e.activationStart) ?? 0;
}, Wr = (e, t = -1) => {
  var u, i;
  const r = Pn();
  let n = "navigate";
  return r && ((u = U.document) != null && u.prerendering || Gr() > 0 ? n = "prerender" : (i = U.document) != null && i.wasDiscarded ? n = "restore" : r.type && (n = r.type.replace(/_/g, "-"))), {
    name: e,
    value: t,
    rating: "good",
    // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
    delta: 0,
    entries: [],
    id: y8(),
    navigationType: n
  };
}, Ei = /* @__PURE__ */ new WeakMap();
function eo(e, t) {
  return Ei.get(e) || Ei.set(e, new t()), Ei.get(e);
}
class ka {
  constructor() {
    ka.prototype.__init.call(this), ka.prototype.__init2.call(this);
  }
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
  __init() {
    this._sessionValue = 0;
  }
  // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
  __init2() {
    this._sessionEntries = [];
  }
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  _processEntry(t) {
    var a;
    if (t.hadRecentInput) return;
    const r = this._sessionEntries[0], n = this._sessionEntries[this._sessionEntries.length - 1];
    this._sessionValue && r && n && t.startTime - n.startTime < 1e3 && t.startTime - r.startTime < 5e3 ? (this._sessionValue += t.value, this._sessionEntries.push(t)) : (this._sessionValue = t.value, this._sessionEntries = [t]), (a = this._onAfterProcessingUnexpectedShift) == null || a.call(this, t);
  }
}
const lr = (e, t, r = {}) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      const n = new PerformanceObserver((a) => {
        Promise.resolve().then(() => {
          t(a.getEntries());
        });
      });
      return n.observe({ type: e, buffered: !0, ...r }), n;
    }
  } catch {
  }
}, Ja = (e) => {
  let t = !1;
  return () => {
    t || (e(), t = !0);
  };
};
let un = -1;
const v8 = () => {
  var e, t;
  return ((e = U.document) == null ? void 0 : e.visibilityState) === "hidden" && !((t = U.document) != null && t.prerendering) ? 0 : 1 / 0;
}, Aa = (e) => {
  U.document.visibilityState === "hidden" && un > -1 && (un = e.type === "visibilitychange" ? e.timeStamp : 0, _8());
}, b8 = () => {
  addEventListener("visibilitychange", Aa, !0), addEventListener("prerenderingchange", Aa, !0);
}, _8 = () => {
  removeEventListener("visibilitychange", Aa, !0), removeEventListener("prerenderingchange", Aa, !0);
}, Ka = () => {
  var e;
  if (U.document && un < 0) {
    const t = Gr();
    un = (U.document.prerendering || (e = globalThis.performance.getEntriesByType("visibility-state").filter((n) => n.name === "hidden" && n.startTime > t)[0]) == null ? void 0 : e.startTime) ?? v8(), b8();
  }
  return {
    get firstHiddenTime() {
      return un;
    }
  };
}, Bn = (e) => {
  var t;
  (t = U.document) != null && t.prerendering ? addEventListener("prerenderingchange", () => e(), !0) : e();
}, S8 = [1800, 3e3], w8 = (e, t = {}) => {
  Bn(() => {
    const r = Ka(), n = Wr("FCP");
    let a;
    const i = lr("paint", (s) => {
      for (const o of s)
        o.name === "first-contentful-paint" && (i.disconnect(), o.startTime < r.firstHiddenTime && (n.value = Math.max(o.startTime - Gr(), 0), n.entries.push(o), a(!0)));
    });
    i && (a = Hr(e, n, S8, t.reportAllChanges));
  });
}, E8 = [0.1, 0.25], C8 = (e, t = {}) => {
  w8(
    Ja(() => {
      var s, o;
      const r = Wr("CLS", 0);
      let n;
      const a = eo(t, ka), u = (c) => {
        for (const f of c)
          a._processEntry(f);
        a._sessionValue > r.value && (r.value = a._sessionValue, r.entries = a._sessionEntries, n());
      }, i = lr("layout-shift", u);
      i && (n = Hr(e, r, E8, t.reportAllChanges), (s = U.document) == null || s.addEventListener("visibilitychange", () => {
        var c;
        ((c = U.document) == null ? void 0 : c.visibilityState) === "hidden" && (u(i.takeRecords()), n(!0));
      }), (o = U == null ? void 0 : U.setTimeout) == null || o.call(U, n));
    })
  );
}, Qa = (e) => {
  const t = (r) => {
    var n;
    (r.type === "pagehide" || ((n = U.document) == null ? void 0 : n.visibilityState) === "hidden") && e(r);
  };
  U.document && (addEventListener("visibilitychange", t, !0), addEventListener("pagehide", t, !0));
}, T8 = [100, 300], k8 = (e, t = {}) => {
  Bn(() => {
    const r = Ka(), n = Wr("FID");
    let a;
    const u = (o) => {
      o.startTime < r.firstHiddenTime && (n.value = o.processingStart - o.startTime, n.entries.push(o), a(!0));
    }, i = (o) => {
      o.forEach(u);
    }, s = lr("first-input", i);
    a = Hr(e, n, T8, t.reportAllChanges), s && Qa(
      Ja(() => {
        i(s.takeRecords()), s.disconnect();
      })
    );
  });
};
let M1 = 0, Ci = 1 / 0, Wn = 0;
const A8 = (e) => {
  e.forEach((t) => {
    t.interactionId && (Ci = Math.min(Ci, t.interactionId), Wn = Math.max(Wn, t.interactionId), M1 = Wn ? (Wn - Ci) / 7 + 1 : 0);
  });
};
let hs;
const L1 = () => hs ? M1 : performance.interactionCount || 0, O8 = () => {
  "interactionCount" in performance || hs || (hs = lr("event", A8, {
    type: "event",
    buffered: !0,
    durationThreshold: 0
  }));
}, Ti = 10;
let F1 = 0;
const I8 = () => L1() - F1;
class Oa {
  constructor() {
    Oa.prototype.__init.call(this), Oa.prototype.__init2.call(this);
  }
  /**
   * A list of longest interactions on the page (by latency) sorted so the
   * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
   * long.
   */
  // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
  __init() {
    this._longestInteractionList = [];
  }
  /**
   * A mapping of longest interactions by their interaction ID.
   * This is used for faster lookup.
   */
  // eslint-disable-next-line @sentry-internal/sdk/no-class-field-initializers, @typescript-eslint/explicit-member-accessibility
  __init2() {
    this._longestInteractionMap = /* @__PURE__ */ new Map();
  }
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
  _resetInteractions() {
    F1 = L1(), this._longestInteractionList.length = 0, this._longestInteractionMap.clear();
  }
  /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  _estimateP98LongestInteraction() {
    const t = Math.min(
      this._longestInteractionList.length - 1,
      Math.floor(I8() / 50)
    );
    return this._longestInteractionList[t];
  }
  /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  _processEntry(t) {
    var a, u;
    if ((a = this._onBeforeProcessingEntry) == null || a.call(this, t), !(t.interactionId || t.entryType === "first-input")) return;
    const r = this._longestInteractionList.at(-1);
    let n = this._longestInteractionMap.get(t.interactionId);
    if (n || this._longestInteractionList.length < Ti || // If the above conditions are false, `minLongestInteraction` will be set.
    t.duration > r._latency) {
      if (n ? t.duration > n._latency ? (n.entries = [t], n._latency = t.duration) : t.duration === n._latency && t.startTime === n.entries[0].startTime && n.entries.push(t) : (n = {
        id: t.interactionId,
        entries: [t],
        _latency: t.duration
      }, this._longestInteractionMap.set(n.id, n), this._longestInteractionList.push(n)), this._longestInteractionList.sort((i, s) => s._latency - i._latency), this._longestInteractionList.length > Ti) {
        const i = this._longestInteractionList.splice(Ti);
        for (const s of i)
          this._longestInteractionMap.delete(s.id);
      }
      (u = this._onAfterProcessingINPCandidate) == null || u.call(this, n);
    }
  }
}
const $1 = (e) => {
  var r;
  const t = U.requestIdleCallback || U.setTimeout;
  ((r = U.document) == null ? void 0 : r.visibilityState) === "hidden" ? e() : (e = Ja(e), t(e), Qa(e));
}, P8 = [200, 500], B8 = 40, N8 = (e, t = {}) => {
  globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype && Bn(() => {
    O8();
    const r = Wr("INP");
    let n;
    const a = eo(t, Oa), u = (s) => {
      $1(() => {
        for (const c of s)
          a._processEntry(c);
        const o = a._estimateP98LongestInteraction();
        o && o._latency !== r.value && (r.value = o._latency, r.entries = o.entries, n());
      });
    }, i = lr("event", u, {
      // Event Timing entries have their durations rounded to the nearest 8ms,
      // so a duration of 40ms would be any event that spans 2.5 or more frames
      // at 60Hz. This threshold is chosen to strike a balance between usefulness
      // and performance. Running this callback for any interaction that spans
      // just one or two frames is likely not worth the insight that could be
      // gained.
      durationThreshold: t.durationThreshold ?? B8
    });
    n = Hr(e, r, P8, t.reportAllChanges), i && (i.observe({ type: "first-input", buffered: !0 }), Qa(() => {
      u(i.takeRecords()), n(!0);
    }));
  });
};
class D8 {
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
  _processEntry(t) {
    var r;
    (r = this._onBeforeProcessingEntry) == null || r.call(this, t);
  }
}
const R8 = [2500, 4e3], x8 = (e, t = {}) => {
  Bn(() => {
    const r = Ka(), n = Wr("LCP");
    let a;
    const u = eo(t, D8), i = (o) => {
      t.reportAllChanges || (o = o.slice(-1));
      for (const c of o)
        u._processEntry(c), c.startTime < r.firstHiddenTime && (n.value = Math.max(c.startTime - Gr(), 0), n.entries = [c], a());
    }, s = lr("largest-contentful-paint", i);
    if (s) {
      a = Hr(e, n, R8, t.reportAllChanges);
      const o = Ja(() => {
        i(s.takeRecords()), s.disconnect(), a(!0);
      });
      for (const c of ["keydown", "click", "visibilitychange"])
        U.document && addEventListener(c, () => $1(o), {
          capture: !0,
          once: !0
        });
    }
  });
}, j8 = [800, 1800], ms = (e) => {
  var t, r;
  (t = U.document) != null && t.prerendering ? Bn(() => ms(e)) : ((r = U.document) == null ? void 0 : r.readyState) !== "complete" ? addEventListener("load", () => ms(e), !0) : setTimeout(e);
}, M8 = (e, t = {}) => {
  const r = Wr("TTFB"), n = Hr(e, r, j8, t.reportAllChanges);
  ms(() => {
    const a = Pn();
    a && (r.value = Math.max(a.responseStart - Gr(), 0), r.entries = [a], n(!0));
  });
}, sn = {}, Ia = {};
let U1, H1, G1, W1, q1;
function z1(e, t = !1) {
  return Nn("cls", e, H8, U1, t);
}
function L8(e, t = !1) {
  return Nn("lcp", e, W8, G1, t);
}
function F8(e) {
  return Nn("fid", e, G8, H1);
}
function $8(e) {
  return Nn("ttfb", e, q8, W1);
}
function U8(e) {
  return Nn("inp", e, z8, q1);
}
function yn(e, t) {
  return V1(e, t), Ia[e] || (V8(e), Ia[e] = !0), Y1(e, t);
}
function qr(e, t) {
  const r = sn[e];
  if (r != null && r.length)
    for (const n of r)
      try {
        n(t);
      } catch (a) {
        Zs && B.error(
          `Error while triggering instrumentation handler.
Type: ${e}
Name: ${kt(n)}
Error:`,
          a
        );
      }
}
function H8() {
  return C8(
    (e) => {
      qr("cls", {
        metric: e
      }), U1 = e;
    },
    // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    { reportAllChanges: !0 }
  );
}
function G8() {
  return k8((e) => {
    qr("fid", {
      metric: e
    }), H1 = e;
  });
}
function W8() {
  return x8(
    (e) => {
      qr("lcp", {
        metric: e
      }), G1 = e;
    },
    // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    { reportAllChanges: !0 }
  );
}
function q8() {
  return M8((e) => {
    qr("ttfb", {
      metric: e
    }), W1 = e;
  });
}
function z8() {
  return N8((e) => {
    qr("inp", {
      metric: e
    }), q1 = e;
  });
}
function Nn(e, t, r, n, a = !1) {
  V1(e, t);
  let u;
  return Ia[e] || (u = r(), Ia[e] = !0), n && t({ metric: n }), Y1(e, t, a ? u : void 0);
}
function V8(e) {
  const t = {};
  e === "event" && (t.durationThreshold = 0), lr(
    e,
    (r) => {
      qr(e, { entries: r });
    },
    t
  );
}
function V1(e, t) {
  sn[e] = sn[e] || [], sn[e].push(t);
}
function Y1(e, t, r) {
  return () => {
    r && r();
    const n = sn[e];
    if (!n)
      return;
    const a = n.indexOf(t);
    a !== -1 && n.splice(a, 1);
  };
}
function Y8(e) {
  return "duration" in e;
}
function ki(e) {
  return typeof e == "number" && isFinite(e);
}
function It(e, t, r, { ...n }) {
  const a = Z(e).start_timestamp;
  return a && a > t && typeof e.updateStartTime == "function" && e.updateStartTime(t), l1(e, () => {
    const u = or({
      startTime: t,
      ...n
    });
    return u && u.end(r), u;
  });
}
function X1(e) {
  var E;
  const t = K();
  if (!t)
    return;
  const { name: r, transaction: n, attributes: a, startTime: u } = e, { release: i, environment: s, sendDefaultPii: o } = t.getOptions(), c = t.getIntegrationByName("Replay"), f = c == null ? void 0 : c.getReplayId(), g = re(), p = g.getUser(), h = p !== void 0 ? p.email || p.id || p.ip_address : void 0;
  let v;
  try {
    v = g.getScopeData().contexts.profile.profile_id;
  } catch {
  }
  const S = {
    release: i,
    environment: s,
    user: h || void 0,
    profile_id: v || void 0,
    replay_id: f || void 0,
    transaction: n,
    // Web vital score calculation relies on the user agent to account for different
    // browsers setting different thresholds for what is considered a good/meh/bad value.
    // For example: Chrome vs. Chrome Mobile
    "user_agent.original": (E = U.navigator) == null ? void 0 : E.userAgent,
    // This tells Sentry to infer the IP address from the request
    "client.address": o ? "{{auto}}" : void 0,
    ...a
  };
  return or({
    name: r,
    attributes: S,
    startTime: u,
    experimental: {
      standalone: !0
    }
  });
}
function to() {
  return U.addEventListener && U.performance;
}
function he(e) {
  return e / 1e3;
}
function J1(e) {
  let t = "unknown", r = "unknown", n = "";
  for (const a of e) {
    if (a === "/") {
      [t, r] = e.split("/");
      break;
    }
    if (!isNaN(Number(a))) {
      t = n === "h" ? "http" : n, r = e.split(n)[1];
      break;
    }
    n += a;
  }
  return n === e && (t = n), { name: t, version: r };
}
function X8() {
  let e = 0, t, r;
  if (!K8())
    return;
  let n = !1;
  function a() {
    n || (n = !0, r && J8(e, t, r), u());
  }
  const u = z1(({ metric: i }) => {
    const s = i.entries[i.entries.length - 1];
    s && (e = i.value, t = s);
  }, !0);
  Qa(() => {
    a();
  }), setTimeout(() => {
    const i = K();
    if (!i)
      return;
    const s = i.on("startNavigationSpan", () => {
      a(), s == null || s();
    }), o = Le();
    if (o) {
      const c = Pe(o);
      Z(c).op === "pageload" && (r = c.spanContext().spanId);
    }
  }, 0);
}
function J8(e, t, r) {
  var o;
  Zs && B.log(`Sending CLS span (${e})`);
  const n = he((tt() || 0) + ((t == null ? void 0 : t.startTime) || 0)), a = re().getScopeData().transactionName, u = t ? Lt((o = t.sources[0]) == null ? void 0 : o.node) : "Layout shift", i = {
    [de]: "auto.http.browser.cls",
    [ir]: "ui.webvital.cls",
    [An]: (t == null ? void 0 : t.duration) || 0,
    // attach the pageload span id to the CLS span so that we can link them in the UI
    "sentry.pageload.span_id": r
  };
  t != null && t.sources && t.sources.forEach((c, f) => {
    i[`cls.source.${f + 1}`] = Lt(c.node);
  });
  const s = X1({
    name: u,
    transaction: a,
    attributes: i,
    startTime: n
  });
  s && (s.addEvent("cls", {
    [Ya]: "",
    [Xa]: e
  }), s.end(n));
}
function K8() {
  try {
    return PerformanceObserver.supportedEntryTypes.includes("layout-shift");
  } catch {
    return !1;
  }
}
const Q8 = 2147483647;
let Df = 0, Oe = {}, Fe, Tr;
function Z8({ recordClsStandaloneSpans: e }) {
  const t = to();
  if (t && tt()) {
    t.mark && U.performance.mark("sentry-tracing-init");
    const r = ub(), n = ab(), a = ib(), u = e ? X8() : nb();
    return () => {
      r(), n(), a(), u == null || u();
    };
  }
  return () => {
  };
}
function eb() {
  yn("longtask", ({ entries: e }) => {
    const t = Le();
    if (!t)
      return;
    const { op: r, start_timestamp: n } = Z(t);
    for (const a of e) {
      const u = he(tt() + a.startTime), i = he(a.duration);
      r === "navigation" && n && u < n || It(t, u, u + i, {
        name: "Main UI thread blocked",
        op: "ui.long-task",
        attributes: {
          [de]: "auto.ui.browser.metrics"
        }
      });
    }
  });
}
function tb() {
  new PerformanceObserver((t) => {
    const r = Le();
    if (r)
      for (const n of t.getEntries()) {
        if (!n.scripts[0])
          continue;
        const a = he(tt() + n.startTime), { start_timestamp: u, op: i } = Z(r);
        if (i === "navigation" && u && a < u)
          continue;
        const s = he(n.duration), o = {
          [de]: "auto.ui.browser.metrics"
        }, c = n.scripts[0], { invoker: f, invokerType: g, sourceURL: p, sourceFunctionName: h, sourceCharPosition: v } = c;
        o["browser.script.invoker"] = f, o["browser.script.invoker_type"] = g, p && (o["code.filepath"] = p), h && (o["code.function"] = h), v !== -1 && (o["browser.script.source_char_position"] = v), It(r, a, a + s, {
          name: "Main UI thread blocked",
          op: "ui.long-animation-frame",
          attributes: o
        });
      }
  }).observe({ type: "long-animation-frame", buffered: !0 });
}
function rb() {
  yn("event", ({ entries: e }) => {
    const t = Le();
    if (t) {
      for (const r of e)
        if (r.name === "click") {
          const n = he(tt() + r.startTime), a = he(r.duration), u = {
            name: Lt(r.target),
            op: `ui.interaction.${r.name}`,
            startTime: n,
            attributes: {
              [de]: "auto.ui.browser.metrics"
            }
          }, i = Hl(r.target);
          i && (u.attributes["ui.component_name"] = i), It(t, n, n + a, u);
        }
    }
  });
}
function nb() {
  return z1(({ metric: e }) => {
    const t = e.entries[e.entries.length - 1];
    t && (Oe.cls = { value: e.value, unit: "" }, Tr = t);
  }, !0);
}
function ab() {
  return L8(({ metric: e }) => {
    const t = e.entries[e.entries.length - 1];
    t && (Oe.lcp = { value: e.value, unit: "millisecond" }, Fe = t);
  }, !0);
}
function ub() {
  return F8(({ metric: e }) => {
    const t = e.entries[e.entries.length - 1];
    if (!t)
      return;
    const r = he(tt()), n = he(t.startTime);
    Oe.fid = { value: e.value, unit: "millisecond" }, Oe["mark.fid"] = { value: r + n, unit: "second" };
  });
}
function ib() {
  return $8(({ metric: e }) => {
    e.entries[e.entries.length - 1] && (Oe.ttfb = { value: e.value, unit: "millisecond" });
  });
}
function sb(e, t) {
  const r = to(), n = tt();
  if (!(r != null && r.getEntries) || !n)
    return;
  const a = he(n), u = r.getEntries(), { op: i, start_timestamp: s } = Z(e);
  if (u.slice(Df).forEach((o) => {
    const c = he(o.startTime), f = he(
      // Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
      // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
      // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
      // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
      Math.max(0, o.duration)
    );
    if (!(i === "navigation" && s && a + c < s))
      switch (o.entryType) {
        case "navigation": {
          db(e, o, a);
          break;
        }
        case "mark":
        case "paint":
        case "measure": {
          ob(e, o, c, f, a, t.ignorePerformanceApiSpans);
          const g = Ka(), p = o.startTime < g.firstHiddenTime;
          o.name === "first-paint" && p && (Oe.fp = { value: o.startTime, unit: "millisecond" }), o.name === "first-contentful-paint" && p && (Oe.fcp = { value: o.startTime, unit: "millisecond" });
          break;
        }
        case "resource": {
          pb(
            e,
            o,
            o.name,
            c,
            f,
            a,
            t.ignoreResourceSpans
          );
          break;
        }
      }
  }), Df = Math.max(u.length - 1, 0), hb(e), i === "pageload") {
    gb(Oe);
    const o = Oe["mark.fid"];
    o && Oe.fid && (It(e, o.value, o.value + he(Oe.fid.value), {
      name: "first input delay",
      op: "ui.action",
      attributes: {
        [de]: "auto.ui.browser.metrics"
      }
    }), delete Oe["mark.fid"]), (!("fcp" in Oe) || !t.recordClsOnPageloadSpan) && delete Oe.cls, Object.entries(Oe).forEach(([c, f]) => {
      rv(c, f.value, f.unit);
    }), e.setAttribute("performance.timeOrigin", a), e.setAttribute("performance.activationStart", Gr()), mb(e);
  }
  Fe = void 0, Tr = void 0, Oe = {};
}
function ob(e, t, r, n, a, u) {
  if (["mark", "measure"].includes(t.entryType) && Mt(t.name, u))
    return;
  const i = Pn(!1), s = he(i ? i.requestStart : 0), o = a + Math.max(r, s), c = a + r, f = c + n, g = {
    [de]: "auto.resource.browser.metrics"
  };
  o !== c && (g["sentry.browser.measure_happened_before_request"] = !0, g["sentry.browser.measure_start_time"] = o), cb(g, t), o <= f && It(e, o, f, {
    name: t.name,
    op: t.entryType,
    attributes: g
  });
}
function cb(e, t) {
  try {
    const r = t.detail;
    if (!r)
      return;
    if (typeof r == "object") {
      for (const [n, a] of Object.entries(r))
        if (a && ln(a))
          e[`sentry.browser.measure.detail.${n}`] = a;
        else if (a !== void 0)
          try {
            e[`sentry.browser.measure.detail.${n}`] = JSON.stringify(a);
          } catch {
          }
      return;
    }
    if (ln(r)) {
      e["sentry.browser.measure.detail"] = r;
      return;
    }
    try {
      e["sentry.browser.measure.detail"] = JSON.stringify(r);
    } catch {
    }
  } catch {
  }
}
function db(e, t, r) {
  ["unloadEvent", "redirect", "domContentLoadedEvent", "loadEvent", "connect"].forEach((n) => {
    qn(e, t, n, r);
  }), qn(e, t, "secureConnection", r, "TLS/SSL"), qn(e, t, "fetch", r, "cache"), qn(e, t, "domainLookup", r, "DNS"), lb(e, t, r);
}
function qn(e, t, r, n, a = r) {
  const u = fb(r), i = t[u], s = t[`${r}Start`];
  !s || !i || It(e, n + he(s), n + he(i), {
    op: `browser.${a}`,
    name: t.name,
    attributes: {
      [de]: "auto.ui.browser.metrics",
      ...r === "redirect" && t.redirectCount != null ? { "http.redirect_count": t.redirectCount } : {}
    }
  });
}
function fb(e) {
  return e === "secureConnection" ? "connectEnd" : e === "fetch" ? "domainLookupStart" : `${e}End`;
}
function lb(e, t, r) {
  const n = r + he(t.requestStart), a = r + he(t.responseEnd), u = r + he(t.responseStart);
  t.responseEnd && (It(e, n, a, {
    op: "browser.request",
    name: t.name,
    attributes: {
      [de]: "auto.ui.browser.metrics"
    }
  }), It(e, u, a, {
    op: "browser.response",
    name: t.name,
    attributes: {
      [de]: "auto.ui.browser.metrics"
    }
  }));
}
function pb(e, t, r, n, a, u, i) {
  if (t.initiatorType === "xmlhttprequest" || t.initiatorType === "fetch")
    return;
  const s = t.initiatorType ? `resource.${t.initiatorType}` : "resource.other";
  if (i != null && i.includes(s))
    return;
  const o = rr(r), c = {
    [de]: "auto.resource.browser.metrics"
  };
  Ai(c, t, "transferSize", "http.response_transfer_size"), Ai(c, t, "encodedBodySize", "http.response_content_length"), Ai(c, t, "decodedBodySize", "http.decoded_response_content_length");
  const f = t.deliveryType;
  f != null && (c["http.response_delivery_type"] = f);
  const g = t.renderBlockingStatus;
  g && (c["resource.render_blocking_status"] = g), o.protocol && (c["url.scheme"] = o.protocol.split(":").pop()), o.host && (c["server.address"] = o.host), c["url.same_origin"] = r.includes(U.location.origin);
  const { name: p, version: h } = J1(t.nextHopProtocol);
  c["network.protocol.name"] = p, c["network.protocol.version"] = h;
  const v = u + n, S = v + a;
  It(e, v, S, {
    name: r.replace(U.location.origin, ""),
    op: s,
    attributes: c
  });
}
function hb(e) {
  const t = U.navigator;
  if (!t)
    return;
  const r = t.connection;
  r && (r.effectiveType && e.setAttribute("effectiveConnectionType", r.effectiveType), r.type && e.setAttribute("connectionType", r.type), ki(r.rtt) && (Oe["connection.rtt"] = { value: r.rtt, unit: "millisecond" })), ki(t.deviceMemory) && e.setAttribute("deviceMemory", `${t.deviceMemory} GB`), ki(t.hardwareConcurrency) && e.setAttribute("hardwareConcurrency", String(t.hardwareConcurrency));
}
function mb(e) {
  Fe && (Fe.element && e.setAttribute("lcp.element", Lt(Fe.element)), Fe.id && e.setAttribute("lcp.id", Fe.id), Fe.url && e.setAttribute("lcp.url", Fe.url.trim().slice(0, 200)), Fe.loadTime != null && e.setAttribute("lcp.loadTime", Fe.loadTime), Fe.renderTime != null && e.setAttribute("lcp.renderTime", Fe.renderTime), e.setAttribute("lcp.size", Fe.size)), Tr != null && Tr.sources && Tr.sources.forEach(
    (t, r) => e.setAttribute(`cls.source.${r + 1}`, Lt(t.node))
  );
}
function Ai(e, t, r, n) {
  const a = t[r];
  a != null && a < Q8 && (e[n] = a);
}
function gb(e) {
  const t = Pn(!1);
  if (!t)
    return;
  const { responseStart: r, requestStart: n } = t;
  n <= r && (e["ttfb.requestTime"] = {
    value: r - n,
    unit: "millisecond"
  });
}
const yb = 1e3;
let Rf, gs, ys;
function vb(e) {
  const t = "dom";
  qt(t, e), zt(t, bb);
}
function bb() {
  if (!U.document)
    return;
  const e = Ke.bind(null, "dom"), t = xf(e, !0);
  U.document.addEventListener("click", t, !1), U.document.addEventListener("keypress", t, !1), ["EventTarget", "Node"].forEach((r) => {
    var u, i;
    const a = (u = U[r]) == null ? void 0 : u.prototype;
    (i = a == null ? void 0 : a.hasOwnProperty) != null && i.call(a, "addEventListener") && (Ve(a, "addEventListener", function(s) {
      return function(o, c, f) {
        if (o === "click" || o == "keypress")
          try {
            const g = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {}, p = g[o] = g[o] || { refCount: 0 };
            if (!p.handler) {
              const h = xf(e);
              p.handler = h, s.call(this, o, h, f);
            }
            p.refCount++;
          } catch {
          }
        return s.call(this, o, c, f);
      };
    }), Ve(
      a,
      "removeEventListener",
      function(s) {
        return function(o, c, f) {
          if (o === "click" || o == "keypress")
            try {
              const g = this.__sentry_instrumentation_handlers__ || {}, p = g[o];
              p && (p.refCount--, p.refCount <= 0 && (s.call(this, o, p.handler, f), p.handler = void 0, delete g[o]), Object.keys(g).length === 0 && delete this.__sentry_instrumentation_handlers__);
            } catch {
            }
          return s.call(this, o, c, f);
        };
      }
    ));
  });
}
function _b(e) {
  if (e.type !== gs)
    return !1;
  try {
    if (!e.target || e.target._sentryId !== ys)
      return !1;
  } catch {
  }
  return !0;
}
function Sb(e, t) {
  return e !== "keypress" ? !1 : t != null && t.tagName ? !(t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable) : !0;
}
function xf(e, t = !1) {
  return (r) => {
    if (!r || r._sentryCaptured)
      return;
    const n = wb(r);
    if (Sb(r.type, n))
      return;
    Ye(r, "_sentryCaptured", !0), n && !n._sentryId && Ye(n, "_sentryId", Qe());
    const a = r.type === "keypress" ? "input" : r.type;
    _b(r) || (e({ event: r, name: a, global: t }), gs = r.type, ys = n ? n._sentryId : void 0), clearTimeout(Rf), Rf = U.setTimeout(() => {
      ys = void 0, gs = void 0;
    }, yb);
  };
}
function wb(e) {
  try {
    return e.target;
  } catch {
    return null;
  }
}
let zn;
function ro(e) {
  const t = "history";
  qt(t, e), zt(t, Eb);
}
function Eb() {
  if (U.addEventListener("popstate", () => {
    const t = U.location.href, r = zn;
    if (zn = t, r === t)
      return;
    Ke("history", { from: r, to: t });
  }), !z4())
    return;
  function e(t) {
    return function(...r) {
      const n = r.length > 2 ? r[2] : void 0;
      if (n) {
        const a = zn, u = Cb(String(n));
        if (zn = u, a === u)
          return t.apply(this, r);
        Ke("history", { from: a, to: u });
      }
      return t.apply(this, r);
    };
  }
  Ve(U.history, "pushState", e), Ve(U.history, "replaceState", e);
}
function Cb(e) {
  try {
    return new URL(e, U.location.origin).toString();
  } catch {
    return e;
  }
}
const fa = {};
function Tb(e) {
  const t = fa[e];
  if (t)
    return t;
  let r = U[e];
  if (cs(r))
    return fa[e] = r.bind(U);
  const n = U.document;
  if (n && typeof n.createElement == "function")
    try {
      const a = n.createElement("iframe");
      a.hidden = !0, n.head.appendChild(a);
      const u = a.contentWindow;
      u != null && u[e] && (r = u[e]), n.head.removeChild(a);
    } catch (a) {
      Zs && B.warn(`Could not create sandbox iframe for ${e} check, bailing to window.${e}: `, a);
    }
  return r && (fa[e] = r.bind(U));
}
function jf(e) {
  fa[e] = void 0;
}
const kr = "__sentry_xhr_v3__";
function K1(e) {
  const t = "xhr";
  qt(t, e), zt(t, kb);
}
function kb() {
  if (!U.XMLHttpRequest)
    return;
  const e = XMLHttpRequest.prototype;
  e.open = new Proxy(e.open, {
    apply(t, r, n) {
      const a = new Error(), u = Te() * 1e3, i = Tt(n[0]) ? n[0].toUpperCase() : void 0, s = Ab(n[1]);
      if (!i || !s)
        return t.apply(r, n);
      r[kr] = {
        method: i,
        url: s,
        request_headers: {}
      }, i === "POST" && s.match(/sentry_key/) && (r.__sentry_own_request__ = !0);
      const o = () => {
        const c = r[kr];
        if (c && r.readyState === 4) {
          try {
            c.status_code = r.status;
          } catch {
          }
          const f = {
            endTimestamp: Te() * 1e3,
            startTimestamp: u,
            xhr: r,
            virtualError: a
          };
          Ke("xhr", f);
        }
      };
      return "onreadystatechange" in r && typeof r.onreadystatechange == "function" ? r.onreadystatechange = new Proxy(r.onreadystatechange, {
        apply(c, f, g) {
          return o(), c.apply(f, g);
        }
      }) : r.addEventListener("readystatechange", o), r.setRequestHeader = new Proxy(r.setRequestHeader, {
        apply(c, f, g) {
          const [p, h] = g, v = f[kr];
          return v && Tt(p) && Tt(h) && (v.request_headers[p.toLowerCase()] = h), c.apply(f, g);
        }
      }), t.apply(r, n);
    }
  }), e.send = new Proxy(e.send, {
    apply(t, r, n) {
      const a = r[kr];
      if (!a)
        return t.apply(r, n);
      n[0] !== void 0 && (a.body = n[0]);
      const u = {
        startTimestamp: Te() * 1e3,
        xhr: r
      };
      return Ke("xhr", u), t.apply(r, n);
    }
  });
}
function Ab(e) {
  if (Tt(e))
    return e;
  try {
    return e.toString();
  } catch {
  }
}
const Oi = [], la = /* @__PURE__ */ new Map(), Ob = 60;
function Ib() {
  if (to() && tt()) {
    const t = Pb();
    return () => {
      t();
    };
  }
  return () => {
  };
}
const Mf = {
  click: "click",
  pointerdown: "click",
  pointerup: "click",
  mousedown: "click",
  mouseup: "click",
  touchstart: "click",
  touchend: "click",
  mouseover: "hover",
  mouseout: "hover",
  mouseenter: "hover",
  mouseleave: "hover",
  pointerover: "hover",
  pointerout: "hover",
  pointerenter: "hover",
  pointerleave: "hover",
  dragstart: "drag",
  dragend: "drag",
  drag: "drag",
  dragenter: "drag",
  dragleave: "drag",
  dragover: "drag",
  drop: "drag",
  keydown: "press",
  keyup: "press",
  keypress: "press",
  input: "press"
};
function Pb() {
  return U8(Bb);
}
const Bb = ({ metric: e }) => {
  if (e.value == null)
    return;
  const t = he(e.value);
  if (t > Ob)
    return;
  const r = e.entries.find((v) => v.duration === e.value && Mf[v.name]);
  if (!r)
    return;
  const { interactionId: n } = r, a = Mf[r.name], u = he(tt() + r.startTime), i = Le(), s = i ? Pe(i) : void 0, c = (n != null ? la.get(n) : void 0) || s, f = c ? Z(c).description : re().getScopeData().transactionName, g = Lt(r.target), p = {
    [de]: "auto.http.browser.inp",
    [ir]: `ui.interaction.${a}`,
    [An]: r.duration
  }, h = X1({
    name: g,
    transaction: f,
    attributes: p,
    startTime: u
  });
  h && (h.addEvent("inp", {
    [Ya]: "millisecond",
    [Xa]: e.value
  }), h.end(u + t));
};
function Nb() {
  const e = ({ entries: t }) => {
    const r = Le(), n = r && Pe(r);
    t.forEach((a) => {
      if (!Y8(a) || !n)
        return;
      const u = a.interactionId;
      if (u != null && !la.has(u)) {
        if (Oi.length > 10) {
          const i = Oi.shift();
          la.delete(i);
        }
        Oi.push(u), la.set(u, n);
      }
    });
  };
  yn("event", e), yn("first-input", e);
}
function Db(e, t = Tb("fetch")) {
  let r = 0, n = 0;
  function a(u) {
    const i = u.body.length;
    r += i, n++;
    const s = {
      body: u.body,
      method: "POST",
      referrerPolicy: "strict-origin",
      headers: e.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: r <= 6e4 && n < 15,
      ...e.fetchOptions
    };
    if (!t)
      return jf("fetch"), Ca("No fetch implementation available");
    try {
      return t(e.url, s).then((o) => (r -= i, n--, {
        statusCode: o.status,
        headers: {
          "x-sentry-rate-limits": o.headers.get("X-Sentry-Rate-Limits"),
          "retry-after": o.headers.get("Retry-After")
        }
      }));
    } catch (o) {
      return jf("fetch"), r -= i, n--, Ca(o);
    }
  }
  return i4(e, a);
}
const Rb = 30, xb = 50;
function vs(e, t, r, n) {
  const a = {
    filename: e,
    function: t === "<anonymous>" ? ar : t,
    in_app: !0
    // All browser frames are considered in_app
  };
  return r !== void 0 && (a.lineno = r), n !== void 0 && (a.colno = n), a;
}
const jb = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, Mb = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, Lb = /\((\S*)(?::(\d+))(?::(\d+))\)/, Fb = (e) => {
  const t = jb.exec(e);
  if (t) {
    const [, n, a, u] = t;
    return vs(n, ar, +a, +u);
  }
  const r = Mb.exec(e);
  if (r) {
    if (r[2] && r[2].indexOf("eval") === 0) {
      const i = Lb.exec(r[2]);
      i && (r[2] = i[1], r[3] = i[2], r[4] = i[3]);
    }
    const [a, u] = Q1(r[1] || ar, r[2]);
    return vs(u, a, r[3] ? +r[3] : void 0, r[4] ? +r[4] : void 0);
  }
}, $b = [Rb, Fb], Ub = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, Hb = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, Gb = (e) => {
  const t = Ub.exec(e);
  if (t) {
    if (t[3] && t[3].indexOf(" > eval") > -1) {
      const u = Hb.exec(t[3]);
      u && (t[1] = t[1] || "eval", t[3] = u[1], t[4] = u[2], t[5] = "");
    }
    let n = t[3], a = t[1] || ar;
    return [a, n] = Q1(a, n), vs(n, a, t[4] ? +t[4] : void 0, t[5] ? +t[5] : void 0);
  }
}, Wb = [xb, Gb], qb = [$b, Wb], zb = xl(...qb), Q1 = (e, t) => {
  const r = e.indexOf("safari-extension") !== -1, n = e.indexOf("safari-web-extension") !== -1;
  return r || n ? [
    e.indexOf("@") !== -1 ? e.split("@")[0] : ar,
    r ? `safari-extension:${t}` : `safari-web-extension:${t}`
  ] : [e, t];
}, ut = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, Vn = 1024, Vb = "Breadcrumbs", Yb = (e = {}) => {
  const t = {
    console: !0,
    dom: !0,
    fetch: !0,
    history: !0,
    sentry: !0,
    xhr: !0,
    ...e
  };
  return {
    name: Vb,
    setup(r) {
      t.console && k1(Qb(r)), t.dom && vb(Kb(r, t.dom)), t.xhr && K1(Zb(r)), t.fetch && D1(e5(r)), t.history && ro(t5(r)), t.sentry && r.on("beforeSendEvent", Jb(r));
    }
  };
}, Xb = Yb;
function Jb(e) {
  return function(r) {
    K() === e && Ht(
      {
        category: `sentry.${r.type === "transaction" ? "transaction" : "event"}`,
        event_id: r.event_id,
        level: r.level,
        message: Jt(r)
      },
      {
        event: r
      }
    );
  };
}
function Kb(e, t) {
  return function(n) {
    if (K() !== e)
      return;
    let a, u, i = typeof t == "object" ? t.serializeAttribute : void 0, s = typeof t == "object" && typeof t.maxStringLength == "number" ? t.maxStringLength : void 0;
    s && s > Vn && (ut && B.warn(
      `\`dom.maxStringLength\` cannot exceed ${Vn}, but a value of ${s} was configured. Sentry will use ${Vn} instead.`
    ), s = Vn), typeof i == "string" && (i = [i]);
    try {
      const c = n.event, f = r5(c) ? c.target : c;
      a = Lt(f, { keyAttrs: i, maxStringLength: s }), u = Hl(f);
    } catch {
      a = "<unknown>";
    }
    if (a.length === 0)
      return;
    const o = {
      category: `ui.${n.name}`,
      message: a
    };
    u && (o.data = { "ui.component_name": u }), Ht(o, {
      event: n.event,
      name: n.name,
      global: n.global
    });
  };
}
function Qb(e) {
  return function(r) {
    if (K() !== e)
      return;
    const n = {
      category: "console",
      data: {
        arguments: r.args,
        logger: "console"
      },
      level: A1(r.level),
      message: _a(r.args, " ")
    };
    if (r.level === "assert")
      if (r.args[0] === !1)
        n.message = `Assertion failed: ${_a(r.args.slice(1), " ") || "console.assert"}`, n.data.arguments = r.args.slice(1);
      else
        return;
    Ht(n, {
      input: r.args,
      level: r.level
    });
  };
}
function Zb(e) {
  return function(r) {
    if (K() !== e)
      return;
    const { startTimestamp: n, endTimestamp: a } = r, u = r.xhr[kr];
    if (!n || !a || !u)
      return;
    const { method: i, url: s, status_code: o, body: c } = u, f = {
      method: i,
      url: s,
      status_code: o
    }, g = {
      xhr: r.xhr,
      input: c,
      startTimestamp: n,
      endTimestamp: a
    }, p = {
      category: "xhr",
      data: f,
      type: "http",
      level: N1(o)
    };
    e.emit("beforeOutgoingRequestBreadcrumb", p, g), Ht(p, g);
  };
}
function e5(e) {
  return function(r) {
    if (K() !== e)
      return;
    const { startTimestamp: n, endTimestamp: a } = r;
    if (a && !(r.fetchData.url.match(/sentry_key/) && r.fetchData.method === "POST"))
      if (r.fetchData.method, r.fetchData.url, r.error) {
        const u = r.fetchData, i = {
          data: r.error,
          input: r.args,
          startTimestamp: n,
          endTimestamp: a
        }, s = {
          category: "fetch",
          data: u,
          level: "error",
          type: "http"
        };
        e.emit("beforeOutgoingRequestBreadcrumb", s, i), Ht(s, i);
      } else {
        const u = r.response, i = {
          ...r.fetchData,
          status_code: u == null ? void 0 : u.status
        };
        r.fetchData.request_body_size, r.fetchData.response_body_size, u == null || u.status;
        const s = {
          input: r.args,
          response: u,
          startTimestamp: n,
          endTimestamp: a
        }, o = {
          category: "fetch",
          data: i,
          type: "http",
          level: N1(i.status_code)
        };
        e.emit("beforeOutgoingRequestBreadcrumb", o, s), Ht(o, s);
      }
  };
}
function t5(e) {
  return function(r) {
    if (K() !== e)
      return;
    let n = r.from, a = r.to;
    const u = rr(X.location.href);
    let i = n ? rr(n) : void 0;
    const s = rr(a);
    i != null && i.path || (i = u), u.protocol === s.protocol && u.host === s.host && (a = s.relative), u.protocol === i.protocol && u.host === i.host && (n = i.relative), Ht({
      category: "navigation",
      data: {
        from: n,
        to: a
      }
    });
  };
}
function r5(e) {
  return !!e && !!e.target;
}
const n5 = [
  "EventTarget",
  "Window",
  "Node",
  "ApplicationCache",
  "AudioTrackList",
  "BroadcastChannel",
  "ChannelMergerNode",
  "CryptoOperation",
  "EventSource",
  "FileReader",
  "HTMLUnknownElement",
  "IDBDatabase",
  "IDBRequest",
  "IDBTransaction",
  "KeyOperation",
  "MediaController",
  "MessagePort",
  "ModalWindow",
  "Notification",
  "SVGElementInstance",
  "Screen",
  "SharedWorker",
  "TextTrack",
  "TextTrackCue",
  "TextTrackList",
  "WebSocket",
  "WebSocketWorker",
  "Worker",
  "XMLHttpRequest",
  "XMLHttpRequestEventTarget",
  "XMLHttpRequestUpload"
], a5 = "BrowserApiErrors", u5 = (e = {}) => {
  const t = {
    XMLHttpRequest: !0,
    eventTarget: !0,
    requestAnimationFrame: !0,
    setInterval: !0,
    setTimeout: !0,
    unregisterOriginalCallbacks: !1,
    ...e
  };
  return {
    name: a5,
    // TODO: This currently only works for the first client this is setup
    // We may want to adjust this to check for client etc.
    setupOnce() {
      t.setTimeout && Ve(X, "setTimeout", Lf), t.setInterval && Ve(X, "setInterval", Lf), t.requestAnimationFrame && Ve(X, "requestAnimationFrame", s5), t.XMLHttpRequest && "XMLHttpRequest" in X && Ve(XMLHttpRequest.prototype, "send", o5);
      const r = t.eventTarget;
      r && (Array.isArray(r) ? r : n5).forEach((a) => c5(a, t));
    }
  };
}, i5 = u5;
function Lf(e) {
  return function(...t) {
    const r = t[0];
    return t[0] = xr(r, {
      mechanism: {
        data: { function: kt(e) },
        handled: !1,
        type: "instrument"
      }
    }), e.apply(this, t);
  };
}
function s5(e) {
  return function(t) {
    return e.apply(this, [
      xr(t, {
        mechanism: {
          data: {
            function: "requestAnimationFrame",
            handler: kt(e)
          },
          handled: !1,
          type: "instrument"
        }
      })
    ]);
  };
}
function o5(e) {
  return function(...t) {
    const r = this;
    return ["onload", "onerror", "onprogress", "onreadystatechange"].forEach((a) => {
      a in r && typeof r[a] == "function" && Ve(r, a, function(u) {
        const i = {
          mechanism: {
            data: {
              function: a,
              handler: kt(u)
            },
            handled: !1,
            type: "instrument"
          }
        }, s = Gs(u);
        return s && (i.mechanism.data.handler = kt(s)), xr(u, i);
      });
    }), e.apply(this, t);
  };
}
function c5(e, t) {
  var a, u;
  const n = (a = X[e]) == null ? void 0 : a.prototype;
  (u = n == null ? void 0 : n.hasOwnProperty) != null && u.call(n, "addEventListener") && (Ve(n, "addEventListener", function(i) {
    return function(s, o, c) {
      try {
        d5(o) && (o.handleEvent = xr(o.handleEvent, {
          mechanism: {
            data: {
              function: "handleEvent",
              handler: kt(o),
              target: e
            },
            handled: !1,
            type: "instrument"
          }
        }));
      } catch {
      }
      return t.unregisterOriginalCallbacks && f5(this, s, o), i.apply(this, [
        s,
        xr(o, {
          mechanism: {
            data: {
              function: "addEventListener",
              handler: kt(o),
              target: e
            },
            handled: !1,
            type: "instrument"
          }
        }),
        c
      ]);
    };
  }), Ve(n, "removeEventListener", function(i) {
    return function(s, o, c) {
      try {
        const f = o.__sentry_wrapped__;
        f && i.call(this, s, f, c);
      } catch {
      }
      return i.call(this, s, o, c);
    };
  }));
}
function d5(e) {
  return typeof e.handleEvent == "function";
}
function f5(e, t, r) {
  e && typeof e == "object" && "removeEventListener" in e && typeof e.removeEventListener == "function" && e.removeEventListener(t, r);
}
const l5 = () => ({
  name: "BrowserSession",
  setupOnce() {
    if (typeof X.document > "u") {
      ut && B.warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
      return;
    }
    vf({ ignoreDuration: !0 }), bf(), ro(({ from: e, to: t }) => {
      e !== void 0 && e !== t && (vf({ ignoreDuration: !0 }), bf());
    });
  }
}), p5 = "GlobalHandlers", h5 = (e = {}) => {
  const t = {
    onerror: !0,
    onunhandledrejection: !0,
    ...e
  };
  return {
    name: p5,
    setupOnce() {
      Error.stackTraceLimit = 50;
    },
    setup(r) {
      t.onerror && (g5(r), Ff("onerror")), t.onunhandledrejection && (y5(r), Ff("onunhandledrejection"));
    }
  };
}, m5 = h5;
function g5(e) {
  jl((t) => {
    const { stackParser: r, attachStacktrace: n } = Z1();
    if (K() !== e || x1())
      return;
    const { msg: a, url: u, line: i, column: s, error: o } = t, c = _5(
      Qs(r, o || a, void 0, n, !1),
      u,
      i,
      s
    );
    c.level = "error", m1(c, {
      originalException: o,
      mechanism: {
        handled: !1,
        type: "onerror"
      }
    });
  });
}
function y5(e) {
  Ml((t) => {
    const { stackParser: r, attachStacktrace: n } = Z1();
    if (K() !== e || x1())
      return;
    const a = v5(t), u = ln(a) ? b5(a) : Qs(r, a, void 0, n, !0);
    u.level = "error", m1(u, {
      originalException: a,
      mechanism: {
        handled: !1,
        type: "onunhandledrejection"
      }
    });
  });
}
function v5(e) {
  if (ln(e))
    return e;
  try {
    if ("reason" in e)
      return e.reason;
    if ("detail" in e && "reason" in e.detail)
      return e.detail.reason;
  } catch {
  }
  return e;
}
function b5(e) {
  return {
    exception: {
      values: [
        {
          type: "UnhandledRejection",
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(e)}`
        }
      ]
    }
  };
}
function _5(e, t, r, n) {
  const a = e.exception = e.exception || {}, u = a.values = a.values || [], i = u[0] = u[0] || {}, s = i.stacktrace = i.stacktrace || {}, o = s.frames = s.frames || [], c = n, f = r, g = Tt(t) && t.length > 0 ? t : wn();
  return o.length === 0 && o.push({
    colno: c,
    filename: g,
    function: ar,
    in_app: !0,
    lineno: f
  }), e;
}
function Ff(e) {
  ut && B.log(`Global Handler attached: ${e}`);
}
function Z1() {
  const e = K();
  return (e == null ? void 0 : e.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: !1
  };
}
const S5 = () => ({
  name: "HttpContext",
  preprocessEvent(e) {
    var n;
    if (!X.navigator && !X.location && !X.document)
      return;
    const t = ls(), r = {
      ...t.headers,
      ...(n = e.request) == null ? void 0 : n.headers
    };
    e.request = {
      ...t,
      ...e.request,
      headers: r
    };
  }
}), w5 = "cause", E5 = 5, C5 = "LinkedErrors", T5 = (e = {}) => {
  const t = e.limit || E5, r = e.key || w5;
  return {
    name: C5,
    preprocessEvent(n, a, u) {
      const i = u.getOptions();
      T4(
        // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
        Js,
        i.stackParser,
        r,
        t,
        n,
        a
      );
    }
  };
}, k5 = T5;
function A5() {
  return O5() ? (ut && Wt(() => {
    console.error(
      "[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/"
    );
  }), !0) : !1;
}
function O5() {
  var u;
  if (typeof X.window > "u")
    return !1;
  const e = X;
  if (e.nw)
    return !1;
  const t = e.chrome || e.browser;
  if (!((u = t == null ? void 0 : t.runtime) != null && u.id))
    return !1;
  const r = wn(), n = ["chrome-extension", "moz-extension", "ms-browser-extension", "safari-web-extension"];
  return !(X === X.top && n.some((i) => r.startsWith(`${i}://`)));
}
function ep(e) {
  return [
    // TODO(v10): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
    // eslint-disable-next-line deprecation/deprecation
    y4(),
    p4(),
    i5(),
    Xb(),
    m5(),
    k5(),
    D4(),
    S5(),
    l5()
  ];
}
function I5(e = {}) {
  const t = !e.skipBrowserExtensionCheck && A5(), r = {
    ...e,
    enabled: t ? !1 : e.enabled,
    stackParser: M3(e.stackParser || zb),
    integrations: $v({
      integrations: e.integrations,
      defaultIntegrations: e.defaultIntegrations == null ? ep() : e.defaultIntegrations
    }),
    transport: e.transport || Db
  };
  return Kv(h8, r);
}
const $f = /* @__PURE__ */ new WeakMap(), Ii = /* @__PURE__ */ new Map(), tp = {
  traceFetch: !0,
  traceXHR: !0,
  enableHTTPTimings: !0,
  trackFetchStreamPerformance: !1
};
function P5(e, t) {
  const {
    traceFetch: r,
    traceXHR: n,
    trackFetchStreamPerformance: a,
    shouldCreateSpanForRequest: u,
    enableHTTPTimings: i,
    tracePropagationTargets: s,
    onRequestSpanStart: o
  } = {
    ...tp,
    ...t
  }, c = typeof u == "function" ? u : (p) => !0, f = (p) => D5(p, s), g = {};
  r && (e.addEventProcessor((p) => (p.type === "transaction" && p.spans && p.spans.forEach((h) => {
    if (h.op === "http.client") {
      const v = Ii.get(h.span_id);
      v && (h.timestamp = v / 1e3, Ii.delete(h.span_id));
    }
  }), p)), a && X4((p) => {
    if (p.response) {
      const h = $f.get(p.response);
      h && p.endTimestamp && Ii.set(h, p.endTimestamp);
    }
  }), D1((p) => {
    const h = $4(p, c, f, g);
    if (p.response && p.fetchData.__span && $f.set(p.response, p.fetchData.__span), h) {
      const v = rp(p.fetchData.url), S = v ? rr(v).host : void 0;
      h.setAttributes({
        "http.url": v,
        "server.address": S
      }), i && Uf(h), o == null || o(h, { headers: p.headers });
    }
  })), n && K1((p) => {
    var v;
    const h = R5(p, c, f, g);
    if (h) {
      i && Uf(h);
      let S;
      try {
        S = new Headers((v = p.xhr.__sentry_xhr_v3__) == null ? void 0 : v.request_headers);
      } catch {
      }
      o == null || o(h, { headers: S });
    }
  });
}
function B5(e) {
  return e.entryType === "resource" && "initiatorType" in e && typeof e.nextHopProtocol == "string" && (e.initiatorType === "fetch" || e.initiatorType === "xmlhttprequest");
}
function Uf(e) {
  const { url: t } = Z(e).data;
  if (!t || typeof t != "string")
    return;
  const r = yn("resource", ({ entries: n }) => {
    n.forEach((a) => {
      B5(a) && a.name.endsWith(t) && (N5(a).forEach((i) => e.setAttribute(...i)), setTimeout(r));
    });
  });
}
function ot(e = 0) {
  return ((tt() || performance.timeOrigin) + e) / 1e3;
}
function N5(e) {
  const { name: t, version: r } = J1(e.nextHopProtocol), n = [];
  return n.push(["network.protocol.version", r], ["network.protocol.name", t]), tt() ? [
    ...n,
    ["http.request.redirect_start", ot(e.redirectStart)],
    ["http.request.fetch_start", ot(e.fetchStart)],
    ["http.request.domain_lookup_start", ot(e.domainLookupStart)],
    ["http.request.domain_lookup_end", ot(e.domainLookupEnd)],
    ["http.request.connect_start", ot(e.connectStart)],
    ["http.request.secure_connection_start", ot(e.secureConnectionStart)],
    ["http.request.connection_end", ot(e.connectEnd)],
    ["http.request.request_start", ot(e.requestStart)],
    ["http.request.response_start", ot(e.responseStart)],
    ["http.request.response_end", ot(e.responseEnd)]
  ] : n;
}
function D5(e, t) {
  const r = wn();
  if (r) {
    let n, a;
    try {
      n = new URL(e, r), a = new URL(r).origin;
    } catch {
      return !1;
    }
    const u = n.origin === a;
    return t ? Mt(n.toString(), t) || u && Mt(n.pathname, t) : u;
  } else {
    const n = !!e.match(/^\/(?!\/)/);
    return t ? Mt(e, t) : n;
  }
}
function R5(e, t, r, n) {
  const a = e.xhr, u = a == null ? void 0 : a[kr];
  if (!a || a.__sentry_own_request__ || !u)
    return;
  const { url: i, method: s } = u, o = Ot() && t(i);
  if (e.endTimestamp && o) {
    const S = a.__sentry_xhr_span_id__;
    if (!S) return;
    const E = n[S];
    E && u.status_code !== void 0 && (Xl(E, u.status_code), E.end(), delete n[S]);
    return;
  }
  const c = rp(i), f = rr(c || i), g = F4(i), p = !!Le(), h = o && p ? or({
    name: `${s} ${g}`,
    attributes: {
      url: i,
      type: "xhr",
      "http.method": s,
      "http.url": c,
      "server.address": f == null ? void 0 : f.host,
      [de]: "auto.http.browser",
      [ir]: "http.client",
      ...(f == null ? void 0 : f.search) && { "http.query": f == null ? void 0 : f.search },
      ...(f == null ? void 0 : f.hash) && { "http.fragment": f == null ? void 0 : f.hash }
    }
  }) : new sr();
  a.__sentry_xhr_span_id__ = h.spanContext().spanId, n[a.__sentry_xhr_span_id__] = h, r(i) && x5(
    a,
    // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    Ot() && p ? h : void 0
  );
  const v = K();
  return v && v.emit("beforeOutgoingRequestSpan", h, e), h;
}
function x5(e, t) {
  const { "sentry-trace": r, baggage: n } = T1({ span: t });
  r && j5(e, r, n);
}
function j5(e, t, r) {
  var a;
  const n = (a = e.__sentry_xhr_v3__) == null ? void 0 : a.request_headers;
  if (!(n != null && n["sentry-trace"]))
    try {
      if (e.setRequestHeader("sentry-trace", t), r) {
        const u = n == null ? void 0 : n.baggage;
        (!u || !M5(u)) && e.setRequestHeader("baggage", r);
      }
    } catch {
    }
}
function M5(e) {
  return e.split(",").some((t) => t.trim().startsWith("sentry-"));
}
function rp(e) {
  try {
    return new URL(e, X.location.origin).href;
  } catch {
    return;
  }
}
function L5() {
  X.document ? X.document.addEventListener("visibilitychange", () => {
    const e = Le();
    if (!e)
      return;
    const t = Pe(e);
    if (X.document.hidden && t) {
      const r = "cancelled", { op: n, status: a } = Z(t);
      ut && B.log(`[Tracing] Transaction: ${r} -> since tab moved to the background, op: ${n}`), a || t.setStatus({ code: Ee, message: r }), t.setAttribute("sentry.cancellation_reason", "document.hidden"), t.end();
    }
  }) : ut && B.warn("[Tracing] Could not set up background tab detection due to lack of global document");
}
const F5 = 3600, np = "sentry_previous_trace", $5 = "sentry.previous_trace";
function U5(e, {
  linkPreviousTrace: t,
  consistentTraceSampling: r
}) {
  const n = t === "session-storage";
  let a = n ? W5() : void 0;
  e.on("spanStart", (i) => {
    if (Pe(i) !== i)
      return;
    const s = re().getPropagationContext();
    a = H5(a, i, s), n && G5(a);
  });
  let u = !0;
  r && e.on("beforeSampling", (i) => {
    if (!a)
      return;
    const s = re(), o = s.getPropagationContext();
    if (u && o.parentSpanId) {
      u = !1;
      return;
    }
    s.setPropagationContext({
      ...o,
      dsc: {
        ...o.dsc,
        sample_rate: String(a.sampleRate),
        sampled: String(bs(a.spanContext))
      },
      sampleRand: a.sampleRand
    }), i.parentSampled = bs(a.spanContext), i.parentSampleRate = a.sampleRate, i.spanAttributes = {
      ...i.spanAttributes,
      [Vl]: a.sampleRate
    };
  });
}
function H5(e, t, r) {
  const n = Z(t);
  function a() {
    var s, o;
    try {
      return Number((s = r.dsc) == null ? void 0 : s.sample_rate) ?? Number((o = n.data) == null ? void 0 : o[Ws]);
    } catch {
      return 0;
    }
  }
  const u = {
    spanContext: t.spanContext(),
    startTimestamp: n.start_timestamp,
    sampleRate: a(),
    sampleRand: r.sampleRand
  };
  if (!e)
    return u;
  const i = e.spanContext;
  return i.traceId === n.trace_id ? e : (Date.now() / 1e3 - e.startTimestamp <= F5 && (ut && B.info(
    `Adding previous_trace ${i} link to span ${{
      op: n.op,
      ...t.spanContext()
    }}`
  ), t.addLink({
    context: i,
    attributes: {
      [fy]: "previous_trace"
    }
  }), t.setAttribute(
    $5,
    `${i.traceId}-${i.spanId}-${bs(i) ? 1 : 0}`
  )), u);
}
function G5(e) {
  try {
    X.sessionStorage.setItem(np, JSON.stringify(e));
  } catch (t) {
    ut && B.warn("Could not store previous trace in sessionStorage", t);
  }
}
function W5() {
  var e;
  try {
    const t = (e = X.sessionStorage) == null ? void 0 : e.getItem(np);
    return JSON.parse(t);
  } catch {
    return;
  }
}
function bs(e) {
  return e.traceFlags === 1;
}
const q5 = "BrowserTracing", z5 = {
  ...ca,
  instrumentNavigation: !0,
  instrumentPageLoad: !0,
  markBackgroundSpan: !0,
  enableLongTask: !0,
  enableLongAnimationFrame: !0,
  enableInp: !0,
  ignoreResourceSpans: [],
  ignorePerformanceApiSpans: [],
  linkPreviousTrace: "in-memory",
  consistentTraceSampling: !1,
  _experiments: {},
  ...tp
}, Hf = (e = {}) => {
  const t = {
    name: void 0,
    source: void 0
  }, r = X.document, {
    enableInp: n,
    enableLongTask: a,
    enableLongAnimationFrame: u,
    _experiments: { enableInteractions: i, enableStandaloneClsSpans: s },
    beforeStartSpan: o,
    idleTimeout: c,
    finalTimeout: f,
    childSpanTimeout: g,
    markBackgroundSpan: p,
    traceFetch: h,
    traceXHR: v,
    trackFetchStreamPerformance: S,
    shouldCreateSpanForRequest: E,
    enableHTTPTimings: d,
    ignoreResourceSpans: m,
    ignorePerformanceApiSpans: l,
    instrumentPageLoad: y,
    instrumentNavigation: b,
    linkPreviousTrace: w,
    consistentTraceSampling: _,
    onRequestSpanStart: k
  } = {
    ...z5,
    ...e
  };
  let O;
  function D(A, P) {
    const j = P.op === "pageload", F = o ? o(P) : P, z = F.attributes || {};
    P.name !== F.name && (z[Je] = "custom", F.attributes = z), t.name = F.name, t.source = z[Je];
    const ee = h1(F, {
      idleTimeout: c,
      finalTimeout: f,
      childSpanTimeout: g,
      // should wait for finish signal if it's a pageload transaction
      disableAutoFinish: j,
      beforeSpanEnd: (M) => {
        O == null || O(), sb(M, {
          recordClsOnPageloadSpan: !s,
          ignoreResourceSpans: m,
          ignorePerformanceApiSpans: l
        }), Wf(A, void 0);
        const ae = re(), me = ae.getPropagationContext();
        ae.setPropagationContext({
          ...me,
          traceId: ee.spanContext().traceId,
          sampled: fr(ee),
          dsc: $t(M)
        });
      }
    });
    Wf(A, ee);
    function ie() {
      r && ["interactive", "complete"].includes(r.readyState) && A.emit("idleSpanEnableAutoFinish", ee);
    }
    j && r && (r.addEventListener("readystatechange", () => {
      ie();
    }), ie());
  }
  return {
    name: q5,
    setup(A) {
      Iy(), O = Z8({ recordClsStandaloneSpans: s || !1 }), n && Ib(), u && V.PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes("long-animation-frame") ? tb() : a && eb(), i && rb();
      function P() {
        const j = Za(A);
        j && !Z(j).timestamp && (ut && B.log(`[Tracing] Finishing current active span with op: ${Z(j).op}`), j.setAttribute(wa, "cancelled"), j.end());
      }
      A.on("startNavigationSpan", (j) => {
        if (K() !== A)
          return;
        P(), Vt().setPropagationContext({ traceId: Ft(), sampleRand: Math.random() });
        const F = re();
        F.setPropagationContext({ traceId: Ft(), sampleRand: Math.random() }), F.setSDKProcessingMetadata({
          normalizedRequest: void 0
        }), D(A, {
          op: "navigation",
          ...j
        });
      }), A.on("startPageLoadSpan", (j, F = {}) => {
        if (K() !== A)
          return;
        P();
        const z = F.sentryTrace || Gf("sentry-trace"), ee = F.baggage || Gf("baggage"), ie = Sy(z, ee), M = re();
        M.setPropagationContext(ie), M.setSDKProcessingMetadata({
          normalizedRequest: ls()
        }), D(A, {
          op: "pageload",
          ...j
        });
      });
    },
    afterAllSetup(A) {
      let P = wn();
      if (w !== "off" && U5(A, { linkPreviousTrace: w, consistentTraceSampling: _ }), X.location) {
        if (y) {
          const j = tt();
          V5(A, {
            name: X.location.pathname,
            // pageload should always start at timeOrigin (and needs to be in s, not ms)
            startTime: j ? j / 1e3 : void 0,
            attributes: {
              [Je]: "url",
              [de]: "auto.pageload.browser"
            }
          });
        }
        b && ro(({ to: j, from: F }) => {
          if (F === void 0 && (P == null ? void 0 : P.indexOf(j)) !== -1) {
            P = void 0;
            return;
          }
          P = void 0;
          const z = B1(j);
          ap(A, {
            name: (z == null ? void 0 : z.pathname) || X.location.pathname,
            attributes: {
              [Je]: "url",
              [de]: "auto.navigation.browser"
            }
          }), re().setSDKProcessingMetadata({
            normalizedRequest: {
              ...ls(),
              // Ensure to set this, so this matches the target route even if the URL has not yet been updated
              url: j
            }
          });
        });
      }
      p && L5(), i && Y5(A, c, f, g, t), n && Nb(), P5(A, {
        traceFetch: h,
        traceXHR: v,
        trackFetchStreamPerformance: S,
        tracePropagationTargets: A.getOptions().tracePropagationTargets,
        shouldCreateSpanForRequest: E,
        enableHTTPTimings: d,
        onRequestSpanStart: k
      });
    }
  };
};
function V5(e, t, r) {
  return e.emit("startPageLoadSpan", t, r), re().setTransactionName(t.name), Za(e);
}
function ap(e, t) {
  return e.emit("startNavigationSpan", t), re().setTransactionName(t.name), Za(e);
}
function Gf(e) {
  const t = X.document, r = t == null ? void 0 : t.querySelector(`meta[name=${e}]`);
  return (r == null ? void 0 : r.getAttribute("content")) || void 0;
}
function Y5(e, t, r, n, a) {
  const u = X.document;
  let i;
  const s = () => {
    const o = "ui.action.click", c = Za(e);
    if (c) {
      const f = Z(c).op;
      if (["navigation", "pageload"].includes(f)) {
        ut && B.warn(`[Tracing] Did not create ${o} span because a pageload or navigation span is in progress.`);
        return;
      }
    }
    if (i && (i.setAttribute(wa, "interactionInterrupted"), i.end(), i = void 0), !a.name) {
      ut && B.warn(`[Tracing] Did not create ${o} transaction because _latestRouteName is missing.`);
      return;
    }
    i = h1(
      {
        name: a.name,
        op: o,
        attributes: {
          [Je]: a.source || "url"
        }
      },
      {
        idleTimeout: t,
        finalTimeout: r,
        childSpanTimeout: n
      }
    );
  };
  u && addEventListener("click", s, { once: !1, capture: !0 });
}
const up = "_sentry_idleSpan";
function Za(e) {
  return e[up];
}
function Wf(e, t) {
  Ye(e, up, t);
}
const ip = ["activate", "mount"], sp = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, X5 = /(?:^|[-_])(\w)/g, J5 = (e) => e.replace(X5, (t) => t.toUpperCase()).replace(/[-_]/g, ""), K5 = "<Root>", Pi = "<Anonymous>", Q5 = (e, t) => e.repeat(t), on = (e, t) => {
  if (!e)
    return Pi;
  if (e.$root === e)
    return K5;
  if (!e.$options)
    return Pi;
  const r = e.$options;
  let n = r.name || r._componentTag || r.__name;
  const a = r.__file;
  if (!n && a) {
    const u = a.match(/([^/\\]+)\.vue$/);
    u && (n = u[1]);
  }
  return (n ? `<${J5(n)}>` : Pi) + (a && t !== !1 ? ` at ${a}` : "");
}, Z5 = (e) => {
  if (e && (e._isVue || e.__isVue) && e.$parent) {
    const t = [];
    let r = 0;
    for (; e; ) {
      if (t.length > 0) {
        const a = t[t.length - 1];
        if (a.constructor === e.constructor) {
          r++, e = e.$parent;
          continue;
        } else r > 0 && (t[t.length - 1] = [a, r], r = 0);
      }
      t.push(e), e = e.$parent;
    }
    return `

found in

${t.map(
      (a, u) => `${(u === 0 ? "---> " : Q5(" ", 5 + u * 2)) + (Array.isArray(a) ? `${on(a[0])}... (${a[1]} recursive calls)` : on(a))}`
    ).join(`
`)}`;
  }
  return `

(found in ${on(e)})`;
}, e6 = (e, t) => {
  const { errorHandler: r } = e.config;
  e.config.errorHandler = (n, a, u) => {
    var c;
    const i = on(a, !1), s = a ? Z5(a) : "", o = {
      componentName: i,
      lifecycleHook: u,
      trace: s
    };
    if (t.attachProps && a && ((c = a.$options) != null && c.propsData ? o.propsData = a.$options.propsData : a.$props && (o.propsData = a.$props)), setTimeout(() => {
      In(n, {
        captureContext: { contexts: { vue: o } },
        mechanism: { handled: !!r, type: "vue" }
      });
    }), typeof r == "function" && e.config.errorHandler)
      r.call(e, n, a, u);
    else
      throw n;
  };
}, qf = "ui.vue", t6 = {
  activate: ["activated", "deactivated"],
  create: ["beforeCreate", "created"],
  // Vue 3
  unmount: ["beforeUnmount", "unmounted"],
  // Vue 2
  destroy: ["beforeDestroy", "destroyed"],
  mount: ["beforeMount", "mounted"],
  update: ["beforeUpdate", "updated"]
};
function Bi(e, t, r) {
  e.$_sentryRootComponentSpanTimer && clearTimeout(e.$_sentryRootComponentSpanTimer), e.$_sentryRootComponentSpanTimer = setTimeout(() => {
    var n;
    (n = e.$root) != null && n.$_sentryRootComponentSpan && (e.$root.$_sentryRootComponentSpan.end(t), e.$root.$_sentryRootComponentSpan = void 0);
  }, r);
}
function r6(e, t) {
  function r(a) {
    return a.replace(/^<([^\s]*)>(?: at [^\s]*)?$/, "$1");
  }
  return e.some((a) => r(t) === r(a));
}
const n6 = (e = {}) => {
  const t = (e.hooks || []).concat(ip).filter((a, u, i) => i.indexOf(a) === u), r = {}, n = e.timeout || 2e3;
  for (const a of t) {
    const u = t6[a];
    if (!u) {
      sp && B.warn(`Unknown hook: ${a}`);
      continue;
    }
    for (const i of u)
      r[i] = function() {
        var p;
        const s = this.$root === this;
        s && (this.$_sentryRootComponentSpan = this.$_sentryRootComponentSpan || or({
          name: "Application Render",
          op: `${qf}.render`,
          attributes: {
            [de]: "auto.ui.vue"
          },
          onlyIfParent: !0
        }), Bi(this, Te(), n));
        const o = on(this, !1);
        if (!(s || // We always want to track the root component
        (Array.isArray(e.trackComponents) ? r6(e.trackComponents, o) : e.trackComponents))) {
          Bi(this, Te(), n);
          return;
        }
        this.$_sentryComponentSpans = this.$_sentryComponentSpans || {};
        const f = i === u[0], g = ((p = this.$root) == null ? void 0 : p.$_sentryRootComponentSpan) || Le();
        if (f) {
          if (g) {
            const h = this.$_sentryComponentSpans[a];
            h && h.end(), this.$_sentryComponentSpans[a] = or({
              name: `Vue ${o}`,
              op: `${qf}.${a}`,
              attributes: {
                [de]: "auto.ui.vue"
              },
              // UI spans should only be created if there is an active root span (transaction)
              onlyIfParent: !0
            });
          }
        } else {
          const h = this.$_sentryComponentSpans[a];
          if (!h) return;
          h.end(), Bi(this, Te(), n);
        }
      };
  }
  return r;
}, a6 = V, u6 = {
  Vue: a6.Vue,
  attachProps: !0,
  attachErrorHandler: !0,
  tracingOptions: {
    hooks: ip,
    timeout: 2e3,
    trackComponents: !1
  }
}, i6 = "Vue", s6 = (e = {}) => ({
  name: i6,
  setup(t) {
    const r = { ...u6, ...t.getOptions(), ...e };
    if (!r.Vue && !r.app) {
      Wt(() => {
        console.warn(
          "[@sentry/vue]: Misconfigured SDK. Vue specific errors will not be captured. Update your `Sentry.init` call with an appropriate config option: `app` (Application Instance - Vue 3) or `Vue` (Vue Constructor - Vue 2)."
        );
      });
      return;
    }
    r.app ? (Array.isArray(r.app) ? r.app : [r.app]).forEach((a) => zf(a, r)) : r.Vue && zf(r.Vue, r);
  }
}), zf = (e, t) => {
  var r;
  sp && ((r = e._instance) == null ? void 0 : r.isMounted) === !0 && Wt(() => {
    console.warn(
      "[@sentry/vue]: Misconfigured SDK. Vue app is already mounted. Make sure to call `app.mount()` after `Sentry.init()`."
    );
  }), t.attachErrorHandler && e6(e, t), Ot(t) && e.mixin(n6(t.tracingOptions));
};
function o6(e = {}) {
  const t = {
    defaultIntegrations: [...ep(), s6()],
    ...e
  };
  return C1(t, "vue"), I5(t);
}
function c6(e, t, r) {
  let n = !0;
  e.onError((a) => In(a, { mechanism: { handled: !1 } })), e.beforeEach((a, u, i) => {
    const s = u.name == null && u.matched.length === 0 || u.name === void 0 && n;
    n && (n = !1);
    const o = {
      [de]: "auto.navigation.vue"
    };
    for (const g of Object.keys(a.params))
      o[`params.${g}`] = a.params[g];
    for (const g of Object.keys(a.query)) {
      const p = a.query[g];
      p && (o[`query.${g}`] = p);
    }
    let c = a.path, f = "url";
    if (a.name && t.routeLabel !== "path")
      c = a.name.toString(), f = "custom";
    else if (a.matched.length > 0) {
      const g = a.matched.length - 1;
      c = a.matched[g].path, f = "route";
    }
    if (re().setTransactionName(c), t.instrumentPageLoad && s) {
      const g = d6();
      g && (Z(g).data[Je] !== "custom" && (g.updateName(c), g.setAttribute(Je, f)), g.setAttributes({
        ...o,
        [de]: "auto.pageload.vue"
      }));
    }
    t.instrumentNavigation && !s && (o[Je] = f, o[de] = "auto.navigation.vue", r({
      name: c,
      op: "navigation",
      attributes: o
    })), i && i();
  });
}
function d6() {
  const e = Le(), t = e && Pe(e);
  if (!t)
    return;
  const r = Z(t).op;
  return r === "navigation" || r === "pageload" ? t : void 0;
}
function f6(e = {}) {
  if (!e.router)
    return Hf(e);
  const t = Hf({
    ...e,
    instrumentNavigation: !1
  }), { router: r, instrumentNavigation: n = !0, instrumentPageLoad: a = !0, routeLabel: u = "name" } = e;
  return {
    ...t,
    afterAllSetup(i) {
      t.afterAllSetup(i), c6(r, { routeLabel: u, instrumentNavigation: n, instrumentPageLoad: a }, (o) => {
        ap(i, o);
      });
    }
  };
}
function op(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function l6(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
const p6 = [
  {
    name: "nodejs",
    version: "0.2.0",
    date: "2011-08-26",
    lts: !1,
    security: !1,
    v8: "2.3.8.0"
  },
  {
    name: "nodejs",
    version: "0.3.0",
    date: "2011-08-26",
    lts: !1,
    security: !1,
    v8: "2.5.1.0"
  },
  {
    name: "nodejs",
    version: "0.4.0",
    date: "2011-08-26",
    lts: !1,
    security: !1,
    v8: "3.1.2.0"
  },
  {
    name: "nodejs",
    version: "0.5.0",
    date: "2011-08-26",
    lts: !1,
    security: !1,
    v8: "3.1.8.25"
  },
  {
    name: "nodejs",
    version: "0.6.0",
    date: "2011-11-04",
    lts: !1,
    security: !1,
    v8: "3.6.6.6"
  },
  {
    name: "nodejs",
    version: "0.7.0",
    date: "2012-01-17",
    lts: !1,
    security: !1,
    v8: "3.8.6.0"
  },
  {
    name: "nodejs",
    version: "0.8.0",
    date: "2012-06-22",
    lts: !1,
    security: !1,
    v8: "3.11.10.10"
  },
  {
    name: "nodejs",
    version: "0.9.0",
    date: "2012-07-20",
    lts: !1,
    security: !1,
    v8: "3.11.10.15"
  },
  {
    name: "nodejs",
    version: "0.10.0",
    date: "2013-03-11",
    lts: !1,
    security: !1,
    v8: "3.14.5.8"
  },
  {
    name: "nodejs",
    version: "0.11.0",
    date: "2013-03-28",
    lts: !1,
    security: !1,
    v8: "3.17.13.0"
  },
  {
    name: "nodejs",
    version: "0.12.0",
    date: "2015-02-06",
    lts: !1,
    security: !1,
    v8: "3.28.73.0"
  },
  {
    name: "nodejs",
    version: "4.0.0",
    date: "2015-09-08",
    lts: !1,
    security: !1,
    v8: "4.5.103.30"
  },
  {
    name: "nodejs",
    version: "4.1.0",
    date: "2015-09-17",
    lts: !1,
    security: !1,
    v8: "4.5.103.33"
  },
  {
    name: "nodejs",
    version: "4.2.0",
    date: "2015-10-12",
    lts: "Argon",
    security: !1,
    v8: "4.5.103.35"
  },
  {
    name: "nodejs",
    version: "4.3.0",
    date: "2016-02-09",
    lts: "Argon",
    security: !1,
    v8: "4.5.103.35"
  },
  {
    name: "nodejs",
    version: "4.4.0",
    date: "2016-03-08",
    lts: "Argon",
    security: !1,
    v8: "4.5.103.35"
  },
  {
    name: "nodejs",
    version: "4.5.0",
    date: "2016-08-16",
    lts: "Argon",
    security: !1,
    v8: "4.5.103.37"
  },
  {
    name: "nodejs",
    version: "4.6.0",
    date: "2016-09-27",
    lts: "Argon",
    security: !0,
    v8: "4.5.103.37"
  },
  {
    name: "nodejs",
    version: "4.7.0",
    date: "2016-12-06",
    lts: "Argon",
    security: !1,
    v8: "4.5.103.43"
  },
  {
    name: "nodejs",
    version: "4.8.0",
    date: "2017-02-21",
    lts: "Argon",
    security: !1,
    v8: "4.5.103.45"
  },
  {
    name: "nodejs",
    version: "4.9.0",
    date: "2018-03-28",
    lts: "Argon",
    security: !0,
    v8: "4.5.103.53"
  },
  {
    name: "nodejs",
    version: "5.0.0",
    date: "2015-10-29",
    lts: !1,
    security: !1,
    v8: "4.6.85.28"
  },
  {
    name: "nodejs",
    version: "5.1.0",
    date: "2015-11-17",
    lts: !1,
    security: !1,
    v8: "4.6.85.31"
  },
  {
    name: "nodejs",
    version: "5.2.0",
    date: "2015-12-09",
    lts: !1,
    security: !1,
    v8: "4.6.85.31"
  },
  {
    name: "nodejs",
    version: "5.3.0",
    date: "2015-12-15",
    lts: !1,
    security: !1,
    v8: "4.6.85.31"
  },
  {
    name: "nodejs",
    version: "5.4.0",
    date: "2016-01-06",
    lts: !1,
    security: !1,
    v8: "4.6.85.31"
  },
  {
    name: "nodejs",
    version: "5.5.0",
    date: "2016-01-21",
    lts: !1,
    security: !1,
    v8: "4.6.85.31"
  },
  {
    name: "nodejs",
    version: "5.6.0",
    date: "2016-02-09",
    lts: !1,
    security: !1,
    v8: "4.6.85.31"
  },
  {
    name: "nodejs",
    version: "5.7.0",
    date: "2016-02-23",
    lts: !1,
    security: !1,
    v8: "4.6.85.31"
  },
  {
    name: "nodejs",
    version: "5.8.0",
    date: "2016-03-09",
    lts: !1,
    security: !1,
    v8: "4.6.85.31"
  },
  {
    name: "nodejs",
    version: "5.9.0",
    date: "2016-03-16",
    lts: !1,
    security: !1,
    v8: "4.6.85.31"
  },
  {
    name: "nodejs",
    version: "5.10.0",
    date: "2016-04-01",
    lts: !1,
    security: !1,
    v8: "4.6.85.31"
  },
  {
    name: "nodejs",
    version: "5.11.0",
    date: "2016-04-21",
    lts: !1,
    security: !1,
    v8: "4.6.85.31"
  },
  {
    name: "nodejs",
    version: "5.12.0",
    date: "2016-06-23",
    lts: !1,
    security: !1,
    v8: "4.6.85.32"
  },
  {
    name: "nodejs",
    version: "6.0.0",
    date: "2016-04-26",
    lts: !1,
    security: !1,
    v8: "5.0.71.35"
  },
  {
    name: "nodejs",
    version: "6.1.0",
    date: "2016-05-05",
    lts: !1,
    security: !1,
    v8: "5.0.71.35"
  },
  {
    name: "nodejs",
    version: "6.2.0",
    date: "2016-05-17",
    lts: !1,
    security: !1,
    v8: "5.0.71.47"
  },
  {
    name: "nodejs",
    version: "6.3.0",
    date: "2016-07-06",
    lts: !1,
    security: !1,
    v8: "5.0.71.52"
  },
  {
    name: "nodejs",
    version: "6.4.0",
    date: "2016-08-12",
    lts: !1,
    security: !1,
    v8: "5.0.71.60"
  },
  {
    name: "nodejs",
    version: "6.5.0",
    date: "2016-08-26",
    lts: !1,
    security: !1,
    v8: "5.1.281.81"
  },
  {
    name: "nodejs",
    version: "6.6.0",
    date: "2016-09-14",
    lts: !1,
    security: !1,
    v8: "5.1.281.83"
  },
  {
    name: "nodejs",
    version: "6.7.0",
    date: "2016-09-27",
    lts: !1,
    security: !0,
    v8: "5.1.281.83"
  },
  {
    name: "nodejs",
    version: "6.8.0",
    date: "2016-10-12",
    lts: !1,
    security: !1,
    v8: "5.1.281.84"
  },
  {
    name: "nodejs",
    version: "6.9.0",
    date: "2016-10-18",
    lts: "Boron",
    security: !1,
    v8: "5.1.281.84"
  },
  {
    name: "nodejs",
    version: "6.10.0",
    date: "2017-02-21",
    lts: "Boron",
    security: !1,
    v8: "5.1.281.93"
  },
  {
    name: "nodejs",
    version: "6.11.0",
    date: "2017-06-06",
    lts: "Boron",
    security: !1,
    v8: "5.1.281.102"
  },
  {
    name: "nodejs",
    version: "6.12.0",
    date: "2017-11-06",
    lts: "Boron",
    security: !1,
    v8: "5.1.281.108"
  },
  {
    name: "nodejs",
    version: "6.13.0",
    date: "2018-02-10",
    lts: "Boron",
    security: !1,
    v8: "5.1.281.111"
  },
  {
    name: "nodejs",
    version: "6.14.0",
    date: "2018-03-28",
    lts: "Boron",
    security: !0,
    v8: "5.1.281.111"
  },
  {
    name: "nodejs",
    version: "6.15.0",
    date: "2018-11-27",
    lts: "Boron",
    security: !0,
    v8: "5.1.281.111"
  },
  {
    name: "nodejs",
    version: "6.16.0",
    date: "2018-12-26",
    lts: "Boron",
    security: !1,
    v8: "5.1.281.111"
  },
  {
    name: "nodejs",
    version: "6.17.0",
    date: "2019-02-28",
    lts: "Boron",
    security: !0,
    v8: "5.1.281.111"
  },
  {
    name: "nodejs",
    version: "7.0.0",
    date: "2016-10-25",
    lts: !1,
    security: !1,
    v8: "5.4.500.36"
  },
  {
    name: "nodejs",
    version: "7.1.0",
    date: "2016-11-08",
    lts: !1,
    security: !1,
    v8: "5.4.500.36"
  },
  {
    name: "nodejs",
    version: "7.2.0",
    date: "2016-11-22",
    lts: !1,
    security: !1,
    v8: "5.4.500.43"
  },
  {
    name: "nodejs",
    version: "7.3.0",
    date: "2016-12-20",
    lts: !1,
    security: !1,
    v8: "5.4.500.45"
  },
  {
    name: "nodejs",
    version: "7.4.0",
    date: "2017-01-04",
    lts: !1,
    security: !1,
    v8: "5.4.500.45"
  },
  {
    name: "nodejs",
    version: "7.5.0",
    date: "2017-01-31",
    lts: !1,
    security: !1,
    v8: "5.4.500.48"
  },
  {
    name: "nodejs",
    version: "7.6.0",
    date: "2017-02-21",
    lts: !1,
    security: !1,
    v8: "5.5.372.40"
  },
  {
    name: "nodejs",
    version: "7.7.0",
    date: "2017-02-28",
    lts: !1,
    security: !1,
    v8: "5.5.372.41"
  },
  {
    name: "nodejs",
    version: "7.8.0",
    date: "2017-03-29",
    lts: !1,
    security: !1,
    v8: "5.5.372.43"
  },
  {
    name: "nodejs",
    version: "7.9.0",
    date: "2017-04-11",
    lts: !1,
    security: !1,
    v8: "5.5.372.43"
  },
  {
    name: "nodejs",
    version: "7.10.0",
    date: "2017-05-02",
    lts: !1,
    security: !1,
    v8: "5.5.372.43"
  },
  {
    name: "nodejs",
    version: "8.0.0",
    date: "2017-05-30",
    lts: !1,
    security: !1,
    v8: "5.8.283.41"
  },
  {
    name: "nodejs",
    version: "8.1.0",
    date: "2017-06-08",
    lts: !1,
    security: !1,
    v8: "5.8.283.41"
  },
  {
    name: "nodejs",
    version: "8.2.0",
    date: "2017-07-19",
    lts: !1,
    security: !1,
    v8: "5.8.283.41"
  },
  {
    name: "nodejs",
    version: "8.3.0",
    date: "2017-08-08",
    lts: !1,
    security: !1,
    v8: "6.0.286.52"
  },
  {
    name: "nodejs",
    version: "8.4.0",
    date: "2017-08-15",
    lts: !1,
    security: !1,
    v8: "6.0.286.52"
  },
  {
    name: "nodejs",
    version: "8.5.0",
    date: "2017-09-12",
    lts: !1,
    security: !1,
    v8: "6.0.287.53"
  },
  {
    name: "nodejs",
    version: "8.6.0",
    date: "2017-09-26",
    lts: !1,
    security: !1,
    v8: "6.0.287.53"
  },
  {
    name: "nodejs",
    version: "8.7.0",
    date: "2017-10-11",
    lts: !1,
    security: !1,
    v8: "6.1.534.42"
  },
  {
    name: "nodejs",
    version: "8.8.0",
    date: "2017-10-24",
    lts: !1,
    security: !1,
    v8: "6.1.534.42"
  },
  {
    name: "nodejs",
    version: "8.9.0",
    date: "2017-10-31",
    lts: "Carbon",
    security: !1,
    v8: "6.1.534.46"
  },
  {
    name: "nodejs",
    version: "8.10.0",
    date: "2018-03-06",
    lts: "Carbon",
    security: !1,
    v8: "6.2.414.50"
  },
  {
    name: "nodejs",
    version: "8.11.0",
    date: "2018-03-28",
    lts: "Carbon",
    security: !0,
    v8: "6.2.414.50"
  },
  {
    name: "nodejs",
    version: "8.12.0",
    date: "2018-09-10",
    lts: "Carbon",
    security: !1,
    v8: "6.2.414.66"
  },
  {
    name: "nodejs",
    version: "8.13.0",
    date: "2018-11-20",
    lts: "Carbon",
    security: !1,
    v8: "6.2.414.72"
  },
  {
    name: "nodejs",
    version: "8.14.0",
    date: "2018-11-27",
    lts: "Carbon",
    security: !0,
    v8: "6.2.414.72"
  },
  {
    name: "nodejs",
    version: "8.15.0",
    date: "2018-12-26",
    lts: "Carbon",
    security: !1,
    v8: "6.2.414.75"
  },
  {
    name: "nodejs",
    version: "8.16.0",
    date: "2019-04-16",
    lts: "Carbon",
    security: !1,
    v8: "6.2.414.77"
  },
  {
    name: "nodejs",
    version: "8.17.0",
    date: "2019-12-17",
    lts: "Carbon",
    security: !0,
    v8: "6.2.414.78"
  },
  {
    name: "nodejs",
    version: "9.0.0",
    date: "2017-10-31",
    lts: !1,
    security: !1,
    v8: "6.2.414.32"
  },
  {
    name: "nodejs",
    version: "9.1.0",
    date: "2017-11-07",
    lts: !1,
    security: !1,
    v8: "6.2.414.32"
  },
  {
    name: "nodejs",
    version: "9.2.0",
    date: "2017-11-14",
    lts: !1,
    security: !1,
    v8: "6.2.414.44"
  },
  {
    name: "nodejs",
    version: "9.3.0",
    date: "2017-12-12",
    lts: !1,
    security: !1,
    v8: "6.2.414.46"
  },
  {
    name: "nodejs",
    version: "9.4.0",
    date: "2018-01-10",
    lts: !1,
    security: !1,
    v8: "6.2.414.46"
  },
  {
    name: "nodejs",
    version: "9.5.0",
    date: "2018-01-31",
    lts: !1,
    security: !1,
    v8: "6.2.414.46"
  },
  {
    name: "nodejs",
    version: "9.6.0",
    date: "2018-02-21",
    lts: !1,
    security: !1,
    v8: "6.2.414.46"
  },
  {
    name: "nodejs",
    version: "9.7.0",
    date: "2018-03-01",
    lts: !1,
    security: !1,
    v8: "6.2.414.46"
  },
  {
    name: "nodejs",
    version: "9.8.0",
    date: "2018-03-07",
    lts: !1,
    security: !1,
    v8: "6.2.414.46"
  },
  {
    name: "nodejs",
    version: "9.9.0",
    date: "2018-03-21",
    lts: !1,
    security: !1,
    v8: "6.2.414.46"
  },
  {
    name: "nodejs",
    version: "9.10.0",
    date: "2018-03-28",
    lts: !1,
    security: !0,
    v8: "6.2.414.46"
  },
  {
    name: "nodejs",
    version: "9.11.0",
    date: "2018-04-04",
    lts: !1,
    security: !1,
    v8: "6.2.414.46"
  },
  {
    name: "nodejs",
    version: "10.0.0",
    date: "2018-04-24",
    lts: !1,
    security: !1,
    v8: "6.6.346.24"
  },
  {
    name: "nodejs",
    version: "10.1.0",
    date: "2018-05-08",
    lts: !1,
    security: !1,
    v8: "6.6.346.27"
  },
  {
    name: "nodejs",
    version: "10.2.0",
    date: "2018-05-23",
    lts: !1,
    security: !1,
    v8: "6.6.346.32"
  },
  {
    name: "nodejs",
    version: "10.3.0",
    date: "2018-05-29",
    lts: !1,
    security: !1,
    v8: "6.6.346.32"
  },
  {
    name: "nodejs",
    version: "10.4.0",
    date: "2018-06-06",
    lts: !1,
    security: !1,
    v8: "6.7.288.43"
  },
  {
    name: "nodejs",
    version: "10.5.0",
    date: "2018-06-20",
    lts: !1,
    security: !1,
    v8: "6.7.288.46"
  },
  {
    name: "nodejs",
    version: "10.6.0",
    date: "2018-07-04",
    lts: !1,
    security: !1,
    v8: "6.7.288.46"
  },
  {
    name: "nodejs",
    version: "10.7.0",
    date: "2018-07-18",
    lts: !1,
    security: !1,
    v8: "6.7.288.49"
  },
  {
    name: "nodejs",
    version: "10.8.0",
    date: "2018-08-01",
    lts: !1,
    security: !1,
    v8: "6.7.288.49"
  },
  {
    name: "nodejs",
    version: "10.9.0",
    date: "2018-08-15",
    lts: !1,
    security: !1,
    v8: "6.8.275.24"
  },
  {
    name: "nodejs",
    version: "10.10.0",
    date: "2018-09-06",
    lts: !1,
    security: !1,
    v8: "6.8.275.30"
  },
  {
    name: "nodejs",
    version: "10.11.0",
    date: "2018-09-19",
    lts: !1,
    security: !1,
    v8: "6.8.275.32"
  },
  {
    name: "nodejs",
    version: "10.12.0",
    date: "2018-10-10",
    lts: !1,
    security: !1,
    v8: "6.8.275.32"
  },
  {
    name: "nodejs",
    version: "10.13.0",
    date: "2018-10-30",
    lts: "Dubnium",
    security: !1,
    v8: "6.8.275.32"
  },
  {
    name: "nodejs",
    version: "10.14.0",
    date: "2018-11-27",
    lts: "Dubnium",
    security: !0,
    v8: "6.8.275.32"
  },
  {
    name: "nodejs",
    version: "10.15.0",
    date: "2018-12-26",
    lts: "Dubnium",
    security: !1,
    v8: "6.8.275.32"
  },
  {
    name: "nodejs",
    version: "10.16.0",
    date: "2019-05-28",
    lts: "Dubnium",
    security: !1,
    v8: "6.8.275.32"
  },
  {
    name: "nodejs",
    version: "10.17.0",
    date: "2019-10-22",
    lts: "Dubnium",
    security: !1,
    v8: "6.8.275.32"
  },
  {
    name: "nodejs",
    version: "10.18.0",
    date: "2019-12-17",
    lts: "Dubnium",
    security: !0,
    v8: "6.8.275.32"
  },
  {
    name: "nodejs",
    version: "10.19.0",
    date: "2020-02-05",
    lts: "Dubnium",
    security: !0,
    v8: "6.8.275.32"
  },
  {
    name: "nodejs",
    version: "10.20.0",
    date: "2020-03-26",
    lts: "Dubnium",
    security: !1,
    v8: "6.8.275.32"
  },
  {
    name: "nodejs",
    version: "10.21.0",
    date: "2020-06-02",
    lts: "Dubnium",
    security: !0,
    v8: "6.8.275.32"
  },
  {
    name: "nodejs",
    version: "10.22.0",
    date: "2020-07-21",
    lts: "Dubnium",
    security: !1,
    v8: "6.8.275.32"
  },
  {
    name: "nodejs",
    version: "10.23.0",
    date: "2020-10-27",
    lts: "Dubnium",
    security: !1,
    v8: "6.8.275.32"
  },
  {
    name: "nodejs",
    version: "10.24.0",
    date: "2021-02-23",
    lts: "Dubnium",
    security: !0,
    v8: "6.8.275.32"
  },
  {
    name: "nodejs",
    version: "11.0.0",
    date: "2018-10-23",
    lts: !1,
    security: !1,
    v8: "7.0.276.28"
  },
  {
    name: "nodejs",
    version: "11.1.0",
    date: "2018-10-30",
    lts: !1,
    security: !1,
    v8: "7.0.276.32"
  },
  {
    name: "nodejs",
    version: "11.2.0",
    date: "2018-11-15",
    lts: !1,
    security: !1,
    v8: "7.0.276.38"
  },
  {
    name: "nodejs",
    version: "11.3.0",
    date: "2018-11-27",
    lts: !1,
    security: !0,
    v8: "7.0.276.38"
  },
  {
    name: "nodejs",
    version: "11.4.0",
    date: "2018-12-07",
    lts: !1,
    security: !1,
    v8: "7.0.276.38"
  },
  {
    name: "nodejs",
    version: "11.5.0",
    date: "2018-12-18",
    lts: !1,
    security: !1,
    v8: "7.0.276.38"
  },
  {
    name: "nodejs",
    version: "11.6.0",
    date: "2018-12-26",
    lts: !1,
    security: !1,
    v8: "7.0.276.38"
  },
  {
    name: "nodejs",
    version: "11.7.0",
    date: "2019-01-17",
    lts: !1,
    security: !1,
    v8: "7.0.276.38"
  },
  {
    name: "nodejs",
    version: "11.8.0",
    date: "2019-01-24",
    lts: !1,
    security: !1,
    v8: "7.0.276.38"
  },
  {
    name: "nodejs",
    version: "11.9.0",
    date: "2019-01-30",
    lts: !1,
    security: !1,
    v8: "7.0.276.38"
  },
  {
    name: "nodejs",
    version: "11.10.0",
    date: "2019-02-14",
    lts: !1,
    security: !1,
    v8: "7.0.276.38"
  },
  {
    name: "nodejs",
    version: "11.11.0",
    date: "2019-03-05",
    lts: !1,
    security: !1,
    v8: "7.0.276.38"
  },
  {
    name: "nodejs",
    version: "11.12.0",
    date: "2019-03-14",
    lts: !1,
    security: !1,
    v8: "7.0.276.38"
  },
  {
    name: "nodejs",
    version: "11.13.0",
    date: "2019-03-28",
    lts: !1,
    security: !1,
    v8: "7.0.276.38"
  },
  {
    name: "nodejs",
    version: "11.14.0",
    date: "2019-04-10",
    lts: !1,
    security: !1,
    v8: "7.0.276.38"
  },
  {
    name: "nodejs",
    version: "11.15.0",
    date: "2019-04-30",
    lts: !1,
    security: !1,
    v8: "7.0.276.38"
  },
  {
    name: "nodejs",
    version: "12.0.0",
    date: "2019-04-23",
    lts: !1,
    security: !1,
    v8: "7.4.288.21"
  },
  {
    name: "nodejs",
    version: "12.1.0",
    date: "2019-04-29",
    lts: !1,
    security: !1,
    v8: "7.4.288.21"
  },
  {
    name: "nodejs",
    version: "12.2.0",
    date: "2019-05-07",
    lts: !1,
    security: !1,
    v8: "7.4.288.21"
  },
  {
    name: "nodejs",
    version: "12.3.0",
    date: "2019-05-21",
    lts: !1,
    security: !1,
    v8: "7.4.288.27"
  },
  {
    name: "nodejs",
    version: "12.4.0",
    date: "2019-06-04",
    lts: !1,
    security: !1,
    v8: "7.4.288.27"
  },
  {
    name: "nodejs",
    version: "12.5.0",
    date: "2019-06-26",
    lts: !1,
    security: !1,
    v8: "7.5.288.22"
  },
  {
    name: "nodejs",
    version: "12.6.0",
    date: "2019-07-03",
    lts: !1,
    security: !1,
    v8: "7.5.288.22"
  },
  {
    name: "nodejs",
    version: "12.7.0",
    date: "2019-07-23",
    lts: !1,
    security: !1,
    v8: "7.5.288.22"
  },
  {
    name: "nodejs",
    version: "12.8.0",
    date: "2019-08-06",
    lts: !1,
    security: !1,
    v8: "7.5.288.22"
  },
  {
    name: "nodejs",
    version: "12.9.0",
    date: "2019-08-20",
    lts: !1,
    security: !1,
    v8: "7.6.303.29"
  },
  {
    name: "nodejs",
    version: "12.10.0",
    date: "2019-09-04",
    lts: !1,
    security: !1,
    v8: "7.6.303.29"
  },
  {
    name: "nodejs",
    version: "12.11.0",
    date: "2019-09-25",
    lts: !1,
    security: !1,
    v8: "7.7.299.11"
  },
  {
    name: "nodejs",
    version: "12.12.0",
    date: "2019-10-11",
    lts: !1,
    security: !1,
    v8: "7.7.299.13"
  },
  {
    name: "nodejs",
    version: "12.13.0",
    date: "2019-10-21",
    lts: "Erbium",
    security: !1,
    v8: "7.7.299.13"
  },
  {
    name: "nodejs",
    version: "12.14.0",
    date: "2019-12-17",
    lts: "Erbium",
    security: !0,
    v8: "7.7.299.13"
  },
  {
    name: "nodejs",
    version: "12.15.0",
    date: "2020-02-05",
    lts: "Erbium",
    security: !0,
    v8: "7.7.299.13"
  },
  {
    name: "nodejs",
    version: "12.16.0",
    date: "2020-02-11",
    lts: "Erbium",
    security: !1,
    v8: "7.8.279.23"
  },
  {
    name: "nodejs",
    version: "12.17.0",
    date: "2020-05-26",
    lts: "Erbium",
    security: !1,
    v8: "7.8.279.23"
  },
  {
    name: "nodejs",
    version: "12.18.0",
    date: "2020-06-02",
    lts: "Erbium",
    security: !0,
    v8: "7.8.279.23"
  },
  {
    name: "nodejs",
    version: "12.19.0",
    date: "2020-10-06",
    lts: "Erbium",
    security: !1,
    v8: "7.8.279.23"
  },
  {
    name: "nodejs",
    version: "12.20.0",
    date: "2020-11-24",
    lts: "Erbium",
    security: !1,
    v8: "7.8.279.23"
  },
  {
    name: "nodejs",
    version: "12.21.0",
    date: "2021-02-23",
    lts: "Erbium",
    security: !0,
    v8: "7.8.279.23"
  },
  {
    name: "nodejs",
    version: "12.22.0",
    date: "2021-03-30",
    lts: "Erbium",
    security: !1,
    v8: "7.8.279.23"
  },
  {
    name: "nodejs",
    version: "13.0.0",
    date: "2019-10-22",
    lts: !1,
    security: !1,
    v8: "7.8.279.17"
  },
  {
    name: "nodejs",
    version: "13.1.0",
    date: "2019-11-05",
    lts: !1,
    security: !1,
    v8: "7.8.279.17"
  },
  {
    name: "nodejs",
    version: "13.2.0",
    date: "2019-11-21",
    lts: !1,
    security: !1,
    v8: "7.9.317.23"
  },
  {
    name: "nodejs",
    version: "13.3.0",
    date: "2019-12-03",
    lts: !1,
    security: !1,
    v8: "7.9.317.25"
  },
  {
    name: "nodejs",
    version: "13.4.0",
    date: "2019-12-17",
    lts: !1,
    security: !0,
    v8: "7.9.317.25"
  },
  {
    name: "nodejs",
    version: "13.5.0",
    date: "2019-12-18",
    lts: !1,
    security: !1,
    v8: "7.9.317.25"
  },
  {
    name: "nodejs",
    version: "13.6.0",
    date: "2020-01-07",
    lts: !1,
    security: !1,
    v8: "7.9.317.25"
  },
  {
    name: "nodejs",
    version: "13.7.0",
    date: "2020-01-21",
    lts: !1,
    security: !1,
    v8: "7.9.317.25"
  },
  {
    name: "nodejs",
    version: "13.8.0",
    date: "2020-02-05",
    lts: !1,
    security: !0,
    v8: "7.9.317.25"
  },
  {
    name: "nodejs",
    version: "13.9.0",
    date: "2020-02-18",
    lts: !1,
    security: !1,
    v8: "7.9.317.25"
  },
  {
    name: "nodejs",
    version: "13.10.0",
    date: "2020-03-04",
    lts: !1,
    security: !1,
    v8: "7.9.317.25"
  },
  {
    name: "nodejs",
    version: "13.11.0",
    date: "2020-03-12",
    lts: !1,
    security: !1,
    v8: "7.9.317.25"
  },
  {
    name: "nodejs",
    version: "13.12.0",
    date: "2020-03-26",
    lts: !1,
    security: !1,
    v8: "7.9.317.25"
  },
  {
    name: "nodejs",
    version: "13.13.0",
    date: "2020-04-14",
    lts: !1,
    security: !1,
    v8: "7.9.317.25"
  },
  {
    name: "nodejs",
    version: "13.14.0",
    date: "2020-04-29",
    lts: !1,
    security: !1,
    v8: "7.9.317.25"
  },
  {
    name: "nodejs",
    version: "14.0.0",
    date: "2020-04-21",
    lts: !1,
    security: !1,
    v8: "8.1.307.30"
  },
  {
    name: "nodejs",
    version: "14.1.0",
    date: "2020-04-29",
    lts: !1,
    security: !1,
    v8: "8.1.307.31"
  },
  {
    name: "nodejs",
    version: "14.2.0",
    date: "2020-05-05",
    lts: !1,
    security: !1,
    v8: "8.1.307.31"
  },
  {
    name: "nodejs",
    version: "14.3.0",
    date: "2020-05-19",
    lts: !1,
    security: !1,
    v8: "8.1.307.31"
  },
  {
    name: "nodejs",
    version: "14.4.0",
    date: "2020-06-02",
    lts: !1,
    security: !0,
    v8: "8.1.307.31"
  },
  {
    name: "nodejs",
    version: "14.5.0",
    date: "2020-06-30",
    lts: !1,
    security: !1,
    v8: "8.3.110.9"
  },
  {
    name: "nodejs",
    version: "14.6.0",
    date: "2020-07-20",
    lts: !1,
    security: !1,
    v8: "8.4.371.19"
  },
  {
    name: "nodejs",
    version: "14.7.0",
    date: "2020-07-29",
    lts: !1,
    security: !1,
    v8: "8.4.371.19"
  },
  {
    name: "nodejs",
    version: "14.8.0",
    date: "2020-08-11",
    lts: !1,
    security: !1,
    v8: "8.4.371.19"
  },
  {
    name: "nodejs",
    version: "14.9.0",
    date: "2020-08-27",
    lts: !1,
    security: !1,
    v8: "8.4.371.19"
  },
  {
    name: "nodejs",
    version: "14.10.0",
    date: "2020-09-08",
    lts: !1,
    security: !1,
    v8: "8.4.371.19"
  },
  {
    name: "nodejs",
    version: "14.11.0",
    date: "2020-09-15",
    lts: !1,
    security: !0,
    v8: "8.4.371.19"
  },
  {
    name: "nodejs",
    version: "14.12.0",
    date: "2020-09-22",
    lts: !1,
    security: !1,
    v8: "8.4.371.19"
  },
  {
    name: "nodejs",
    version: "14.13.0",
    date: "2020-09-29",
    lts: !1,
    security: !1,
    v8: "8.4.371.19"
  },
  {
    name: "nodejs",
    version: "14.14.0",
    date: "2020-10-15",
    lts: !1,
    security: !1,
    v8: "8.4.371.19"
  },
  {
    name: "nodejs",
    version: "14.15.0",
    date: "2020-10-27",
    lts: "Fermium",
    security: !1,
    v8: "8.4.371.19"
  },
  {
    name: "nodejs",
    version: "14.16.0",
    date: "2021-02-23",
    lts: "Fermium",
    security: !0,
    v8: "8.4.371.19"
  },
  {
    name: "nodejs",
    version: "14.17.0",
    date: "2021-05-11",
    lts: "Fermium",
    security: !1,
    v8: "8.4.371.23"
  },
  {
    name: "nodejs",
    version: "14.18.0",
    date: "2021-09-28",
    lts: "Fermium",
    security: !1,
    v8: "8.4.371.23"
  },
  {
    name: "nodejs",
    version: "14.19.0",
    date: "2022-02-01",
    lts: "Fermium",
    security: !1,
    v8: "8.4.371.23"
  },
  {
    name: "nodejs",
    version: "14.20.0",
    date: "2022-07-07",
    lts: "Fermium",
    security: !0,
    v8: "8.4.371.23"
  },
  {
    name: "nodejs",
    version: "14.21.0",
    date: "2022-11-01",
    lts: "Fermium",
    security: !1,
    v8: "8.4.371.23"
  },
  {
    name: "nodejs",
    version: "15.0.0",
    date: "2020-10-20",
    lts: !1,
    security: !1,
    v8: "8.6.395.16"
  },
  {
    name: "nodejs",
    version: "15.1.0",
    date: "2020-11-04",
    lts: !1,
    security: !1,
    v8: "8.6.395.17"
  },
  {
    name: "nodejs",
    version: "15.2.0",
    date: "2020-11-10",
    lts: !1,
    security: !1,
    v8: "8.6.395.17"
  },
  {
    name: "nodejs",
    version: "15.3.0",
    date: "2020-11-24",
    lts: !1,
    security: !1,
    v8: "8.6.395.17"
  },
  {
    name: "nodejs",
    version: "15.4.0",
    date: "2020-12-09",
    lts: !1,
    security: !1,
    v8: "8.6.395.17"
  },
  {
    name: "nodejs",
    version: "15.5.0",
    date: "2020-12-22",
    lts: !1,
    security: !1,
    v8: "8.6.395.17"
  },
  {
    name: "nodejs",
    version: "15.6.0",
    date: "2021-01-14",
    lts: !1,
    security: !1,
    v8: "8.6.395.17"
  },
  {
    name: "nodejs",
    version: "15.7.0",
    date: "2021-01-25",
    lts: !1,
    security: !1,
    v8: "8.6.395.17"
  },
  {
    name: "nodejs",
    version: "15.8.0",
    date: "2021-02-02",
    lts: !1,
    security: !1,
    v8: "8.6.395.17"
  },
  {
    name: "nodejs",
    version: "15.9.0",
    date: "2021-02-18",
    lts: !1,
    security: !1,
    v8: "8.6.395.17"
  },
  {
    name: "nodejs",
    version: "15.10.0",
    date: "2021-02-23",
    lts: !1,
    security: !0,
    v8: "8.6.395.17"
  },
  {
    name: "nodejs",
    version: "15.11.0",
    date: "2021-03-03",
    lts: !1,
    security: !1,
    v8: "8.6.395.17"
  },
  {
    name: "nodejs",
    version: "15.12.0",
    date: "2021-03-17",
    lts: !1,
    security: !1,
    v8: "8.6.395.17"
  },
  {
    name: "nodejs",
    version: "15.13.0",
    date: "2021-03-31",
    lts: !1,
    security: !1,
    v8: "8.6.395.17"
  },
  {
    name: "nodejs",
    version: "15.14.0",
    date: "2021-04-06",
    lts: !1,
    security: !1,
    v8: "8.6.395.17"
  },
  {
    name: "nodejs",
    version: "16.0.0",
    date: "2021-04-20",
    lts: !1,
    security: !1,
    v8: "9.0.257.17"
  },
  {
    name: "nodejs",
    version: "16.1.0",
    date: "2021-05-04",
    lts: !1,
    security: !1,
    v8: "9.0.257.24"
  },
  {
    name: "nodejs",
    version: "16.2.0",
    date: "2021-05-19",
    lts: !1,
    security: !1,
    v8: "9.0.257.25"
  },
  {
    name: "nodejs",
    version: "16.3.0",
    date: "2021-06-03",
    lts: !1,
    security: !1,
    v8: "9.0.257.25"
  },
  {
    name: "nodejs",
    version: "16.4.0",
    date: "2021-06-23",
    lts: !1,
    security: !1,
    v8: "9.1.269.36"
  },
  {
    name: "nodejs",
    version: "16.5.0",
    date: "2021-07-14",
    lts: !1,
    security: !1,
    v8: "9.1.269.38"
  },
  {
    name: "nodejs",
    version: "16.6.0",
    date: "2021-07-29",
    lts: !1,
    security: !0,
    v8: "9.2.230.21"
  },
  {
    name: "nodejs",
    version: "16.7.0",
    date: "2021-08-18",
    lts: !1,
    security: !1,
    v8: "9.2.230.21"
  },
  {
    name: "nodejs",
    version: "16.8.0",
    date: "2021-08-25",
    lts: !1,
    security: !1,
    v8: "9.2.230.21"
  },
  {
    name: "nodejs",
    version: "16.9.0",
    date: "2021-09-07",
    lts: !1,
    security: !1,
    v8: "9.3.345.16"
  },
  {
    name: "nodejs",
    version: "16.10.0",
    date: "2021-09-22",
    lts: !1,
    security: !1,
    v8: "9.3.345.19"
  },
  {
    name: "nodejs",
    version: "16.11.0",
    date: "2021-10-08",
    lts: !1,
    security: !1,
    v8: "9.4.146.19"
  },
  {
    name: "nodejs",
    version: "16.12.0",
    date: "2021-10-20",
    lts: !1,
    security: !1,
    v8: "9.4.146.19"
  },
  {
    name: "nodejs",
    version: "16.13.0",
    date: "2021-10-26",
    lts: "Gallium",
    security: !1,
    v8: "9.4.146.19"
  },
  {
    name: "nodejs",
    version: "16.14.0",
    date: "2022-02-08",
    lts: "Gallium",
    security: !1,
    v8: "9.4.146.24"
  },
  {
    name: "nodejs",
    version: "16.15.0",
    date: "2022-04-26",
    lts: "Gallium",
    security: !1,
    v8: "9.4.146.24"
  },
  {
    name: "nodejs",
    version: "16.16.0",
    date: "2022-07-07",
    lts: "Gallium",
    security: !0,
    v8: "9.4.146.24"
  },
  {
    name: "nodejs",
    version: "16.17.0",
    date: "2022-08-16",
    lts: "Gallium",
    security: !1,
    v8: "9.4.146.26"
  },
  {
    name: "nodejs",
    version: "16.18.0",
    date: "2022-10-12",
    lts: "Gallium",
    security: !1,
    v8: "9.4.146.26"
  },
  {
    name: "nodejs",
    version: "16.19.0",
    date: "2022-12-13",
    lts: "Gallium",
    security: !1,
    v8: "9.4.146.26"
  },
  {
    name: "nodejs",
    version: "16.20.0",
    date: "2023-03-28",
    lts: "Gallium",
    security: !1,
    v8: "9.4.146.26"
  },
  {
    name: "nodejs",
    version: "17.0.0",
    date: "2021-10-19",
    lts: !1,
    security: !1,
    v8: "9.5.172.21"
  },
  {
    name: "nodejs",
    version: "17.1.0",
    date: "2021-11-09",
    lts: !1,
    security: !1,
    v8: "9.5.172.25"
  },
  {
    name: "nodejs",
    version: "17.2.0",
    date: "2021-11-30",
    lts: !1,
    security: !1,
    v8: "9.6.180.14"
  },
  {
    name: "nodejs",
    version: "17.3.0",
    date: "2021-12-17",
    lts: !1,
    security: !1,
    v8: "9.6.180.15"
  },
  {
    name: "nodejs",
    version: "17.4.0",
    date: "2022-01-18",
    lts: !1,
    security: !1,
    v8: "9.6.180.15"
  },
  {
    name: "nodejs",
    version: "17.5.0",
    date: "2022-02-10",
    lts: !1,
    security: !1,
    v8: "9.6.180.15"
  },
  {
    name: "nodejs",
    version: "17.6.0",
    date: "2022-02-22",
    lts: !1,
    security: !1,
    v8: "9.6.180.15"
  },
  {
    name: "nodejs",
    version: "17.7.0",
    date: "2022-03-09",
    lts: !1,
    security: !1,
    v8: "9.6.180.15"
  },
  {
    name: "nodejs",
    version: "17.8.0",
    date: "2022-03-22",
    lts: !1,
    security: !1,
    v8: "9.6.180.15"
  },
  {
    name: "nodejs",
    version: "17.9.0",
    date: "2022-04-07",
    lts: !1,
    security: !1,
    v8: "9.6.180.15"
  },
  {
    name: "nodejs",
    version: "18.0.0",
    date: "2022-04-18",
    lts: !1,
    security: !1,
    v8: "10.1.124.8"
  },
  {
    name: "nodejs",
    version: "18.1.0",
    date: "2022-05-03",
    lts: !1,
    security: !1,
    v8: "10.1.124.8"
  },
  {
    name: "nodejs",
    version: "18.2.0",
    date: "2022-05-17",
    lts: !1,
    security: !1,
    v8: "10.1.124.8"
  },
  {
    name: "nodejs",
    version: "18.3.0",
    date: "2022-06-02",
    lts: !1,
    security: !1,
    v8: "10.2.154.4"
  },
  {
    name: "nodejs",
    version: "18.4.0",
    date: "2022-06-16",
    lts: !1,
    security: !1,
    v8: "10.2.154.4"
  },
  {
    name: "nodejs",
    version: "18.5.0",
    date: "2022-07-06",
    lts: !1,
    security: !0,
    v8: "10.2.154.4"
  },
  {
    name: "nodejs",
    version: "18.6.0",
    date: "2022-07-13",
    lts: !1,
    security: !1,
    v8: "10.2.154.13"
  },
  {
    name: "nodejs",
    version: "18.7.0",
    date: "2022-07-26",
    lts: !1,
    security: !1,
    v8: "10.2.154.13"
  },
  {
    name: "nodejs",
    version: "18.8.0",
    date: "2022-08-24",
    lts: !1,
    security: !1,
    v8: "10.2.154.13"
  },
  {
    name: "nodejs",
    version: "18.9.0",
    date: "2022-09-07",
    lts: !1,
    security: !1,
    v8: "10.2.154.15"
  },
  {
    name: "nodejs",
    version: "18.10.0",
    date: "2022-09-28",
    lts: !1,
    security: !1,
    v8: "10.2.154.15"
  },
  {
    name: "nodejs",
    version: "18.11.0",
    date: "2022-10-13",
    lts: !1,
    security: !1,
    v8: "10.2.154.15"
  },
  {
    name: "nodejs",
    version: "18.12.0",
    date: "2022-10-25",
    lts: "Hydrogen",
    security: !1,
    v8: "10.2.154.15"
  },
  {
    name: "nodejs",
    version: "18.13.0",
    date: "2023-01-05",
    lts: "Hydrogen",
    security: !1,
    v8: "10.2.154.23"
  },
  {
    name: "nodejs",
    version: "18.14.0",
    date: "2023-02-01",
    lts: "Hydrogen",
    security: !1,
    v8: "10.2.154.23"
  },
  {
    name: "nodejs",
    version: "18.15.0",
    date: "2023-03-05",
    lts: "Hydrogen",
    security: !1,
    v8: "10.2.154.26"
  },
  {
    name: "nodejs",
    version: "18.16.0",
    date: "2023-04-12",
    lts: "Hydrogen",
    security: !1,
    v8: "10.2.154.26"
  },
  {
    name: "nodejs",
    version: "18.17.0",
    date: "2023-07-18",
    lts: "Hydrogen",
    security: !1,
    v8: "10.2.154.26"
  },
  {
    name: "nodejs",
    version: "18.18.0",
    date: "2023-09-18",
    lts: "Hydrogen",
    security: !1,
    v8: "10.2.154.26"
  },
  {
    name: "nodejs",
    version: "18.19.0",
    date: "2023-11-29",
    lts: "Hydrogen",
    security: !1,
    v8: "10.2.154.26"
  },
  {
    name: "nodejs",
    version: "18.20.0",
    date: "2024-03-26",
    lts: "Hydrogen",
    security: !1,
    v8: "10.2.154.26"
  },
  {
    name: "nodejs",
    version: "19.0.0",
    date: "2022-10-17",
    lts: !1,
    security: !1,
    v8: "10.7.193.13"
  },
  {
    name: "nodejs",
    version: "19.1.0",
    date: "2022-11-14",
    lts: !1,
    security: !1,
    v8: "10.7.193.20"
  },
  {
    name: "nodejs",
    version: "19.2.0",
    date: "2022-11-29",
    lts: !1,
    security: !1,
    v8: "10.8.168.20"
  },
  {
    name: "nodejs",
    version: "19.3.0",
    date: "2022-12-14",
    lts: !1,
    security: !1,
    v8: "10.8.168.21"
  },
  {
    name: "nodejs",
    version: "19.4.0",
    date: "2023-01-05",
    lts: !1,
    security: !1,
    v8: "10.8.168.25"
  },
  {
    name: "nodejs",
    version: "19.5.0",
    date: "2023-01-24",
    lts: !1,
    security: !1,
    v8: "10.8.168.25"
  },
  {
    name: "nodejs",
    version: "19.6.0",
    date: "2023-02-01",
    lts: !1,
    security: !1,
    v8: "10.8.168.25"
  },
  {
    name: "nodejs",
    version: "19.7.0",
    date: "2023-02-21",
    lts: !1,
    security: !1,
    v8: "10.8.168.25"
  },
  {
    name: "nodejs",
    version: "19.8.0",
    date: "2023-03-14",
    lts: !1,
    security: !1,
    v8: "10.8.168.25"
  },
  {
    name: "nodejs",
    version: "19.9.0",
    date: "2023-04-10",
    lts: !1,
    security: !1,
    v8: "10.8.168.25"
  },
  {
    name: "nodejs",
    version: "20.0.0",
    date: "2023-04-17",
    lts: !1,
    security: !1,
    v8: "11.3.244.4"
  },
  {
    name: "nodejs",
    version: "20.1.0",
    date: "2023-05-03",
    lts: !1,
    security: !1,
    v8: "11.3.244.8"
  },
  {
    name: "nodejs",
    version: "20.2.0",
    date: "2023-05-16",
    lts: !1,
    security: !1,
    v8: "11.3.244.8"
  },
  {
    name: "nodejs",
    version: "20.3.0",
    date: "2023-06-08",
    lts: !1,
    security: !1,
    v8: "11.3.244.8"
  },
  {
    name: "nodejs",
    version: "20.4.0",
    date: "2023-07-04",
    lts: !1,
    security: !1,
    v8: "11.3.244.8"
  },
  {
    name: "nodejs",
    version: "20.5.0",
    date: "2023-07-19",
    lts: !1,
    security: !1,
    v8: "11.3.244.8"
  },
  {
    name: "nodejs",
    version: "20.6.0",
    date: "2023-08-23",
    lts: !1,
    security: !1,
    v8: "11.3.244.8"
  },
  {
    name: "nodejs",
    version: "20.7.0",
    date: "2023-09-18",
    lts: !1,
    security: !1,
    v8: "11.3.244.8"
  },
  {
    name: "nodejs",
    version: "20.8.0",
    date: "2023-09-28",
    lts: !1,
    security: !1,
    v8: "11.3.244.8"
  },
  {
    name: "nodejs",
    version: "20.9.0",
    date: "2023-10-24",
    lts: "Iron",
    security: !1,
    v8: "11.3.244.8"
  },
  {
    name: "nodejs",
    version: "20.10.0",
    date: "2023-11-22",
    lts: "Iron",
    security: !1,
    v8: "11.3.244.8"
  },
  {
    name: "nodejs",
    version: "20.11.0",
    date: "2024-01-09",
    lts: "Iron",
    security: !1,
    v8: "11.3.244.8"
  },
  {
    name: "nodejs",
    version: "20.12.0",
    date: "2024-03-26",
    lts: "Iron",
    security: !1,
    v8: "11.3.244.8"
  },
  {
    name: "nodejs",
    version: "20.13.0",
    date: "2024-05-07",
    lts: "Iron",
    security: !1,
    v8: "11.3.244.8"
  },
  {
    name: "nodejs",
    version: "20.14.0",
    date: "2024-05-28",
    lts: "Iron",
    security: !1,
    v8: "11.3.244.8"
  },
  {
    name: "nodejs",
    version: "20.15.0",
    date: "2024-06-20",
    lts: "Iron",
    security: !1,
    v8: "11.3.244.8"
  },
  {
    name: "nodejs",
    version: "20.16.0",
    date: "2024-07-24",
    lts: "Iron",
    security: !1,
    v8: "11.3.244.8"
  },
  {
    name: "nodejs",
    version: "20.17.0",
    date: "2024-08-21",
    lts: "Iron",
    security: !1,
    v8: "11.3.244.8"
  },
  {
    name: "nodejs",
    version: "20.18.0",
    date: "2024-10-03",
    lts: "Iron",
    security: !1,
    v8: "11.3.244.8"
  },
  {
    name: "nodejs",
    version: "21.0.0",
    date: "2023-10-17",
    lts: !1,
    security: !1,
    v8: "11.8.172.13"
  },
  {
    name: "nodejs",
    version: "21.1.0",
    date: "2023-10-24",
    lts: !1,
    security: !1,
    v8: "11.8.172.15"
  },
  {
    name: "nodejs",
    version: "21.2.0",
    date: "2023-11-14",
    lts: !1,
    security: !1,
    v8: "11.8.172.17"
  },
  {
    name: "nodejs",
    version: "21.3.0",
    date: "2023-11-30",
    lts: !1,
    security: !1,
    v8: "11.8.172.17"
  },
  {
    name: "nodejs",
    version: "21.4.0",
    date: "2023-12-05",
    lts: !1,
    security: !1,
    v8: "11.8.172.17"
  },
  {
    name: "nodejs",
    version: "21.5.0",
    date: "2023-12-19",
    lts: !1,
    security: !1,
    v8: "11.8.172.17"
  },
  {
    name: "nodejs",
    version: "21.6.0",
    date: "2024-01-14",
    lts: !1,
    security: !1,
    v8: "11.8.172.17"
  },
  {
    name: "nodejs",
    version: "21.7.0",
    date: "2024-03-06",
    lts: !1,
    security: !1,
    v8: "11.8.172.17"
  },
  {
    name: "nodejs",
    version: "22.0.0",
    date: "2024-04-24",
    lts: !1,
    security: !1,
    v8: "12.4.254.14"
  },
  {
    name: "nodejs",
    version: "22.1.0",
    date: "2024-05-02",
    lts: !1,
    security: !1,
    v8: "12.4.254.14"
  },
  {
    name: "nodejs",
    version: "22.2.0",
    date: "2024-05-15",
    lts: !1,
    security: !1,
    v8: "12.4.254.14"
  },
  {
    name: "nodejs",
    version: "22.3.0",
    date: "2024-06-11",
    lts: !1,
    security: !1,
    v8: "12.4.254.20"
  },
  {
    name: "nodejs",
    version: "22.4.0",
    date: "2024-07-02",
    lts: !1,
    security: !1,
    v8: "12.4.254.21"
  },
  {
    name: "nodejs",
    version: "22.5.0",
    date: "2024-07-17",
    lts: !1,
    security: !1,
    v8: "12.4.254.21"
  },
  {
    name: "nodejs",
    version: "22.6.0",
    date: "2024-08-06",
    lts: !1,
    security: !1,
    v8: "12.4.254.21"
  },
  {
    name: "nodejs",
    version: "22.7.0",
    date: "2024-08-21",
    lts: !1,
    security: !1,
    v8: "12.4.254.21"
  },
  {
    name: "nodejs",
    version: "22.8.0",
    date: "2024-09-03",
    lts: !1,
    security: !1,
    v8: "12.4.254.21"
  },
  {
    name: "nodejs",
    version: "22.9.0",
    date: "2024-09-17",
    lts: !1,
    security: !1,
    v8: "12.4.254.21"
  },
  {
    name: "nodejs",
    version: "22.10.0",
    date: "2024-10-16",
    lts: !1,
    security: !1,
    v8: "12.4.254.21"
  },
  {
    name: "nodejs",
    version: "22.11.0",
    date: "2024-10-29",
    lts: "Jod",
    security: !1,
    v8: "12.4.254.21"
  },
  {
    name: "nodejs",
    version: "22.12.0",
    date: "2024-12-02",
    lts: "Jod",
    security: !1,
    v8: "12.4.254.21"
  },
  {
    name: "nodejs",
    version: "23.0.0",
    date: "2024-10-16",
    lts: !1,
    security: !1,
    v8: "12.9.202.26"
  },
  {
    name: "nodejs",
    version: "23.1.0",
    date: "2024-10-24",
    lts: !1,
    security: !1,
    v8: "12.9.202.28"
  },
  {
    name: "nodejs",
    version: "23.2.0",
    date: "2024-11-11",
    lts: !1,
    security: !1,
    v8: "12.9.202.28"
  },
  {
    name: "nodejs",
    version: "23.3.0",
    date: "2024-11-20",
    lts: !1,
    security: !1,
    v8: "12.9.202.28"
  }
];
var cp = {}, dp = {}, h6 = { A: "ie", B: "edge", C: "firefox", D: "chrome", E: "safari", F: "opera", G: "ios_saf", H: "op_mini", I: "android", J: "bb", K: "op_mob", L: "and_chr", M: "and_ff", N: "ie_mob", O: "and_uc", P: "samsung", Q: "and_qq", R: "baidu", S: "kaios" };
dp.browsers = h6;
var fp = {}, m6 = { 0: "22", 1: "23", 2: "24", 3: "25", 4: "26", 5: "27", 6: "115", 7: "116", 8: "117", 9: "118", A: "10", B: "11", C: "12", D: "7", E: "8", F: "9", G: "15", H: "80", I: "133", J: "4", K: "6", L: "13", M: "14", N: "16", O: "17", P: "18", Q: "79", R: "81", S: "83", T: "84", U: "85", V: "86", W: "87", X: "88", Y: "89", Z: "90", a: "91", b: "92", c: "93", d: "94", e: "95", f: "96", g: "97", h: "98", i: "99", j: "100", k: "101", l: "102", m: "103", n: "104", o: "105", p: "106", q: "107", r: "108", s: "109", t: "110", u: "111", v: "112", w: "113", x: "114", y: "20", z: "21", AB: "119", BB: "120", CB: "121", DB: "122", EB: "123", FB: "124", GB: "125", HB: "126", IB: "127", JB: "128", KB: "129", LB: "130", MB: "131", NB: "132", OB: "5", PB: "19", QB: "28", RB: "29", SB: "30", TB: "31", UB: "32", VB: "33", WB: "34", XB: "35", YB: "36", ZB: "37", aB: "38", bB: "39", cB: "40", dB: "41", eB: "42", fB: "43", gB: "44", hB: "45", iB: "46", jB: "47", kB: "48", lB: "49", mB: "50", nB: "51", oB: "52", pB: "53", qB: "54", rB: "55", sB: "56", tB: "57", uB: "58", vB: "60", wB: "62", xB: "63", yB: "64", zB: "65", "0B": "66", "1B": "67", "2B": "68", "3B": "69", "4B": "70", "5B": "71", "6B": "72", "7B": "73", "8B": "74", "9B": "75", AC: "76", BC: "77", CC: "78", DC: "135", EC: "11.1", FC: "12.1", GC: "15.5", HC: "16.0", IC: "17.0", JC: "18.0", KC: "3", LC: "59", MC: "61", NC: "82", OC: "134", PC: "136", QC: "3.2", RC: "10.1", SC: "15.2-15.3", TC: "15.4", UC: "16.1", VC: "16.2", WC: "16.3", XC: "16.4", YC: "16.5", ZC: "17.1", aC: "17.2", bC: "17.3", cC: "17.4", dC: "17.5", eC: "18.1", fC: "18.2", gC: "18.3", hC: "18.4", iC: "11.5", jC: "4.2-4.3", kC: "5.5", lC: "2", mC: "137", nC: "138", oC: "3.5", pC: "3.6", qC: "3.1", rC: "5.1", sC: "6.1", tC: "7.1", uC: "9.1", vC: "13.1", wC: "14.1", xC: "15.1", yC: "15.6", zC: "16.6", "0C": "17.6", "1C": "TP", "2C": "9.5-9.6", "3C": "10.0-10.1", "4C": "10.5", "5C": "10.6", "6C": "11.6", "7C": "4.0-4.1", "8C": "5.0-5.1", "9C": "6.0-6.1", AD: "7.0-7.1", BD: "8.1-8.4", CD: "9.0-9.2", DD: "9.3", ED: "10.0-10.2", FD: "10.3", GD: "11.0-11.2", HD: "11.3-11.4", ID: "12.0-12.1", JD: "12.2-12.5", KD: "13.0-13.1", LD: "13.2", MD: "13.3", ND: "13.4-13.7", OD: "14.0-14.4", PD: "14.5-14.8", QD: "15.0-15.1", RD: "15.6-15.8", SD: "16.6-16.7", TD: "17.6-17.7", UD: "all", VD: "2.1", WD: "2.2", XD: "2.3", YD: "4.1", ZD: "4.4", aD: "4.4.3-4.4.4", bD: "5.0-5.4", cD: "6.2-6.4", dD: "7.2-7.4", eD: "8.2", fD: "9.2", gD: "11.1-11.2", hD: "12.0", iD: "13.0", jD: "14.0", kD: "15.0", lD: "19.0", mD: "14.9", nD: "13.52", oD: "2.5", pD: "3.0-3.1" };
fp.browserVersions = m6;
var g6 = { A: { A: { K: 0, D: 0, E: 0, F: 0.0321964, A: 0, B: 0.418554, kC: 0 }, B: "ms", C: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "kC", "K", "D", "E", "F", "A", "B", "", "", ""], E: "IE", F: { kC: 962323200, K: 998870400, D: 1161129600, E: 1237420800, F: 1300060800, A: 1346716800, B: 1381968e3 } }, B: { A: { 6: 7212e-6, 7: 3606e-6, 8: 3606e-6, 9: 3606e-6, C: 0, L: 0, M: 0, G: 0, N: 0, O: 0, P: 0.093756, Q: 0, H: 0, R: 0, S: 0, T: 0, U: 0, V: 0, W: 0, X: 0, Y: 0, Z: 0, a: 0, b: 0.010818, c: 0, d: 0, e: 0, f: 0, g: 0, h: 0, i: 0, j: 0, k: 0, l: 0, m: 0, n: 0, o: 0, p: 0, q: 0, r: 3606e-6, s: 0.050484, t: 0, u: 0, v: 0, w: 7212e-6, x: 0.010818, AB: 3606e-6, BB: 0.025242, CB: 7212e-6, DB: 0.014424, EB: 7212e-6, FB: 7212e-6, GB: 7212e-6, HB: 0.021636, IB: 0.01803, JB: 0.014424, KB: 0.01803, LB: 0.043272, MB: 0.151452, NB: 1.92921, I: 2.56747 }, B: "webkit", C: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "C", "L", "M", "G", "N", "O", "P", "Q", "H", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "6", "7", "8", "9", "AB", "BB", "CB", "DB", "EB", "FB", "GB", "HB", "IB", "JB", "KB", "LB", "MB", "NB", "I", "", "", ""], E: "Edge", F: { 6: 1689897600, 7: 1692576e3, 8: 1694649600, 9: 1697155200, C: 1438128e3, L: 1447286400, M: 1470096e3, G: 1491868800, N: 1508198400, O: 1525046400, P: 1542067200, Q: 1579046400, H: 1581033600, R: 1586736e3, S: 1590019200, T: 1594857600, U: 1598486400, V: 1602201600, W: 1605830400, X: 161136e4, Y: 1614816e3, Z: 1618358400, a: 1622073600, b: 1626912e3, c: 1630627200, d: 1632441600, e: 1634774400, f: 1637539200, g: 1641427200, h: 1643932800, i: 1646265600, j: 1649635200, k: 1651190400, l: 1653955200, m: 1655942400, n: 1659657600, o: 1661990400, p: 1664755200, q: 1666915200, r: 1670198400, s: 1673481600, t: 1675900800, u: 1678665600, v: 1680825600, w: 1683158400, x: 1685664e3, AB: 1698969600, BB: 1701993600, CB: 1706227200, DB: 1708732800, EB: 1711152e3, FB: 1713398400, GB: 1715990400, HB: 1718841600, IB: 1721865600, JB: 1724371200, KB: 1726704e3, LB: 1729123200, MB: 1731542400, NB: 1737417600, I: 1740614400 }, D: { C: "ms", L: "ms", M: "ms", G: "ms", N: "ms", O: "ms", P: "ms" } }, C: { A: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0.241602, 7: 0, 8: 0, 9: 0.104574, lC: 0, KC: 0, J: 0, OB: 0, K: 0, D: 0, E: 0, F: 0, A: 0, B: 0.021636, C: 0, L: 0, M: 0, G: 0, N: 0, O: 0, P: 0, PB: 0, y: 0, z: 0, QB: 0, RB: 0, SB: 0, TB: 0, UB: 0, VB: 0, WB: 0, XB: 0, YB: 0, ZB: 0, aB: 0, bB: 0, cB: 0, dB: 0, eB: 0, fB: 3606e-6, gB: 3606e-6, hB: 0, iB: 0, jB: 0, kB: 0, lB: 0, mB: 0, nB: 0, oB: 0.028848, pB: 7212e-6, qB: 0, rB: 3606e-6, sB: 0.010818, tB: 0, uB: 0, LC: 3606e-6, vB: 0, MC: 0, wB: 0, xB: 0, yB: 0, zB: 0, "0B": 0, "1B": 0, "2B": 0, "3B": 0, "4B": 0, "5B": 0, "6B": 0, "7B": 0, "8B": 0, "9B": 0, AC: 0, BC: 0, CC: 0.010818, Q: 0, H: 0, R: 0, NC: 0, S: 0, T: 0, U: 0, V: 0, W: 0, X: 3606e-6, Y: 0, Z: 0, a: 0, b: 0, c: 0, d: 0, e: 0, f: 0, g: 0, h: 0, i: 0, j: 0, k: 0, l: 0, m: 0, n: 0, o: 0, p: 0, q: 0, r: 0, s: 3606e-6, t: 0, u: 0, v: 0, w: 3606e-6, x: 0, AB: 0, BB: 3606e-6, CB: 0, DB: 0, EB: 0, FB: 0, GB: 0.021636, HB: 0, IB: 7212e-6, JB: 0.079332, KB: 3606e-6, LB: 3606e-6, MB: 7212e-6, NB: 0.014424, I: 0.028848, OC: 0.385842, DC: 1.17556, PC: 7212e-6, mC: 0, nC: 0, oC: 0, pC: 0 }, B: "moz", C: ["lC", "KC", "oC", "pC", "J", "OB", "K", "D", "E", "F", "A", "B", "C", "L", "M", "G", "N", "O", "P", "PB", "y", "z", "0", "1", "2", "3", "4", "5", "QB", "RB", "SB", "TB", "UB", "VB", "WB", "XB", "YB", "ZB", "aB", "bB", "cB", "dB", "eB", "fB", "gB", "hB", "iB", "jB", "kB", "lB", "mB", "nB", "oB", "pB", "qB", "rB", "sB", "tB", "uB", "LC", "vB", "MC", "wB", "xB", "yB", "zB", "0B", "1B", "2B", "3B", "4B", "5B", "6B", "7B", "8B", "9B", "AC", "BC", "CC", "Q", "H", "R", "NC", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "6", "7", "8", "9", "AB", "BB", "CB", "DB", "EB", "FB", "GB", "HB", "IB", "JB", "KB", "LB", "MB", "NB", "I", "OC", "DC", "PC", "mC", "nC"], E: "Firefox", F: { 0: 1368489600, 1: 1372118400, 2: 1375747200, 3: 1379376e3, 4: 1386633600, 5: 1391472e3, 6: 1688428800, 7: 1690848e3, 8: 1693267200, 9: 1695686400, lC: 1161648e3, KC: 1213660800, oC: 124632e4, pC: 1264032e3, J: 1300752e3, OB: 1308614400, K: 1313452800, D: 1317081600, E: 1317081600, F: 1320710400, A: 1324339200, B: 1327968e3, C: 1331596800, L: 1335225600, M: 1338854400, G: 1342483200, N: 1346112e3, O: 1349740800, P: 1353628800, PB: 1357603200, y: 1361232e3, z: 1364860800, QB: 1395100800, RB: 1398729600, SB: 1402358400, TB: 1405987200, UB: 1409616e3, VB: 1413244800, WB: 1417392e3, XB: 1421107200, YB: 1424736e3, ZB: 1428278400, aB: 1431475200, bB: 1435881600, cB: 1439251200, dB: 144288e4, eB: 1446508800, fB: 1450137600, gB: 1453852800, hB: 1457395200, iB: 1461628800, jB: 1465257600, kB: 1470096e3, lB: 1474329600, mB: 1479168e3, nB: 1485216e3, oB: 1488844800, pB: 149256e4, qB: 1497312e3, rB: 1502150400, sB: 1506556800, tB: 1510617600, uB: 1516665600, LC: 1520985600, vB: 1525824e3, MC: 1529971200, wB: 1536105600, xB: 1540252800, yB: 1544486400, zB: 154872e4, "0B": 1552953600, "1B": 1558396800, "2B": 1562630400, "3B": 1567468800, "4B": 1571788800, "5B": 1575331200, "6B": 1578355200, "7B": 1581379200, "8B": 1583798400, "9B": 1586304e3, AC: 1588636800, BC: 1591056e3, CC: 1593475200, Q: 1595894400, H: 1598313600, R: 1600732800, NC: 1603152e3, S: 1605571200, T: 1607990400, U: 1611619200, V: 1614038400, W: 1616457600, X: 1618790400, Y: 1622505600, Z: 1626134400, a: 1628553600, b: 1630972800, c: 1633392e3, d: 1635811200, e: 1638835200, f: 1641859200, g: 1644364800, h: 1646697600, i: 1649116800, j: 1651536e3, k: 1653955200, l: 1656374400, m: 1658793600, n: 1661212800, o: 1663632e3, p: 1666051200, q: 1668470400, r: 1670889600, s: 1673913600, t: 1676332800, u: 1678752e3, v: 1681171200, w: 1683590400, x: 1686009600, AB: 1698105600, BB: 1700524800, CB: 1702944e3, DB: 1705968e3, EB: 1708387200, FB: 1710806400, GB: 1713225600, HB: 1715644800, IB: 1718064e3, JB: 1720483200, KB: 1722902400, LB: 1725321600, MB: 1727740800, NB: 173016e4, I: 1732579200, OC: 1736208e3, DC: 1738627200, PC: null, mC: null, nC: null } }, D: { A: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0.028848, 7: 0.111786, 8: 0.068514, 9: 0.05409, J: 0, OB: 0, K: 0, D: 0, E: 0, F: 0, A: 0, B: 0, C: 0, L: 0, M: 0, G: 0, N: 0, O: 0, P: 0, PB: 0, y: 0, z: 0, QB: 0, RB: 0, SB: 0, TB: 0, UB: 0, VB: 0, WB: 0, XB: 0, YB: 0, ZB: 0, aB: 7212e-6, bB: 0, cB: 0, dB: 3606e-6, eB: 0, fB: 0, gB: 0, hB: 3606e-6, iB: 0, jB: 3606e-6, kB: 0.014424, lB: 0.014424, mB: 0.01803, nB: 0, oB: 7212e-6, pB: 7212e-6, qB: 0, rB: 0, sB: 0.014424, tB: 3606e-6, uB: 7212e-6, LC: 0, vB: 0, MC: 0, wB: 0, xB: 0, yB: 0, zB: 0, "0B": 0.01803, "1B": 0, "2B": 0, "3B": 7212e-6, "4B": 0.010818, "5B": 0, "6B": 0, "7B": 7212e-6, "8B": 3606e-6, "9B": 3606e-6, AC: 3606e-6, BC: 0.014424, CC: 0.010818, Q: 0.079332, H: 0.010818, R: 0.025242, S: 0.032454, T: 3606e-6, U: 7212e-6, V: 0.01803, W: 0.068514, X: 0.014424, Y: 3606e-6, Z: 7212e-6, a: 0.039666, b: 7212e-6, c: 0.014424, d: 0.028848, e: 7212e-6, f: 7212e-6, g: 0.01803, h: 0.03606, i: 0.014424, j: 7212e-6, k: 0.014424, l: 0.010818, m: 0.082938, n: 0.082938, o: 0.010818, p: 0.021636, q: 0.025242, r: 0.039666, s: 1.02771, t: 0.01803, u: 0.032454, v: 0.046878, w: 0.12621, x: 0.082938, AB: 0.039666, BB: 0.061302, CB: 0.10818, DB: 0.075726, EB: 0.086544, FB: 0.133422, GB: 0.494022, HB: 0.436326, IB: 0.155058, JB: 0.140634, KB: 0.115392, LB: 0.16227, MB: 1.38831, NB: 7.9909, I: 7.16873, OC: 0.014424, DC: 0.014424, PC: 0 }, B: "webkit", C: ["", "", "", "", "", "", "", "J", "OB", "K", "D", "E", "F", "A", "B", "C", "L", "M", "G", "N", "O", "P", "PB", "y", "z", "0", "1", "2", "3", "4", "5", "QB", "RB", "SB", "TB", "UB", "VB", "WB", "XB", "YB", "ZB", "aB", "bB", "cB", "dB", "eB", "fB", "gB", "hB", "iB", "jB", "kB", "lB", "mB", "nB", "oB", "pB", "qB", "rB", "sB", "tB", "uB", "LC", "vB", "MC", "wB", "xB", "yB", "zB", "0B", "1B", "2B", "3B", "4B", "5B", "6B", "7B", "8B", "9B", "AC", "BC", "CC", "Q", "H", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "6", "7", "8", "9", "AB", "BB", "CB", "DB", "EB", "FB", "GB", "HB", "IB", "JB", "KB", "LB", "MB", "NB", "I", "OC", "DC", "PC"], E: "Chrome", F: { 0: 1343692800, 1: 1348531200, 2: 1352246400, 3: 1357862400, 4: 1361404800, 5: 1364428800, 6: 1689724800, 7: 1692057600, 8: 1694476800, 9: 1696896e3, J: 1264377600, OB: 1274745600, K: 1283385600, D: 1287619200, E: 1291248e3, F: 1296777600, A: 1299542400, B: 1303862400, C: 1307404800, L: 1312243200, M: 1316131200, G: 1316131200, N: 1319500800, O: 1323734400, P: 1328659200, PB: 1332892800, y: 133704e4, z: 1340668800, QB: 1369094400, RB: 1374105600, SB: 1376956800, TB: 1384214400, UB: 1389657600, VB: 1392940800, WB: 1397001600, XB: 1400544e3, YB: 1405468800, ZB: 1409011200, aB: 141264e4, bB: 1416268800, cB: 1421798400, dB: 1425513600, eB: 1429401600, fB: 143208e4, gB: 1437523200, hB: 1441152e3, iB: 1444780800, jB: 1449014400, kB: 1453248e3, lB: 1456963200, mB: 1460592e3, nB: 1464134400, oB: 1469059200, pB: 1472601600, qB: 1476230400, rB: 1480550400, sB: 1485302400, tB: 1489017600, uB: 149256e4, LC: 1496707200, vB: 1500940800, MC: 1504569600, wB: 1508198400, xB: 1512518400, yB: 1516752e3, zB: 1520294400, "0B": 1523923200, "1B": 1527552e3, "2B": 1532390400, "3B": 1536019200, "4B": 1539648e3, "5B": 1543968e3, "6B": 154872e4, "7B": 1552348800, "8B": 1555977600, "9B": 1559606400, AC: 1564444800, BC: 1568073600, CC: 1571702400, Q: 1575936e3, H: 1580860800, R: 1586304e3, S: 1589846400, T: 1594684800, U: 1598313600, V: 1601942400, W: 1605571200, X: 1611014400, Y: 1614556800, Z: 1618272e3, a: 1621987200, b: 1626739200, c: 1630368e3, d: 1632268800, e: 1634601600, f: 1637020800, g: 1641340800, h: 1643673600, i: 1646092800, j: 1648512e3, k: 1650931200, l: 1653350400, m: 1655769600, n: 1659398400, o: 1661817600, p: 1664236800, q: 1666656e3, r: 166968e4, s: 1673308800, t: 1675728e3, u: 1678147200, v: 1680566400, w: 1682985600, x: 1685404800, AB: 1698710400, BB: 1701993600, CB: 1705968e3, DB: 1708387200, EB: 1710806400, FB: 1713225600, GB: 1715644800, HB: 1718064e3, IB: 1721174400, JB: 1724112e3, KB: 1726531200, LB: 1728950400, MB: 1731369600, NB: 1736812800, I: 1738627200, OC: null, DC: null, PC: null } }, E: { A: { J: 0, OB: 0, K: 0, D: 0, E: 3606e-6, F: 0, A: 0, B: 0, C: 0, L: 0, M: 0.01803, G: 3606e-6, qC: 0, QC: 0, rC: 0, sC: 0, tC: 0, uC: 0, RC: 0, EC: 3606e-6, FC: 7212e-6, vC: 0.03606, wC: 0.050484, xC: 0.010818, SC: 7212e-6, TC: 0.014424, GC: 0.01803, yC: 0.16227, HC: 0.028848, UC: 0.025242, VC: 0.01803, WC: 0.046878, XC: 0.01803, YC: 0.028848, zC: 0.219966, IC: 0.010818, ZC: 0.093756, aC: 0.021636, bC: 0.025242, cC: 0.061302, dC: 0.115392, "0C": 0.338964, JC: 0.05409, eC: 0.454356, fC: 0.176694, gC: 0.858228, hC: 0, "1C": 0 }, B: "webkit", C: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "qC", "QC", "J", "OB", "rC", "K", "sC", "D", "tC", "E", "F", "uC", "A", "RC", "B", "EC", "C", "FC", "L", "vC", "M", "wC", "G", "xC", "SC", "TC", "GC", "yC", "HC", "UC", "VC", "WC", "XC", "YC", "zC", "IC", "ZC", "aC", "bC", "cC", "dC", "0C", "JC", "eC", "fC", "gC", "hC", "1C", ""], E: "Safari", F: { qC: 1205798400, QC: 1226534400, J: 1244419200, OB: 1275868800, rC: 131112e4, K: 1343174400, sC: 13824e5, D: 13824e5, tC: 1410998400, E: 1413417600, F: 1443657600, uC: 1458518400, A: 1474329600, RC: 1490572800, B: 1505779200, EC: 1522281600, C: 1537142400, FC: 1553472e3, L: 1568851200, vC: 1585008e3, M: 1600214400, wC: 1619395200, G: 1632096e3, xC: 1635292800, SC: 1639353600, TC: 1647216e3, GC: 1652745600, yC: 1658275200, HC: 1662940800, UC: 1666569600, VC: 1670889600, WC: 1674432e3, XC: 1679875200, YC: 1684368e3, zC: 1690156800, IC: 1695686400, ZC: 1698192e3, aC: 1702252800, bC: 1705881600, cC: 1709596800, dC: 1715558400, "0C": 1722211200, JC: 1726444800, eC: 1730073600, fC: 1733875200, gC: 1737936e3, hC: null, "1C": null } }, F: { A: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, F: 0, B: 0, C: 0, G: 0, N: 0, O: 0, P: 0, PB: 0, y: 0, z: 0, QB: 0, RB: 0, SB: 0, TB: 0, UB: 0, VB: 0, WB: 0, XB: 0, YB: 0, ZB: 0, aB: 0, bB: 0, cB: 3606e-6, dB: 0, eB: 0, fB: 0, gB: 0, hB: 0, iB: 0.010818, jB: 0, kB: 0, lB: 0, mB: 0, nB: 0, oB: 0, pB: 0, qB: 0, rB: 0, sB: 0, tB: 0, uB: 0, vB: 0, wB: 0, xB: 0, yB: 0, zB: 0, "0B": 0, "1B": 0, "2B": 0, "3B": 0, "4B": 0, "5B": 0, "6B": 0, "7B": 0, "8B": 0, "9B": 0, AC: 0, BC: 0, CC: 0, Q: 0, H: 0, R: 0, NC: 0, S: 0, T: 0, U: 0, V: 3606e-6, W: 0.039666, X: 0, Y: 0, Z: 0, a: 0, b: 0, c: 0, d: 0, e: 0.03606, f: 0, g: 0, h: 0, i: 0, j: 0, k: 0, l: 0.010818, m: 0, n: 0, o: 0, p: 0, q: 0, r: 0, s: 0, t: 0, u: 0, v: 0, w: 0, x: 0.068514, "2C": 0, "3C": 0, "4C": 0, "5C": 0, EC: 0, iC: 0, "6C": 0, FC: 0 }, B: "webkit", C: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "F", "2C", "3C", "4C", "5C", "B", "EC", "iC", "6C", "C", "FC", "G", "N", "O", "P", "PB", "y", "z", "0", "1", "2", "3", "4", "5", "QB", "RB", "SB", "TB", "UB", "VB", "WB", "XB", "YB", "ZB", "aB", "bB", "cB", "dB", "eB", "fB", "gB", "hB", "iB", "jB", "kB", "lB", "mB", "nB", "oB", "pB", "qB", "rB", "sB", "tB", "uB", "vB", "wB", "xB", "yB", "zB", "0B", "1B", "2B", "3B", "4B", "5B", "6B", "7B", "8B", "9B", "AC", "BC", "CC", "Q", "H", "R", "NC", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "", "", ""], E: "Opera", F: { 0: 1401753600, 1: 1405987200, 2: 1409616e3, 3: 1413331200, 4: 1417132800, 5: 1422316800, F: 1150761600, "2C": 1223424e3, "3C": 1251763200, "4C": 1267488e3, "5C": 1277942400, B: 1292457600, EC: 1302566400, iC: 1309219200, "6C": 1323129600, C: 1323129600, FC: 1352073600, G: 1372723200, N: 1377561600, O: 1381104e3, P: 1386288e3, PB: 1390867200, y: 1393891200, z: 1399334400, QB: 1425945600, RB: 1430179200, SB: 1433808e3, TB: 1438646400, UB: 1442448e3, VB: 1445904e3, WB: 1449100800, XB: 1454371200, YB: 1457308800, ZB: 146232e4, aB: 1465344e3, bB: 1470096e3, cB: 1474329600, dB: 1477267200, eB: 1481587200, fB: 1486425600, gB: 1490054400, hB: 1494374400, iB: 1498003200, jB: 1502236800, kB: 1506470400, lB: 1510099200, mB: 1515024e3, nB: 1517961600, oB: 1521676800, pB: 1525910400, qB: 1530144e3, rB: 1534982400, sB: 1537833600, tB: 1543363200, uB: 1548201600, vB: 1554768e3, wB: 1561593600, xB: 1566259200, yB: 1570406400, zB: 1573689600, "0B": 1578441600, "1B": 1583971200, "2B": 1587513600, "3B": 1592956800, "4B": 1595894400, "5B": 1600128e3, "6B": 1603238400, "7B": 161352e4, "8B": 1612224e3, "9B": 1616544e3, AC: 1619568e3, BC: 1623715200, CC: 1627948800, Q: 1631577600, H: 1633392e3, R: 1635984e3, NC: 1638403200, S: 1642550400, T: 1644969600, U: 1647993600, V: 1650412800, W: 1652745600, X: 1654646400, Y: 1657152e3, Z: 1660780800, a: 1663113600, b: 1668816e3, c: 1668643200, d: 1671062400, e: 1675209600, f: 1677024e3, g: 1679529600, h: 1681948800, i: 1684195200, j: 1687219200, k: 1690329600, l: 1692748800, m: 1696204800, n: 169992e4, o: 169992e4, p: 1702944e3, q: 1707264e3, r: 1710115200, s: 1711497600, t: 1716336e3, u: 1719273600, v: 1721088e3, w: 1724284800, x: 1727222400 }, D: { F: "o", B: "o", C: "o", "2C": "o", "3C": "o", "4C": "o", "5C": "o", EC: "o", iC: "o", "6C": "o", FC: "o" } }, G: { A: { E: 0, QC: 0, "7C": 0, jC: 294636e-8, "8C": 147318e-8, "9C": 883907e-8, AD: 736589e-8, BD: 0, CD: 294636e-8, DD: 0.0220977, ED: 294636e-8, FD: 0.0324099, GD: 0.117854, HD: 0.0103122, ID: 589271e-8, JD: 0.156157, KD: 294636e-8, LD: 589271e-8, MD: 589271e-8, ND: 0.0220977, OD: 0.122274, PD: 0.066293, QD: 0.0353563, SC: 0.0353563, TC: 0.0427222, GC: 0.0486149, RD: 0.599583, HC: 0.0869175, UC: 0.181201, VC: 0.091337, WC: 0.163523, XC: 0.0353563, YC: 0.0677662, SD: 0.713018, IC: 0.0441953, ZC: 0.0780784, aC: 0.0604003, bC: 0.0869175, cC: 0.179728, dC: 0.425748, TD: 1.39805, JC: 0.411017, eC: 3.78017, fC: 1.21537, gC: 4.33409, hC: 883907e-8 }, B: "webkit", C: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "QC", "7C", "jC", "8C", "9C", "AD", "E", "BD", "CD", "DD", "ED", "FD", "GD", "HD", "ID", "JD", "KD", "LD", "MD", "ND", "OD", "PD", "QD", "SC", "TC", "GC", "RD", "HC", "UC", "VC", "WC", "XC", "YC", "SD", "IC", "ZC", "aC", "bC", "cC", "dC", "TD", "JC", "eC", "fC", "gC", "hC", "", ""], E: "Safari on iOS", F: { QC: 1270252800, "7C": 1283904e3, jC: 1299628800, "8C": 1331078400, "9C": 1359331200, AD: 1394409600, E: 1410912e3, BD: 1413763200, CD: 1442361600, DD: 1458518400, ED: 1473724800, FD: 1490572800, GD: 1505779200, HD: 1522281600, ID: 1537142400, JD: 1553472e3, KD: 1568851200, LD: 1572220800, MD: 1580169600, ND: 1585008e3, OD: 1600214400, PD: 1619395200, QD: 1632096e3, SC: 1639353600, TC: 1647216e3, GC: 1652659200, RD: 1658275200, HC: 1662940800, UC: 1666569600, VC: 1670889600, WC: 1674432e3, XC: 1679875200, YC: 1684368e3, SD: 1690156800, IC: 1694995200, ZC: 1698192e3, aC: 1702252800, bC: 1705881600, cC: 1709596800, dC: 1715558400, TD: 1722211200, JC: 1726444800, eC: 1730073600, fC: 1733875200, gC: 1737936e3, hC: null } }, H: { A: { UD: 0.04 }, B: "o", C: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "UD", "", "", ""], E: "Opera Mini", F: { UD: 1426464e3 } }, I: { A: { KC: 0, J: 0, I: 0.682721, VD: 0, WD: 0, XD: 0, YD: 0, jC: 136832e-9, ZD: 0, aD: 82099e-8 }, B: "webkit", C: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "VD", "WD", "XD", "KC", "J", "YD", "jC", "ZD", "aD", "I", "", "", ""], E: "Android Browser", F: { VD: 1256515200, WD: 1274313600, XD: 1291593600, KC: 1298332800, J: 1318896e3, YD: 1341792e3, jC: 1374624e3, ZD: 1386547200, aD: 1401667200, I: 1740441600 } }, J: { A: { D: 0, A: 0 }, B: "webkit", C: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "D", "A", "", "", ""], E: "Blackberry Browser", F: { D: 1325376e3, A: 1359504e3 } }, K: { A: { A: 0, B: 0, C: 0, H: 1.00862, EC: 0, iC: 0, FC: 0 }, B: "o", C: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "A", "B", "EC", "iC", "C", "FC", "H", "", "", ""], E: "Opera Mobile", F: { A: 1287100800, B: 1300752e3, EC: 1314835200, iC: 1318291200, C: 1330300800, FC: 1349740800, H: 1709769600 }, D: { H: "webkit" } }, L: { A: { I: 45.4281 }, B: "webkit", C: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "I", "", "", ""], E: "Chrome for Android", F: { I: 1740441600 } }, M: { A: { DC: 0.345276 }, B: "moz", C: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "DC", "", "", ""], E: "Firefox for Android", F: { DC: 1738627200 } }, N: { A: { A: 0, B: 0 }, B: "ms", C: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "A", "B", "", "", ""], E: "IE Mobile", F: { A: 1340150400, B: 1353456e3 } }, O: { A: { GC: 0.844008 }, B: "webkit", C: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "GC", "", "", ""], E: "UC Browser for Android", F: { GC: 1710115200 }, D: { GC: "webkit" } }, P: { A: { 0: 0.0329859, 1: 0.0329859, 2: 0.0439812, 3: 0.0439812, 4: 0.0989576, 5: 1.97915, J: 0.0659717, y: 0, z: 0.0219906, bD: 0, cD: 0, dD: 0.0219906, eD: 0, fD: 0, RC: 0, gD: 0, hD: 0, iD: 0, jD: 0, kD: 0, HC: 0, IC: 0.0109953, JC: 0, lD: 0 }, B: "webkit", C: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "J", "bD", "cD", "dD", "eD", "fD", "RC", "gD", "hD", "iD", "jD", "kD", "HC", "IC", "JC", "lD", "y", "z", "0", "1", "2", "3", "4", "5", "", "", ""], E: "Samsung Internet", F: { 0: 1689292800, 1: 1697587200, 2: 1711497600, 3: 1715126400, 4: 1717718400, 5: 1725667200, J: 1461024e3, bD: 1481846400, cD: 1509408e3, dD: 1528329600, eD: 1546128e3, fD: 1554163200, RC: 1567900800, gD: 1582588800, hD: 1593475200, iD: 1605657600, jD: 1618531200, kD: 1629072e3, HC: 1640736e3, IC: 1651708800, JC: 1659657600, lD: 1667260800, y: 1677369600, z: 1684454400 } }, Q: { A: { mD: 0.204608 }, B: "webkit", C: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "mD", "", "", ""], E: "QQ Browser", F: { mD: 1710288e3 } }, R: { A: { nD: 0 }, B: "webkit", C: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "nD", "", "", ""], E: "Baidu Browser", F: { nD: 1710201600 } }, S: { A: { oD: 0.019182, pD: 0 }, B: "moz", C: ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "oD", "pD", "", "", ""], E: "KaiOS Browser", F: { oD: 1527811200, pD: 1631664e3 } } };
const y6 = dp.browsers, _s = fp.browserVersions, Vf = g6;
function Yf(e) {
  return Object.keys(e).reduce((t, r) => (t[_s[r]] = e[r], t), {});
}
cp.agents = Object.keys(Vf).reduce((e, t) => {
  let r = Vf[t];
  return e[y6[t]] = Object.keys(r).reduce((n, a) => (a === "A" ? n.usage_global = Yf(r[a]) : a === "C" ? n.versions = r[a].reduce((u, i) => (i === "" ? u.push(null) : u.push(_s[i]), u), []) : a === "D" ? n.prefix_exceptions = Yf(r[a]) : a === "E" ? n.browser = r[a] : a === "F" ? n.release_date = Object.keys(r[a]).reduce(
    (u, i) => (u[_s[i]] = r[a][i], u),
    {}
  ) : n.prefix = r[a], n), {}), e;
}, {});
var v6 = {
  "0.20": "39",
  "0.21": "41",
  "0.22": "41",
  "0.23": "41",
  "0.24": "41",
  "0.25": "42",
  "0.26": "42",
  "0.27": "43",
  "0.28": "43",
  "0.29": "43",
  "0.30": "44",
  "0.31": "45",
  "0.32": "45",
  "0.33": "45",
  "0.34": "45",
  "0.35": "45",
  "0.36": "47",
  "0.37": "49",
  "1.0": "49",
  "1.1": "50",
  "1.2": "51",
  "1.3": "52",
  "1.4": "53",
  "1.5": "54",
  "1.6": "56",
  "1.7": "58",
  "1.8": "59",
  "2.0": "61",
  "2.1": "61",
  "3.0": "66",
  "3.1": "66",
  "4.0": "69",
  "4.1": "69",
  "4.2": "69",
  "5.0": "73",
  "6.0": "76",
  "6.1": "76",
  "7.0": "78",
  "7.1": "78",
  "7.2": "78",
  "7.3": "78",
  "8.0": "80",
  "8.1": "80",
  "8.2": "80",
  "8.3": "80",
  "8.4": "80",
  "8.5": "80",
  "9.0": "83",
  "9.1": "83",
  "9.2": "83",
  "9.3": "83",
  "9.4": "83",
  "10.0": "85",
  "10.1": "85",
  "10.2": "85",
  "10.3": "85",
  "10.4": "85",
  "11.0": "87",
  "11.1": "87",
  "11.2": "87",
  "11.3": "87",
  "11.4": "87",
  "11.5": "87",
  "12.0": "89",
  "12.1": "89",
  "12.2": "89",
  "13.0": "91",
  "13.1": "91",
  "13.2": "91",
  "13.3": "91",
  "13.4": "91",
  "13.5": "91",
  "13.6": "91",
  "14.0": "93",
  "14.1": "93",
  "14.2": "93",
  "15.0": "94",
  "15.1": "94",
  "15.2": "94",
  "15.3": "94",
  "15.4": "94",
  "15.5": "94",
  "16.0": "96",
  "16.1": "96",
  "16.2": "96",
  "17.0": "98",
  "17.1": "98",
  "17.2": "98",
  "17.3": "98",
  "17.4": "98",
  "18.0": "100",
  "18.1": "100",
  "18.2": "100",
  "18.3": "100",
  "19.0": "102",
  "19.1": "102",
  "20.0": "104",
  "20.1": "104",
  "20.2": "104",
  "20.3": "104",
  "21.0": "106",
  "21.1": "106",
  "21.2": "106",
  "21.3": "106",
  "21.4": "106",
  "22.0": "108",
  "22.1": "108",
  "22.2": "108",
  "22.3": "108",
  "23.0": "110",
  "23.1": "110",
  "23.2": "110",
  "23.3": "110",
  "24.0": "112",
  "24.1": "112",
  "24.2": "112",
  "24.3": "112",
  "24.4": "112",
  "24.5": "112",
  "24.6": "112",
  "24.7": "112",
  "24.8": "112",
  "25.0": "114",
  "25.1": "114",
  "25.2": "114",
  "25.3": "114",
  "25.4": "114",
  "25.5": "114",
  "25.6": "114",
  "25.7": "114",
  "25.8": "114",
  "25.9": "114",
  "26.0": "116",
  "26.1": "116",
  "26.2": "116",
  "26.3": "116",
  "26.4": "116",
  "26.5": "116",
  "26.6": "116",
  "27.0": "118",
  "27.1": "118",
  "27.2": "118",
  "27.3": "118",
  "28.0": "120",
  "28.1": "120",
  "28.2": "120",
  "28.3": "120",
  "29.0": "122",
  "29.1": "122",
  "29.2": "122",
  "29.3": "122",
  "29.4": "122",
  "30.0": "124",
  "30.1": "124",
  "30.2": "124",
  "30.3": "124",
  "30.4": "124",
  "30.5": "124",
  "31.0": "126",
  "31.1": "126",
  "31.2": "126",
  "31.3": "126",
  "31.4": "126",
  "31.5": "126",
  "31.6": "126",
  "31.7": "126",
  "32.0": "128",
  "32.1": "128",
  "32.2": "128",
  "32.3": "128",
  "33.0": "130",
  "33.1": "130",
  "33.2": "130",
  "33.3": "130",
  "33.4": "130",
  "34.0": "132",
  "34.1": "132",
  "34.2": "132",
  "34.3": "132",
  "35.0": "134",
  "36.0": "136"
};
const b6 = {
  start: "2015-09-08",
  lts: "2015-10-12",
  maintenance: "2017-04-01",
  end: "2018-04-30",
  codename: "Argon"
}, _6 = {
  start: "2015-10-29",
  maintenance: "2016-04-30",
  end: "2016-06-30"
}, S6 = {
  start: "2016-04-26",
  lts: "2016-10-18",
  maintenance: "2018-04-30",
  end: "2019-04-30",
  codename: "Boron"
}, w6 = {
  start: "2016-10-25",
  maintenance: "2017-04-30",
  end: "2017-06-30"
}, E6 = {
  start: "2017-05-30",
  lts: "2017-10-31",
  maintenance: "2019-01-01",
  end: "2019-12-31",
  codename: "Carbon"
}, C6 = {
  start: "2017-10-01",
  maintenance: "2018-04-01",
  end: "2018-06-30"
}, T6 = {
  start: "2018-04-24",
  lts: "2018-10-30",
  maintenance: "2020-05-19",
  end: "2021-04-30",
  codename: "Dubnium"
}, k6 = {
  start: "2018-10-23",
  maintenance: "2019-04-22",
  end: "2019-06-01"
}, A6 = {
  start: "2019-04-23",
  lts: "2019-10-21",
  maintenance: "2020-11-30",
  end: "2022-04-30",
  codename: "Erbium"
}, O6 = {
  start: "2019-10-22",
  maintenance: "2020-04-01",
  end: "2020-06-01"
}, I6 = {
  start: "2020-04-21",
  lts: "2020-10-27",
  maintenance: "2021-10-19",
  end: "2023-04-30",
  codename: "Fermium"
}, P6 = {
  start: "2020-10-20",
  maintenance: "2021-04-01",
  end: "2021-06-01"
}, B6 = {
  start: "2021-04-20",
  lts: "2021-10-26",
  maintenance: "2022-10-18",
  end: "2023-09-11",
  codename: "Gallium"
}, N6 = {
  start: "2021-10-19",
  maintenance: "2022-04-01",
  end: "2022-06-01"
}, D6 = {
  start: "2022-04-19",
  lts: "2022-10-25",
  maintenance: "2023-10-18",
  end: "2025-04-30",
  codename: "Hydrogen"
}, R6 = {
  start: "2022-10-18",
  maintenance: "2023-04-01",
  end: "2023-06-01"
}, x6 = {
  start: "2023-04-18",
  lts: "2023-10-24",
  maintenance: "2024-10-22",
  end: "2026-04-30",
  codename: "Iron"
}, j6 = {
  start: "2023-10-17",
  maintenance: "2024-04-01",
  end: "2024-06-01"
}, M6 = {
  start: "2024-04-24",
  lts: "2024-10-29",
  maintenance: "2025-10-21",
  end: "2027-04-30",
  codename: "Jod"
}, L6 = {
  start: "2024-10-16",
  maintenance: "2025-04-01",
  end: "2025-06-01"
}, F6 = {
  start: "2025-04-22",
  lts: "2025-10-28",
  maintenance: "2026-10-20",
  end: "2028-04-30",
  codename: ""
}, $6 = {
  "v0.8": {
    start: "2012-06-25",
    end: "2014-07-31"
  },
  "v0.10": {
    start: "2013-03-11",
    end: "2016-10-31"
  },
  "v0.12": {
    start: "2015-02-06",
    end: "2016-12-31"
  },
  v4: b6,
  v5: _6,
  v6: S6,
  v7: w6,
  v8: E6,
  v9: C6,
  v10: T6,
  v11: k6,
  v12: A6,
  v13: O6,
  v14: I6,
  v15: P6,
  v16: B6,
  v17: N6,
  v18: D6,
  v19: R6,
  v20: x6,
  v21: j6,
  v22: M6,
  v23: L6,
  v24: F6
}, U6 = {}, H6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: U6
}, Symbol.toStringTag, { value: "Module" })), G6 = /* @__PURE__ */ l6(H6);
function no(e) {
  this.name = "BrowserslistError", this.message = e, this.browserslist = !0, Error.captureStackTrace && Error.captureStackTrace(this, no);
}
no.prototype = Error.prototype;
var lp = no, Yn = lp;
function gr() {
}
var W6 = {
  loadQueries: function() {
    throw new Yn(
      "Sharable configs are not supported in client-side build of Browserslist"
    );
  },
  getStat: function(t) {
    return t.stats;
  },
  loadConfig: function(t) {
    if (t.config)
      throw new Yn(
        "Browserslist config are not supported in client-side build"
      );
  },
  loadCountry: function() {
    throw new Yn(
      "Country statistics are not supported in client-side build of Browserslist"
    );
  },
  loadFeature: function() {
    throw new Yn(
      "Supports queries are not available in client-side build of Browserslist"
    );
  },
  currentNode: function(t, r) {
    return t(["maintained node versions"], r)[0];
  },
  parseConfig: gr,
  readConfig: gr,
  findConfig: gr,
  findConfigFile: gr,
  clearCaches: gr,
  oldDataWarning: gr,
  env: {}
}, Xf = /^\s+and\s+(.*)/i, Jf = /^(?:,\s*|\s+or\s+)(.*)/i;
function pp(e) {
  return Array.isArray(e) ? e.reduce(function(t, r) {
    return t.concat(pp(r));
  }, []) : [e];
}
function q6(e, t) {
  for (var r = e.length, n = 1; n <= r; n++) {
    var a = e.substr(-n, n);
    if (t(a, n, r))
      return e.slice(0, -n);
  }
  return "";
}
function Ni(e, t) {
  var r = { query: t };
  t.indexOf("not ") === 0 && (r.not = !0, t = t.slice(4));
  for (var n in e) {
    var a = e[n], u = t.match(a.regexp);
    if (u) {
      r.type = n;
      for (var i = 0; i < a.matches.length; i++)
        r[a.matches[i]] = u[i + 1];
      return r;
    }
  }
  return r.type = "unknown", r;
}
function z6(e, t, r) {
  var n;
  return q6(t, function(a, u, i) {
    return Xf.test(a) ? (n = Ni(e, a.match(Xf)[1]), n.compose = "and", r.unshift(n), !0) : Jf.test(a) ? (n = Ni(e, a.match(Jf)[1]), n.compose = "or", r.unshift(n), !0) : u === i ? (n = Ni(e, a.trim()), n.compose = "or", r.unshift(n), !0) : !1;
  });
}
var V6 = function(t, r) {
  return Array.isArray(r) || (r = [r]), pp(
    r.map(function(n) {
      var a = [];
      do
        n = z6(t, n, a);
      while (n);
      return a;
    })
  );
}, Y6 = p6, St = cp.agents, at = v6, Di = $6, Pa = G6, $e = lp, Ce = W6, X6 = V6, J6 = 365.259641 * 24 * 60 * 60 * 1e3, hp = "37", K6 = 14;
function mp(e, t) {
  return (e + ".").indexOf(t + ".") === 0;
}
function Q6(e) {
  var t = e.slice(1);
  return x.nodeVersions.some(function(r) {
    return mp(r, t);
  });
}
function Kf(e) {
  return e.filter(function(t) {
    return typeof t == "string";
  });
}
function Xn(e) {
  var t = e;
  return e.split(".").length === 3 && (t = e.split(".").slice(0, -1).join(".")), t;
}
function Dt(e) {
  return function(r) {
    return e + " " + r;
  };
}
function Ss(e) {
  return parseInt(e.split(".")[0]);
}
function Jn(e, t) {
  if (e.length === 0) return [];
  var r = gp(e.map(Ss)), n = r[r.length - t];
  if (!n)
    return e;
  for (var a = [], u = e.length - 1; u >= 0 && !(n > Ss(e[u])); u--)
    a.unshift(e[u]);
  return a;
}
function gp(e) {
  for (var t = [], r = 0; r < e.length; r++)
    t.indexOf(e[r]) === -1 && t.push(e[r]);
  return t;
}
function eu(e, t, r) {
  for (var n in r)
    e[t + " " + n] = r[n];
}
function Qf(e, t) {
  if (t = parseFloat(t), e === ">")
    return function(n) {
      return r(n) > t;
    };
  return e === ">=" ? function(n) {
    return r(n) >= t;
  } : e === "<" ? function(n) {
    return parseFloat(n) < t;
  } : function(n) {
    return parseFloat(n) <= t;
  };
  function r(n) {
    return parseFloat(n.split("-")[1] || n);
  }
}
function Z6(e, t) {
  return t = t.split(".").map(xt), t[1] = t[1] || 0, t[2] = t[2] || 0, e === ">" ? function(r) {
    return r = r.split(".").map(xt), rn(r, t) > 0;
  } : e === ">=" ? function(r) {
    return r = r.split(".").map(xt), rn(r, t) >= 0;
  } : e === "<" ? function(r) {
    return r = r.split(".").map(xt), rn(t, r) > 0;
  } : function(r) {
    return r = r.split(".").map(xt), rn(t, r) >= 0;
  };
}
function xt(e) {
  return parseInt(e);
}
function pa(e, t) {
  return e < t ? -1 : e > t ? 1 : 0;
}
function rn(e, t) {
  return pa(parseInt(e[0]), parseInt(t[0])) || pa(parseInt(e[1] || "0"), parseInt(t[1] || "0")) || pa(parseInt(e[2] || "0"), parseInt(t[2] || "0"));
}
function Zf(e, t) {
  switch (t = t.split(".").map(xt), typeof t[1] > "u" && (t[1] = "x"), e) {
    case "<=":
      return function(r) {
        return r = r.split(".").map(xt), e0(r, t) <= 0;
      };
    case ">=":
    default:
      return function(r) {
        return r = r.split(".").map(xt), e0(r, t) >= 0;
      };
  }
}
function e0(e, t) {
  return e[0] !== t[0] ? e[0] < t[0] ? -1 : 1 : t[1] === "x" ? 0 : e[1] !== t[1] ? e[1] < t[1] ? -1 : 1 : 0;
}
function e_(e, t) {
  return e.versions.indexOf(t) !== -1 ? t : x.versionAliases[e.name][t] ? x.versionAliases[e.name][t] : !1;
}
function Kn(e, t) {
  var r = e_(e, t);
  return r || (e.versions.length === 1 ? e.versions[0] : !1);
}
function yp(e, t) {
  return e = e / 1e3, Object.keys(St).reduce(function(r, n) {
    var a = jt(n, t);
    if (!a) return r;
    var u = Object.keys(a.releaseDate).filter(function(i) {
      var s = a.releaseDate[i];
      return s !== null && s >= e;
    });
    return r.concat(u.map(Dt(a.name)));
  }, []);
}
function t0(e) {
  return {
    name: e.name,
    versions: e.versions,
    released: e.released,
    releaseDate: e.releaseDate
  };
}
function jt(e, t) {
  if (e = e.toLowerCase(), e = x.aliases[e] || e, t.mobileToDesktop && x.desktopNames[e]) {
    var r = x.data[x.desktopNames[e]];
    if (e === "android")
      return r_(t0(x.data[e]), r);
    var n = t0(r);
    return n.name = e, n;
  }
  return x.data[e];
}
function r0(e, t) {
  var r = t.indexOf(hp);
  return e.filter(function(n) {
    return /^(?:[2-4]\.|[34]$)/.test(n);
  }).concat(t.slice(r));
}
function t_(e) {
  var t = {};
  for (var r in e)
    t[r] = e[r];
  return t;
}
function r_(e, t) {
  return e.released = r0(e.released, t.released), e.versions = r0(e.versions, t.versions), e.releaseDate = t_(e.releaseDate), e.released.forEach(function(r) {
    e.releaseDate[r] === void 0 && (e.releaseDate[r] = t.releaseDate[r]);
  }), e;
}
function yr(e, t) {
  var r = jt(e, t);
  if (!r) throw new $e("Unknown browser " + e);
  return r;
}
function n_(e) {
  return new $e(
    "Unknown browser query `" + e + "`. Maybe you are using old Browserslist or made typo in query."
  );
}
function Qn(e, t, r, n) {
  var a = 1;
  switch (t) {
    case "android":
      if (n.mobileToDesktop) return e;
      var u = x.data.chrome.released;
      a = u.length - u.indexOf(hp);
      break;
    case "op_mob":
      var i = x.data.op_mob.released.slice(-1)[0];
      a = Ss(i) - K6 + 1;
      break;
    default:
      return e;
  }
  return r <= a ? e.slice(-1) : e.slice(a - 1 - r);
}
function n0(e, t) {
  return typeof e == "string" && (e.indexOf("y") >= 0 || t && e.indexOf("a") >= 0);
}
function wr(e, t) {
  return ao(e).reduce(function(r, n, a) {
    if (n.not && a === 0)
      throw new $e(
        "Write any browsers query (for instance, `defaults`) before `" + n.query + "`"
      );
    var u = uo[n.type], i = u.select.call(x, t, n).map(function(o) {
      var c = o.split(" ");
      return c[1] === "0" ? c[0] + " " + jt(c[0], t).versions[0] : o;
    });
    if (n.compose === "and")
      return n.not ? r.filter(function(o) {
        return i.indexOf(o) === -1;
      }) : r.filter(function(o) {
        return i.indexOf(o) !== -1;
      });
    if (n.not) {
      var s = {};
      return i.forEach(function(o) {
        s[o] = !0;
      }), r.filter(function(o) {
        return !s[o];
      });
    }
    return r.concat(i);
  }, []);
}
function vp(e) {
  return typeof e > "u" && (e = {}), typeof e.path > "u" && (e.path = Pa.resolve ? Pa.resolve(".") : "."), e;
}
function bp(e, t) {
  if (typeof e > "u" || e === null) {
    var r = x.loadConfig(t);
    r ? e = r : e = x.defaults;
  }
  return e;
}
function _p(e) {
  if (!(typeof e == "string" || Array.isArray(e)))
    throw new $e(
      "Browser queries must be an array or string. Got " + typeof e + "."
    );
}
var Ri = {}, xi = {};
function x(e, t) {
  t = vp(t), e = bp(e, t), _p(e);
  var r = ao(e).some(function(o) {
    return uo[o.type].needsPath;
  }), n = {
    ignoreUnknownVersions: t.ignoreUnknownVersions,
    dangerousExtend: t.dangerousExtend,
    mobileToDesktop: t.mobileToDesktop,
    env: t.env
  };
  r && (n.path = t.path), Ce.oldDataWarning(x.data);
  var a = Ce.getStat(t, x.data);
  if (a) {
    n.customUsage = {};
    for (var u in a)
      eu(n.customUsage, u, a[u]);
  }
  var i = JSON.stringify([e, n]);
  if (Ri[i]) return Ri[i];
  var s = gp(wr(e, n)).sort(function(o, c) {
    if (o = o.split(" "), c = c.split(" "), o[0] === c[0]) {
      var f = o[1].split("-")[0], g = c[1].split("-")[0];
      return rn(g.split("."), f.split("."));
    } else
      return pa(o[0], c[0]);
  });
  return Ce.env.BROWSERSLIST_DISABLE_CACHE || (Ri[i] = s), s;
}
function ao(e) {
  var t = JSON.stringify(e);
  if (t in xi) return xi[t];
  var r = X6(uo, e);
  return Ce.env.BROWSERSLIST_DISABLE_CACHE || (xi[t] = r), r;
}
x.parse = function(e, t) {
  return t = vp(t), e = bp(e, t), _p(e), ao(e);
};
x.cache = {};
x.data = {};
x.usage = {
  global: {},
  custom: null
};
x.defaults = ["> 0.5%", "last 2 versions", "Firefox ESR", "not dead"];
x.aliases = {
  fx: "firefox",
  ff: "firefox",
  ios: "ios_saf",
  explorer: "ie",
  blackberry: "bb",
  explorermobile: "ie_mob",
  operamini: "op_mini",
  operamobile: "op_mob",
  chromeandroid: "and_chr",
  firefoxandroid: "and_ff",
  ucandroid: "and_uc",
  qqandroid: "and_qq"
};
x.desktopNames = {
  and_chr: "chrome",
  and_ff: "firefox",
  ie_mob: "ie",
  android: "chrome"
  // has extra processing logic
};
x.versionAliases = {};
x.clearCaches = Ce.clearCaches;
x.parseConfig = Ce.parseConfig;
x.readConfig = Ce.readConfig;
x.findConfigFile = Ce.findConfigFile;
x.findConfig = Ce.findConfig;
x.loadConfig = Ce.loadConfig;
x.coverage = function(e, t) {
  var r;
  if (typeof t > "u")
    r = x.usage.global;
  else if (t === "my stats") {
    var n = {};
    n.path = Pa.resolve ? Pa.resolve(".") : ".";
    var a = Ce.getStat(n);
    if (!a)
      throw new $e("Custom usage statistics was not provided");
    r = {};
    for (var u in a)
      eu(r, u, a[u]);
  } else if (typeof t == "string")
    t.length > 2 ? t = t.toLowerCase() : t = t.toUpperCase(), Ce.loadCountry(x.usage, t, x.data), r = x.usage[t];
  else {
    "dataByBrowser" in t && (t = t.dataByBrowser), r = {};
    for (var i in t)
      for (var s in t[i])
        r[i + " " + s] = t[i][s];
  }
  return e.reduce(function(o, c) {
    var f = r[c];
    return f === void 0 && (f = r[c.replace(/ \S+$/, " 0")]), o + (f || 0);
  }, 0);
};
function ji(e, t) {
  var r = x.nodeVersions.filter(function(n) {
    return mp(n, t.version);
  });
  if (r.length === 0) {
    if (e.ignoreUnknownVersions)
      return [];
    throw new $e(
      "Unknown version " + t.version + " of Node.js"
    );
  }
  return ["node " + r[r.length - 1]];
}
function Mi(e, t) {
  var r = parseInt(t.year), n = parseInt(t.month || "01") - 1, a = parseInt(t.day || "01");
  return yp(Date.UTC(r, n, a, 0, 0, 0), e);
}
function a0(e, t) {
  var r = parseFloat(t.coverage), n = x.usage.global;
  if (t.place)
    if (t.place.match(/^my\s+stats$/i)) {
      if (!e.customUsage)
        throw new $e("Custom usage statistics was not provided");
      n = e.customUsage;
    } else {
      var a;
      t.place.length === 2 ? a = t.place.toUpperCase() : a = t.place.toLowerCase(), Ce.loadCountry(x.usage, a, x.data), n = x.usage[a];
    }
  for (var u = Object.keys(n).sort(function(f, g) {
    return n[g] - n[f];
  }), i = 0, s = [], o, c = 0; c < u.length && (o = u[c], !(n[o] === 0 || (i += n[o], s.push(o), i >= r))); c++)
    ;
  return s;
}
var uo = {
  last_major_versions: {
    matches: ["versions"],
    regexp: /^last\s+(\d+)\s+major\s+versions?$/i,
    select: function(e, t) {
      return Object.keys(St).reduce(function(r, n) {
        var a = jt(n, e);
        if (!a) return r;
        var u = Jn(a.released, t.versions);
        return u = u.map(Dt(a.name)), u = Qn(u, a.name, t.versions, e), r.concat(u);
      }, []);
    }
  },
  last_versions: {
    matches: ["versions"],
    regexp: /^last\s+(\d+)\s+versions?$/i,
    select: function(e, t) {
      return Object.keys(St).reduce(function(r, n) {
        var a = jt(n, e);
        if (!a) return r;
        var u = a.released.slice(-t.versions);
        return u = u.map(Dt(a.name)), u = Qn(u, a.name, t.versions, e), r.concat(u);
      }, []);
    }
  },
  last_electron_major_versions: {
    matches: ["versions"],
    regexp: /^last\s+(\d+)\s+electron\s+major\s+versions?$/i,
    select: function(e, t) {
      var r = Jn(Object.keys(at), t.versions);
      return r.map(function(n) {
        return "chrome " + at[n];
      });
    }
  },
  last_node_major_versions: {
    matches: ["versions"],
    regexp: /^last\s+(\d+)\s+node\s+major\s+versions?$/i,
    select: function(e, t) {
      return Jn(x.nodeVersions, t.versions).map(
        function(r) {
          return "node " + r;
        }
      );
    }
  },
  last_browser_major_versions: {
    matches: ["versions", "browser"],
    regexp: /^last\s+(\d+)\s+(\w+)\s+major\s+versions?$/i,
    select: function(e, t) {
      var r = yr(t.browser, e), n = Jn(r.released, t.versions), a = n.map(Dt(r.name));
      return a = Qn(a, r.name, t.versions, e), a;
    }
  },
  last_electron_versions: {
    matches: ["versions"],
    regexp: /^last\s+(\d+)\s+electron\s+versions?$/i,
    select: function(e, t) {
      return Object.keys(at).slice(-t.versions).map(function(r) {
        return "chrome " + at[r];
      });
    }
  },
  last_node_versions: {
    matches: ["versions"],
    regexp: /^last\s+(\d+)\s+node\s+versions?$/i,
    select: function(e, t) {
      return x.nodeVersions.slice(-t.versions).map(function(r) {
        return "node " + r;
      });
    }
  },
  last_browser_versions: {
    matches: ["versions", "browser"],
    regexp: /^last\s+(\d+)\s+(\w+)\s+versions?$/i,
    select: function(e, t) {
      var r = yr(t.browser, e), n = r.released.slice(-t.versions).map(Dt(r.name));
      return n = Qn(n, r.name, t.versions, e), n;
    }
  },
  unreleased_versions: {
    matches: [],
    regexp: /^unreleased\s+versions$/i,
    select: function(e) {
      return Object.keys(St).reduce(function(t, r) {
        var n = jt(r, e);
        if (!n) return t;
        var a = n.versions.filter(function(u) {
          return n.released.indexOf(u) === -1;
        });
        return a = a.map(Dt(n.name)), t.concat(a);
      }, []);
    }
  },
  unreleased_electron_versions: {
    matches: [],
    regexp: /^unreleased\s+electron\s+versions?$/i,
    select: function() {
      return [];
    }
  },
  unreleased_browser_versions: {
    matches: ["browser"],
    regexp: /^unreleased\s+(\w+)\s+versions?$/i,
    select: function(e, t) {
      var r = yr(t.browser, e);
      return r.versions.filter(function(n) {
        return r.released.indexOf(n) === -1;
      }).map(Dt(r.name));
    }
  },
  last_years: {
    matches: ["years"],
    regexp: /^last\s+(\d*.?\d+)\s+years?$/i,
    select: function(e, t) {
      return yp(Date.now() - J6 * t.years, e);
    }
  },
  since_y: {
    matches: ["year"],
    regexp: /^since (\d+)$/i,
    select: Mi
  },
  since_y_m: {
    matches: ["year", "month"],
    regexp: /^since (\d+)-(\d+)$/i,
    select: Mi
  },
  since_y_m_d: {
    matches: ["year", "month", "day"],
    regexp: /^since (\d+)-(\d+)-(\d+)$/i,
    select: Mi
  },
  popularity: {
    matches: ["sign", "popularity"],
    regexp: /^(>=?|<=?)\s*(\d+|\d+\.\d+|\.\d+)%$/,
    select: function(e, t) {
      var r = parseFloat(t.popularity), n = x.usage.global;
      return Object.keys(n).reduce(function(a, u) {
        return t.sign === ">" ? n[u] > r && a.push(u) : t.sign === "<" ? n[u] < r && a.push(u) : t.sign === "<=" ? n[u] <= r && a.push(u) : n[u] >= r && a.push(u), a;
      }, []);
    }
  },
  popularity_in_my_stats: {
    matches: ["sign", "popularity"],
    regexp: /^(>=?|<=?)\s*(\d+|\d+\.\d+|\.\d+)%\s+in\s+my\s+stats$/,
    select: function(e, t) {
      var r = parseFloat(t.popularity);
      if (!e.customUsage)
        throw new $e("Custom usage statistics was not provided");
      var n = e.customUsage;
      return Object.keys(n).reduce(function(a, u) {
        var i = n[u];
        return i == null || (t.sign === ">" ? i > r && a.push(u) : t.sign === "<" ? i < r && a.push(u) : t.sign === "<=" ? i <= r && a.push(u) : i >= r && a.push(u)), a;
      }, []);
    }
  },
  popularity_in_config_stats: {
    matches: ["sign", "popularity", "config"],
    regexp: /^(>=?|<=?)\s*(\d+|\d+\.\d+|\.\d+)%\s+in\s+(\S+)\s+stats$/,
    select: function(e, t) {
      var r = parseFloat(t.popularity), n = Ce.loadStat(e, t.config, x.data);
      if (n) {
        e.customUsage = {};
        for (var a in n)
          eu(e.customUsage, a, n[a]);
      }
      if (!e.customUsage)
        throw new $e("Custom usage statistics was not provided");
      var u = e.customUsage;
      return Object.keys(u).reduce(function(i, s) {
        var o = u[s];
        return o == null || (t.sign === ">" ? o > r && i.push(s) : t.sign === "<" ? o < r && i.push(s) : t.sign === "<=" ? o <= r && i.push(s) : o >= r && i.push(s)), i;
      }, []);
    }
  },
  popularity_in_place: {
    matches: ["sign", "popularity", "place"],
    regexp: /^(>=?|<=?)\s*(\d+|\d+\.\d+|\.\d+)%\s+in\s+((alt-)?\w\w)$/,
    select: function(e, t) {
      var r = parseFloat(t.popularity), n = t.place;
      n.length === 2 ? n = n.toUpperCase() : n = n.toLowerCase(), Ce.loadCountry(x.usage, n, x.data);
      var a = x.usage[n];
      return Object.keys(a).reduce(function(u, i) {
        var s = a[i];
        return s == null || (t.sign === ">" ? s > r && u.push(i) : t.sign === "<" ? s < r && u.push(i) : t.sign === "<=" ? s <= r && u.push(i) : s >= r && u.push(i)), u;
      }, []);
    }
  },
  cover: {
    matches: ["coverage"],
    regexp: /^cover\s+(\d+|\d+\.\d+|\.\d+)%$/i,
    select: a0
  },
  cover_in: {
    matches: ["coverage", "place"],
    regexp: /^cover\s+(\d+|\d+\.\d+|\.\d+)%\s+in\s+(my\s+stats|(alt-)?\w\w)$/i,
    select: a0
  },
  supports: {
    matches: ["supportType", "feature"],
    regexp: /^(?:(fully|partially)\s+)?supports\s+([\w-]+)$/,
    select: function(e, t) {
      Ce.loadFeature(x.cache, t.feature);
      var r = t.supportType !== "fully", n = x.cache[t.feature], a = [];
      for (var u in n) {
        for (var i = jt(u, e), s = i.released.length - 1; s >= 0 && !(i.released[s] in n[u]); )
          s--;
        var o = e.mobileToDesktop && u in x.desktopNames && n0(n[u][i.released[s]], r);
        i.versions.forEach(function(c) {
          var f = n[u][c];
          f === void 0 && o && (f = n[x.desktopNames[u]][c]), n0(f, r) && a.push(u + " " + c);
        });
      }
      return a;
    }
  },
  electron_range: {
    matches: ["from", "to"],
    regexp: /^electron\s+([\d.]+)\s*-\s*([\d.]+)$/i,
    select: function(e, t) {
      var r = Xn(t.from), n = Xn(t.to), a = parseFloat(t.from), u = parseFloat(t.to);
      if (!at[r])
        throw new $e("Unknown version " + a + " of electron");
      if (!at[n])
        throw new $e("Unknown version " + u + " of electron");
      return Object.keys(at).filter(function(i) {
        var s = parseFloat(i);
        return s >= a && s <= u;
      }).map(function(i) {
        return "chrome " + at[i];
      });
    }
  },
  node_range: {
    matches: ["from", "to"],
    regexp: /^node\s+([\d.]+)\s*-\s*([\d.]+)$/i,
    select: function(e, t) {
      return x.nodeVersions.filter(Zf(">=", t.from)).filter(Zf("<=", t.to)).map(function(r) {
        return "node " + r;
      });
    }
  },
  browser_range: {
    matches: ["browser", "from", "to"],
    regexp: /^(\w+)\s+([\d.]+)\s*-\s*([\d.]+)$/i,
    select: function(e, t) {
      var r = yr(t.browser, e), n = parseFloat(Kn(r, t.from) || t.from), a = parseFloat(Kn(r, t.to) || t.to);
      function u(i) {
        var s = parseFloat(i);
        return s >= n && s <= a;
      }
      return r.released.filter(u).map(Dt(r.name));
    }
  },
  electron_ray: {
    matches: ["sign", "version"],
    regexp: /^electron\s*(>=?|<=?)\s*([\d.]+)$/i,
    select: function(e, t) {
      var r = Xn(t.version);
      return Object.keys(at).filter(Qf(t.sign, r)).map(function(n) {
        return "chrome " + at[n];
      });
    }
  },
  node_ray: {
    matches: ["sign", "version"],
    regexp: /^node\s*(>=?|<=?)\s*([\d.]+)$/i,
    select: function(e, t) {
      return x.nodeVersions.filter(Z6(t.sign, t.version)).map(function(r) {
        return "node " + r;
      });
    }
  },
  browser_ray: {
    matches: ["browser", "sign", "version"],
    regexp: /^(\w+)\s*(>=?|<=?)\s*([\d.]+)$/,
    select: function(e, t) {
      var r = t.version, n = yr(t.browser, e), a = x.versionAliases[n.name][r];
      return a && (r = a), n.released.filter(Qf(t.sign, r)).map(function(u) {
        return n.name + " " + u;
      });
    }
  },
  firefox_esr: {
    matches: [],
    regexp: /^(firefox|ff|fx)\s+esr$/i,
    select: function() {
      return ["firefox 128"];
    }
  },
  opera_mini_all: {
    matches: [],
    regexp: /(operamini|op_mini)\s+all/i,
    select: function() {
      return ["op_mini all"];
    }
  },
  electron_version: {
    matches: ["version"],
    regexp: /^electron\s+([\d.]+)$/i,
    select: function(e, t) {
      var r = Xn(t.version), n = at[r];
      if (!n)
        throw new $e(
          "Unknown version " + t.version + " of electron"
        );
      return ["chrome " + n];
    }
  },
  node_major_version: {
    matches: ["version"],
    regexp: /^node\s+(\d+)$/i,
    select: ji
  },
  node_minor_version: {
    matches: ["version"],
    regexp: /^node\s+(\d+\.\d+)$/i,
    select: ji
  },
  node_patch_version: {
    matches: ["version"],
    regexp: /^node\s+(\d+\.\d+\.\d+)$/i,
    select: ji
  },
  current_node: {
    matches: [],
    regexp: /^current\s+node$/i,
    select: function(e) {
      return [Ce.currentNode(wr, e)];
    }
  },
  maintained_node: {
    matches: [],
    regexp: /^maintained\s+node\s+versions$/i,
    select: function(e) {
      var t = Date.now(), r = Object.keys(Di).filter(function(n) {
        return t < Date.parse(Di[n].end) && t > Date.parse(Di[n].start) && Q6(n);
      }).map(function(n) {
        return "node " + n.slice(1);
      });
      return wr(r, e);
    }
  },
  phantomjs_1_9: {
    matches: [],
    regexp: /^phantomjs\s+1.9$/i,
    select: function() {
      return ["safari 5"];
    }
  },
  phantomjs_2_1: {
    matches: [],
    regexp: /^phantomjs\s+2.1$/i,
    select: function() {
      return ["safari 6"];
    }
  },
  browser_version: {
    matches: ["browser", "version"],
    regexp: /^(\w+)\s+(tp|[\d.]+)$/i,
    select: function(e, t) {
      var r = t.version;
      /^tp$/i.test(r) && (r = "TP");
      var n = yr(t.browser, e), a = Kn(n, r);
      if (a)
        r = a;
      else if (r.indexOf(".") === -1 ? a = r + ".0" : a = r.replace(/\.0$/, ""), a = Kn(n, a), a)
        r = a;
      else {
        if (e.ignoreUnknownVersions)
          return [];
        throw new $e(
          "Unknown version " + r + " of " + t.browser
        );
      }
      return [n.name + " " + r];
    }
  },
  browserslist_config: {
    matches: [],
    regexp: /^browserslist config$/i,
    needsPath: !0,
    select: function(e) {
      return x(void 0, e);
    }
  },
  extends: {
    matches: ["config"],
    regexp: /^extends (.+)$/i,
    needsPath: !0,
    select: function(e, t) {
      return wr(Ce.loadQueries(e, t.config), e);
    }
  },
  defaults: {
    matches: [],
    regexp: /^defaults$/i,
    select: function(e) {
      return wr(x.defaults, e);
    }
  },
  dead: {
    matches: [],
    regexp: /^dead$/i,
    select: function(e) {
      var t = [
        "Baidu >= 0",
        "ie <= 11",
        "ie_mob <= 11",
        "bb <= 10",
        "op_mob <= 12.1",
        "samsung 4"
      ];
      return wr(t, e);
    }
  },
  unknown: {
    matches: [],
    regexp: /^(\w+)$/i,
    select: function(e, t) {
      throw jt(t.query, e) ? new $e(
        "Specify versions in Browserslist query for browser " + t.query
      ) : n_(t.query);
    }
  }
};
(function() {
  for (var e in St) {
    var t = St[e];
    x.data[e] = {
      name: e,
      versions: Kf(St[e].versions),
      released: Kf(St[e].versions.slice(0, -3)),
      releaseDate: St[e].release_date
    }, eu(x.usage.global, e, t.usage_global), x.versionAliases[e] = {};
    for (var r = 0; r < t.versions.length; r++) {
      var n = t.versions[r];
      if (n && n.indexOf("-") !== -1)
        for (var a = n.split("-"), u = 0; u < a.length; u++)
          x.versionAliases[e][a[u]] = n;
    }
  }
  x.nodeVersions = Y6.map(function(i) {
    return i.version;
  });
})();
var a_ = x;
const u_ = /* @__PURE__ */ op(a_);
var i_ = {
  // Whether `u` flag present. In which case we transform to
  // \u{10FFFF} instead of \uFFFF.
  _hasUFlag: !1,
  // Only run this plugin if we have `s` flag.
  shouldRun: function(t) {
    var r = t.flags.includes("s");
    return r ? (t.flags = t.flags.replace("s", ""), this._hasUFlag = t.flags.includes("u"), !0) : !1;
  },
  Char: function(t) {
    var r = t.node;
    if (!(r.kind !== "meta" || r.value !== ".")) {
      var n = "\\uFFFF", a = "￿";
      this._hasUFlag && (n = "\\u{10FFFF}", a = "􏿿"), t.replace({
        type: "CharacterClass",
        expressions: [{
          type: "ClassRange",
          from: {
            type: "Char",
            value: "\\0",
            kind: "decimal",
            symbol: "\0"
          },
          to: {
            type: "Char",
            value: n,
            kind: "unicode",
            symbol: a
          }
        }]
      });
    }
  }
}, s_ = {
  // To track the names of the groups, and return them
  // in the transform result state.
  //
  // A map from name to number: {foo: 2, bar: 4}
  _groupNames: {},
  /**
   * Initialises the trasnform.
   */
  init: function() {
    this._groupNames = {};
  },
  /**
   * Returns extra state, which eventually is returned to
   */
  getExtra: function() {
    return this._groupNames;
  },
  Group: function(t) {
    var r = t.node;
    r.name && (this._groupNames[r.name] = r.number, delete r.name, delete r.nameRaw);
  },
  Backreference: function(t) {
    var r = t.node;
    r.kind === "name" && (r.kind = "number", r.reference = r.number, delete r.referenceRaw);
  }
}, o_ = {
  RegExp: function(t) {
    var r = t.node;
    r.flags.includes("x") && (r.flags = r.flags.replace("x", ""));
  }
}, c_ = {
  // "dotAll" `s` flag
  dotAll: i_,
  // Named capturing groups.
  namedCapturingGroups: s_,
  // `x` flag
  xFlag: o_
};
function We(e) {
  return e ? d_[e.type](e) : "";
}
var d_ = {
  RegExp: function(t) {
    return "/" + We(t.body) + "/" + t.flags;
  },
  Alternative: function(t) {
    return (t.expressions || []).map(We).join("");
  },
  Disjunction: function(t) {
    return We(t.left) + "|" + We(t.right);
  },
  Group: function(t) {
    var r = We(t.expression);
    return t.capturing ? t.name ? "(?<" + (t.nameRaw || t.name) + ">" + r + ")" : "(" + r + ")" : "(?:" + r + ")";
  },
  Backreference: function(t) {
    switch (t.kind) {
      case "number":
        return "\\" + t.reference;
      case "name":
        return "\\k<" + (t.referenceRaw || t.reference) + ">";
      default:
        throw new TypeError("Unknown Backreference kind: " + t.kind);
    }
  },
  Assertion: function(t) {
    switch (t.kind) {
      case "^":
      case "$":
      case "\\b":
      case "\\B":
        return t.kind;
      case "Lookahead": {
        var r = We(t.assertion);
        return t.negative ? "(?!" + r + ")" : "(?=" + r + ")";
      }
      case "Lookbehind": {
        var n = We(t.assertion);
        return t.negative ? "(?<!" + n + ")" : "(?<=" + n + ")";
      }
      default:
        throw new TypeError("Unknown Assertion kind: " + t.kind);
    }
  },
  CharacterClass: function(t) {
    var r = t.expressions.map(We).join("");
    return t.negative ? "[^" + r + "]" : "[" + r + "]";
  },
  ClassRange: function(t) {
    return We(t.from) + "-" + We(t.to);
  },
  Repetition: function(t) {
    return "" + We(t.expression) + We(t.quantifier);
  },
  Quantifier: function(t) {
    var r = void 0, n = t.greedy ? "" : "?";
    switch (t.kind) {
      case "+":
      case "?":
      case "*":
        r = t.kind;
        break;
      case "Range":
        t.from === t.to ? r = "{" + t.from + "}" : t.to ? r = "{" + t.from + "," + t.to + "}" : r = "{" + t.from + ",}";
        break;
      default:
        throw new TypeError("Unknown Quantifier kind: " + t.kind);
    }
    return "" + r + n;
  },
  Char: function(t) {
    var r = t.value;
    switch (t.kind) {
      case "simple":
        return t.escaped ? "\\" + r : r;
      case "hex":
      case "unicode":
      case "oct":
      case "decimal":
      case "control":
      case "meta":
        return r;
      default:
        throw new TypeError("Unknown Char kind: " + t.kind);
    }
  },
  UnicodeProperty: function(t) {
    var r = t.negative ? "P" : "p", n = void 0;
    return !t.shorthand && !t.binary ? n = t.name + "=" : n = "", "\\" + r + "{" + n + t.value + "}";
  }
}, Sp = {
  /**
   * Generates a regexp string from an AST.
   *
   * @param Object ast - an AST node
   */
  generate: We
}, io = {
  General_Category: "gc",
  Script: "sc",
  Script_Extensions: "scx"
}, vn = ru(io), tu = {
  ASCII: "ASCII",
  ASCII_Hex_Digit: "AHex",
  Alphabetic: "Alpha",
  Any: "Any",
  Assigned: "Assigned",
  Bidi_Control: "Bidi_C",
  Bidi_Mirrored: "Bidi_M",
  Case_Ignorable: "CI",
  Cased: "Cased",
  Changes_When_Casefolded: "CWCF",
  Changes_When_Casemapped: "CWCM",
  Changes_When_Lowercased: "CWL",
  Changes_When_NFKC_Casefolded: "CWKCF",
  Changes_When_Titlecased: "CWT",
  Changes_When_Uppercased: "CWU",
  Dash: "Dash",
  Default_Ignorable_Code_Point: "DI",
  Deprecated: "Dep",
  Diacritic: "Dia",
  Emoji: "Emoji",
  Emoji_Component: "Emoji_Component",
  Emoji_Modifier: "Emoji_Modifier",
  Emoji_Modifier_Base: "Emoji_Modifier_Base",
  Emoji_Presentation: "Emoji_Presentation",
  Extended_Pictographic: "Extended_Pictographic",
  Extender: "Ext",
  Grapheme_Base: "Gr_Base",
  Grapheme_Extend: "Gr_Ext",
  Hex_Digit: "Hex",
  IDS_Binary_Operator: "IDSB",
  IDS_Trinary_Operator: "IDST",
  ID_Continue: "IDC",
  ID_Start: "IDS",
  Ideographic: "Ideo",
  Join_Control: "Join_C",
  Logical_Order_Exception: "LOE",
  Lowercase: "Lower",
  Math: "Math",
  Noncharacter_Code_Point: "NChar",
  Pattern_Syntax: "Pat_Syn",
  Pattern_White_Space: "Pat_WS",
  Quotation_Mark: "QMark",
  Radical: "Radical",
  Regional_Indicator: "RI",
  Sentence_Terminal: "STerm",
  Soft_Dotted: "SD",
  Terminal_Punctuation: "Term",
  Unified_Ideograph: "UIdeo",
  Uppercase: "Upper",
  Variation_Selector: "VS",
  White_Space: "space",
  XID_Continue: "XIDC",
  XID_Start: "XIDS"
}, Gt = ru(tu), so = {
  Cased_Letter: "LC",
  Close_Punctuation: "Pe",
  Connector_Punctuation: "Pc",
  Control: ["Cc", "cntrl"],
  Currency_Symbol: "Sc",
  Dash_Punctuation: "Pd",
  Decimal_Number: ["Nd", "digit"],
  Enclosing_Mark: "Me",
  Final_Punctuation: "Pf",
  Format: "Cf",
  Initial_Punctuation: "Pi",
  Letter: "L",
  Letter_Number: "Nl",
  Line_Separator: "Zl",
  Lowercase_Letter: "Ll",
  Mark: ["M", "Combining_Mark"],
  Math_Symbol: "Sm",
  Modifier_Letter: "Lm",
  Modifier_Symbol: "Sk",
  Nonspacing_Mark: "Mn",
  Number: "N",
  Open_Punctuation: "Ps",
  Other: "C",
  Other_Letter: "Lo",
  Other_Number: "No",
  Other_Punctuation: "Po",
  Other_Symbol: "So",
  Paragraph_Separator: "Zp",
  Private_Use: "Co",
  Punctuation: ["P", "punct"],
  Separator: "Z",
  Space_Separator: "Zs",
  Spacing_Mark: "Mc",
  Surrogate: "Cs",
  Symbol: "S",
  Titlecase_Letter: "Lt",
  Unassigned: "Cn",
  Uppercase_Letter: "Lu"
}, Ba = ru(so), oo = {
  Adlam: "Adlm",
  Ahom: "Ahom",
  Anatolian_Hieroglyphs: "Hluw",
  Arabic: "Arab",
  Armenian: "Armn",
  Avestan: "Avst",
  Balinese: "Bali",
  Bamum: "Bamu",
  Bassa_Vah: "Bass",
  Batak: "Batk",
  Bengali: "Beng",
  Bhaiksuki: "Bhks",
  Bopomofo: "Bopo",
  Brahmi: "Brah",
  Braille: "Brai",
  Buginese: "Bugi",
  Buhid: "Buhd",
  Canadian_Aboriginal: "Cans",
  Carian: "Cari",
  Caucasian_Albanian: "Aghb",
  Chakma: "Cakm",
  Cham: "Cham",
  Cherokee: "Cher",
  Common: "Zyyy",
  Coptic: ["Copt", "Qaac"],
  Cuneiform: "Xsux",
  Cypriot: "Cprt",
  Cyrillic: "Cyrl",
  Deseret: "Dsrt",
  Devanagari: "Deva",
  Dogra: "Dogr",
  Duployan: "Dupl",
  Egyptian_Hieroglyphs: "Egyp",
  Elbasan: "Elba",
  Ethiopic: "Ethi",
  Georgian: "Geor",
  Glagolitic: "Glag",
  Gothic: "Goth",
  Grantha: "Gran",
  Greek: "Grek",
  Gujarati: "Gujr",
  Gunjala_Gondi: "Gong",
  Gurmukhi: "Guru",
  Han: "Hani",
  Hangul: "Hang",
  Hanifi_Rohingya: "Rohg",
  Hanunoo: "Hano",
  Hatran: "Hatr",
  Hebrew: "Hebr",
  Hiragana: "Hira",
  Imperial_Aramaic: "Armi",
  Inherited: ["Zinh", "Qaai"],
  Inscriptional_Pahlavi: "Phli",
  Inscriptional_Parthian: "Prti",
  Javanese: "Java",
  Kaithi: "Kthi",
  Kannada: "Knda",
  Katakana: "Kana",
  Kayah_Li: "Kali",
  Kharoshthi: "Khar",
  Khmer: "Khmr",
  Khojki: "Khoj",
  Khudawadi: "Sind",
  Lao: "Laoo",
  Latin: "Latn",
  Lepcha: "Lepc",
  Limbu: "Limb",
  Linear_A: "Lina",
  Linear_B: "Linb",
  Lisu: "Lisu",
  Lycian: "Lyci",
  Lydian: "Lydi",
  Mahajani: "Mahj",
  Makasar: "Maka",
  Malayalam: "Mlym",
  Mandaic: "Mand",
  Manichaean: "Mani",
  Marchen: "Marc",
  Medefaidrin: "Medf",
  Masaram_Gondi: "Gonm",
  Meetei_Mayek: "Mtei",
  Mende_Kikakui: "Mend",
  Meroitic_Cursive: "Merc",
  Meroitic_Hieroglyphs: "Mero",
  Miao: "Plrd",
  Modi: "Modi",
  Mongolian: "Mong",
  Mro: "Mroo",
  Multani: "Mult",
  Myanmar: "Mymr",
  Nabataean: "Nbat",
  New_Tai_Lue: "Talu",
  Newa: "Newa",
  Nko: "Nkoo",
  Nushu: "Nshu",
  Ogham: "Ogam",
  Ol_Chiki: "Olck",
  Old_Hungarian: "Hung",
  Old_Italic: "Ital",
  Old_North_Arabian: "Narb",
  Old_Permic: "Perm",
  Old_Persian: "Xpeo",
  Old_Sogdian: "Sogo",
  Old_South_Arabian: "Sarb",
  Old_Turkic: "Orkh",
  Oriya: "Orya",
  Osage: "Osge",
  Osmanya: "Osma",
  Pahawh_Hmong: "Hmng",
  Palmyrene: "Palm",
  Pau_Cin_Hau: "Pauc",
  Phags_Pa: "Phag",
  Phoenician: "Phnx",
  Psalter_Pahlavi: "Phlp",
  Rejang: "Rjng",
  Runic: "Runr",
  Samaritan: "Samr",
  Saurashtra: "Saur",
  Sharada: "Shrd",
  Shavian: "Shaw",
  Siddham: "Sidd",
  SignWriting: "Sgnw",
  Sinhala: "Sinh",
  Sogdian: "Sogd",
  Sora_Sompeng: "Sora",
  Soyombo: "Soyo",
  Sundanese: "Sund",
  Syloti_Nagri: "Sylo",
  Syriac: "Syrc",
  Tagalog: "Tglg",
  Tagbanwa: "Tagb",
  Tai_Le: "Tale",
  Tai_Tham: "Lana",
  Tai_Viet: "Tavt",
  Takri: "Takr",
  Tamil: "Taml",
  Tangut: "Tang",
  Telugu: "Telu",
  Thaana: "Thaa",
  Thai: "Thai",
  Tibetan: "Tibt",
  Tifinagh: "Tfng",
  Tirhuta: "Tirh",
  Ugaritic: "Ugar",
  Vai: "Vaii",
  Warang_Citi: "Wara",
  Yi: "Yiii",
  Zanabazar_Square: "Zanb"
}, Na = ru(oo);
function ru(e) {
  var t = {};
  for (var r in e)
    if (e.hasOwnProperty(r)) {
      var n = e[r];
      if (Array.isArray(n))
        for (var a = 0; a < n.length; a++)
          t[n[a]] = r;
      else
        t[n] = r;
    }
  return t;
}
function f_(e) {
  return io.hasOwnProperty(e) || vn.hasOwnProperty(e) || tu.hasOwnProperty(e) || Gt.hasOwnProperty(e);
}
function l_(e, t) {
  return h_(e) ? wp(t) : m_(e) ? Ep(t) : !1;
}
function p_(e) {
  return vn.hasOwnProperty(e) || Gt.hasOwnProperty(e);
}
function h_(e) {
  return e === "General_Category" || e == "gc";
}
function m_(e) {
  return e === "Script" || e === "Script_Extensions" || e === "sc" || e === "scx";
}
function wp(e) {
  return so.hasOwnProperty(e) || Ba.hasOwnProperty(e);
}
function Ep(e) {
  return oo.hasOwnProperty(e) || Na.hasOwnProperty(e);
}
function g_(e) {
  return tu.hasOwnProperty(e) || Gt.hasOwnProperty(e);
}
function y_(e) {
  return vn.hasOwnProperty(e) ? vn[e] : Gt.hasOwnProperty(e) ? Gt[e] : null;
}
function v_(e) {
  return Ba.hasOwnProperty(e) ? Ba[e] : Na.hasOwnProperty(e) ? Na[e] : Gt.hasOwnProperty(e) ? Gt[e] : null;
}
var b_ = {
  isAlias: p_,
  isValidName: f_,
  isValidValue: l_,
  isGeneralCategoryValue: wp,
  isScriptCategoryValue: Ep,
  isBinaryPropertyName: g_,
  getCanonicalName: y_,
  getCanonicalValue: v_,
  NON_BINARY_PROP_NAMES_TO_ALIASES: io,
  NON_BINARY_ALIASES_TO_PROP_NAMES: vn,
  BINARY_PROP_NAMES_TO_ALIASES: tu,
  BINARY_ALIASES_TO_PROP_NAMES: Gt,
  GENERAL_CATEGORY_VALUE_TO_ALIASES: so,
  GENERAL_CATEGORY_VALUE_ALIASES_TO_VALUES: Ba,
  SCRIPT_VALUE_TO_ALIASES: oo,
  SCRIPT_VALUE_ALIASES_TO_VALUE: Na
}, __ = /* @__PURE__ */ function() {
  function e(t, r) {
    var n = [], a = !0, u = !1, i = void 0;
    try {
      for (var s = t[Symbol.iterator](), o; !(a = (o = s.next()).done) && (n.push(o.value), !(r && n.length === r)); a = !0)
        ;
    } catch (c) {
      u = !0, i = c;
    } finally {
      try {
        !a && s.return && s.return();
      } finally {
        if (u) throw i;
      }
    }
    return n;
  }
  return function(t, r) {
    if (Array.isArray(t))
      return t;
    if (Symbol.iterator in Object(t))
      return e(t, r);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
}();
function Cp(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = Array(e.length); t < e.length; t++)
      r[t] = e[t];
    return r;
  } else
    return Array.from(e);
}
var ct = void 0, ye = {}, N = void 0, I = void 0;
function R(e, t) {
  return ye.options.captureLocations ? !e || !t ? e || t : {
    startOffset: e.startOffset,
    endOffset: t.endOffset,
    startLine: e.startLine,
    endLine: t.endLine,
    startColumn: e.startColumn,
    endColumn: t.endColumn
  } : null;
}
var Tp = "$", S_ = [[-1, 1, function(e, t) {
  I = R(t, t), N = e;
}], [0, 4, function(e, t, r, n, a, u, i, s) {
  I = R(a, s), N = ce({
    type: "RegExp",
    body: t,
    flags: k_(n)
  }, Zn(a, s || i));
}], [1, 1, function(e, t) {
  I = R(t, t), N = e;
}], [1, 0, function() {
  I = null, N = "";
}], [2, 1, function(e, t) {
  I = R(t, t), N = e;
}], [2, 2, function(e, t, r, n) {
  I = R(r, n), N = e + t;
}], [3, 1, function(e, t) {
  I = R(t, t), N = e;
}], [4, 1, function(e, t) {
  I = R(t, t), N = e;
}], [4, 3, function(e, t, r, n, a, u) {
  I = R(n, u);
  var i = null;
  a && (i = Zn(n || a, u || a)), N = ce({
    type: "Disjunction",
    left: e,
    right: r
  }, i);
}], [5, 1, function(e, t) {
  if (I = R(t, t), e.length === 0) {
    N = null;
    return;
  }
  e.length === 1 ? N = ce(e[0], I) : N = ce({
    type: "Alternative",
    expressions: e
  }, I);
}], [6, 0, function() {
  I = null, N = [];
}], [6, 2, function(e, t, r, n) {
  I = R(r, n), N = e.concat(t);
}], [7, 1, function(e, t) {
  I = R(t, t), N = ce(Object.assign({ type: "Assertion" }, e), I);
}], [7, 2, function(e, t, r, n) {
  I = R(r, n), N = e, t && (N = ce({
    type: "Repetition",
    expression: e,
    quantifier: t
  }, I));
}], [8, 1, function(e, t) {
  I = R(t, t), N = { kind: "^" };
}], [8, 1, function(e, t) {
  I = R(t, t), N = { kind: "$" };
}], [8, 1, function(e, t) {
  I = R(t, t), N = { kind: "\\b" };
}], [8, 1, function(e, t) {
  I = R(t, t), N = { kind: "\\B" };
}], [8, 3, function(e, t, r, n, a, u) {
  I = R(n, u), N = {
    kind: "Lookahead",
    assertion: t
  };
}], [8, 3, function(e, t, r, n, a, u) {
  I = R(n, u), N = {
    kind: "Lookahead",
    negative: !0,
    assertion: t
  };
}], [8, 3, function(e, t, r, n, a, u) {
  I = R(n, u), N = {
    kind: "Lookbehind",
    assertion: t
  };
}], [8, 3, function(e, t, r, n, a, u) {
  I = R(n, u), N = {
    kind: "Lookbehind",
    negative: !0,
    assertion: t
  };
}], [9, 1, function(e, t) {
  I = R(t, t), N = e;
}], [9, 1, function(e, t) {
  I = R(t, t), N = e;
}], [9, 1, function(e, t) {
  I = R(t, t), N = e;
}], [10, 1, function(e, t) {
  I = R(t, t), N = je(e, "simple", I);
}], [10, 1, function(e, t) {
  I = R(t, t), N = je(e.slice(1), "simple", I), N.escaped = !0;
}], [10, 1, function(e, t) {
  I = R(t, t), N = je(e, "unicode", I), N.isSurrogatePair = !0;
}], [10, 1, function(e, t) {
  I = R(t, t), N = je(e, "unicode", I);
}], [10, 1, function(e, t) {
  I = R(t, t), N = C_(e, I);
}], [10, 1, function(e, t) {
  I = R(t, t), N = je(e, "control", I);
}], [10, 1, function(e, t) {
  I = R(t, t), N = je(e, "hex", I);
}], [10, 1, function(e, t) {
  I = R(t, t), N = je(e, "oct", I);
}], [10, 1, function(e, t) {
  I = R(t, t), N = A_(e, I);
}], [10, 1, function(e, t) {
  I = R(t, t), N = je(e, "meta", I);
}], [10, 1, function(e, t) {
  I = R(t, t), N = je(e, "meta", I);
}], [10, 1, function(e, t) {
  I = R(t, t), N = N_(e, t);
}], [11, 1, function(e, t) {
  I = R(t, t), N = e;
}], [11, 0], [12, 1, function(e, t) {
  I = R(t, t), N = e;
}], [12, 2, function(e, t, r, n) {
  I = R(r, n), e.greedy = !1, N = e;
}], [13, 1, function(e, t) {
  I = R(t, t), N = ce({
    type: "Quantifier",
    kind: e,
    greedy: !0
  }, I);
}], [13, 1, function(e, t) {
  I = R(t, t), N = ce({
    type: "Quantifier",
    kind: e,
    greedy: !0
  }, I);
}], [13, 1, function(e, t) {
  I = R(t, t), N = ce({
    type: "Quantifier",
    kind: e,
    greedy: !0
  }, I);
}], [13, 1, function(e, t) {
  I = R(t, t);
  var r = Fi(e);
  N = ce({
    type: "Quantifier",
    kind: "Range",
    from: r[0],
    to: r[0],
    greedy: !0
  }, I);
}], [13, 1, function(e, t) {
  I = R(t, t), N = ce({
    type: "Quantifier",
    kind: "Range",
    from: Fi(e)[0],
    greedy: !0
  }, I);
}], [13, 1, function(e, t) {
  I = R(t, t);
  var r = Fi(e);
  N = ce({
    type: "Quantifier",
    kind: "Range",
    from: r[0],
    to: r[1],
    greedy: !0
  }, I);
}], [14, 1, function(e, t) {
  I = R(t, t), N = e;
}], [14, 1, function(e, t) {
  I = R(t, t), N = e;
}], [15, 3, function(e, t, r, n, a, u) {
  I = R(n, u);
  var i = String(e), s = Ap(i);
  if (!ye.options.allowGroupNameDuplicates && bn.hasOwnProperty(s))
    throw new SyntaxError('Duplicate of the named group "' + s + '".');
  bn[s] = e.groupNumber, N = ce({
    type: "Group",
    capturing: !0,
    name: s,
    nameRaw: i,
    number: e.groupNumber,
    expression: t
  }, I);
}], [15, 3, function(e, t, r, n, a, u) {
  I = R(n, u), N = ce({
    type: "Group",
    capturing: !0,
    number: e.groupNumber,
    expression: t
  }, I);
}], [16, 3, function(e, t, r, n, a, u) {
  I = R(n, u), N = ce({
    type: "Group",
    capturing: !1,
    expression: t
  }, I);
}], [17, 3, function(e, t, r, n, a, u) {
  I = R(n, u), N = ce({
    type: "CharacterClass",
    negative: !0,
    expressions: t
  }, I);
}], [17, 3, function(e, t, r, n, a, u) {
  I = R(n, u), N = ce({
    type: "CharacterClass",
    expressions: t
  }, I);
}], [18, 0, function() {
  I = null, N = [];
}], [18, 1, function(e, t) {
  I = R(t, t), N = e;
}], [19, 1, function(e, t) {
  I = R(t, t), N = [e];
}], [19, 2, function(e, t, r, n) {
  I = R(r, n), N = [e].concat(t);
}], [19, 4, function(e, t, r, n, a, u, i, s) {
  I = R(a, s), s0(e, r), N = [ce({
    type: "ClassRange",
    from: e,
    to: r
  }, Zn(a, i))], n && (N = N.concat(n));
}], [20, 1, function(e, t) {
  I = R(t, t), N = e;
}], [20, 2, function(e, t, r, n) {
  I = R(r, n), N = [e].concat(t);
}], [20, 4, function(e, t, r, n, a, u, i, s) {
  I = R(a, s), s0(e, r), N = [ce({
    type: "ClassRange",
    from: e,
    to: r
  }, Zn(a, i))], n && (N = N.concat(n));
}], [21, 1, function(e, t) {
  I = R(t, t), N = je(e, "simple", I);
}], [21, 1, function(e, t) {
  I = R(t, t), N = e;
}], [22, 1, function(e, t) {
  I = R(t, t), N = e;
}], [22, 1, function(e, t) {
  I = R(t, t), N = je(e, "meta", I);
}]], u0 = { SLASH: "23", CHAR: "24", BAR: "25", BOS: "26", EOS: "27", ESC_b: "28", ESC_B: "29", POS_LA_ASSERT: "30", R_PAREN: "31", NEG_LA_ASSERT: "32", POS_LB_ASSERT: "33", NEG_LB_ASSERT: "34", ESC_CHAR: "35", U_CODE_SURROGATE: "36", U_CODE: "37", U_PROP_VALUE_EXP: "38", CTRL_CH: "39", HEX_CODE: "40", OCT_CODE: "41", DEC_CODE: "42", META_CHAR: "43", ANY: "44", NAMED_GROUP_REF: "45", Q_MARK: "46", STAR: "47", PLUS: "48", RANGE_EXACT: "49", RANGE_OPEN: "50", RANGE_CLOSED: "51", NAMED_CAPTURE_GROUP: "52", L_PAREN: "53", NON_CAPTURE_GROUP: "54", NEG_CLASS: "55", R_BRACKET: "56", L_BRACKET: "57", DASH: "58", $: "59" }, Li = [{ 0: 1, 23: "s2" }, { 59: "acc" }, { 3: 3, 4: 4, 5: 5, 6: 6, 23: "r10", 24: "r10", 25: "r10", 26: "r10", 27: "r10", 28: "r10", 29: "r10", 30: "r10", 32: "r10", 33: "r10", 34: "r10", 35: "r10", 36: "r10", 37: "r10", 38: "r10", 39: "r10", 40: "r10", 41: "r10", 42: "r10", 43: "r10", 44: "r10", 45: "r10", 52: "r10", 53: "r10", 54: "r10", 55: "r10", 57: "r10" }, { 23: "s7" }, { 23: "r6", 25: "s12" }, { 23: "r7", 25: "r7", 31: "r7" }, { 7: 14, 8: 15, 9: 16, 10: 25, 14: 27, 15: 42, 16: 43, 17: 26, 23: "r9", 24: "s28", 25: "r9", 26: "s17", 27: "s18", 28: "s19", 29: "s20", 30: "s21", 31: "r9", 32: "s22", 33: "s23", 34: "s24", 35: "s29", 36: "s30", 37: "s31", 38: "s32", 39: "s33", 40: "s34", 41: "s35", 42: "s36", 43: "s37", 44: "s38", 45: "s39", 52: "s44", 53: "s45", 54: "s46", 55: "s40", 57: "s41" }, { 1: 8, 2: 9, 24: "s10", 59: "r3" }, { 59: "r1" }, { 24: "s11", 59: "r2" }, { 24: "r4", 59: "r4" }, { 24: "r5", 59: "r5" }, { 5: 13, 6: 6, 23: "r10", 24: "r10", 25: "r10", 26: "r10", 27: "r10", 28: "r10", 29: "r10", 30: "r10", 31: "r10", 32: "r10", 33: "r10", 34: "r10", 35: "r10", 36: "r10", 37: "r10", 38: "r10", 39: "r10", 40: "r10", 41: "r10", 42: "r10", 43: "r10", 44: "r10", 45: "r10", 52: "r10", 53: "r10", 54: "r10", 55: "r10", 57: "r10" }, { 23: "r8", 25: "r8", 31: "r8" }, { 23: "r11", 24: "r11", 25: "r11", 26: "r11", 27: "r11", 28: "r11", 29: "r11", 30: "r11", 31: "r11", 32: "r11", 33: "r11", 34: "r11", 35: "r11", 36: "r11", 37: "r11", 38: "r11", 39: "r11", 40: "r11", 41: "r11", 42: "r11", 43: "r11", 44: "r11", 45: "r11", 52: "r11", 53: "r11", 54: "r11", 55: "r11", 57: "r11" }, { 23: "r12", 24: "r12", 25: "r12", 26: "r12", 27: "r12", 28: "r12", 29: "r12", 30: "r12", 31: "r12", 32: "r12", 33: "r12", 34: "r12", 35: "r12", 36: "r12", 37: "r12", 38: "r12", 39: "r12", 40: "r12", 41: "r12", 42: "r12", 43: "r12", 44: "r12", 45: "r12", 52: "r12", 53: "r12", 54: "r12", 55: "r12", 57: "r12" }, { 11: 47, 12: 48, 13: 49, 23: "r38", 24: "r38", 25: "r38", 26: "r38", 27: "r38", 28: "r38", 29: "r38", 30: "r38", 31: "r38", 32: "r38", 33: "r38", 34: "r38", 35: "r38", 36: "r38", 37: "r38", 38: "r38", 39: "r38", 40: "r38", 41: "r38", 42: "r38", 43: "r38", 44: "r38", 45: "r38", 46: "s52", 47: "s50", 48: "s51", 49: "s53", 50: "s54", 51: "s55", 52: "r38", 53: "r38", 54: "r38", 55: "r38", 57: "r38" }, { 23: "r14", 24: "r14", 25: "r14", 26: "r14", 27: "r14", 28: "r14", 29: "r14", 30: "r14", 31: "r14", 32: "r14", 33: "r14", 34: "r14", 35: "r14", 36: "r14", 37: "r14", 38: "r14", 39: "r14", 40: "r14", 41: "r14", 42: "r14", 43: "r14", 44: "r14", 45: "r14", 52: "r14", 53: "r14", 54: "r14", 55: "r14", 57: "r14" }, { 23: "r15", 24: "r15", 25: "r15", 26: "r15", 27: "r15", 28: "r15", 29: "r15", 30: "r15", 31: "r15", 32: "r15", 33: "r15", 34: "r15", 35: "r15", 36: "r15", 37: "r15", 38: "r15", 39: "r15", 40: "r15", 41: "r15", 42: "r15", 43: "r15", 44: "r15", 45: "r15", 52: "r15", 53: "r15", 54: "r15", 55: "r15", 57: "r15" }, { 23: "r16", 24: "r16", 25: "r16", 26: "r16", 27: "r16", 28: "r16", 29: "r16", 30: "r16", 31: "r16", 32: "r16", 33: "r16", 34: "r16", 35: "r16", 36: "r16", 37: "r16", 38: "r16", 39: "r16", 40: "r16", 41: "r16", 42: "r16", 43: "r16", 44: "r16", 45: "r16", 52: "r16", 53: "r16", 54: "r16", 55: "r16", 57: "r16" }, { 23: "r17", 24: "r17", 25: "r17", 26: "r17", 27: "r17", 28: "r17", 29: "r17", 30: "r17", 31: "r17", 32: "r17", 33: "r17", 34: "r17", 35: "r17", 36: "r17", 37: "r17", 38: "r17", 39: "r17", 40: "r17", 41: "r17", 42: "r17", 43: "r17", 44: "r17", 45: "r17", 52: "r17", 53: "r17", 54: "r17", 55: "r17", 57: "r17" }, { 4: 57, 5: 5, 6: 6, 24: "r10", 25: "r10", 26: "r10", 27: "r10", 28: "r10", 29: "r10", 30: "r10", 31: "r10", 32: "r10", 33: "r10", 34: "r10", 35: "r10", 36: "r10", 37: "r10", 38: "r10", 39: "r10", 40: "r10", 41: "r10", 42: "r10", 43: "r10", 44: "r10", 45: "r10", 52: "r10", 53: "r10", 54: "r10", 55: "r10", 57: "r10" }, { 4: 59, 5: 5, 6: 6, 24: "r10", 25: "r10", 26: "r10", 27: "r10", 28: "r10", 29: "r10", 30: "r10", 31: "r10", 32: "r10", 33: "r10", 34: "r10", 35: "r10", 36: "r10", 37: "r10", 38: "r10", 39: "r10", 40: "r10", 41: "r10", 42: "r10", 43: "r10", 44: "r10", 45: "r10", 52: "r10", 53: "r10", 54: "r10", 55: "r10", 57: "r10" }, { 4: 61, 5: 5, 6: 6, 24: "r10", 25: "r10", 26: "r10", 27: "r10", 28: "r10", 29: "r10", 30: "r10", 31: "r10", 32: "r10", 33: "r10", 34: "r10", 35: "r10", 36: "r10", 37: "r10", 38: "r10", 39: "r10", 40: "r10", 41: "r10", 42: "r10", 43: "r10", 44: "r10", 45: "r10", 52: "r10", 53: "r10", 54: "r10", 55: "r10", 57: "r10" }, { 4: 63, 5: 5, 6: 6, 24: "r10", 25: "r10", 26: "r10", 27: "r10", 28: "r10", 29: "r10", 30: "r10", 31: "r10", 32: "r10", 33: "r10", 34: "r10", 35: "r10", 36: "r10", 37: "r10", 38: "r10", 39: "r10", 40: "r10", 41: "r10", 42: "r10", 43: "r10", 44: "r10", 45: "r10", 52: "r10", 53: "r10", 54: "r10", 55: "r10", 57: "r10" }, { 23: "r22", 24: "r22", 25: "r22", 26: "r22", 27: "r22", 28: "r22", 29: "r22", 30: "r22", 31: "r22", 32: "r22", 33: "r22", 34: "r22", 35: "r22", 36: "r22", 37: "r22", 38: "r22", 39: "r22", 40: "r22", 41: "r22", 42: "r22", 43: "r22", 44: "r22", 45: "r22", 46: "r22", 47: "r22", 48: "r22", 49: "r22", 50: "r22", 51: "r22", 52: "r22", 53: "r22", 54: "r22", 55: "r22", 57: "r22" }, { 23: "r23", 24: "r23", 25: "r23", 26: "r23", 27: "r23", 28: "r23", 29: "r23", 30: "r23", 31: "r23", 32: "r23", 33: "r23", 34: "r23", 35: "r23", 36: "r23", 37: "r23", 38: "r23", 39: "r23", 40: "r23", 41: "r23", 42: "r23", 43: "r23", 44: "r23", 45: "r23", 46: "r23", 47: "r23", 48: "r23", 49: "r23", 50: "r23", 51: "r23", 52: "r23", 53: "r23", 54: "r23", 55: "r23", 57: "r23" }, { 23: "r24", 24: "r24", 25: "r24", 26: "r24", 27: "r24", 28: "r24", 29: "r24", 30: "r24", 31: "r24", 32: "r24", 33: "r24", 34: "r24", 35: "r24", 36: "r24", 37: "r24", 38: "r24", 39: "r24", 40: "r24", 41: "r24", 42: "r24", 43: "r24", 44: "r24", 45: "r24", 46: "r24", 47: "r24", 48: "r24", 49: "r24", 50: "r24", 51: "r24", 52: "r24", 53: "r24", 54: "r24", 55: "r24", 57: "r24" }, { 23: "r25", 24: "r25", 25: "r25", 26: "r25", 27: "r25", 28: "r25", 29: "r25", 30: "r25", 31: "r25", 32: "r25", 33: "r25", 34: "r25", 35: "r25", 36: "r25", 37: "r25", 38: "r25", 39: "r25", 40: "r25", 41: "r25", 42: "r25", 43: "r25", 44: "r25", 45: "r25", 46: "r25", 47: "r25", 48: "r25", 49: "r25", 50: "r25", 51: "r25", 52: "r25", 53: "r25", 54: "r25", 55: "r25", 56: "r25", 57: "r25", 58: "r25" }, { 23: "r26", 24: "r26", 25: "r26", 26: "r26", 27: "r26", 28: "r26", 29: "r26", 30: "r26", 31: "r26", 32: "r26", 33: "r26", 34: "r26", 35: "r26", 36: "r26", 37: "r26", 38: "r26", 39: "r26", 40: "r26", 41: "r26", 42: "r26", 43: "r26", 44: "r26", 45: "r26", 46: "r26", 47: "r26", 48: "r26", 49: "r26", 50: "r26", 51: "r26", 52: "r26", 53: "r26", 54: "r26", 55: "r26", 56: "r26", 57: "r26", 58: "r26" }, { 23: "r27", 24: "r27", 25: "r27", 26: "r27", 27: "r27", 28: "r27", 29: "r27", 30: "r27", 31: "r27", 32: "r27", 33: "r27", 34: "r27", 35: "r27", 36: "r27", 37: "r27", 38: "r27", 39: "r27", 40: "r27", 41: "r27", 42: "r27", 43: "r27", 44: "r27", 45: "r27", 46: "r27", 47: "r27", 48: "r27", 49: "r27", 50: "r27", 51: "r27", 52: "r27", 53: "r27", 54: "r27", 55: "r27", 56: "r27", 57: "r27", 58: "r27" }, { 23: "r28", 24: "r28", 25: "r28", 26: "r28", 27: "r28", 28: "r28", 29: "r28", 30: "r28", 31: "r28", 32: "r28", 33: "r28", 34: "r28", 35: "r28", 36: "r28", 37: "r28", 38: "r28", 39: "r28", 40: "r28", 41: "r28", 42: "r28", 43: "r28", 44: "r28", 45: "r28", 46: "r28", 47: "r28", 48: "r28", 49: "r28", 50: "r28", 51: "r28", 52: "r28", 53: "r28", 54: "r28", 55: "r28", 56: "r28", 57: "r28", 58: "r28" }, { 23: "r29", 24: "r29", 25: "r29", 26: "r29", 27: "r29", 28: "r29", 29: "r29", 30: "r29", 31: "r29", 32: "r29", 33: "r29", 34: "r29", 35: "r29", 36: "r29", 37: "r29", 38: "r29", 39: "r29", 40: "r29", 41: "r29", 42: "r29", 43: "r29", 44: "r29", 45: "r29", 46: "r29", 47: "r29", 48: "r29", 49: "r29", 50: "r29", 51: "r29", 52: "r29", 53: "r29", 54: "r29", 55: "r29", 56: "r29", 57: "r29", 58: "r29" }, { 23: "r30", 24: "r30", 25: "r30", 26: "r30", 27: "r30", 28: "r30", 29: "r30", 30: "r30", 31: "r30", 32: "r30", 33: "r30", 34: "r30", 35: "r30", 36: "r30", 37: "r30", 38: "r30", 39: "r30", 40: "r30", 41: "r30", 42: "r30", 43: "r30", 44: "r30", 45: "r30", 46: "r30", 47: "r30", 48: "r30", 49: "r30", 50: "r30", 51: "r30", 52: "r30", 53: "r30", 54: "r30", 55: "r30", 56: "r30", 57: "r30", 58: "r30" }, { 23: "r31", 24: "r31", 25: "r31", 26: "r31", 27: "r31", 28: "r31", 29: "r31", 30: "r31", 31: "r31", 32: "r31", 33: "r31", 34: "r31", 35: "r31", 36: "r31", 37: "r31", 38: "r31", 39: "r31", 40: "r31", 41: "r31", 42: "r31", 43: "r31", 44: "r31", 45: "r31", 46: "r31", 47: "r31", 48: "r31", 49: "r31", 50: "r31", 51: "r31", 52: "r31", 53: "r31", 54: "r31", 55: "r31", 56: "r31", 57: "r31", 58: "r31" }, { 23: "r32", 24: "r32", 25: "r32", 26: "r32", 27: "r32", 28: "r32", 29: "r32", 30: "r32", 31: "r32", 32: "r32", 33: "r32", 34: "r32", 35: "r32", 36: "r32", 37: "r32", 38: "r32", 39: "r32", 40: "r32", 41: "r32", 42: "r32", 43: "r32", 44: "r32", 45: "r32", 46: "r32", 47: "r32", 48: "r32", 49: "r32", 50: "r32", 51: "r32", 52: "r32", 53: "r32", 54: "r32", 55: "r32", 56: "r32", 57: "r32", 58: "r32" }, { 23: "r33", 24: "r33", 25: "r33", 26: "r33", 27: "r33", 28: "r33", 29: "r33", 30: "r33", 31: "r33", 32: "r33", 33: "r33", 34: "r33", 35: "r33", 36: "r33", 37: "r33", 38: "r33", 39: "r33", 40: "r33", 41: "r33", 42: "r33", 43: "r33", 44: "r33", 45: "r33", 46: "r33", 47: "r33", 48: "r33", 49: "r33", 50: "r33", 51: "r33", 52: "r33", 53: "r33", 54: "r33", 55: "r33", 56: "r33", 57: "r33", 58: "r33" }, { 23: "r34", 24: "r34", 25: "r34", 26: "r34", 27: "r34", 28: "r34", 29: "r34", 30: "r34", 31: "r34", 32: "r34", 33: "r34", 34: "r34", 35: "r34", 36: "r34", 37: "r34", 38: "r34", 39: "r34", 40: "r34", 41: "r34", 42: "r34", 43: "r34", 44: "r34", 45: "r34", 46: "r34", 47: "r34", 48: "r34", 49: "r34", 50: "r34", 51: "r34", 52: "r34", 53: "r34", 54: "r34", 55: "r34", 56: "r34", 57: "r34", 58: "r34" }, { 23: "r35", 24: "r35", 25: "r35", 26: "r35", 27: "r35", 28: "r35", 29: "r35", 30: "r35", 31: "r35", 32: "r35", 33: "r35", 34: "r35", 35: "r35", 36: "r35", 37: "r35", 38: "r35", 39: "r35", 40: "r35", 41: "r35", 42: "r35", 43: "r35", 44: "r35", 45: "r35", 46: "r35", 47: "r35", 48: "r35", 49: "r35", 50: "r35", 51: "r35", 52: "r35", 53: "r35", 54: "r35", 55: "r35", 56: "r35", 57: "r35", 58: "r35" }, { 23: "r36", 24: "r36", 25: "r36", 26: "r36", 27: "r36", 28: "r36", 29: "r36", 30: "r36", 31: "r36", 32: "r36", 33: "r36", 34: "r36", 35: "r36", 36: "r36", 37: "r36", 38: "r36", 39: "r36", 40: "r36", 41: "r36", 42: "r36", 43: "r36", 44: "r36", 45: "r36", 46: "r36", 47: "r36", 48: "r36", 49: "r36", 50: "r36", 51: "r36", 52: "r36", 53: "r36", 54: "r36", 55: "r36", 56: "r36", 57: "r36", 58: "r36" }, { 10: 70, 18: 65, 19: 66, 21: 67, 22: 69, 24: "s28", 28: "s71", 35: "s29", 36: "s30", 37: "s31", 38: "s32", 39: "s33", 40: "s34", 41: "s35", 42: "s36", 43: "s37", 44: "s38", 45: "s39", 56: "r54", 58: "s68" }, { 10: 70, 18: 83, 19: 66, 21: 67, 22: 69, 24: "s28", 28: "s71", 35: "s29", 36: "s30", 37: "s31", 38: "s32", 39: "s33", 40: "s34", 41: "s35", 42: "s36", 43: "s37", 44: "s38", 45: "s39", 56: "r54", 58: "s68" }, { 23: "r47", 24: "r47", 25: "r47", 26: "r47", 27: "r47", 28: "r47", 29: "r47", 30: "r47", 31: "r47", 32: "r47", 33: "r47", 34: "r47", 35: "r47", 36: "r47", 37: "r47", 38: "r47", 39: "r47", 40: "r47", 41: "r47", 42: "r47", 43: "r47", 44: "r47", 45: "r47", 46: "r47", 47: "r47", 48: "r47", 49: "r47", 50: "r47", 51: "r47", 52: "r47", 53: "r47", 54: "r47", 55: "r47", 57: "r47" }, { 23: "r48", 24: "r48", 25: "r48", 26: "r48", 27: "r48", 28: "r48", 29: "r48", 30: "r48", 31: "r48", 32: "r48", 33: "r48", 34: "r48", 35: "r48", 36: "r48", 37: "r48", 38: "r48", 39: "r48", 40: "r48", 41: "r48", 42: "r48", 43: "r48", 44: "r48", 45: "r48", 46: "r48", 47: "r48", 48: "r48", 49: "r48", 50: "r48", 51: "r48", 52: "r48", 53: "r48", 54: "r48", 55: "r48", 57: "r48" }, { 4: 85, 5: 5, 6: 6, 24: "r10", 25: "r10", 26: "r10", 27: "r10", 28: "r10", 29: "r10", 30: "r10", 31: "r10", 32: "r10", 33: "r10", 34: "r10", 35: "r10", 36: "r10", 37: "r10", 38: "r10", 39: "r10", 40: "r10", 41: "r10", 42: "r10", 43: "r10", 44: "r10", 45: "r10", 52: "r10", 53: "r10", 54: "r10", 55: "r10", 57: "r10" }, { 4: 87, 5: 5, 6: 6, 24: "r10", 25: "r10", 26: "r10", 27: "r10", 28: "r10", 29: "r10", 30: "r10", 31: "r10", 32: "r10", 33: "r10", 34: "r10", 35: "r10", 36: "r10", 37: "r10", 38: "r10", 39: "r10", 40: "r10", 41: "r10", 42: "r10", 43: "r10", 44: "r10", 45: "r10", 52: "r10", 53: "r10", 54: "r10", 55: "r10", 57: "r10" }, { 4: 89, 5: 5, 6: 6, 24: "r10", 25: "r10", 26: "r10", 27: "r10", 28: "r10", 29: "r10", 30: "r10", 31: "r10", 32: "r10", 33: "r10", 34: "r10", 35: "r10", 36: "r10", 37: "r10", 38: "r10", 39: "r10", 40: "r10", 41: "r10", 42: "r10", 43: "r10", 44: "r10", 45: "r10", 52: "r10", 53: "r10", 54: "r10", 55: "r10", 57: "r10" }, { 23: "r13", 24: "r13", 25: "r13", 26: "r13", 27: "r13", 28: "r13", 29: "r13", 30: "r13", 31: "r13", 32: "r13", 33: "r13", 34: "r13", 35: "r13", 36: "r13", 37: "r13", 38: "r13", 39: "r13", 40: "r13", 41: "r13", 42: "r13", 43: "r13", 44: "r13", 45: "r13", 52: "r13", 53: "r13", 54: "r13", 55: "r13", 57: "r13" }, { 23: "r37", 24: "r37", 25: "r37", 26: "r37", 27: "r37", 28: "r37", 29: "r37", 30: "r37", 31: "r37", 32: "r37", 33: "r37", 34: "r37", 35: "r37", 36: "r37", 37: "r37", 38: "r37", 39: "r37", 40: "r37", 41: "r37", 42: "r37", 43: "r37", 44: "r37", 45: "r37", 52: "r37", 53: "r37", 54: "r37", 55: "r37", 57: "r37" }, { 23: "r39", 24: "r39", 25: "r39", 26: "r39", 27: "r39", 28: "r39", 29: "r39", 30: "r39", 31: "r39", 32: "r39", 33: "r39", 34: "r39", 35: "r39", 36: "r39", 37: "r39", 38: "r39", 39: "r39", 40: "r39", 41: "r39", 42: "r39", 43: "r39", 44: "r39", 45: "r39", 46: "s56", 52: "r39", 53: "r39", 54: "r39", 55: "r39", 57: "r39" }, { 23: "r41", 24: "r41", 25: "r41", 26: "r41", 27: "r41", 28: "r41", 29: "r41", 30: "r41", 31: "r41", 32: "r41", 33: "r41", 34: "r41", 35: "r41", 36: "r41", 37: "r41", 38: "r41", 39: "r41", 40: "r41", 41: "r41", 42: "r41", 43: "r41", 44: "r41", 45: "r41", 46: "r41", 52: "r41", 53: "r41", 54: "r41", 55: "r41", 57: "r41" }, { 23: "r42", 24: "r42", 25: "r42", 26: "r42", 27: "r42", 28: "r42", 29: "r42", 30: "r42", 31: "r42", 32: "r42", 33: "r42", 34: "r42", 35: "r42", 36: "r42", 37: "r42", 38: "r42", 39: "r42", 40: "r42", 41: "r42", 42: "r42", 43: "r42", 44: "r42", 45: "r42", 46: "r42", 52: "r42", 53: "r42", 54: "r42", 55: "r42", 57: "r42" }, { 23: "r43", 24: "r43", 25: "r43", 26: "r43", 27: "r43", 28: "r43", 29: "r43", 30: "r43", 31: "r43", 32: "r43", 33: "r43", 34: "r43", 35: "r43", 36: "r43", 37: "r43", 38: "r43", 39: "r43", 40: "r43", 41: "r43", 42: "r43", 43: "r43", 44: "r43", 45: "r43", 46: "r43", 52: "r43", 53: "r43", 54: "r43", 55: "r43", 57: "r43" }, { 23: "r44", 24: "r44", 25: "r44", 26: "r44", 27: "r44", 28: "r44", 29: "r44", 30: "r44", 31: "r44", 32: "r44", 33: "r44", 34: "r44", 35: "r44", 36: "r44", 37: "r44", 38: "r44", 39: "r44", 40: "r44", 41: "r44", 42: "r44", 43: "r44", 44: "r44", 45: "r44", 46: "r44", 52: "r44", 53: "r44", 54: "r44", 55: "r44", 57: "r44" }, { 23: "r45", 24: "r45", 25: "r45", 26: "r45", 27: "r45", 28: "r45", 29: "r45", 30: "r45", 31: "r45", 32: "r45", 33: "r45", 34: "r45", 35: "r45", 36: "r45", 37: "r45", 38: "r45", 39: "r45", 40: "r45", 41: "r45", 42: "r45", 43: "r45", 44: "r45", 45: "r45", 46: "r45", 52: "r45", 53: "r45", 54: "r45", 55: "r45", 57: "r45" }, { 23: "r46", 24: "r46", 25: "r46", 26: "r46", 27: "r46", 28: "r46", 29: "r46", 30: "r46", 31: "r46", 32: "r46", 33: "r46", 34: "r46", 35: "r46", 36: "r46", 37: "r46", 38: "r46", 39: "r46", 40: "r46", 41: "r46", 42: "r46", 43: "r46", 44: "r46", 45: "r46", 46: "r46", 52: "r46", 53: "r46", 54: "r46", 55: "r46", 57: "r46" }, { 23: "r40", 24: "r40", 25: "r40", 26: "r40", 27: "r40", 28: "r40", 29: "r40", 30: "r40", 31: "r40", 32: "r40", 33: "r40", 34: "r40", 35: "r40", 36: "r40", 37: "r40", 38: "r40", 39: "r40", 40: "r40", 41: "r40", 42: "r40", 43: "r40", 44: "r40", 45: "r40", 52: "r40", 53: "r40", 54: "r40", 55: "r40", 57: "r40" }, { 25: "s12", 31: "s58" }, { 23: "r18", 24: "r18", 25: "r18", 26: "r18", 27: "r18", 28: "r18", 29: "r18", 30: "r18", 31: "r18", 32: "r18", 33: "r18", 34: "r18", 35: "r18", 36: "r18", 37: "r18", 38: "r18", 39: "r18", 40: "r18", 41: "r18", 42: "r18", 43: "r18", 44: "r18", 45: "r18", 52: "r18", 53: "r18", 54: "r18", 55: "r18", 57: "r18" }, { 25: "s12", 31: "s60" }, { 23: "r19", 24: "r19", 25: "r19", 26: "r19", 27: "r19", 28: "r19", 29: "r19", 30: "r19", 31: "r19", 32: "r19", 33: "r19", 34: "r19", 35: "r19", 36: "r19", 37: "r19", 38: "r19", 39: "r19", 40: "r19", 41: "r19", 42: "r19", 43: "r19", 44: "r19", 45: "r19", 52: "r19", 53: "r19", 54: "r19", 55: "r19", 57: "r19" }, { 25: "s12", 31: "s62" }, { 23: "r20", 24: "r20", 25: "r20", 26: "r20", 27: "r20", 28: "r20", 29: "r20", 30: "r20", 31: "r20", 32: "r20", 33: "r20", 34: "r20", 35: "r20", 36: "r20", 37: "r20", 38: "r20", 39: "r20", 40: "r20", 41: "r20", 42: "r20", 43: "r20", 44: "r20", 45: "r20", 52: "r20", 53: "r20", 54: "r20", 55: "r20", 57: "r20" }, { 25: "s12", 31: "s64" }, { 23: "r21", 24: "r21", 25: "r21", 26: "r21", 27: "r21", 28: "r21", 29: "r21", 30: "r21", 31: "r21", 32: "r21", 33: "r21", 34: "r21", 35: "r21", 36: "r21", 37: "r21", 38: "r21", 39: "r21", 40: "r21", 41: "r21", 42: "r21", 43: "r21", 44: "r21", 45: "r21", 52: "r21", 53: "r21", 54: "r21", 55: "r21", 57: "r21" }, { 56: "s72" }, { 56: "r55" }, { 10: 70, 20: 73, 21: 75, 22: 76, 24: "s28", 28: "s71", 35: "s29", 36: "s30", 37: "s31", 38: "s32", 39: "s33", 40: "s34", 41: "s35", 42: "s36", 43: "s37", 44: "s38", 45: "s39", 56: "r56", 58: "s74" }, { 24: "r62", 28: "r62", 35: "r62", 36: "r62", 37: "r62", 38: "r62", 39: "r62", 40: "r62", 41: "r62", 42: "r62", 43: "r62", 44: "r62", 45: "r62", 56: "r62", 58: "r62" }, { 24: "r63", 28: "r63", 35: "r63", 36: "r63", 37: "r63", 38: "r63", 39: "r63", 40: "r63", 41: "r63", 42: "r63", 43: "r63", 44: "r63", 45: "r63", 56: "r63", 58: "r63" }, { 24: "r64", 28: "r64", 35: "r64", 36: "r64", 37: "r64", 38: "r64", 39: "r64", 40: "r64", 41: "r64", 42: "r64", 43: "r64", 44: "r64", 45: "r64", 56: "r64", 58: "r64" }, { 24: "r65", 28: "r65", 35: "r65", 36: "r65", 37: "r65", 38: "r65", 39: "r65", 40: "r65", 41: "r65", 42: "r65", 43: "r65", 44: "r65", 45: "r65", 56: "r65", 58: "r65" }, { 23: "r52", 24: "r52", 25: "r52", 26: "r52", 27: "r52", 28: "r52", 29: "r52", 30: "r52", 31: "r52", 32: "r52", 33: "r52", 34: "r52", 35: "r52", 36: "r52", 37: "r52", 38: "r52", 39: "r52", 40: "r52", 41: "r52", 42: "r52", 43: "r52", 44: "r52", 45: "r52", 46: "r52", 47: "r52", 48: "r52", 49: "r52", 50: "r52", 51: "r52", 52: "r52", 53: "r52", 54: "r52", 55: "r52", 57: "r52" }, { 56: "r57" }, { 10: 70, 21: 77, 22: 69, 24: "s28", 28: "s71", 35: "s29", 36: "s30", 37: "s31", 38: "s32", 39: "s33", 40: "s34", 41: "s35", 42: "s36", 43: "s37", 44: "s38", 45: "s39", 56: "r62", 58: "s68" }, { 56: "r59" }, { 10: 70, 20: 79, 21: 75, 22: 76, 24: "s28", 28: "s71", 35: "s29", 36: "s30", 37: "s31", 38: "s32", 39: "s33", 40: "s34", 41: "s35", 42: "s36", 43: "s37", 44: "s38", 45: "s39", 56: "r63", 58: "s80" }, { 10: 70, 18: 78, 19: 66, 21: 67, 22: 69, 24: "s28", 28: "s71", 35: "s29", 36: "s30", 37: "s31", 38: "s32", 39: "s33", 40: "s34", 41: "s35", 42: "s36", 43: "s37", 44: "s38", 45: "s39", 56: "r54", 58: "s68" }, { 56: "r58" }, { 56: "r60" }, { 10: 70, 21: 81, 22: 69, 24: "s28", 28: "s71", 35: "s29", 36: "s30", 37: "s31", 38: "s32", 39: "s33", 40: "s34", 41: "s35", 42: "s36", 43: "s37", 44: "s38", 45: "s39", 56: "r62", 58: "s68" }, { 10: 70, 18: 82, 19: 66, 21: 67, 22: 69, 24: "s28", 28: "s71", 35: "s29", 36: "s30", 37: "s31", 38: "s32", 39: "s33", 40: "s34", 41: "s35", 42: "s36", 43: "s37", 44: "s38", 45: "s39", 56: "r54", 58: "s68" }, { 56: "r61" }, { 56: "s84" }, { 23: "r53", 24: "r53", 25: "r53", 26: "r53", 27: "r53", 28: "r53", 29: "r53", 30: "r53", 31: "r53", 32: "r53", 33: "r53", 34: "r53", 35: "r53", 36: "r53", 37: "r53", 38: "r53", 39: "r53", 40: "r53", 41: "r53", 42: "r53", 43: "r53", 44: "r53", 45: "r53", 46: "r53", 47: "r53", 48: "r53", 49: "r53", 50: "r53", 51: "r53", 52: "r53", 53: "r53", 54: "r53", 55: "r53", 57: "r53" }, { 25: "s12", 31: "s86" }, { 23: "r49", 24: "r49", 25: "r49", 26: "r49", 27: "r49", 28: "r49", 29: "r49", 30: "r49", 31: "r49", 32: "r49", 33: "r49", 34: "r49", 35: "r49", 36: "r49", 37: "r49", 38: "r49", 39: "r49", 40: "r49", 41: "r49", 42: "r49", 43: "r49", 44: "r49", 45: "r49", 46: "r49", 47: "r49", 48: "r49", 49: "r49", 50: "r49", 51: "r49", 52: "r49", 53: "r49", 54: "r49", 55: "r49", 57: "r49" }, { 25: "s12", 31: "s88" }, { 23: "r50", 24: "r50", 25: "r50", 26: "r50", 27: "r50", 28: "r50", 29: "r50", 30: "r50", 31: "r50", 32: "r50", 33: "r50", 34: "r50", 35: "r50", 36: "r50", 37: "r50", 38: "r50", 39: "r50", 40: "r50", 41: "r50", 42: "r50", 43: "r50", 44: "r50", 45: "r50", 46: "r50", 47: "r50", 48: "r50", 49: "r50", 50: "r50", 51: "r50", 52: "r50", 53: "r50", 54: "r50", 55: "r50", 57: "r50" }, { 25: "s12", 31: "s90" }, { 23: "r51", 24: "r51", 25: "r51", 26: "r51", 27: "r51", 28: "r51", 29: "r51", 30: "r51", 31: "r51", 32: "r51", 33: "r51", 34: "r51", 35: "r51", 36: "r51", 37: "r51", 38: "r51", 39: "r51", 40: "r51", 41: "r51", 42: "r51", 43: "r51", 44: "r51", 45: "r51", 46: "r51", 47: "r51", 48: "r51", 49: "r51", 50: "r51", 51: "r51", 52: "r51", 53: "r51", 54: "r51", 55: "r51", 57: "r51" }], xe = [], ze = void 0, w_ = [[/^#[^\n]+/, function() {
}], [/^\s+/, function() {
}], [/^-/, function() {
  return "DASH";
}], [/^\//, function() {
  return "CHAR";
}], [/^#/, function() {
  return "CHAR";
}], [/^\|/, function() {
  return "CHAR";
}], [/^\./, function() {
  return "CHAR";
}], [/^\{/, function() {
  return "CHAR";
}], [/^\{\d+\}/, function() {
  return "RANGE_EXACT";
}], [/^\{\d+,\}/, function() {
  return "RANGE_OPEN";
}], [/^\{\d+,\d+\}/, function() {
  return "RANGE_CLOSED";
}], [/^\\k<(([\u0041-\u005a\u0061-\u007a\u00aa\u00b5\u00ba\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376-\u0377\u037a-\u037d\u037f\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u052f\u0531-\u0556\u0559\u0560-\u0588\u05d0-\u05ea\u05ef-\u05f2\u0620-\u064a\u066e-\u066f\u0671-\u06d3\u06d5\u06e5-\u06e6\u06ee-\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4-\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u0860-\u086a\u08a0-\u08b4\u08b6-\u08bd\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098c\u098f-\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc-\u09dd\u09df-\u09e1\u09f0-\u09f1\u09fc\u0a05-\u0a0a\u0a0f-\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32-\u0a33\u0a35-\u0a36\u0a38-\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2-\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0-\u0ae1\u0af9\u0b05-\u0b0c\u0b0f-\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32-\u0b33\u0b35-\u0b39\u0b3d\u0b5c-\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99-\u0b9a\u0b9c\u0b9e-\u0b9f\u0ba3-\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c39\u0c3d\u0c58-\u0c5a\u0c60-\u0c61\u0c80\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0-\u0ce1\u0cf1-\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d54-\u0d56\u0d5f-\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32-\u0e33\u0e40-\u0e46\u0e81-\u0e82\u0e84\u0e86-\u0e8a\u0e8c-\u0ea3\u0ea5\u0ea7-\u0eb0\u0eb2-\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065-\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f5\u13f8-\u13fd\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f8\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1878\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191e\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19b0-\u19c9\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae-\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1c80-\u1c88\u1c90-\u1cba\u1cbd-\u1cbf\u1ce9-\u1cec\u1cee-\u1cf3\u1cf5-\u1cf6\u1cfa\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2118-\u211d\u2124\u2126\u2128\u212a-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2-\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309b-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312f\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fef\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a-\ua62b\ua640-\ua66e\ua67f-\ua69d\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua7bf\ua7c2-\ua7c6\ua7f7-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua8fd-\ua8fe\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\ua9e0-\ua9e4\ua9e6-\ua9ef\ua9fa-\ua9fe\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa7e-\uaaaf\uaab1\uaab5-\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uab30-\uab5a\uab5c-\uab67\uab70-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc]|\ud800[\udc00-\udc0b\udc0d-\udc26\udc28-\udc3a\udc3c-\udc3d\udc3f-\udc4d\udc50-\udc5d\udc80-\udcfa\udd40-\udd74\ude80-\ude9c\udea0-\uded0\udf00-\udf1f\udf2d-\udf4a\udf50-\udf75\udf80-\udf9d\udfa0-\udfc3\udfc8-\udfcf\udfd1-\udfd5]|\ud801[\udc00-\udc9d\udcb0-\udcd3\udcd8-\udcfb\udd00-\udd27\udd30-\udd63\ude00-\udf36\udf40-\udf55\udf60-\udf67]|\ud802[\udc00-\udc05\udc08\udc0a-\udc35\udc37-\udc38\udc3c\udc3f-\udc55\udc60-\udc76\udc80-\udc9e\udce0-\udcf2\udcf4-\udcf5\udd00-\udd15\udd20-\udd39\udd80-\uddb7\uddbe-\uddbf\ude00\ude10-\ude13\ude15-\ude17\ude19-\ude35\ude60-\ude7c\ude80-\ude9c\udec0-\udec7\udec9-\udee4\udf00-\udf35\udf40-\udf55\udf60-\udf72\udf80-\udf91]|\ud803[\udc00-\udc48\udc80-\udcb2\udcc0-\udcf2\udd00-\udd23\udf00-\udf1c\udf27\udf30-\udf45\udfe0-\udff6]|\ud804[\udc03-\udc37\udc83-\udcaf\udcd0-\udce8\udd03-\udd26\udd44\udd50-\udd72\udd76\udd83-\uddb2\uddc1-\uddc4\uddda\udddc\ude00-\ude11\ude13-\ude2b\ude80-\ude86\ude88\ude8a-\ude8d\ude8f-\ude9d\ude9f-\udea8\udeb0-\udede\udf05-\udf0c\udf0f-\udf10\udf13-\udf28\udf2a-\udf30\udf32-\udf33\udf35-\udf39\udf3d\udf50\udf5d-\udf61]|\ud805[\udc00-\udc34\udc47-\udc4a\udc5f\udc80-\udcaf\udcc4-\udcc5\udcc7\udd80-\uddae\uddd8-\udddb\ude00-\ude2f\ude44\ude80-\udeaa\udeb8\udf00-\udf1a]|\ud806[\udc00-\udc2b\udca0-\udcdf\udcff\udda0-\udda7\uddaa-\uddd0\udde1\udde3\ude00\ude0b-\ude32\ude3a\ude50\ude5c-\ude89\ude9d\udec0-\udef8]|\ud807[\udc00-\udc08\udc0a-\udc2e\udc40\udc72-\udc8f\udd00-\udd06\udd08-\udd09\udd0b-\udd30\udd46\udd60-\udd65\udd67-\udd68\udd6a-\udd89\udd98\udee0-\udef2]|\ud808[\udc00-\udf99]|\ud809[\udc00-\udc6e\udc80-\udd43]|\ud80c[\udc00-\udfff]|\ud80d[\udc00-\udc2e]|\ud811[\udc00-\ude46]|\ud81a[\udc00-\ude38\ude40-\ude5e\uded0-\udeed\udf00-\udf2f\udf40-\udf43\udf63-\udf77\udf7d-\udf8f]|\ud81b[\ude40-\ude7f\udf00-\udf4a\udf50\udf93-\udf9f\udfe0-\udfe1\udfe3]|\ud81c[\udc00-\udfff]|\ud81d[\udc00-\udfff]|\ud81e[\udc00-\udfff]|\ud81f[\udc00-\udfff]|\ud820[\udc00-\udfff]|\ud821[\udc00-\udff7]|\ud822[\udc00-\udef2]|\ud82c[\udc00-\udd1e\udd50-\udd52\udd64-\udd67\udd70-\udefb]|\ud82f[\udc00-\udc6a\udc70-\udc7c\udc80-\udc88\udc90-\udc99]|\ud835[\udc00-\udc54\udc56-\udc9c\udc9e-\udc9f\udca2\udca5-\udca6\udca9-\udcac\udcae-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd1e-\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd52-\udea5\udea8-\udec0\udec2-\udeda\udedc-\udefa\udefc-\udf14\udf16-\udf34\udf36-\udf4e\udf50-\udf6e\udf70-\udf88\udf8a-\udfa8\udfaa-\udfc2\udfc4-\udfcb]|\ud838[\udd00-\udd2c\udd37-\udd3d\udd4e\udec0-\udeeb]|\ud83a[\udc00-\udcc4\udd00-\udd43\udd4b]|\ud83b[\ude00-\ude03\ude05-\ude1f\ude21-\ude22\ude24\ude27\ude29-\ude32\ude34-\ude37\ude39\ude3b\ude42\ude47\ude49\ude4b\ude4d-\ude4f\ude51-\ude52\ude54\ude57\ude59\ude5b\ude5d\ude5f\ude61-\ude62\ude64\ude67-\ude6a\ude6c-\ude72\ude74-\ude77\ude79-\ude7c\ude7e\ude80-\ude89\ude8b-\ude9b\udea1-\udea3\udea5-\udea9\udeab-\udebb]|\ud840[\udc00-\udfff]|\ud841[\udc00-\udfff]|\ud842[\udc00-\udfff]|\ud843[\udc00-\udfff]|\ud844[\udc00-\udfff]|\ud845[\udc00-\udfff]|\ud846[\udc00-\udfff]|\ud847[\udc00-\udfff]|\ud848[\udc00-\udfff]|\ud849[\udc00-\udfff]|\ud84a[\udc00-\udfff]|\ud84b[\udc00-\udfff]|\ud84c[\udc00-\udfff]|\ud84d[\udc00-\udfff]|\ud84e[\udc00-\udfff]|\ud84f[\udc00-\udfff]|\ud850[\udc00-\udfff]|\ud851[\udc00-\udfff]|\ud852[\udc00-\udfff]|\ud853[\udc00-\udfff]|\ud854[\udc00-\udfff]|\ud855[\udc00-\udfff]|\ud856[\udc00-\udfff]|\ud857[\udc00-\udfff]|\ud858[\udc00-\udfff]|\ud859[\udc00-\udfff]|\ud85a[\udc00-\udfff]|\ud85b[\udc00-\udfff]|\ud85c[\udc00-\udfff]|\ud85d[\udc00-\udfff]|\ud85e[\udc00-\udfff]|\ud85f[\udc00-\udfff]|\ud860[\udc00-\udfff]|\ud861[\udc00-\udfff]|\ud862[\udc00-\udfff]|\ud863[\udc00-\udfff]|\ud864[\udc00-\udfff]|\ud865[\udc00-\udfff]|\ud866[\udc00-\udfff]|\ud867[\udc00-\udfff]|\ud868[\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|\ud86a[\udc00-\udfff]|\ud86b[\udc00-\udfff]|\ud86c[\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d\udc20-\udfff]|\ud86f[\udc00-\udfff]|\ud870[\udc00-\udfff]|\ud871[\udc00-\udfff]|\ud872[\udc00-\udfff]|\ud873[\udc00-\udea1\udeb0-\udfff]|\ud874[\udc00-\udfff]|\ud875[\udc00-\udfff]|\ud876[\udc00-\udfff]|\ud877[\udc00-\udfff]|\ud878[\udc00-\udfff]|\ud879[\udc00-\udfff]|\ud87a[\udc00-\udfe0]|\ud87e[\udc00-\ude1d])|[$_]|(\\u[0-9a-fA-F]{4}|\\u\{[0-9a-fA-F]{1,}\}))(([\u0030-\u0039\u0041-\u005a\u005f\u0061-\u007a\u00aa\u00b5\u00b7\u00ba\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0300-\u0374\u0376-\u0377\u037a-\u037d\u037f\u0386-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u0483-\u0487\u048a-\u052f\u0531-\u0556\u0559\u0560-\u0588\u0591-\u05bd\u05bf\u05c1-\u05c2\u05c4-\u05c5\u05c7\u05d0-\u05ea\u05ef-\u05f2\u0610-\u061a\u0620-\u0669\u066e-\u06d3\u06d5-\u06dc\u06df-\u06e8\u06ea-\u06fc\u06ff\u0710-\u074a\u074d-\u07b1\u07c0-\u07f5\u07fa\u07fd\u0800-\u082d\u0840-\u085b\u0860-\u086a\u08a0-\u08b4\u08b6-\u08bd\u08d3-\u08e1\u08e3-\u0963\u0966-\u096f\u0971-\u0983\u0985-\u098c\u098f-\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bc-\u09c4\u09c7-\u09c8\u09cb-\u09ce\u09d7\u09dc-\u09dd\u09df-\u09e3\u09e6-\u09f1\u09fc\u09fe\u0a01-\u0a03\u0a05-\u0a0a\u0a0f-\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32-\u0a33\u0a35-\u0a36\u0a38-\u0a39\u0a3c\u0a3e-\u0a42\u0a47-\u0a48\u0a4b-\u0a4d\u0a51\u0a59-\u0a5c\u0a5e\u0a66-\u0a75\u0a81-\u0a83\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2-\u0ab3\u0ab5-\u0ab9\u0abc-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ad0\u0ae0-\u0ae3\u0ae6-\u0aef\u0af9-\u0aff\u0b01-\u0b03\u0b05-\u0b0c\u0b0f-\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32-\u0b33\u0b35-\u0b39\u0b3c-\u0b44\u0b47-\u0b48\u0b4b-\u0b4d\u0b56-\u0b57\u0b5c-\u0b5d\u0b5f-\u0b63\u0b66-\u0b6f\u0b71\u0b82-\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99-\u0b9a\u0b9c\u0b9e-\u0b9f\u0ba3-\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd0\u0bd7\u0be6-\u0bef\u0c00-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c39\u0c3d-\u0c44\u0c46-\u0c48\u0c4a-\u0c4d\u0c55-\u0c56\u0c58-\u0c5a\u0c60-\u0c63\u0c66-\u0c6f\u0c80-\u0c83\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbc-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5-\u0cd6\u0cde\u0ce0-\u0ce3\u0ce6-\u0cef\u0cf1-\u0cf2\u0d00-\u0d03\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d44\u0d46-\u0d48\u0d4a-\u0d4e\u0d54-\u0d57\u0d5f-\u0d63\u0d66-\u0d6f\u0d7a-\u0d7f\u0d82-\u0d83\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0de6-\u0def\u0df2-\u0df3\u0e01-\u0e3a\u0e40-\u0e4e\u0e50-\u0e59\u0e81-\u0e82\u0e84\u0e86-\u0e8a\u0e8c-\u0ea3\u0ea5\u0ea7-\u0ebd\u0ec0-\u0ec4\u0ec6\u0ec8-\u0ecd\u0ed0-\u0ed9\u0edc-\u0edf\u0f00\u0f18-\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f3e-\u0f47\u0f49-\u0f6c\u0f71-\u0f84\u0f86-\u0f97\u0f99-\u0fbc\u0fc6\u1000-\u1049\u1050-\u109d\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u135d-\u135f\u1369-\u1371\u1380-\u138f\u13a0-\u13f5\u13f8-\u13fd\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f8\u1700-\u170c\u170e-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176c\u176e-\u1770\u1772-\u1773\u1780-\u17d3\u17d7\u17dc-\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u1820-\u1878\u1880-\u18aa\u18b0-\u18f5\u1900-\u191e\u1920-\u192b\u1930-\u193b\u1946-\u196d\u1970-\u1974\u1980-\u19ab\u19b0-\u19c9\u19d0-\u19da\u1a00-\u1a1b\u1a20-\u1a5e\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1aa7\u1ab0-\u1abd\u1b00-\u1b4b\u1b50-\u1b59\u1b6b-\u1b73\u1b80-\u1bf3\u1c00-\u1c37\u1c40-\u1c49\u1c4d-\u1c7d\u1c80-\u1c88\u1c90-\u1cba\u1cbd-\u1cbf\u1cd0-\u1cd2\u1cd4-\u1cfa\u1d00-\u1df9\u1dfb-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u203f-\u2040\u2054\u2071\u207f\u2090-\u209c\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2102\u2107\u210a-\u2113\u2115\u2118-\u211d\u2124\u2126\u2128\u212a-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d7f-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2de0-\u2dff\u3005-\u3007\u3021-\u302f\u3031-\u3035\u3038-\u303c\u3041-\u3096\u3099-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312f\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fef\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua62b\ua640-\ua66f\ua674-\ua67d\ua67f-\ua6f1\ua717-\ua71f\ua722-\ua788\ua78b-\ua7bf\ua7c2-\ua7c6\ua7f7-\ua827\ua840-\ua873\ua880-\ua8c5\ua8d0-\ua8d9\ua8e0-\ua8f7\ua8fb\ua8fd-\ua92d\ua930-\ua953\ua960-\ua97c\ua980-\ua9c0\ua9cf-\ua9d9\ua9e0-\ua9fe\uaa00-\uaa36\uaa40-\uaa4d\uaa50-\uaa59\uaa60-\uaa76\uaa7a-\uaac2\uaadb-\uaadd\uaae0-\uaaef\uaaf2-\uaaf6\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uab30-\uab5a\uab5c-\uab67\uab70-\uabea\uabec-\uabed\uabf0-\uabf9\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe00-\ufe0f\ufe20-\ufe2f\ufe33-\ufe34\ufe4d-\ufe4f\ufe70-\ufe74\ufe76-\ufefc\uff10-\uff19\uff21-\uff3a\uff3f\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc]|\ud800[\udc00-\udc0b\udc0d-\udc26\udc28-\udc3a\udc3c-\udc3d\udc3f-\udc4d\udc50-\udc5d\udc80-\udcfa\udd40-\udd74\uddfd\ude80-\ude9c\udea0-\uded0\udee0\udf00-\udf1f\udf2d-\udf4a\udf50-\udf7a\udf80-\udf9d\udfa0-\udfc3\udfc8-\udfcf\udfd1-\udfd5]|\ud801[\udc00-\udc9d\udca0-\udca9\udcb0-\udcd3\udcd8-\udcfb\udd00-\udd27\udd30-\udd63\ude00-\udf36\udf40-\udf55\udf60-\udf67]|\ud802[\udc00-\udc05\udc08\udc0a-\udc35\udc37-\udc38\udc3c\udc3f-\udc55\udc60-\udc76\udc80-\udc9e\udce0-\udcf2\udcf4-\udcf5\udd00-\udd15\udd20-\udd39\udd80-\uddb7\uddbe-\uddbf\ude00-\ude03\ude05-\ude06\ude0c-\ude13\ude15-\ude17\ude19-\ude35\ude38-\ude3a\ude3f\ude60-\ude7c\ude80-\ude9c\udec0-\udec7\udec9-\udee6\udf00-\udf35\udf40-\udf55\udf60-\udf72\udf80-\udf91]|\ud803[\udc00-\udc48\udc80-\udcb2\udcc0-\udcf2\udd00-\udd27\udd30-\udd39\udf00-\udf1c\udf27\udf30-\udf50\udfe0-\udff6]|\ud804[\udc00-\udc46\udc66-\udc6f\udc7f-\udcba\udcd0-\udce8\udcf0-\udcf9\udd00-\udd34\udd36-\udd3f\udd44-\udd46\udd50-\udd73\udd76\udd80-\uddc4\uddc9-\uddcc\uddd0-\uddda\udddc\ude00-\ude11\ude13-\ude37\ude3e\ude80-\ude86\ude88\ude8a-\ude8d\ude8f-\ude9d\ude9f-\udea8\udeb0-\udeea\udef0-\udef9\udf00-\udf03\udf05-\udf0c\udf0f-\udf10\udf13-\udf28\udf2a-\udf30\udf32-\udf33\udf35-\udf39\udf3b-\udf44\udf47-\udf48\udf4b-\udf4d\udf50\udf57\udf5d-\udf63\udf66-\udf6c\udf70-\udf74]|\ud805[\udc00-\udc4a\udc50-\udc59\udc5e-\udc5f\udc80-\udcc5\udcc7\udcd0-\udcd9\udd80-\uddb5\uddb8-\uddc0\uddd8-\udddd\ude00-\ude40\ude44\ude50-\ude59\ude80-\udeb8\udec0-\udec9\udf00-\udf1a\udf1d-\udf2b\udf30-\udf39]|\ud806[\udc00-\udc3a\udca0-\udce9\udcff\udda0-\udda7\uddaa-\uddd7\uddda-\udde1\udde3-\udde4\ude00-\ude3e\ude47\ude50-\ude99\ude9d\udec0-\udef8]|\ud807[\udc00-\udc08\udc0a-\udc36\udc38-\udc40\udc50-\udc59\udc72-\udc8f\udc92-\udca7\udca9-\udcb6\udd00-\udd06\udd08-\udd09\udd0b-\udd36\udd3a\udd3c-\udd3d\udd3f-\udd47\udd50-\udd59\udd60-\udd65\udd67-\udd68\udd6a-\udd8e\udd90-\udd91\udd93-\udd98\udda0-\udda9\udee0-\udef6]|\ud808[\udc00-\udf99]|\ud809[\udc00-\udc6e\udc80-\udd43]|\ud80c[\udc00-\udfff]|\ud80d[\udc00-\udc2e]|\ud811[\udc00-\ude46]|\ud81a[\udc00-\ude38\ude40-\ude5e\ude60-\ude69\uded0-\udeed\udef0-\udef4\udf00-\udf36\udf40-\udf43\udf50-\udf59\udf63-\udf77\udf7d-\udf8f]|\ud81b[\ude40-\ude7f\udf00-\udf4a\udf4f-\udf87\udf8f-\udf9f\udfe0-\udfe1\udfe3]|\ud81c[\udc00-\udfff]|\ud81d[\udc00-\udfff]|\ud81e[\udc00-\udfff]|\ud81f[\udc00-\udfff]|\ud820[\udc00-\udfff]|\ud821[\udc00-\udff7]|\ud822[\udc00-\udef2]|\ud82c[\udc00-\udd1e\udd50-\udd52\udd64-\udd67\udd70-\udefb]|\ud82f[\udc00-\udc6a\udc70-\udc7c\udc80-\udc88\udc90-\udc99\udc9d-\udc9e]|\ud834[\udd65-\udd69\udd6d-\udd72\udd7b-\udd82\udd85-\udd8b\uddaa-\uddad\ude42-\ude44]|\ud835[\udc00-\udc54\udc56-\udc9c\udc9e-\udc9f\udca2\udca5-\udca6\udca9-\udcac\udcae-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd1e-\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd52-\udea5\udea8-\udec0\udec2-\udeda\udedc-\udefa\udefc-\udf14\udf16-\udf34\udf36-\udf4e\udf50-\udf6e\udf70-\udf88\udf8a-\udfa8\udfaa-\udfc2\udfc4-\udfcb\udfce-\udfff]|\ud836[\ude00-\ude36\ude3b-\ude6c\ude75\ude84\ude9b-\ude9f\udea1-\udeaf]|\ud838[\udc00-\udc06\udc08-\udc18\udc1b-\udc21\udc23-\udc24\udc26-\udc2a\udd00-\udd2c\udd30-\udd3d\udd40-\udd49\udd4e\udec0-\udef9]|\ud83a[\udc00-\udcc4\udcd0-\udcd6\udd00-\udd4b\udd50-\udd59]|\ud83b[\ude00-\ude03\ude05-\ude1f\ude21-\ude22\ude24\ude27\ude29-\ude32\ude34-\ude37\ude39\ude3b\ude42\ude47\ude49\ude4b\ude4d-\ude4f\ude51-\ude52\ude54\ude57\ude59\ude5b\ude5d\ude5f\ude61-\ude62\ude64\ude67-\ude6a\ude6c-\ude72\ude74-\ude77\ude79-\ude7c\ude7e\ude80-\ude89\ude8b-\ude9b\udea1-\udea3\udea5-\udea9\udeab-\udebb]|\ud840[\udc00-\udfff]|\ud841[\udc00-\udfff]|\ud842[\udc00-\udfff]|\ud843[\udc00-\udfff]|\ud844[\udc00-\udfff]|\ud845[\udc00-\udfff]|\ud846[\udc00-\udfff]|\ud847[\udc00-\udfff]|\ud848[\udc00-\udfff]|\ud849[\udc00-\udfff]|\ud84a[\udc00-\udfff]|\ud84b[\udc00-\udfff]|\ud84c[\udc00-\udfff]|\ud84d[\udc00-\udfff]|\ud84e[\udc00-\udfff]|\ud84f[\udc00-\udfff]|\ud850[\udc00-\udfff]|\ud851[\udc00-\udfff]|\ud852[\udc00-\udfff]|\ud853[\udc00-\udfff]|\ud854[\udc00-\udfff]|\ud855[\udc00-\udfff]|\ud856[\udc00-\udfff]|\ud857[\udc00-\udfff]|\ud858[\udc00-\udfff]|\ud859[\udc00-\udfff]|\ud85a[\udc00-\udfff]|\ud85b[\udc00-\udfff]|\ud85c[\udc00-\udfff]|\ud85d[\udc00-\udfff]|\ud85e[\udc00-\udfff]|\ud85f[\udc00-\udfff]|\ud860[\udc00-\udfff]|\ud861[\udc00-\udfff]|\ud862[\udc00-\udfff]|\ud863[\udc00-\udfff]|\ud864[\udc00-\udfff]|\ud865[\udc00-\udfff]|\ud866[\udc00-\udfff]|\ud867[\udc00-\udfff]|\ud868[\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|\ud86a[\udc00-\udfff]|\ud86b[\udc00-\udfff]|\ud86c[\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d\udc20-\udfff]|\ud86f[\udc00-\udfff]|\ud870[\udc00-\udfff]|\ud871[\udc00-\udfff]|\ud872[\udc00-\udfff]|\ud873[\udc00-\udea1\udeb0-\udfff]|\ud874[\udc00-\udfff]|\ud875[\udc00-\udfff]|\ud876[\udc00-\udfff]|\ud877[\udc00-\udfff]|\ud878[\udc00-\udfff]|\ud879[\udc00-\udfff]|\ud87a[\udc00-\udfe0]|\ud87e[\udc00-\ude1d]|\udb40[\udd00-\uddef])|[$_]|(\\u[0-9a-fA-F]{4}|\\u\{[0-9a-fA-F]{1,}\})|[\u200c\u200d])*>/, function() {
  var e = ct.slice(3, -1);
  return o0(e, this.getCurrentState()), "NAMED_GROUP_REF";
}], [/^\\b/, function() {
  return "ESC_b";
}], [/^\\B/, function() {
  return "ESC_B";
}], [/^\\c[a-zA-Z]/, function() {
  return "CTRL_CH";
}], [/^\\0\d{1,2}/, function() {
  return "OCT_CODE";
}], [/^\\0/, function() {
  return "DEC_CODE";
}], [/^\\\d{1,3}/, function() {
  return "DEC_CODE";
}], [/^\\u[dD][89abAB][0-9a-fA-F]{2}\\u[dD][c-fC-F][0-9a-fA-F]{2}/, function() {
  return "U_CODE_SURROGATE";
}], [/^\\u\{[0-9a-fA-F]{1,}\}/, function() {
  return "U_CODE";
}], [/^\\u[0-9a-fA-F]{4}/, function() {
  return "U_CODE";
}], [/^\\[pP]\{\w+(?:=\w+)?\}/, function() {
  return "U_PROP_VALUE_EXP";
}], [/^\\x[0-9a-fA-F]{2}/, function() {
  return "HEX_CODE";
}], [/^\\[tnrdDsSwWvf]/, function() {
  return "META_CHAR";
}], [/^\\\//, function() {
  return "ESC_CHAR";
}], [/^\\[ #]/, function() {
  return "ESC_CHAR";
}], [/^\\[\^\$\.\*\+\?\(\)\\\[\]\{\}\|\/]/, function() {
  return "ESC_CHAR";
}], [/^\\[^*?+\[()\\|]/, function() {
  var e = this.getCurrentState();
  if (e === "u_class" && ct === "\\-")
    return "ESC_CHAR";
  if (e === "u" || e === "xu" || e === "u_class")
    throw new SyntaxError("invalid Unicode escape " + ct);
  return "ESC_CHAR";
}], [/^\(/, function() {
  return "CHAR";
}], [/^\)/, function() {
  return "CHAR";
}], [/^\(\?=/, function() {
  return "POS_LA_ASSERT";
}], [/^\(\?!/, function() {
  return "NEG_LA_ASSERT";
}], [/^\(\?<=/, function() {
  return "POS_LB_ASSERT";
}], [/^\(\?<!/, function() {
  return "NEG_LB_ASSERT";
}], [/^\(\?:/, function() {
  return "NON_CAPTURE_GROUP";
}], [/^\(\?<(([\u0041-\u005a\u0061-\u007a\u00aa\u00b5\u00ba\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376-\u0377\u037a-\u037d\u037f\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u052f\u0531-\u0556\u0559\u0560-\u0588\u05d0-\u05ea\u05ef-\u05f2\u0620-\u064a\u066e-\u066f\u0671-\u06d3\u06d5\u06e5-\u06e6\u06ee-\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4-\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u0860-\u086a\u08a0-\u08b4\u08b6-\u08bd\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098c\u098f-\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc-\u09dd\u09df-\u09e1\u09f0-\u09f1\u09fc\u0a05-\u0a0a\u0a0f-\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32-\u0a33\u0a35-\u0a36\u0a38-\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2-\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0-\u0ae1\u0af9\u0b05-\u0b0c\u0b0f-\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32-\u0b33\u0b35-\u0b39\u0b3d\u0b5c-\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99-\u0b9a\u0b9c\u0b9e-\u0b9f\u0ba3-\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c39\u0c3d\u0c58-\u0c5a\u0c60-\u0c61\u0c80\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0-\u0ce1\u0cf1-\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d54-\u0d56\u0d5f-\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32-\u0e33\u0e40-\u0e46\u0e81-\u0e82\u0e84\u0e86-\u0e8a\u0e8c-\u0ea3\u0ea5\u0ea7-\u0eb0\u0eb2-\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065-\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f5\u13f8-\u13fd\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f8\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1878\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191e\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19b0-\u19c9\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae-\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1c80-\u1c88\u1c90-\u1cba\u1cbd-\u1cbf\u1ce9-\u1cec\u1cee-\u1cf3\u1cf5-\u1cf6\u1cfa\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2118-\u211d\u2124\u2126\u2128\u212a-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2-\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309b-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312f\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fef\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a-\ua62b\ua640-\ua66e\ua67f-\ua69d\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua7bf\ua7c2-\ua7c6\ua7f7-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua8fd-\ua8fe\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\ua9e0-\ua9e4\ua9e6-\ua9ef\ua9fa-\ua9fe\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa7e-\uaaaf\uaab1\uaab5-\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uab30-\uab5a\uab5c-\uab67\uab70-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc]|\ud800[\udc00-\udc0b\udc0d-\udc26\udc28-\udc3a\udc3c-\udc3d\udc3f-\udc4d\udc50-\udc5d\udc80-\udcfa\udd40-\udd74\ude80-\ude9c\udea0-\uded0\udf00-\udf1f\udf2d-\udf4a\udf50-\udf75\udf80-\udf9d\udfa0-\udfc3\udfc8-\udfcf\udfd1-\udfd5]|\ud801[\udc00-\udc9d\udcb0-\udcd3\udcd8-\udcfb\udd00-\udd27\udd30-\udd63\ude00-\udf36\udf40-\udf55\udf60-\udf67]|\ud802[\udc00-\udc05\udc08\udc0a-\udc35\udc37-\udc38\udc3c\udc3f-\udc55\udc60-\udc76\udc80-\udc9e\udce0-\udcf2\udcf4-\udcf5\udd00-\udd15\udd20-\udd39\udd80-\uddb7\uddbe-\uddbf\ude00\ude10-\ude13\ude15-\ude17\ude19-\ude35\ude60-\ude7c\ude80-\ude9c\udec0-\udec7\udec9-\udee4\udf00-\udf35\udf40-\udf55\udf60-\udf72\udf80-\udf91]|\ud803[\udc00-\udc48\udc80-\udcb2\udcc0-\udcf2\udd00-\udd23\udf00-\udf1c\udf27\udf30-\udf45\udfe0-\udff6]|\ud804[\udc03-\udc37\udc83-\udcaf\udcd0-\udce8\udd03-\udd26\udd44\udd50-\udd72\udd76\udd83-\uddb2\uddc1-\uddc4\uddda\udddc\ude00-\ude11\ude13-\ude2b\ude80-\ude86\ude88\ude8a-\ude8d\ude8f-\ude9d\ude9f-\udea8\udeb0-\udede\udf05-\udf0c\udf0f-\udf10\udf13-\udf28\udf2a-\udf30\udf32-\udf33\udf35-\udf39\udf3d\udf50\udf5d-\udf61]|\ud805[\udc00-\udc34\udc47-\udc4a\udc5f\udc80-\udcaf\udcc4-\udcc5\udcc7\udd80-\uddae\uddd8-\udddb\ude00-\ude2f\ude44\ude80-\udeaa\udeb8\udf00-\udf1a]|\ud806[\udc00-\udc2b\udca0-\udcdf\udcff\udda0-\udda7\uddaa-\uddd0\udde1\udde3\ude00\ude0b-\ude32\ude3a\ude50\ude5c-\ude89\ude9d\udec0-\udef8]|\ud807[\udc00-\udc08\udc0a-\udc2e\udc40\udc72-\udc8f\udd00-\udd06\udd08-\udd09\udd0b-\udd30\udd46\udd60-\udd65\udd67-\udd68\udd6a-\udd89\udd98\udee0-\udef2]|\ud808[\udc00-\udf99]|\ud809[\udc00-\udc6e\udc80-\udd43]|\ud80c[\udc00-\udfff]|\ud80d[\udc00-\udc2e]|\ud811[\udc00-\ude46]|\ud81a[\udc00-\ude38\ude40-\ude5e\uded0-\udeed\udf00-\udf2f\udf40-\udf43\udf63-\udf77\udf7d-\udf8f]|\ud81b[\ude40-\ude7f\udf00-\udf4a\udf50\udf93-\udf9f\udfe0-\udfe1\udfe3]|\ud81c[\udc00-\udfff]|\ud81d[\udc00-\udfff]|\ud81e[\udc00-\udfff]|\ud81f[\udc00-\udfff]|\ud820[\udc00-\udfff]|\ud821[\udc00-\udff7]|\ud822[\udc00-\udef2]|\ud82c[\udc00-\udd1e\udd50-\udd52\udd64-\udd67\udd70-\udefb]|\ud82f[\udc00-\udc6a\udc70-\udc7c\udc80-\udc88\udc90-\udc99]|\ud835[\udc00-\udc54\udc56-\udc9c\udc9e-\udc9f\udca2\udca5-\udca6\udca9-\udcac\udcae-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd1e-\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd52-\udea5\udea8-\udec0\udec2-\udeda\udedc-\udefa\udefc-\udf14\udf16-\udf34\udf36-\udf4e\udf50-\udf6e\udf70-\udf88\udf8a-\udfa8\udfaa-\udfc2\udfc4-\udfcb]|\ud838[\udd00-\udd2c\udd37-\udd3d\udd4e\udec0-\udeeb]|\ud83a[\udc00-\udcc4\udd00-\udd43\udd4b]|\ud83b[\ude00-\ude03\ude05-\ude1f\ude21-\ude22\ude24\ude27\ude29-\ude32\ude34-\ude37\ude39\ude3b\ude42\ude47\ude49\ude4b\ude4d-\ude4f\ude51-\ude52\ude54\ude57\ude59\ude5b\ude5d\ude5f\ude61-\ude62\ude64\ude67-\ude6a\ude6c-\ude72\ude74-\ude77\ude79-\ude7c\ude7e\ude80-\ude89\ude8b-\ude9b\udea1-\udea3\udea5-\udea9\udeab-\udebb]|\ud840[\udc00-\udfff]|\ud841[\udc00-\udfff]|\ud842[\udc00-\udfff]|\ud843[\udc00-\udfff]|\ud844[\udc00-\udfff]|\ud845[\udc00-\udfff]|\ud846[\udc00-\udfff]|\ud847[\udc00-\udfff]|\ud848[\udc00-\udfff]|\ud849[\udc00-\udfff]|\ud84a[\udc00-\udfff]|\ud84b[\udc00-\udfff]|\ud84c[\udc00-\udfff]|\ud84d[\udc00-\udfff]|\ud84e[\udc00-\udfff]|\ud84f[\udc00-\udfff]|\ud850[\udc00-\udfff]|\ud851[\udc00-\udfff]|\ud852[\udc00-\udfff]|\ud853[\udc00-\udfff]|\ud854[\udc00-\udfff]|\ud855[\udc00-\udfff]|\ud856[\udc00-\udfff]|\ud857[\udc00-\udfff]|\ud858[\udc00-\udfff]|\ud859[\udc00-\udfff]|\ud85a[\udc00-\udfff]|\ud85b[\udc00-\udfff]|\ud85c[\udc00-\udfff]|\ud85d[\udc00-\udfff]|\ud85e[\udc00-\udfff]|\ud85f[\udc00-\udfff]|\ud860[\udc00-\udfff]|\ud861[\udc00-\udfff]|\ud862[\udc00-\udfff]|\ud863[\udc00-\udfff]|\ud864[\udc00-\udfff]|\ud865[\udc00-\udfff]|\ud866[\udc00-\udfff]|\ud867[\udc00-\udfff]|\ud868[\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|\ud86a[\udc00-\udfff]|\ud86b[\udc00-\udfff]|\ud86c[\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d\udc20-\udfff]|\ud86f[\udc00-\udfff]|\ud870[\udc00-\udfff]|\ud871[\udc00-\udfff]|\ud872[\udc00-\udfff]|\ud873[\udc00-\udea1\udeb0-\udfff]|\ud874[\udc00-\udfff]|\ud875[\udc00-\udfff]|\ud876[\udc00-\udfff]|\ud877[\udc00-\udfff]|\ud878[\udc00-\udfff]|\ud879[\udc00-\udfff]|\ud87a[\udc00-\udfe0]|\ud87e[\udc00-\ude1d])|[$_]|(\\u[0-9a-fA-F]{4}|\\u\{[0-9a-fA-F]{1,}\}))(([\u0030-\u0039\u0041-\u005a\u005f\u0061-\u007a\u00aa\u00b5\u00b7\u00ba\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0300-\u0374\u0376-\u0377\u037a-\u037d\u037f\u0386-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u0483-\u0487\u048a-\u052f\u0531-\u0556\u0559\u0560-\u0588\u0591-\u05bd\u05bf\u05c1-\u05c2\u05c4-\u05c5\u05c7\u05d0-\u05ea\u05ef-\u05f2\u0610-\u061a\u0620-\u0669\u066e-\u06d3\u06d5-\u06dc\u06df-\u06e8\u06ea-\u06fc\u06ff\u0710-\u074a\u074d-\u07b1\u07c0-\u07f5\u07fa\u07fd\u0800-\u082d\u0840-\u085b\u0860-\u086a\u08a0-\u08b4\u08b6-\u08bd\u08d3-\u08e1\u08e3-\u0963\u0966-\u096f\u0971-\u0983\u0985-\u098c\u098f-\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bc-\u09c4\u09c7-\u09c8\u09cb-\u09ce\u09d7\u09dc-\u09dd\u09df-\u09e3\u09e6-\u09f1\u09fc\u09fe\u0a01-\u0a03\u0a05-\u0a0a\u0a0f-\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32-\u0a33\u0a35-\u0a36\u0a38-\u0a39\u0a3c\u0a3e-\u0a42\u0a47-\u0a48\u0a4b-\u0a4d\u0a51\u0a59-\u0a5c\u0a5e\u0a66-\u0a75\u0a81-\u0a83\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2-\u0ab3\u0ab5-\u0ab9\u0abc-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ad0\u0ae0-\u0ae3\u0ae6-\u0aef\u0af9-\u0aff\u0b01-\u0b03\u0b05-\u0b0c\u0b0f-\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32-\u0b33\u0b35-\u0b39\u0b3c-\u0b44\u0b47-\u0b48\u0b4b-\u0b4d\u0b56-\u0b57\u0b5c-\u0b5d\u0b5f-\u0b63\u0b66-\u0b6f\u0b71\u0b82-\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99-\u0b9a\u0b9c\u0b9e-\u0b9f\u0ba3-\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd0\u0bd7\u0be6-\u0bef\u0c00-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c39\u0c3d-\u0c44\u0c46-\u0c48\u0c4a-\u0c4d\u0c55-\u0c56\u0c58-\u0c5a\u0c60-\u0c63\u0c66-\u0c6f\u0c80-\u0c83\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbc-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5-\u0cd6\u0cde\u0ce0-\u0ce3\u0ce6-\u0cef\u0cf1-\u0cf2\u0d00-\u0d03\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d44\u0d46-\u0d48\u0d4a-\u0d4e\u0d54-\u0d57\u0d5f-\u0d63\u0d66-\u0d6f\u0d7a-\u0d7f\u0d82-\u0d83\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0de6-\u0def\u0df2-\u0df3\u0e01-\u0e3a\u0e40-\u0e4e\u0e50-\u0e59\u0e81-\u0e82\u0e84\u0e86-\u0e8a\u0e8c-\u0ea3\u0ea5\u0ea7-\u0ebd\u0ec0-\u0ec4\u0ec6\u0ec8-\u0ecd\u0ed0-\u0ed9\u0edc-\u0edf\u0f00\u0f18-\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f3e-\u0f47\u0f49-\u0f6c\u0f71-\u0f84\u0f86-\u0f97\u0f99-\u0fbc\u0fc6\u1000-\u1049\u1050-\u109d\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u135d-\u135f\u1369-\u1371\u1380-\u138f\u13a0-\u13f5\u13f8-\u13fd\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f8\u1700-\u170c\u170e-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176c\u176e-\u1770\u1772-\u1773\u1780-\u17d3\u17d7\u17dc-\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u1820-\u1878\u1880-\u18aa\u18b0-\u18f5\u1900-\u191e\u1920-\u192b\u1930-\u193b\u1946-\u196d\u1970-\u1974\u1980-\u19ab\u19b0-\u19c9\u19d0-\u19da\u1a00-\u1a1b\u1a20-\u1a5e\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1aa7\u1ab0-\u1abd\u1b00-\u1b4b\u1b50-\u1b59\u1b6b-\u1b73\u1b80-\u1bf3\u1c00-\u1c37\u1c40-\u1c49\u1c4d-\u1c7d\u1c80-\u1c88\u1c90-\u1cba\u1cbd-\u1cbf\u1cd0-\u1cd2\u1cd4-\u1cfa\u1d00-\u1df9\u1dfb-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u203f-\u2040\u2054\u2071\u207f\u2090-\u209c\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2102\u2107\u210a-\u2113\u2115\u2118-\u211d\u2124\u2126\u2128\u212a-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d7f-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2de0-\u2dff\u3005-\u3007\u3021-\u302f\u3031-\u3035\u3038-\u303c\u3041-\u3096\u3099-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312f\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fef\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua62b\ua640-\ua66f\ua674-\ua67d\ua67f-\ua6f1\ua717-\ua71f\ua722-\ua788\ua78b-\ua7bf\ua7c2-\ua7c6\ua7f7-\ua827\ua840-\ua873\ua880-\ua8c5\ua8d0-\ua8d9\ua8e0-\ua8f7\ua8fb\ua8fd-\ua92d\ua930-\ua953\ua960-\ua97c\ua980-\ua9c0\ua9cf-\ua9d9\ua9e0-\ua9fe\uaa00-\uaa36\uaa40-\uaa4d\uaa50-\uaa59\uaa60-\uaa76\uaa7a-\uaac2\uaadb-\uaadd\uaae0-\uaaef\uaaf2-\uaaf6\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uab30-\uab5a\uab5c-\uab67\uab70-\uabea\uabec-\uabed\uabf0-\uabf9\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe00-\ufe0f\ufe20-\ufe2f\ufe33-\ufe34\ufe4d-\ufe4f\ufe70-\ufe74\ufe76-\ufefc\uff10-\uff19\uff21-\uff3a\uff3f\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc]|\ud800[\udc00-\udc0b\udc0d-\udc26\udc28-\udc3a\udc3c-\udc3d\udc3f-\udc4d\udc50-\udc5d\udc80-\udcfa\udd40-\udd74\uddfd\ude80-\ude9c\udea0-\uded0\udee0\udf00-\udf1f\udf2d-\udf4a\udf50-\udf7a\udf80-\udf9d\udfa0-\udfc3\udfc8-\udfcf\udfd1-\udfd5]|\ud801[\udc00-\udc9d\udca0-\udca9\udcb0-\udcd3\udcd8-\udcfb\udd00-\udd27\udd30-\udd63\ude00-\udf36\udf40-\udf55\udf60-\udf67]|\ud802[\udc00-\udc05\udc08\udc0a-\udc35\udc37-\udc38\udc3c\udc3f-\udc55\udc60-\udc76\udc80-\udc9e\udce0-\udcf2\udcf4-\udcf5\udd00-\udd15\udd20-\udd39\udd80-\uddb7\uddbe-\uddbf\ude00-\ude03\ude05-\ude06\ude0c-\ude13\ude15-\ude17\ude19-\ude35\ude38-\ude3a\ude3f\ude60-\ude7c\ude80-\ude9c\udec0-\udec7\udec9-\udee6\udf00-\udf35\udf40-\udf55\udf60-\udf72\udf80-\udf91]|\ud803[\udc00-\udc48\udc80-\udcb2\udcc0-\udcf2\udd00-\udd27\udd30-\udd39\udf00-\udf1c\udf27\udf30-\udf50\udfe0-\udff6]|\ud804[\udc00-\udc46\udc66-\udc6f\udc7f-\udcba\udcd0-\udce8\udcf0-\udcf9\udd00-\udd34\udd36-\udd3f\udd44-\udd46\udd50-\udd73\udd76\udd80-\uddc4\uddc9-\uddcc\uddd0-\uddda\udddc\ude00-\ude11\ude13-\ude37\ude3e\ude80-\ude86\ude88\ude8a-\ude8d\ude8f-\ude9d\ude9f-\udea8\udeb0-\udeea\udef0-\udef9\udf00-\udf03\udf05-\udf0c\udf0f-\udf10\udf13-\udf28\udf2a-\udf30\udf32-\udf33\udf35-\udf39\udf3b-\udf44\udf47-\udf48\udf4b-\udf4d\udf50\udf57\udf5d-\udf63\udf66-\udf6c\udf70-\udf74]|\ud805[\udc00-\udc4a\udc50-\udc59\udc5e-\udc5f\udc80-\udcc5\udcc7\udcd0-\udcd9\udd80-\uddb5\uddb8-\uddc0\uddd8-\udddd\ude00-\ude40\ude44\ude50-\ude59\ude80-\udeb8\udec0-\udec9\udf00-\udf1a\udf1d-\udf2b\udf30-\udf39]|\ud806[\udc00-\udc3a\udca0-\udce9\udcff\udda0-\udda7\uddaa-\uddd7\uddda-\udde1\udde3-\udde4\ude00-\ude3e\ude47\ude50-\ude99\ude9d\udec0-\udef8]|\ud807[\udc00-\udc08\udc0a-\udc36\udc38-\udc40\udc50-\udc59\udc72-\udc8f\udc92-\udca7\udca9-\udcb6\udd00-\udd06\udd08-\udd09\udd0b-\udd36\udd3a\udd3c-\udd3d\udd3f-\udd47\udd50-\udd59\udd60-\udd65\udd67-\udd68\udd6a-\udd8e\udd90-\udd91\udd93-\udd98\udda0-\udda9\udee0-\udef6]|\ud808[\udc00-\udf99]|\ud809[\udc00-\udc6e\udc80-\udd43]|\ud80c[\udc00-\udfff]|\ud80d[\udc00-\udc2e]|\ud811[\udc00-\ude46]|\ud81a[\udc00-\ude38\ude40-\ude5e\ude60-\ude69\uded0-\udeed\udef0-\udef4\udf00-\udf36\udf40-\udf43\udf50-\udf59\udf63-\udf77\udf7d-\udf8f]|\ud81b[\ude40-\ude7f\udf00-\udf4a\udf4f-\udf87\udf8f-\udf9f\udfe0-\udfe1\udfe3]|\ud81c[\udc00-\udfff]|\ud81d[\udc00-\udfff]|\ud81e[\udc00-\udfff]|\ud81f[\udc00-\udfff]|\ud820[\udc00-\udfff]|\ud821[\udc00-\udff7]|\ud822[\udc00-\udef2]|\ud82c[\udc00-\udd1e\udd50-\udd52\udd64-\udd67\udd70-\udefb]|\ud82f[\udc00-\udc6a\udc70-\udc7c\udc80-\udc88\udc90-\udc99\udc9d-\udc9e]|\ud834[\udd65-\udd69\udd6d-\udd72\udd7b-\udd82\udd85-\udd8b\uddaa-\uddad\ude42-\ude44]|\ud835[\udc00-\udc54\udc56-\udc9c\udc9e-\udc9f\udca2\udca5-\udca6\udca9-\udcac\udcae-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd1e-\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd52-\udea5\udea8-\udec0\udec2-\udeda\udedc-\udefa\udefc-\udf14\udf16-\udf34\udf36-\udf4e\udf50-\udf6e\udf70-\udf88\udf8a-\udfa8\udfaa-\udfc2\udfc4-\udfcb\udfce-\udfff]|\ud836[\ude00-\ude36\ude3b-\ude6c\ude75\ude84\ude9b-\ude9f\udea1-\udeaf]|\ud838[\udc00-\udc06\udc08-\udc18\udc1b-\udc21\udc23-\udc24\udc26-\udc2a\udd00-\udd2c\udd30-\udd3d\udd40-\udd49\udd4e\udec0-\udef9]|\ud83a[\udc00-\udcc4\udcd0-\udcd6\udd00-\udd4b\udd50-\udd59]|\ud83b[\ude00-\ude03\ude05-\ude1f\ude21-\ude22\ude24\ude27\ude29-\ude32\ude34-\ude37\ude39\ude3b\ude42\ude47\ude49\ude4b\ude4d-\ude4f\ude51-\ude52\ude54\ude57\ude59\ude5b\ude5d\ude5f\ude61-\ude62\ude64\ude67-\ude6a\ude6c-\ude72\ude74-\ude77\ude79-\ude7c\ude7e\ude80-\ude89\ude8b-\ude9b\udea1-\udea3\udea5-\udea9\udeab-\udebb]|\ud840[\udc00-\udfff]|\ud841[\udc00-\udfff]|\ud842[\udc00-\udfff]|\ud843[\udc00-\udfff]|\ud844[\udc00-\udfff]|\ud845[\udc00-\udfff]|\ud846[\udc00-\udfff]|\ud847[\udc00-\udfff]|\ud848[\udc00-\udfff]|\ud849[\udc00-\udfff]|\ud84a[\udc00-\udfff]|\ud84b[\udc00-\udfff]|\ud84c[\udc00-\udfff]|\ud84d[\udc00-\udfff]|\ud84e[\udc00-\udfff]|\ud84f[\udc00-\udfff]|\ud850[\udc00-\udfff]|\ud851[\udc00-\udfff]|\ud852[\udc00-\udfff]|\ud853[\udc00-\udfff]|\ud854[\udc00-\udfff]|\ud855[\udc00-\udfff]|\ud856[\udc00-\udfff]|\ud857[\udc00-\udfff]|\ud858[\udc00-\udfff]|\ud859[\udc00-\udfff]|\ud85a[\udc00-\udfff]|\ud85b[\udc00-\udfff]|\ud85c[\udc00-\udfff]|\ud85d[\udc00-\udfff]|\ud85e[\udc00-\udfff]|\ud85f[\udc00-\udfff]|\ud860[\udc00-\udfff]|\ud861[\udc00-\udfff]|\ud862[\udc00-\udfff]|\ud863[\udc00-\udfff]|\ud864[\udc00-\udfff]|\ud865[\udc00-\udfff]|\ud866[\udc00-\udfff]|\ud867[\udc00-\udfff]|\ud868[\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|\ud86a[\udc00-\udfff]|\ud86b[\udc00-\udfff]|\ud86c[\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d\udc20-\udfff]|\ud86f[\udc00-\udfff]|\ud870[\udc00-\udfff]|\ud871[\udc00-\udfff]|\ud872[\udc00-\udfff]|\ud873[\udc00-\udea1\udeb0-\udfff]|\ud874[\udc00-\udfff]|\ud875[\udc00-\udfff]|\ud876[\udc00-\udfff]|\ud877[\udc00-\udfff]|\ud878[\udc00-\udfff]|\ud879[\udc00-\udfff]|\ud87a[\udc00-\udfe0]|\ud87e[\udc00-\ude1d]|\udb40[\udd00-\uddef])|[$_]|(\\u[0-9a-fA-F]{4}|\\u\{[0-9a-fA-F]{1,}\})|[\u200c\u200d])*>/, function() {
  return ct = ct.slice(3, -1), o0(ct, this.getCurrentState()), "NAMED_CAPTURE_GROUP";
}], [/^\(/, function() {
  return "L_PAREN";
}], [/^\)/, function() {
  return "R_PAREN";
}], [/^[*?+[^$]/, function() {
  return "CHAR";
}], [/^\\\]/, function() {
  return "ESC_CHAR";
}], [/^\]/, function() {
  return this.popState(), "R_BRACKET";
}], [/^\^/, function() {
  return "BOS";
}], [/^\$/, function() {
  return "EOS";
}], [/^\*/, function() {
  return "STAR";
}], [/^\?/, function() {
  return "Q_MARK";
}], [/^\+/, function() {
  return "PLUS";
}], [/^\|/, function() {
  return "BAR";
}], [/^\./, function() {
  return "ANY";
}], [/^\//, function() {
  return "SLASH";
}], [/^[^*?+\[()\\|]/, function() {
  return "CHAR";
}], [/^\[\^/, function() {
  var e = this.getCurrentState();
  return this.pushState(e === "u" || e === "xu" ? "u_class" : "class"), "NEG_CLASS";
}], [/^\[/, function() {
  var e = this.getCurrentState();
  return this.pushState(e === "u" || e === "xu" ? "u_class" : "class"), "L_BRACKET";
}]], E_ = { INITIAL: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 20, 22, 23, 24, 26, 27, 30, 31, 32, 33, 34, 35, 36, 37, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51], u: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 26, 27, 30, 31, 32, 33, 34, 35, 36, 37, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51], xu: [0, 1, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 30, 31, 32, 33, 34, 35, 36, 37, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51], x: [0, 1, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 20, 22, 23, 24, 26, 27, 30, 31, 32, 33, 34, 35, 36, 37, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51], u_class: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51], class: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 20, 22, 23, 24, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51] }, i0 = {
  type: Tp,
  value: ""
};
ze = {
  initString: function(t) {
    return this._string = t, this._cursor = 0, this._states = ["INITIAL"], this._tokensQueue = [], this._currentLine = 1, this._currentColumn = 0, this._currentLineBeginOffset = 0, this._tokenStartOffset = 0, this._tokenEndOffset = 0, this._tokenStartLine = 1, this._tokenEndLine = 1, this._tokenStartColumn = 0, this._tokenEndColumn = 0, this;
  },
  /**
   * Returns tokenizer states.
   */
  getStates: function() {
    return this._states;
  },
  getCurrentState: function() {
    return this._states[this._states.length - 1];
  },
  pushState: function(t) {
    this._states.push(t);
  },
  begin: function(t) {
    this.pushState(t);
  },
  popState: function() {
    return this._states.length > 1 ? this._states.pop() : this._states[0];
  },
  getNextToken: function() {
    if (this._tokensQueue.length > 0)
      return this.onToken(this._toToken(this._tokensQueue.shift()));
    if (!this.hasMoreTokens())
      return this.onToken(i0);
    for (var t = this._string.slice(this._cursor), r = E_[this.getCurrentState()], n = 0; n < r.length; n++) {
      var a = r[n], u = w_[a], i = this._match(t, u[0]);
      if (t === "" && i === "" && this._cursor++, i !== null) {
        ct = i, ct.length;
        var s = u[1].call(this);
        if (!s)
          return this.getNextToken();
        if (Array.isArray(s)) {
          var o = s.slice(1);
          if (s = s[0], o.length > 0) {
            var c;
            (c = this._tokensQueue).unshift.apply(c, Cp(o));
          }
        }
        return this.onToken(this._toToken(s, ct));
      }
    }
    if (this.isEOF())
      return this._cursor++, i0;
    this.throwUnexpectedToken(t[0], this._currentLine, this._currentColumn);
  },
  /**
   * Throws default "Unexpected token" exception, showing the actual
   * line from the source, pointing with the ^ marker to the bad token.
   * In addition, shows `line:column` location.
   */
  throwUnexpectedToken: function(t, r, n) {
    var a = this._string.split(`
`)[r - 1], u = "";
    if (a) {
      var i = " ".repeat(n);
      u = `

` + a + `
` + i + `^
`;
    }
    throw new SyntaxError(u + 'Unexpected token: "' + t + '" ' + ("at " + r + ":" + n + "."));
  },
  getCursor: function() {
    return this._cursor;
  },
  getCurrentLine: function() {
    return this._currentLine;
  },
  getCurrentColumn: function() {
    return this._currentColumn;
  },
  _captureLocation: function(t) {
    var r = /\n/g;
    this._tokenStartOffset = this._cursor, this._tokenStartLine = this._currentLine, this._tokenStartColumn = this._tokenStartOffset - this._currentLineBeginOffset;
    for (var n = void 0; (n = r.exec(t)) !== null; )
      this._currentLine++, this._currentLineBeginOffset = this._tokenStartOffset + n.index + 1;
    this._tokenEndOffset = this._cursor + t.length, this._tokenEndLine = this._currentLine, this._tokenEndColumn = this._currentColumn = this._tokenEndOffset - this._currentLineBeginOffset;
  },
  _toToken: function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return {
      // Basic data.
      type: t,
      value: r,
      // Location data.
      startOffset: this._tokenStartOffset,
      endOffset: this._tokenEndOffset,
      startLine: this._tokenStartLine,
      endLine: this._tokenEndLine,
      startColumn: this._tokenStartColumn,
      endColumn: this._tokenEndColumn
    };
  },
  isEOF: function() {
    return this._cursor === this._string.length;
  },
  hasMoreTokens: function() {
    return this._cursor <= this._string.length;
  },
  _match: function(t, r) {
    var n = t.match(r);
    return n ? (this._captureLocation(n[0]), this._cursor += n[0].length, n[0]) : null;
  },
  /**
   * Allows analyzing, and transforming token. Default implementation
   * just passes the token through.
   */
  onToken: function(t) {
    return t;
  }
};
ye.lexer = ze;
ye.tokenizer = ze;
ye.options = {
  captureLocations: !0
};
var Kt = {
  /**
   * Sets global parsing options.
   */
  setOptions: function(t) {
    return ye.options = t, this;
  },
  /**
   * Returns parsing options.
   */
  getOptions: function() {
    return ye.options;
  },
  /**
   * Parses a string.
   */
  parse: function(t, r) {
    if (!ze)
      throw new Error("Tokenizer instance wasn't specified.");
    ze.initString(t);
    var n = ye.options;
    r && (ye.options = Object.assign({}, ye.options, r)), Kt.onParseBegin(t, ze, ye.options), xe.length = 0, xe.push(0);
    var a = ze.getNextToken(), u = null;
    do {
      a || (ye.options = n, Op());
      var i = xe[xe.length - 1], s = u0[a.type];
      Li[i].hasOwnProperty(s) || (ye.options = n, c0(a));
      var o = Li[i][s];
      if (o[0] === "s") {
        var c = null;
        ye.options.captureLocations && (c = {
          startOffset: a.startOffset,
          endOffset: a.endOffset,
          startLine: a.startLine,
          endLine: a.endLine,
          startColumn: a.startColumn,
          endColumn: a.endColumn
        }), u = this.onShift(a), xe.push({ symbol: u0[u.type], semanticValue: u.value, loc: c }, Number(o.slice(1))), a = ze.getNextToken();
      } else if (o[0] === "r") {
        var f = o.slice(1), g = S_[f], p = typeof g[2] == "function", h = p ? [] : null, v = p && ye.options.captureLocations ? [] : null;
        if (g[1] !== 0)
          for (var S = g[1]; S-- > 0; ) {
            xe.pop();
            var E = xe.pop();
            p && (h.unshift(E.semanticValue), v && v.unshift(E.loc));
          }
        var d = { symbol: g[0] };
        if (p) {
          ct = u ? u.value : null, u && u.value.length;
          var m = v !== null ? h.concat(v) : h;
          g[2].apply(g, Cp(m)), d.semanticValue = N, v && (d.loc = I);
        }
        var l = xe[xe.length - 1], y = g[0];
        xe.push(d, Li[l][y]);
      } else if (o === "acc") {
        xe.pop();
        var b = xe.pop();
        return (xe.length !== 1 || xe[0] !== 0 || ze.hasMoreTokens()) && (ye.options = n, c0(a)), b.hasOwnProperty("semanticValue") ? (ye.options = n, Kt.onParseEnd(b.semanticValue), b.semanticValue) : (Kt.onParseEnd(), ye.options = n, !0);
      }
    } while (ze.hasMoreTokens() || xe.length > 1);
  },
  setTokenizer: function(t) {
    return ze = t, Kt;
  },
  getTokenizer: function() {
    return ze;
  },
  onParseBegin: function(t, r, n) {
  },
  onParseEnd: function(t) {
  },
  /**
   * Allows analyzing, and transforming shifted token. Default implementation
   * just passes the token through.
   */
  onShift: function(t) {
    return t;
  }
}, co = 0, bn = {}, kp = "";
Kt.onParseBegin = function(e, t) {
  kp = e, co = 0, bn = {};
  var r = e.lastIndexOf("/"), n = e.slice(r);
  n.includes("x") && n.includes("u") ? t.pushState("xu") : (n.includes("x") && t.pushState("x"), n.includes("u") && t.pushState("u"));
};
Kt.onShift = function(e) {
  return (e.type === "L_PAREN" || e.type === "NAMED_CAPTURE_GROUP") && (e.value = new String(e.value), e.value.groupNumber = ++co), e;
};
function Fi(e) {
  var t = e.match(/\d+/g).map(Number);
  if (Number.isFinite(t[1]) && t[1] < t[0])
    throw new SyntaxError("Numbers out of order in " + e + " quantifier");
  return t;
}
function s0(e, t) {
  if (e.kind === "control" || t.kind === "control" || !isNaN(e.codePoint) && !isNaN(t.codePoint) && e.codePoint > t.codePoint)
    throw new SyntaxError("Range " + e.value + "-" + t.value + " out of order in character class");
}
var vr = b_;
function C_(e, t) {
  var r = e[1] === "P", n = e.indexOf("="), a = e.slice(3, n !== -1 ? n : -1), u = void 0, i = n === -1 && vr.isGeneralCategoryValue(a), s = n === -1 && vr.isBinaryPropertyName(a);
  if (i)
    u = a, a = "General_Category";
  else if (s)
    u = a;
  else {
    if (!vr.isValidName(a))
      throw new SyntaxError("Invalid unicode property name: " + a + ".");
    if (u = e.slice(n + 1, -1), !vr.isValidValue(a, u))
      throw new SyntaxError("Invalid " + a + " unicode property value: " + u + ".");
  }
  return ce({
    type: "UnicodeProperty",
    name: a,
    value: u,
    negative: r,
    shorthand: i,
    binary: s,
    canonicalName: vr.getCanonicalName(a) || a,
    canonicalValue: vr.getCanonicalValue(u) || u
  }, t);
}
function je(e, t, r) {
  var n = void 0, a = void 0;
  switch (t) {
    case "decimal": {
      a = Number(e.slice(1)), n = String.fromCodePoint(a);
      break;
    }
    case "oct": {
      a = parseInt(e.slice(1), 8), n = String.fromCodePoint(a);
      break;
    }
    case "hex":
    case "unicode": {
      if (e.lastIndexOf("\\u") > 0) {
        var u = e.split("\\u").slice(1), i = __(u, 2), s = i[0], o = i[1];
        s = parseInt(s, 16), o = parseInt(o, 16), a = (s - 55296) * 1024 + (o - 56320) + 65536, n = String.fromCodePoint(a);
      } else {
        var c = e.slice(2).replace("{", "");
        if (a = parseInt(c, 16), a > 1114111)
          throw new SyntaxError("Bad character escape sequence: " + e);
        n = String.fromCodePoint(a);
      }
      break;
    }
    case "meta": {
      switch (e) {
        case "\\t":
          n = "	", a = n.codePointAt(0);
          break;
        case "\\n":
          n = `
`, a = n.codePointAt(0);
          break;
        case "\\r":
          n = "\r", a = n.codePointAt(0);
          break;
        case "\\v":
          n = "\v", a = n.codePointAt(0);
          break;
        case "\\f":
          n = "\f", a = n.codePointAt(0);
          break;
        case "\\b":
          n = "\b", a = n.codePointAt(0);
        case "\\0":
          n = "\0", a = 0;
        case ".":
          n = ".", a = NaN;
          break;
        default:
          a = NaN;
      }
      break;
    }
    case "simple": {
      n = e, a = n.codePointAt(0);
      break;
    }
  }
  return ce({
    type: "Char",
    value: e,
    kind: t,
    symbol: n,
    codePoint: a
  }, r);
}
var T_ = "gimsuxy";
function k_(e) {
  var t = /* @__PURE__ */ new Set(), r = !0, n = !1, a = void 0;
  try {
    for (var u = e[Symbol.iterator](), i; !(r = (i = u.next()).done); r = !0) {
      var s = i.value;
      if (t.has(s) || !T_.includes(s))
        throw new SyntaxError("Invalid flags: " + e);
      t.add(s);
    }
  } catch (o) {
    n = !0, a = o;
  } finally {
    try {
      !r && u.return && u.return();
    } finally {
      if (n)
        throw a;
    }
  }
  return e.split("").sort().join("");
}
function A_(e, t) {
  var r = Number(e.slice(1));
  return r > 0 && r <= co ? ce({
    type: "Backreference",
    kind: "number",
    number: r,
    reference: r
  }, t) : je(e, "decimal", t);
}
var O_ = /^\\u[0-9a-fA-F]{4}/, I_ = /^\\u\{[0-9a-fA-F]{1,}\}/, P_ = /\\u\{[0-9a-fA-F]{1,}\}/;
function o0(e, t) {
  var r = P_.test(e), n = t === "u" || t === "xu" || t === "u_class";
  if (r && !n)
    throw new SyntaxError('invalid group Unicode name "' + e + '", use `u` flag.');
  return e;
}
var B_ = /\\u(?:([dD][89aAbB][0-9a-fA-F]{2})\\u([dD][c-fC-F][0-9a-fA-F]{2})|([dD][89aAbB][0-9a-fA-F]{2})|([dD][c-fC-F][0-9a-fA-F]{2})|([0-9a-ce-fA-CE-F][0-9a-fA-F]{3}|[dD][0-7][0-9a-fA-F]{2})|\{(0*(?:[0-9a-fA-F]{1,5}|10[0-9a-fA-F]{4}))\})/;
function Ap(e) {
  return e.replace(new RegExp(B_, "g"), function(t, r, n, a, u, i, s) {
    return r ? String.fromCodePoint(parseInt(r, 16), parseInt(n, 16)) : a ? String.fromCodePoint(parseInt(a, 16)) : u ? String.fromCodePoint(parseInt(u, 16)) : i ? String.fromCodePoint(parseInt(i, 16)) : s ? String.fromCodePoint(parseInt(s, 16)) : t;
  });
}
function N_(e, t) {
  var r = e.slice(3, -1), n = Ap(r);
  if (bn.hasOwnProperty(n))
    return ce({
      type: "Backreference",
      kind: "name",
      number: bn[n],
      reference: n,
      referenceRaw: r
    }, t);
  var a = null, u = null, i = null, s = null;
  t && (a = t.startOffset, u = t.startLine, i = t.endLine, s = t.startColumn);
  var o = /^[\w$<>]/, c = void 0, f = [
    // Init to first \k, taking 2 symbols.
    je(e.slice(1, 2), "simple", a ? {
      startLine: u,
      endLine: i,
      startColumn: s,
      startOffset: a,
      endOffset: a += 2,
      endColumn: s += 2
    } : null)
  ];
  for (f[0].escaped = !0, e = e.slice(2); e.length > 0; ) {
    var g = null;
    (g = e.match(O_)) || (g = e.match(I_)) ? (a && (c = {
      startLine: u,
      endLine: i,
      startColumn: s,
      startOffset: a,
      endOffset: a += g[0].length,
      endColumn: s += g[0].length
    }), f.push(je(g[0], "unicode", c)), e = e.slice(g[0].length)) : (g = e.match(o)) && (a && (c = {
      startLine: u,
      endLine: i,
      startColumn: s,
      startOffset: a,
      endOffset: ++a,
      endColumn: ++s
    }), f.push(je(g[0], "simple", c)), e = e.slice(1));
  }
  return f;
}
function ce(e, t) {
  return ye.options.captureLocations && (e.loc = {
    source: kp.slice(t.startOffset, t.endOffset),
    start: {
      line: t.startLine,
      column: t.startColumn,
      offset: t.startOffset
    },
    end: {
      line: t.endLine,
      column: t.endColumn,
      offset: t.endOffset
    }
  }), e;
}
function Zn(e, t) {
  return ye.options.captureLocations ? {
    startOffset: e.startOffset,
    endOffset: t.endOffset,
    startLine: e.startLine,
    endLine: t.endLine,
    startColumn: e.startColumn,
    endColumn: t.endColumn
  } : null;
}
function c0(e) {
  e.type === Tp && Op(), ze.throwUnexpectedToken(e.value, e.startLine, e.startColumn);
}
function Op() {
  D_("Unexpected end of input.");
}
function D_(e) {
  throw new SyntaxError(e);
}
var R_ = Kt, _n = R_, x_ = _n.parse.bind(_n);
_n.parse = function(e, t) {
  return x_("" + e, t);
};
_n.setOptions({ captureLocations: !1 });
var nu = _n, j_ = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}();
function M_(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var ea = "expressions", d0 = "expression", fo = function() {
  function e(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    M_(this, e), this.node = t, this.parentPath = r, this.parent = r ? r.node : null, this.property = n, this.index = a;
  }
  return j_(e, [{
    key: "_enforceProp",
    value: function(r) {
      if (!this.node.hasOwnProperty(r))
        throw new Error("Node of type " + this.node.type + ` doesn't have "` + r + '" collection.');
    }
    /**
     * Sets a node into a children collection or the single child.
     * By default child nodes are supposed to be under `expressions` property.
     * An explicit property can be passed.
     *
     * @param Object node - a node to set into a collection or as single child
     * @param number index - index at which to set
     * @param string property - name of the collection or single property
     */
  }, {
    key: "setChild",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, u = void 0;
      return n != null ? (a || (a = ea), this._enforceProp(a), this.node[a][n] = r, u = e.getForNode(r, this, a, n)) : (a || (a = d0), this._enforceProp(a), this.node[a] = r, u = e.getForNode(r, this, a, null)), u;
    }
    /**
     * Appends a node to a children collection.
     * By default child nodes are supposed to be under `expressions` property.
     * An explicit property can be passed.
     *
     * @param Object node - a node to set into a collection or as single child
     * @param string property - name of the collection or single property
     */
  }, {
    key: "appendChild",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
      n || (n = ea), this._enforceProp(n);
      var a = this.node[n].length;
      return this.setChild(r, a, n);
    }
    /**
     * Inserts a node into a collection.
     * By default child nodes are supposed to be under `expressions` property.
     * An explicit property can be passed.
     *
     * @param Object node - a node to insert into a collection
     * @param number index - index at which to insert
     * @param string property - name of the collection property
     */
  }, {
    key: "insertChildAt",
    value: function(r, n) {
      var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ea;
      this._enforceProp(a), this.node[a].splice(n, 0, r), n <= e.getTraversingIndex() && e.updateTraversingIndex(1), this._rebuildIndex(this.node, a);
    }
    /**
     * Removes a node.
     */
  }, {
    key: "remove",
    value: function() {
      if (!this.isRemoved() && (e.registry.delete(this.node), this.node = null, !!this.parent)) {
        if (this.index !== null) {
          this.parent[this.property].splice(this.index, 1), this.index <= e.getTraversingIndex() && e.updateTraversingIndex(-1), this._rebuildIndex(this.parent, this.property), this.index = null, this.property = null;
          return;
        }
        delete this.parent[this.property], this.property = null;
      }
    }
    /**
     * Rebuilds child nodes index (used on remove/insert).
     */
  }, {
    key: "_rebuildIndex",
    value: function(r, n) {
      for (var a = e.getForNode(r), u = 0; u < r[n].length; u++) {
        var i = e.getForNode(r[n][u], a, n, u);
        i.index = u;
      }
    }
    /**
     * Whether the path was removed.
     */
  }, {
    key: "isRemoved",
    value: function() {
      return this.node === null;
    }
    /**
     * Replaces a node with the passed one.
     */
  }, {
    key: "replace",
    value: function(r) {
      return e.registry.delete(this.node), this.node = r, this.parent ? (this.index !== null ? this.parent[this.property][this.index] = r : this.parent[this.property] = r, e.getForNode(r, this.parentPath, this.property, this.index)) : null;
    }
    /**
     * Updates a node inline.
     */
  }, {
    key: "update",
    value: function(r) {
      Object.assign(this.node, r);
    }
    /**
     * Returns parent.
     */
  }, {
    key: "getParent",
    value: function() {
      return this.parentPath;
    }
    /**
     * Returns nth child.
     */
  }, {
    key: "getChild",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      return this.node.expressions ? e.getForNode(this.node.expressions[r], this, ea, r) : this.node.expression && r == 0 ? e.getForNode(this.node.expression, this, d0) : null;
    }
    /**
     * Whether a path node is syntactically equal to the passed one.
     *
     * NOTE: we don't rely on `source` property from the `loc` data
     * (which would be the fastest comparison), since it might be unsync
     * after several modifications. We use here simple `JSON.stringify`
     * excluding the `loc` data.
     *
     * @param NodePath other - path to compare to.
     * @return boolean
     */
  }, {
    key: "hasEqualSource",
    value: function(r) {
      return JSON.stringify(this.node, $i) === JSON.stringify(r.node, $i);
    }
    /**
     * JSON-encodes a node skipping location.
     */
  }, {
    key: "jsonEncode",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = r.format, a = r.useLoc;
      return JSON.stringify(this.node, a ? null : $i, n);
    }
    /**
     * Returns previous sibling.
     */
  }, {
    key: "getPreviousSibling",
    value: function() {
      return !this.parent || this.index == null ? null : e.getForNode(this.parent[this.property][this.index - 1], e.getForNode(this.parent), this.property, this.index - 1);
    }
    /**
     * Returns next sibling.
     */
  }, {
    key: "getNextSibling",
    value: function() {
      return !this.parent || this.index == null ? null : e.getForNode(this.parent[this.property][this.index + 1], e.getForNode(this.parent), this.property, this.index + 1);
    }
    /**
     * Returns a NodePath instance for a node.
     *
     * The same NodePath can be reused in several places, e.g.
     * a parent node passed for all its children.
     */
  }], [{
    key: "getForNode",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, u = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : -1;
      if (!r)
        return null;
      e.registry.has(r) || e.registry.set(r, new e(r, n, a, u == -1 ? null : u));
      var i = e.registry.get(r);
      return n !== null && (i.parentPath = n, i.parent = i.parentPath.node), a !== null && (i.property = a), u >= 0 && (i.index = u), i;
    }
    /**
     * Initializes the NodePath registry. The registry is a map from
     * a node to its NodePath instance.
     */
  }, {
    key: "initRegistry",
    value: function() {
      e.registry || (e.registry = /* @__PURE__ */ new Map()), e.registry.clear();
    }
    /**
     * Updates index of a currently traversing collection.
     */
  }, {
    key: "updateTraversingIndex",
    value: function(r) {
      return e.traversingIndexStack[e.traversingIndexStack.length - 1] += r;
    }
    /**
     * Returns current traversing index.
     */
  }, {
    key: "getTraversingIndex",
    value: function() {
      return e.traversingIndexStack[e.traversingIndexStack.length - 1];
    }
  }]), e;
}();
fo.initRegistry();
fo.traversingIndexStack = [];
function $i(e, t) {
  if (e !== "loc")
    return t;
}
var lo = fo, Pr = lo;
function L_(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.pre, n = t.post, a = t.skipProperty;
  function u(i, s, o, c) {
    if (!(!i || typeof i.type != "string")) {
      var f = void 0;
      if (r && (f = r(i, s, o, c)), f !== !1) {
        s && s[o] && (isNaN(c) ? i = s[o] : i = s[o][c]);
        for (var g in i)
          if (i.hasOwnProperty(g)) {
            if (a ? a(g, i) : g[0] === "$")
              continue;
            var p = i[g];
            if (Array.isArray(p)) {
              var h = 0;
              for (Pr.traversingIndexStack.push(h); h < p.length; )
                u(p[h], i, g, h), h = Pr.updateTraversingIndex(1);
              Pr.traversingIndexStack.pop();
            } else
              u(p, i, g);
          }
      }
      n && n(i, s, o, c);
    }
  }
  u(e, null);
}
var Ip = {
  /**
   * Traverses an AST.
   *
   * @param Object ast - an AST node
   *
   * @param Object | Array<Object> handlers:
   *
   *   an object (or an array of objects)
   *
   *   Each such object contains a handler function per node.
   *   In case of an array of handlers, they are applied in order.
   *   A handler may return a transformed node (or a different type).
   *
   *   The per-node function may instead be an object with functions pre and post.
   *   pre is called before visiting the node, post after.
   *   If a handler is a function, it is treated as the pre function, with an empty post.
   *
   * @param Object options:
   *
   *   a config object, specifying traversal options:
   *
   *   `asNodes`: boolean - whether handlers should receives raw AST nodes
   *   (false by default), instead of a `NodePath` wrapper. Note, by default
   *   `NodePath` wrapper provides a set of convenient method to manipulate
   *   a traversing AST, and also has access to all parents list. A raw
   *   nodes traversal should be used in rare cases, when no `NodePath`
   *   features are needed.
   *
   * Special hooks:
   *
   *   - `shouldRun(ast)` - a predicate determining whether the handler
   *                        should be applied.
   *
   * NOTE: Multiple handlers are used as an optimization of applying all of
   * them in one AST traversal pass.
   */
  traverse: function(t, r) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : { asNodes: !1 };
    Array.isArray(r) || (r = [r]), r = r.filter(function(u) {
      return typeof u.shouldRun != "function" ? !0 : u.shouldRun(t);
    }), Pr.initRegistry(), r.forEach(function(u) {
      typeof u.init == "function" && u.init(t);
    });
    function a(u, i, s, o) {
      var c = Pr.getForNode(i), f = Pr.getForNode(u, c, s, o);
      return f;
    }
    L_(t, {
      /**
       * Handler on node enter.
       */
      pre: function(i, s, o, c) {
        var f = void 0;
        n.asNodes || (f = a(i, s, o, c));
        var g = !0, p = !1, h = void 0;
        try {
          for (var v = r[Symbol.iterator](), S; !(g = (S = v.next()).done); g = !0) {
            var E = S.value;
            if (typeof E["*"] == "function")
              if (f) {
                if (!f.isRemoved()) {
                  var d = E["*"](f);
                  if (d === !1)
                    return !1;
                }
              } else
                E["*"](i, s, o, c);
            var m = void 0;
            if (typeof E[i.type] == "function" ? m = E[i.type] : typeof E[i.type] == "object" && typeof E[i.type].pre == "function" && (m = E[i.type].pre), m)
              if (f) {
                if (!f.isRemoved()) {
                  var l = m.call(E, f);
                  if (l === !1)
                    return !1;
                }
              } else
                m.call(E, i, s, o, c);
          }
        } catch (y) {
          p = !0, h = y;
        } finally {
          try {
            !g && v.return && v.return();
          } finally {
            if (p)
              throw h;
          }
        }
      },
      // pre func
      /**
       * Handler on node exit.
       */
      post: function(i, s, o, c) {
        if (i) {
          var f = void 0;
          n.asNodes || (f = a(i, s, o, c));
          var g = !0, p = !1, h = void 0;
          try {
            for (var v = r[Symbol.iterator](), S; !(g = (S = v.next()).done); g = !0) {
              var E = S.value, d = void 0;
              if (typeof E[i.type] == "object" && typeof E[i.type].post == "function" && (d = E[i.type].post), d)
                if (f) {
                  if (!f.isRemoved()) {
                    var m = d.call(E, f);
                    if (m === !1)
                      return !1;
                  }
                } else
                  d.call(E, i, s, o, c);
            }
          } catch (l) {
            p = !0, h = l;
          } finally {
            try {
              !g && v.return && v.return();
            } finally {
              if (p)
                throw h;
            }
          }
        }
      },
      // post func
      /**
       * Skip locations by default.
       */
      skipProperty: function(i) {
        return i === "loc";
      }
    });
  }
}, F_ = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}();
function $_(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var f0 = Sp, U_ = nu, H_ = Ip, l0 = function() {
  function e(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    $_(this, e), this._ast = t, this._source = null, this._string = null, this._regexp = null, this._extra = r;
  }
  return F_(e, [{
    key: "getAST",
    value: function() {
      return this._ast;
    }
  }, {
    key: "setExtra",
    value: function(r) {
      this._extra = r;
    }
  }, {
    key: "getExtra",
    value: function() {
      return this._extra;
    }
  }, {
    key: "toRegExp",
    value: function() {
      return this._regexp || (this._regexp = new RegExp(this.getSource(), this._ast.flags)), this._regexp;
    }
  }, {
    key: "getSource",
    value: function() {
      return this._source || (this._source = f0.generate(this._ast.body)), this._source;
    }
  }, {
    key: "getFlags",
    value: function() {
      return this._ast.flags;
    }
  }, {
    key: "toString",
    value: function() {
      return this._string || (this._string = f0.generate(this._ast)), this._string;
    }
  }]), e;
}(), po = {
  /**
   * Expose `TransformResult`.
   */
  TransformResult: l0,
  /**
   * Transforms a regular expression applying a set of
   * transformation handlers.
   *
   * @param string | AST | RegExp:
   *
   *   a regular expression in different representations: a string,
   *   a RegExp object, or an AST.
   *
   * @param Object | Array<Object>:
   *
   *   a handler (or a list of handlers) from `traverse` API.
   *
   * @return TransformResult instance.
   *
   * Example:
   *
   *   transform(/[a-z]/i, {
   *     onChar(path) {
   *       const {node} = path;
   *
   *       if (...) {
   *         path.remove();
   *       }
   *     }
   *   });
   */
  transform: function(t, r) {
    var n = t;
    return t instanceof RegExp && (t = "" + t), typeof t == "string" && (n = U_.parse(t, {
      captureLocations: !0
    })), H_.traverse(n, r), new l0(n);
  }
}, ta = c_, G_ = po, W_ = {
  /**
   * Translates a regexp in new syntax to equivalent regexp in old syntax.
   *
   * @param string|RegExp|AST - regexp
   * @param Array transformsWhitelist - names of the transforms to apply
   */
  transform: function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = r.length > 0 ? r : Object.keys(ta), a = void 0, u = {};
    return n.forEach(function(i) {
      if (!ta.hasOwnProperty(i))
        throw new Error("Unknown compat-transform: " + i + ". Available transforms are: " + Object.keys(ta).join(", "));
      var s = ta[i];
      a = G_.transform(t, s), t = a.getAST(), typeof s.getExtra == "function" && (u[i] = s.getExtra());
    }), a.setExtra(u), a;
  }
}, q_ = function e(t) {
  if (t === null || typeof t != "object")
    return t;
  var r = void 0;
  Array.isArray(t) ? r = [] : r = {};
  for (var n in t)
    r[n] = e(t[n]);
  return r;
}, z_ = {
  shouldRun: function(t) {
    return t.flags.includes("u");
  },
  Char: function(t) {
    var r = t.node;
    r.kind !== "unicode" || !r.isSurrogatePair || isNaN(r.codePoint) || (r.value = "\\u{" + r.codePoint.toString(16) + "}", delete r.isSurrogatePair);
  }
}, p0 = "A".codePointAt(0), h0 = "Z".codePointAt(0), m0 = "a".codePointAt(0), g0 = "z".codePointAt(0), y0 = "0".codePointAt(0), v0 = "9".codePointAt(0), V_ = {
  Char: function(t) {
    var r = t.node, n = t.parent;
    if (!(isNaN(r.codePoint) || r.kind === "simple") && !(n.type === "ClassRange" && !Y_(n)) && X_(r.codePoint)) {
      var a = String.fromCodePoint(r.codePoint), u = {
        type: "Char",
        kind: "simple",
        value: a,
        symbol: a,
        codePoint: r.codePoint
      };
      J_(a, n.type) && (u.escaped = !0), t.replace(u);
    }
  }
};
function Y_(e) {
  var t = e.from, r = e.to;
  return t.codePoint >= y0 && t.codePoint <= v0 && r.codePoint >= y0 && r.codePoint <= v0 || t.codePoint >= p0 && t.codePoint <= h0 && r.codePoint >= p0 && r.codePoint <= h0 || t.codePoint >= m0 && t.codePoint <= g0 && r.codePoint >= m0 && r.codePoint <= g0;
}
function X_(e) {
  return e >= 32 && e <= 126;
}
function J_(e, t) {
  return t === "ClassRange" || t === "CharacterClass" ? /[\]\\^-]/.test(e) : /[*[()+?^$./\\|{}]/.test(e);
}
var b0 = "A".codePointAt(0), _0 = "Z".codePointAt(0), K_ = {
  _AZClassRanges: null,
  _hasUFlag: !1,
  init: function(t) {
    this._AZClassRanges = /* @__PURE__ */ new Set(), this._hasUFlag = t.flags.includes("u");
  },
  shouldRun: function(t) {
    return t.flags.includes("i");
  },
  Char: function(t) {
    var r = t.node, n = t.parent;
    if (!isNaN(r.codePoint) && !(!this._hasUFlag && r.codePoint >= 4096)) {
      if (n.type === "ClassRange") {
        if (!this._AZClassRanges.has(n) && !Q_(n))
          return;
        this._AZClassRanges.add(n);
      }
      var a = r.symbol.toLowerCase();
      a !== r.symbol && (r.value = Z_(a, r), r.symbol = a, r.codePoint = a.codePointAt(0));
    }
  }
};
function Q_(e) {
  var t = e.from, r = e.to;
  return t.codePoint >= b0 && t.codePoint <= _0 && r.codePoint >= b0 && r.codePoint <= _0;
}
function Z_(e, t) {
  var r = e.codePointAt(0);
  if (t.kind === "decimal")
    return "\\" + r;
  if (t.kind === "oct")
    return "\\0" + r.toString(8);
  if (t.kind === "hex")
    return "\\x" + r.toString(16);
  if (t.kind === "unicode")
    if (t.isSurrogatePair) {
      var n = eS(r), a = n.lead, u = n.trail;
      return "\\u" + "0".repeat(4 - a.length) + a + "\\u" + "0".repeat(4 - u.length) + u;
    } else {
      if (t.value.includes("{"))
        return "\\u{" + r.toString(16) + "}";
      var i = r.toString(16);
      return "\\u" + "0".repeat(4 - i.length) + i;
    }
  return e;
}
function eS(e) {
  var t = Math.floor((e - 65536) / 1024) + 55296, r = (e - 65536) % 1024 + 56320;
  return {
    lead: t.toString(16),
    trail: r.toString(16)
  };
}
var tS = {
  CharacterClass: function(t) {
    for (var r = t.node, n = {}, a = 0; a < r.expressions.length; a++) {
      var u = t.getChild(a), i = u.jsonEncode();
      n.hasOwnProperty(i) && (u.remove(), a--), n[i] = !0;
    }
  }
};
function rS(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = Array(e.length); t < e.length; t++)
      r[t] = e[t];
    return r;
  } else
    return Array.from(e);
}
function Pp(e) {
  if (e.type !== "Disjunction")
    throw new TypeError('Expected "Disjunction" node, got "' + e.type + '"');
  var t = [];
  return e.left && e.left.type === "Disjunction" ? t.push.apply(t, rS(Pp(e.left)).concat([e.right])) : t.push(e.left, e.right), t;
}
function nS(e) {
  return e.reduce(function(t, r) {
    return {
      type: "Disjunction",
      left: t,
      right: r
    };
  });
}
function aS(e) {
  e.kind === "*" ? e.kind = "+" : e.kind === "+" ? (e.kind = "Range", e.from = 2, delete e.to) : e.kind === "?" ? (e.kind = "Range", e.from = 1, e.to = 2) : e.kind === "Range" && (e.from += 1, e.to && (e.to += 1));
}
var ho = {
  disjunctionToList: Pp,
  listToDisjunction: nS,
  increaseQuantifierByOne: aS
}, uS = ho, iS = uS.increaseQuantifierByOne, sS = {
  Repetition: function(t) {
    var r = t.node, n = t.parent;
    if (!(n.type !== "Alternative" || !t.index)) {
      var a = t.getPreviousSibling();
      if (a)
        if (a.node.type === "Repetition") {
          if (!a.getChild().hasEqualSource(t.getChild()))
            return;
          var u = S0(a.node.quantifier), i = u.from, s = u.to, o = S0(r.quantifier), c = o.from, f = o.to;
          if (a.node.quantifier.greedy !== r.quantifier.greedy && !ra(a.node.quantifier) && !ra(r.quantifier))
            return;
          r.quantifier.kind = "Range", r.quantifier.from = i + c, s && f ? r.quantifier.to = s + f : delete r.quantifier.to, (ra(a.node.quantifier) || ra(r.quantifier)) && (r.quantifier.greedy = !0), a.remove();
        } else {
          if (!a.hasEqualSource(t.getChild()))
            return;
          iS(r.quantifier), a.remove();
        }
    }
  }
};
function ra(e) {
  return e.greedy && (e.kind === "+" || e.kind === "*" || e.kind === "Range" && !e.to);
}
function S0(e) {
  var t = void 0, r = void 0;
  return e.kind === "*" ? t = 0 : e.kind === "+" ? t = 1 : e.kind === "?" ? (t = 0, r = 1) : (t = e.from, e.to && (r = e.to)), { from: t, to: r };
}
var oS = {
  Quantifier: function(t) {
    var r = t.node;
    r.kind === "Range" && (cS(t), dS(t), fS(t));
  }
};
function cS(e) {
  var t = e.node;
  t.from !== 0 || t.to || (t.kind = "*", delete t.from);
}
function dS(e) {
  var t = e.node;
  t.from !== 1 || t.to || (t.kind = "+", delete t.from);
}
function fS(e) {
  var t = e.node;
  t.from !== 1 || t.to !== 1 || e.parentPath.replace(e.parentPath.node.expression);
}
var lS = {
  ClassRange: function(t) {
    var r = t.node;
    r.from.codePoint === r.to.codePoint ? t.replace(r.from) : r.from.codePoint === r.to.codePoint - 1 && (t.getParent().insertChildAt(r.to, t.index + 1), t.replace(r.from));
  }
};
function w0(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = Array(e.length); t < e.length; t++)
      r[t] = e[t];
    return r;
  } else
    return Array.from(e);
}
var pS = {
  _hasIFlag: !1,
  _hasUFlag: !1,
  init: function(t) {
    this._hasIFlag = t.flags.includes("i"), this._hasUFlag = t.flags.includes("u");
  },
  CharacterClass: function(t) {
    hS(t), mS(t, this._hasIFlag, this._hasUFlag), gS(t);
  }
};
function hS(e) {
  var t = e.node;
  t.expressions.forEach(function(r, n) {
    yS(r) && e.getChild(n).replace({
      type: "Char",
      value: "\\d",
      kind: "meta"
    });
  });
}
function mS(e, t, r) {
  var n = e.node, a = null, u = null, i = null, s = null, o = null, c = null;
  n.expressions.forEach(function(f, g) {
    mo(f, "\\d") ? a = e.getChild(g) : vS(f) ? u = e.getChild(g) : bS(f) ? i = e.getChild(g) : _S(f) ? s = e.getChild(g) : t && r && cn(f, 383) ? o = e.getChild(g) : t && r && cn(f, 8490) && (c = e.getChild(g));
  }), a && (u && i || t && (u || i)) && s && (!r || !t || o && c) && (a.replace({
    type: "Char",
    value: "\\w",
    kind: "meta"
  }), u && u.remove(), i && i.remove(), s.remove(), o && o.remove(), c && c.remove());
}
var Ui = [function(e) {
  return Bp(e, " ");
}].concat(w0(["\\f", "\\n", "\\r", "\\t", "\\v"].map(function(e) {
  return function(t) {
    return mo(t, e);
  };
})), w0([160, 5760, 8232, 8233, 8239, 8287, 12288, 65279].map(function(e) {
  return function(t) {
    return cn(t, e);
  };
})), [function(e) {
  return e.type === "ClassRange" && cn(e.from, 8192) && cn(e.to, 8202);
}]);
function gS(e) {
  var t = e.node;
  if (!(t.expressions.length < Ui.length || !Ui.every(function(n) {
    return t.expressions.some(function(a) {
      return n(a);
    });
  }))) {
    var r = t.expressions.find(function(n) {
      return mo(n, "\\n");
    });
    r.value = "\\s", r.symbol = void 0, r.codePoint = NaN, t.expressions.map(function(n, a) {
      return Ui.some(function(u) {
        return u(n);
      }) ? e.getChild(a) : void 0;
    }).filter(Boolean).forEach(function(n) {
      return n.remove();
    });
  }
}
function yS(e) {
  return e.type === "ClassRange" && e.from.value === "0" && e.to.value === "9";
}
function Bp(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "simple";
  return e.type === "Char" && e.value === t && e.kind === r;
}
function mo(e, t) {
  return Bp(e, t, "meta");
}
function vS(e) {
  return e.type === "ClassRange" && e.from.value === "a" && e.to.value === "z";
}
function bS(e) {
  return e.type === "ClassRange" && e.from.value === "A" && e.to.value === "Z";
}
function _S(e) {
  return e.type === "Char" && e.value === "_" && e.kind === "simple";
}
function cn(e, t) {
  return e.type === "Char" && e.kind === "unicode" && e.codePoint === t;
}
var SS = {
  CharacterClass: function(t) {
    var r = t.node;
    if (!(r.expressions.length !== 1 || !TS(t) || !wS(r.expressions[0]))) {
      var n = r.expressions[0], a = n.value, u = n.kind, i = n.escaped;
      if (r.negative) {
        if (!ES(a))
          return;
        a = CS(a);
      }
      t.replace({
        type: "Char",
        value: a,
        kind: u,
        escaped: i || kS(a)
      });
    }
  }
};
function wS(e) {
  return e.type === "Char" && // We don't extract [\b] (backspace) since \b has different
  // semantics (word boundary).
  e.value !== "\\b";
}
function ES(e) {
  return /^\\[dwsDWS]$/.test(e);
}
function CS(e) {
  return /[dws]/.test(e) ? e.toUpperCase() : e.toLowerCase();
}
function TS(e) {
  var t = e.parent, r = e.index;
  if (t.type !== "Alternative")
    return !0;
  var n = t.expressions[r - 1];
  return n == null ? !0 : !(n.type === "Backreference" && n.kind === "number" || n.type === "Char" && n.kind === "decimal");
}
function kS(e) {
  return /[*[()+?$./{}|]/.test(e);
}
var AS = {
  _hasXFlag: !1,
  init: function(t) {
    this._hasXFlag = t.flags.includes("x");
  },
  Char: function(t) {
    var r = t.node;
    r.escaped && OS(t, this._hasXFlag) && delete r.escaped;
  }
};
function OS(e, t) {
  var r = e.node.value, n = e.index, a = e.parent;
  return a.type !== "CharacterClass" && a.type !== "ClassRange" ? !PS(r, n, a, t) : !IS(r, n, a);
}
function IS(e, t, r) {
  return e === "^" ? t === 0 && !r.negative : e === "-" ? !0 : /[\]\\]/.test(e);
}
function PS(e, t, r, n) {
  return e === "{" ? BS(t, r) : e === "}" ? NS(t, r) : n && /[ #]/.test(e) ? !0 : /[*[()+?^$./\\|]/.test(e);
}
function Da(e, t, r) {
  for (var n = e, a = (r ? n >= 0 : n < t.expressions.length) && t.expressions[n]; a && a.type === "Char" && a.kind === "simple" && !a.escaped && /\d/.test(a.value); )
    r ? n-- : n++, a = (r ? n >= 0 : n < t.expressions.length) && t.expressions[n];
  return Math.abs(e - n);
}
function Br(e, t) {
  return e && e.type === "Char" && e.kind === "simple" && !e.escaped && e.value === t;
}
function BS(e, t) {
  if (e == null)
    return !1;
  var r = Da(e + 1, t), n = e + r + 1, a = n < t.expressions.length && t.expressions[n];
  if (r) {
    if (Br(a, "}"))
      return !0;
    if (Br(a, ","))
      return r = Da(n + 1, t), n = n + r + 1, a = n < t.expressions.length && t.expressions[n], Br(a, "}");
  }
  return !1;
}
function NS(e, t) {
  if (e == null)
    return !1;
  var r = Da(e - 1, t, !0), n = e - r - 1, a = n >= 0 && t.expressions[n];
  return r && Br(a, "{") ? !0 : Br(a, ",") ? (r = Da(n - 1, t, !0), n = n - r - 1, a = n < t.expressions.length && t.expressions[n], r && Br(a, "{")) : !1;
}
var DS = {
  _hasIUFlags: !1,
  init: function(t) {
    this._hasIUFlags = t.flags.includes("i") && t.flags.includes("u");
  },
  CharacterClass: function(t) {
    var r = t.node, n = r.expressions, a = [];
    n.forEach(function(o) {
      _t(o) && a.push(o.value);
    }), n.sort(RS);
    for (var u = 0; u < n.length; u++) {
      var i = n[u];
      if (xS(i, a, this._hasIUFlags) || jS(i, n[u - 1]) || MS(i, n[u + 1]))
        n.splice(u, 1), u--;
      else {
        var s = LS(i, u, n);
        n.splice(u - s + 1, s), u -= s;
      }
    }
  }
};
function RS(e, t) {
  var r = na(e), n = na(t);
  if (r === n) {
    if (e.type === "ClassRange" && t.type !== "ClassRange")
      return -1;
    if (t.type === "ClassRange" && e.type !== "ClassRange")
      return 1;
    if (e.type === "ClassRange" && t.type === "ClassRange")
      return na(e.to) - na(t.to);
    if (_t(e) && _t(t) || E0(e) && E0(t))
      return e.value < t.value ? -1 : 1;
  }
  return r - n;
}
function na(e) {
  return e.type === "Char" ? e.value === "-" || e.kind === "control" ? 1 / 0 : e.kind === "meta" && isNaN(e.codePoint) ? -1 : e.codePoint : e.from.codePoint;
}
function _t(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  return e.type === "Char" && e.kind === "meta" && (t ? e.value === t : /^\\[dws]$/i.test(e.value));
}
function E0(e) {
  return e.type === "Char" && e.kind === "control";
}
function xS(e, t, r) {
  for (var n = 0; n < t.length; n++)
    if (ws(e, t[n], r))
      return !0;
  return !1;
}
function ws(e, t, r) {
  return e.type === "ClassRange" ? ws(e.from, t, r) && ws(e.to, t, r) : t === "\\S" && (_t(e, "\\w") || _t(e, "\\d")) || t === "\\D" && (_t(e, "\\W") || _t(e, "\\s")) || t === "\\w" && _t(e, "\\d") || t === "\\W" && _t(e, "\\s") ? !0 : e.type !== "Char" || isNaN(e.codePoint) ? !1 : t === "\\s" ? C0(e) : t === "\\S" ? !C0(e) : t === "\\d" ? Es(e) : t === "\\D" ? !Es(e) : t === "\\w" ? Cs(e, r) : t === "\\W" ? !Cs(e, r) : !1;
}
function C0(e) {
  return e.codePoint === 9 || // \t
  e.codePoint === 10 || // \n
  e.codePoint === 11 || // \v
  e.codePoint === 12 || // \f
  e.codePoint === 13 || // \r
  e.codePoint === 32 || // space
  e.codePoint === 160 || // nbsp
  e.codePoint === 5760 || // part of Zs
  e.codePoint >= 8192 && e.codePoint <= 8202 || // part of Zs
  e.codePoint === 8232 || // line separator
  e.codePoint === 8233 || // paragraph separator
  e.codePoint === 8239 || // part of Zs
  e.codePoint === 8287 || // part of Zs
  e.codePoint === 12288 || // part of Zs
  e.codePoint === 65279;
}
function Es(e) {
  return e.codePoint >= 48 && e.codePoint <= 57;
}
function Cs(e, t) {
  return Es(e) || e.codePoint >= 65 && e.codePoint <= 90 || // A-Z
  e.codePoint >= 97 && e.codePoint <= 122 || // a-z
  e.value === "_" || t && (e.codePoint === 383 || e.codePoint === 8490);
}
function jS(e, t) {
  if (t && t.type === "ClassRange") {
    if (Ts(e, t))
      return !0;
    if (
      // We only want \w chars or char codes to keep readability
      Ra(e) && t.to.codePoint === e.codePoint - 1
    )
      return t.to = e, !0;
    if (e.type === "ClassRange" && e.from.codePoint <= t.to.codePoint + 1 && e.to.codePoint >= t.from.codePoint - 1)
      return e.from.codePoint < t.from.codePoint && (t.from = e.from), e.to.codePoint > t.to.codePoint && (t.to = e.to), !0;
  }
  return !1;
}
function MS(e, t) {
  return t && t.type === "ClassRange" && // We only want \w chars or char codes to keep readability
  Ra(e) && t.from.codePoint === e.codePoint + 1 ? (t.from = e, !0) : !1;
}
function Ts(e, t) {
  return e.type === "Char" && isNaN(e.codePoint) ? !1 : e.type === "ClassRange" ? Ts(e.from, t) && Ts(e.to, t) : e.codePoint >= t.from.codePoint && e.codePoint <= t.to.codePoint;
}
function LS(e, t, r) {
  if (!Ra(e))
    return 0;
  for (var n = 0; t > 0; ) {
    var a = r[t], u = r[t - 1];
    if (Ra(u) && u.codePoint === a.codePoint - 1)
      n++, t--;
    else
      break;
  }
  return n > 1 ? (r[t] = {
    type: "ClassRange",
    from: r[t],
    to: e
  }, n) : 0;
}
function Ra(e) {
  return e && e.type === "Char" && !isNaN(e.codePoint) && (Cs(e, !1) || e.kind === "unicode" || e.kind === "hex" || e.kind === "oct" || e.kind === "decimal");
}
var FS = lo, Np = ho, $S = Np.disjunctionToList, US = Np.listToDisjunction, HS = {
  Disjunction: function(t) {
    var r = t.node, n = {}, a = $S(r).filter(function(u) {
      var i = u ? FS.getForNode(u).jsonEncode() : "null";
      return n.hasOwnProperty(i) ? !1 : (n[i] = u, !0);
    });
    t.replace(US(a));
  }
}, GS = {
  Disjunction: function(t) {
    var r = t.node, n = t.parent;
    if (T0[n.type]) {
      var a = /* @__PURE__ */ new Map();
      if (!(!ha(r, a) || !a.size)) {
        var u = {
          type: "CharacterClass",
          expressions: Array.from(a.keys()).sort().map(function(i) {
            return a.get(i);
          })
        };
        T0[n.type](t.getParent(), u);
      }
    }
  }
}, T0 = {
  RegExp: function(t, r) {
    var n = t.node;
    n.body = r;
  },
  Group: function(t, r) {
    var n = t.node;
    n.capturing ? n.expression = r : t.replace(r);
  }
};
function ha(e, t) {
  if (!e)
    return !1;
  var r = e.type;
  if (r === "Disjunction") {
    var n = e.left, a = e.right;
    return ha(n, t) && ha(a, t);
  } else if (r === "Char") {
    if (e.kind === "meta" && e.symbol === ".")
      return !1;
    var u = e.value;
    return t.set(u, e), !0;
  } else if (r === "CharacterClass" && !e.negative)
    return e.expressions.every(function(i) {
      return ha(i, t);
    });
  return !1;
}
var WS = {
  Group: function(t) {
    var r = t.node, n = t.parent, a = t.getChild();
    r.capturing || a || (n.type === "Repetition" ? t.getParent().replace(r) : n.type !== "RegExp" && t.remove());
  }
};
function Hi(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = Array(e.length); t < e.length; t++)
      r[t] = e[t];
    return r;
  } else
    return Array.from(e);
}
var qS = {
  Group: function(t) {
    var r = t.node, n = t.parent, a = t.getChild();
    if (!(r.capturing || !a) && zS(t) && !(a.node.type === "Disjunction" && n.type !== "RegExp") && !(n.type === "Repetition" && a.node.type !== "Char" && a.node.type !== "CharacterClass"))
      if (a.node.type === "Alternative") {
        var u = t.getParent();
        u.node.type === "Alternative" && u.replace({
          type: "Alternative",
          expressions: [].concat(Hi(n.expressions.slice(0, t.index)), Hi(a.node.expressions), Hi(n.expressions.slice(t.index + 1)))
        });
      } else
        t.replace(a.node);
  }
};
function zS(e) {
  var t = e.parent, r = e.index;
  if (t.type !== "Alternative")
    return !0;
  var n = t.expressions[r - 1];
  return n == null ? !0 : !(n.type === "Backreference" && n.kind === "number" || n.type === "Char" && n.kind === "decimal");
}
function xa(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = Array(e.length); t < e.length; t++)
      r[t] = e[t];
    return r;
  } else
    return Array.from(e);
}
var ja = lo, VS = ho, Dp = VS.increaseQuantifierByOne, YS = {
  Alternative: function(t) {
    for (var r = t.node, n = 1; n < r.expressions.length; ) {
      var a = t.getChild(n);
      if (n = Math.max(1, XS(t, a, n)), n >= r.expressions.length || (a = t.getChild(n), n = Math.max(1, JS(t, a, n)), n >= r.expressions.length))
        break;
      a = t.getChild(n), n = Math.max(1, KS(t, a, n)), n++;
    }
  }
};
function XS(e, t, r) {
  for (var n = e.node, a = Math.ceil(r / 2), u = 0; u < a; ) {
    var i = r - 2 * u - 1, s = void 0, o = void 0;
    if (u === 0 ? (s = t, o = e.getChild(i)) : (s = ja.getForNode({
      type: "Alternative",
      expressions: [].concat(xa(n.expressions.slice(r - u, r)), [t.node])
    }), o = ja.getForNode({
      type: "Alternative",
      expressions: [].concat(xa(n.expressions.slice(i, r - u)))
    })), s.hasEqualSource(o)) {
      for (var c = 0; c < 2 * u + 1; c++)
        e.getChild(i).remove();
      return t.replace({
        type: "Repetition",
        expression: u === 0 && s.node.type !== "Repetition" ? s.node : {
          type: "Group",
          capturing: !1,
          expression: s.node
        },
        quantifier: {
          type: "Quantifier",
          kind: "Range",
          from: 2,
          to: 2,
          greedy: !0
        }
      }), i;
    }
    u++;
  }
  return r;
}
function JS(e, t, r) {
  for (var n = e.node, a = 0; a < r; ) {
    var u = e.getChild(a);
    if (u.node.type === "Repetition" && u.node.quantifier.greedy) {
      var i = u.getChild(), s = void 0;
      if (i.node.type === "Group" && !i.node.capturing && (i = i.getChild()), a + 1 === r ? (s = t, s.node.type === "Group" && !s.node.capturing && (s = s.getChild())) : s = ja.getForNode({
        type: "Alternative",
        expressions: [].concat(xa(n.expressions.slice(a + 1, r + 1)))
      }), i.hasEqualSource(s)) {
        for (var o = a; o < r; o++)
          e.getChild(a + 1).remove();
        return Dp(u.node.quantifier), a;
      }
    }
    a++;
  }
  return r;
}
function KS(e, t, r) {
  var n = e.node;
  if (t.node.type === "Repetition" && t.node.quantifier.greedy) {
    var a = t.getChild(), u = void 0;
    a.node.type === "Group" && !a.node.capturing && (a = a.getChild());
    var i = void 0;
    if (a.node.type === "Alternative" ? (i = a.node.expressions.length, u = ja.getForNode({
      type: "Alternative",
      expressions: [].concat(xa(n.expressions.slice(r - i, r)))
    })) : (i = 1, u = e.getChild(r - 1), u.node.type === "Group" && !u.node.capturing && (u = u.getChild())), u.hasEqualSource(a)) {
      for (var s = r - i; s < r; s++)
        e.getChild(r - i).remove();
      return Dp(t.node.quantifier), r - i;
    }
  }
  return r;
}
var QS = /* @__PURE__ */ new Map([
  // \ud83d\ude80 -> \u{1f680}
  ["charSurrogatePairToSingleUnicode", z_],
  // \u0061 -> a
  ["charCodeToSimpleChar", V_],
  // /Aa/i -> /aa/i
  ["charCaseInsensitiveLowerCaseTransform", K_],
  // [\d\d] -> [\d]
  ["charClassRemoveDuplicates", tS],
  // a{1,2}a{2,3} -> a{3,5}
  ["quantifiersMerge", sS],
  // a{1,} -> a+, a{3,3} -> a{3}, a{1} -> a
  ["quantifierRangeToSymbol", oS],
  // [a-a] -> [a], [a-b] -> [ab]
  ["charClassClassrangesToChars", lS],
  // [0-9] -> [\d]
  ["charClassToMeta", pS],
  // [\d] -> \d, [^\w] -> \W
  ["charClassToSingleChar", SS],
  // \e -> e
  ["charEscapeUnescape", AS],
  // [a-de-f] -> [a-f]
  ["charClassClassrangesMerge", DS],
  // (ab|ab) -> (ab)
  ["disjunctionRemoveDuplicates", HS],
  // (a|b|c) -> [abc]
  ["groupSingleCharsToCharClass", GS],
  // (?:)a -> a
  ["removeEmptyGroup", WS],
  // (?:a) -> a
  ["ungroup", qS],
  // abcabcabc -> (?:abc){3}
  ["combineRepeatingPatterns", YS]
]), k0 = q_, ZS = nu, A0 = po, aa = QS, e7 = {
  /**
   * Optimizer transforms a regular expression into an optimized version,
   * replacing some sub-expressions with their idiomatic patterns.
   *
   * @param string | RegExp | AST - a regexp to optimize.
   *
   * @return TransformResult - an optimized regexp.
   *
   * Example:
   *
   *   /[a-zA-Z_0-9][a-zA-Z_0-9]*\e{1,}/
   *
   * Optimized to:
   *
   *   /\w+e+/
   */
  optimize: function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.whitelist, a = n === void 0 ? [] : n, u = r.blacklist, i = u === void 0 ? [] : u, s = a.length > 0 ? a : Array.from(aa.keys()), o = s.filter(function(p) {
      return !i.includes(p);
    }), c = t;
    t instanceof RegExp && (t = "" + t), typeof t == "string" && (c = ZS.parse(t));
    var f = new A0.TransformResult(c), g = void 0;
    do
      g = f.toString(), c = k0(f.getAST()), o.forEach(function(p) {
        if (!aa.has(p))
          throw new Error("Unknown optimization-transform: " + p + ". Available transforms are: " + Array.from(aa.keys()).join(", "));
        var h = aa.get(p), v = A0.transform(c, h);
        v.toString() !== f.toString() && (v.toString().length <= f.toString().length ? f = v : c = k0(f.getAST()));
      });
    while (f.toString() !== g);
    return f;
  }
}, Rp = "ε", t7 = Rp + "*", au = {
  EPSILON: Rp,
  EPSILON_CLOSURE: t7
}, r7 = /* @__PURE__ */ function() {
  function e(t, r) {
    var n = [], a = !0, u = !1, i = void 0;
    try {
      for (var s = t[Symbol.iterator](), o; !(a = (o = s.next()).done) && (n.push(o.value), !(r && n.length === r)); a = !0)
        ;
    } catch (c) {
      u = !0, i = c;
    } finally {
      try {
        !a && s.return && s.return();
      } finally {
        if (u) throw i;
      }
    }
    return n;
  }
  return function(t, r) {
    if (Array.isArray(t))
      return t;
    if (Symbol.iterator in Object(t))
      return e(t, r);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
}(), n7 = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}();
function a7(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = Array(e.length); t < e.length; t++)
      r[t] = e[t];
    return r;
  } else
    return Array.from(e);
}
function u7(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var xp = au, i7 = xp.EPSILON, O0 = xp.EPSILON_CLOSURE, s7 = function() {
  function e(t, r) {
    u7(this, e), this.in = t, this.out = r;
  }
  return n7(e, [{
    key: "matches",
    value: function(r) {
      return this.in.matches(r);
    }
    /**
     * Returns an alphabet for this NFA.
     */
  }, {
    key: "getAlphabet",
    value: function() {
      if (!this._alphabet) {
        this._alphabet = /* @__PURE__ */ new Set();
        var r = this.getTransitionTable();
        for (var n in r) {
          var a = r[n];
          for (var u in a)
            u !== O0 && this._alphabet.add(u);
        }
      }
      return this._alphabet;
    }
    /**
     * Returns set of accepting states.
     */
  }, {
    key: "getAcceptingStates",
    value: function() {
      return this._acceptingStates || this.getTransitionTable(), this._acceptingStates;
    }
    /**
     * Returns accepting state numbers.
     */
  }, {
    key: "getAcceptingStateNumbers",
    value: function() {
      if (!this._acceptingStateNumbers) {
        this._acceptingStateNumbers = /* @__PURE__ */ new Set();
        var r = !0, n = !1, a = void 0;
        try {
          for (var u = this.getAcceptingStates()[Symbol.iterator](), i; !(r = (i = u.next()).done); r = !0) {
            var s = i.value;
            this._acceptingStateNumbers.add(s.number);
          }
        } catch (o) {
          n = !0, a = o;
        } finally {
          try {
            !r && u.return && u.return();
          } finally {
            if (n)
              throw a;
          }
        }
      }
      return this._acceptingStateNumbers;
    }
    /**
     * Builds and returns transition table.
     */
  }, {
    key: "getTransitionTable",
    value: function() {
      var r = this;
      if (!this._transitionTable) {
        this._transitionTable = {}, this._acceptingStates = /* @__PURE__ */ new Set();
        var n = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set(), u = function i(s) {
          if (!n.has(s)) {
            n.add(s), s.number = n.size, r._transitionTable[s.number] = {}, s.accepting && r._acceptingStates.add(s);
            var o = s.getTransitions(), c = !0, f = !1, g = void 0;
            try {
              for (var p = o[Symbol.iterator](), h; !(c = (h = p.next()).done); c = !0) {
                var v = h.value, S = r7(v, 2), E = S[0], d = S[1], m = [];
                a.add(E);
                var l = !0, y = !1, b = void 0;
                try {
                  for (var w = d[Symbol.iterator](), _; !(l = (_ = w.next()).done); l = !0) {
                    var k = _.value;
                    i(k), m.push(k.number);
                  }
                } catch (O) {
                  y = !0, b = O;
                } finally {
                  try {
                    !l && w.return && w.return();
                  } finally {
                    if (y)
                      throw b;
                  }
                }
                r._transitionTable[s.number][E] = m;
              }
            } catch (O) {
              f = !0, g = O;
            } finally {
              try {
                !c && p.return && p.return();
              } finally {
                if (f)
                  throw g;
              }
            }
          }
        };
        u(this.in), n.forEach(function(i) {
          delete r._transitionTable[i.number][i7], r._transitionTable[i.number][O0] = [].concat(a7(i.getEpsilonClosure())).map(function(s) {
            return s.number;
          });
        });
      }
      return this._transitionTable;
    }
  }]), e;
}(), jp = s7, o7 = /* @__PURE__ */ function() {
  function e(t, r) {
    var n = [], a = !0, u = !1, i = void 0;
    try {
      for (var s = t[Symbol.iterator](), o; !(a = (o = s.next()).done) && (n.push(o.value), !(r && n.length === r)); a = !0)
        ;
    } catch (c) {
      u = !0, i = c;
    } finally {
      try {
        !a && s.return && s.return();
      } finally {
        if (u) throw i;
      }
    }
    return n;
  }
  return function(t, r) {
    if (Array.isArray(t))
      return t;
    if (Symbol.iterator in Object(t))
      return e(t, r);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
}();
function c7(e) {
  return Array.isArray(e) ? e : Array.from(e);
}
function ks(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = Array(e.length); t < e.length; t++)
      r[t] = e[t];
    return r;
  } else
    return Array.from(e);
}
var wt = null;
function d7(e) {
  var t = e.getTransitionTable(), r = Object.keys(t), n = e.getAlphabet(), a = e.getAcceptingStateNumbers();
  wt = {};
  var u = /* @__PURE__ */ new Set();
  r.forEach(function(te) {
    te = Number(te);
    var le = a.has(te);
    le ? wt[te] = a : (u.add(te), wt[te] = u);
  });
  var i = [
    // 0-equivalent sets.
    [u, a].filter(function(te) {
      return te.size > 0;
    })
  ], s = void 0, o = void 0;
  s = i[i.length - 1], o = i[i.length - 2];
  for (var c = function() {
    var le = {}, ke = !0, we = !1, ve = void 0;
    try {
      for (var fe = s[Symbol.iterator](), Ae; !(ke = (Ae = fe.next()).done); ke = !0) {
        var Be = Ae.value, W = {}, Q = c7(Be), Y = Q[0], se = Q.slice(1);
        W[Y] = /* @__PURE__ */ new Set([Y]);
        var pe = !0, Ne = !1, oe = void 0;
        try {
          e: for (var it = se[Symbol.iterator](), Ie; !(pe = (Ie = it.next()).done); pe = !0) {
            var be = Ie.value, rt = !0, De = !1, ht = void 0;
            try {
              for (var st = Object.keys(W)[Symbol.iterator](), mt; !(rt = (mt = st.next()).done); rt = !0) {
                var Yr = mt.value;
                if (l7(be, Yr, t, n)) {
                  W[Yr].add(be), W[be] = W[Yr];
                  continue e;
                }
              }
            } catch (gt) {
              De = !0, ht = gt;
            } finally {
              try {
                !rt && st.return && st.return();
              } finally {
                if (De)
                  throw ht;
              }
            }
            W[be] = /* @__PURE__ */ new Set([be]);
          }
        } catch (gt) {
          Ne = !0, oe = gt;
        } finally {
          try {
            !pe && it.return && it.return();
          } finally {
            if (Ne)
              throw oe;
          }
        }
        Object.assign(le, W);
      }
    } catch (gt) {
      we = !0, ve = gt;
    } finally {
      try {
        !ke && fe.return && fe.return();
      } finally {
        if (we)
          throw ve;
      }
    }
    wt = le;
    var ou = new Set(Object.keys(le).map(function(gt) {
      return le[gt];
    }));
    i.push([].concat(ks(ou))), s = i[i.length - 1], o = i[i.length - 2];
  }; !f7(s, o); )
    c();
  var f = /* @__PURE__ */ new Map(), g = 1;
  s.forEach(function(te) {
    return f.set(te, g++);
  });
  var p = {}, h = /* @__PURE__ */ new Set(), v = function(le, ke) {
    var we = !0, ve = !1, fe = void 0;
    try {
      for (var Ae = le[Symbol.iterator](), Be; !(we = (Be = Ae.next()).done); we = !0) {
        var W = Be.value;
        a.has(W) && h.add(ke);
      }
    } catch (Q) {
      ve = !0, fe = Q;
    } finally {
      try {
        !we && Ae.return && Ae.return();
      } finally {
        if (ve)
          throw fe;
      }
    }
  }, S = !0, E = !1, d = void 0;
  try {
    for (var m = f.entries()[Symbol.iterator](), l; !(S = (l = m.next()).done); S = !0) {
      var y = l.value, b = o7(y, 2), w = b[0], _ = b[1];
      p[_] = {};
      var k = !0, O = !1, D = void 0;
      try {
        for (var A = n[Symbol.iterator](), P; !(k = (P = A.next()).done); k = !0) {
          var j = P.value;
          v(w, _);
          var F = void 0, z = !0, ee = !1, ie = void 0;
          try {
            for (var M = w[Symbol.iterator](), ae; !(z = (ae = M.next()).done); z = !0) {
              var me = ae.value;
              if (F = t[me][j], F)
                break;
            }
          } catch (te) {
            ee = !0, ie = te;
          } finally {
            try {
              !z && M.return && M.return();
            } finally {
              if (ee)
                throw ie;
            }
          }
          F && (p[_][j] = f.get(wt[F]));
        }
      } catch (te) {
        O = !0, D = te;
      } finally {
        try {
          !k && A.return && A.return();
        } finally {
          if (O)
            throw D;
        }
      }
    }
  } catch (te) {
    E = !0, d = te;
  } finally {
    try {
      !S && m.return && m.return();
    } finally {
      if (E)
        throw d;
    }
  }
  return e.setTransitionTable(p), e.setAcceptingStateNumbers(h), e;
}
function f7(e, t) {
  if (!t || e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++) {
    var n = e[r], a = t[r];
    if (n.size !== a.size || [].concat(ks(n)).sort().join(",") !== [].concat(ks(a)).sort().join(","))
      return !1;
  }
  return !0;
}
function l7(e, t, r, n) {
  var a = !0, u = !1, i = void 0;
  try {
    for (var s = n[Symbol.iterator](), o; !(a = (o = s.next()).done); a = !0) {
      var c = o.value;
      if (!p7(e, t, r, c))
        return !1;
    }
  } catch (f) {
    u = !0, i = f;
  } finally {
    try {
      !a && s.return && s.return();
    } finally {
      if (u)
        throw i;
    }
  }
  return !0;
}
function p7(e, t, r, n) {
  if (!wt[e] || !wt[t])
    return !1;
  var a = r[e][n], u = r[t][n];
  return !a && !u ? !0 : wt[e].has(a) && wt[t].has(u);
}
var h7 = {
  minimize: d7
}, m7 = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}();
function I0(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = Array(e.length); t < e.length; t++)
      r[t] = e[t];
    return r;
  } else
    return Array.from(e);
}
function g7(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var y7 = h7, v7 = au, P0 = v7.EPSILON_CLOSURE, b7 = function() {
  function e(t) {
    g7(this, e), this._nfa = t;
  }
  return m7(e, [{
    key: "minimize",
    value: function() {
      this.getTransitionTable(), this._originalAcceptingStateNumbers = this._acceptingStateNumbers, this._originalTransitionTable = this._transitionTable, y7.minimize(this);
    }
    /**
     * Returns alphabet for this DFA.
     */
  }, {
    key: "getAlphabet",
    value: function() {
      return this._nfa.getAlphabet();
    }
    /**
     * Returns accepting states.
     */
  }, {
    key: "getAcceptingStateNumbers",
    value: function() {
      return this._acceptingStateNumbers || this.getTransitionTable(), this._acceptingStateNumbers;
    }
    /**
     * Returns original accepting states.
     */
  }, {
    key: "getOriginaAcceptingStateNumbers",
    value: function() {
      return this._originalAcceptingStateNumbers || this.getTransitionTable(), this._originalAcceptingStateNumbers;
    }
    /**
     * Sets transition table.
     */
  }, {
    key: "setTransitionTable",
    value: function(r) {
      this._transitionTable = r;
    }
    /**
     * Sets accepting states.
     */
  }, {
    key: "setAcceptingStateNumbers",
    value: function(r) {
      this._acceptingStateNumbers = r;
    }
    /**
     * DFA transition table is built from NFA table.
     */
  }, {
    key: "getTransitionTable",
    value: function() {
      var r = this;
      if (this._transitionTable)
        return this._transitionTable;
      var n = this._nfa.getTransitionTable(), a = Object.keys(n);
      this._acceptingStateNumbers = /* @__PURE__ */ new Set();
      for (var u = n[a[0]][P0], i = [u], s = this.getAlphabet(), o = this._nfa.getAcceptingStateNumbers(), c = {}, f = function(te) {
        var le = !0, ke = !1, we = void 0;
        try {
          for (var ve = o[Symbol.iterator](), fe; !(le = (fe = ve.next()).done); le = !0) {
            var Ae = fe.value;
            if (te.indexOf(Ae) !== -1) {
              r._acceptingStateNumbers.add(te.join(","));
              break;
            }
          }
        } catch (Be) {
          ke = !0, we = Be;
        } finally {
          try {
            !le && ve.return && ve.return();
          } finally {
            if (ke)
              throw we;
          }
        }
      }; i.length > 0; ) {
        var g = i.shift(), p = g.join(",");
        c[p] = {};
        var h = !0, v = !1, S = void 0;
        try {
          for (var E = s[Symbol.iterator](), d; !(h = (d = E.next()).done); h = !0) {
            var m = d.value, l = [];
            f(g);
            var y = !0, b = !1, w = void 0;
            try {
              for (var _ = g[Symbol.iterator](), k; !(y = (k = _.next()).done); y = !0) {
                var O = k.value, D = n[O][m];
                if (D) {
                  var A = !0, P = !1, j = void 0;
                  try {
                    for (var F = D[Symbol.iterator](), z; !(A = (z = F.next()).done); A = !0) {
                      var ee = z.value;
                      n[ee] && l.push.apply(l, I0(n[ee][P0]));
                    }
                  } catch (me) {
                    P = !0, j = me;
                  } finally {
                    try {
                      !A && F.return && F.return();
                    } finally {
                      if (P)
                        throw j;
                    }
                  }
                }
              }
            } catch (me) {
              b = !0, w = me;
            } finally {
              try {
                !y && _.return && _.return();
              } finally {
                if (b)
                  throw w;
              }
            }
            var ie = new Set(l), M = [].concat(I0(ie));
            if (M.length > 0) {
              var ae = M.join(",");
              c[p][m] = ae, c.hasOwnProperty(ae) || i.unshift(M);
            }
          }
        } catch (me) {
          v = !0, S = me;
        } finally {
          try {
            !h && E.return && E.return();
          } finally {
            if (v)
              throw S;
          }
        }
      }
      return this._transitionTable = this._remapStateNumbers(c);
    }
    /**
     * Remaps state numbers in the resulting table:
     * combined states '1,2,3' -> 1, '3,4' -> 2, etc.
     */
  }, {
    key: "_remapStateNumbers",
    value: function(r) {
      var n = {};
      this._originalTransitionTable = r;
      var a = {};
      Object.keys(r).forEach(function(S, E) {
        n[S] = E + 1;
      });
      for (var u in r) {
        var i = r[u], s = {};
        for (var o in i)
          s[o] = n[i[o]];
        a[n[u]] = s;
      }
      this._originalAcceptingStateNumbers = this._acceptingStateNumbers, this._acceptingStateNumbers = /* @__PURE__ */ new Set();
      var c = !0, f = !1, g = void 0;
      try {
        for (var p = this._originalAcceptingStateNumbers[Symbol.iterator](), h; !(c = (h = p.next()).done); c = !0) {
          var v = h.value;
          this._acceptingStateNumbers.add(n[v]);
        }
      } catch (S) {
        f = !0, g = S;
      } finally {
        try {
          !c && p.return && p.return();
        } finally {
          if (f)
            throw g;
        }
      }
      return a;
    }
    /**
     * Returns original DFA table, where state numbers
     * are combined numbers from NFA.
     */
  }, {
    key: "getOriginalTransitionTable",
    value: function() {
      return this._originalTransitionTable || this.getTransitionTable(), this._originalTransitionTable;
    }
    /**
     * Checks whether this DFA accepts a string.
     */
  }, {
    key: "matches",
    value: function(r) {
      for (var n = 1, a = 0, u = this.getTransitionTable(); r[a]; )
        if (n = u[n][r[a++]], !n)
          return !1;
      return !!this.getAcceptingStateNumbers().has(n);
    }
  }]), e;
}(), _7 = b7, S7 = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}();
function w7(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var E7 = function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.accepting, n = r === void 0 ? !1 : r;
    w7(this, e), this._transitions = /* @__PURE__ */ new Map(), this.accepting = n;
  }
  return S7(e, [{
    key: "getTransitions",
    value: function() {
      return this._transitions;
    }
    /**
     * Creates a transition on symbol.
     */
  }, {
    key: "addTransition",
    value: function(r, n) {
      return this.getTransitionsOnSymbol(r).add(n), this;
    }
    /**
     * Returns transitions set on symbol.
     */
  }, {
    key: "getTransitionsOnSymbol",
    value: function(r) {
      var n = this._transitions.get(r);
      return n || (n = /* @__PURE__ */ new Set(), this._transitions.set(r, n)), n;
    }
  }]), e;
}(), C7 = E7, T7 = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}();
function k7(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function A7(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function O7(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var I7 = C7, P7 = au, Gi = P7.EPSILON, B7 = function(e) {
  O7(t, e);
  function t() {
    return k7(this, t), A7(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
  }
  return T7(t, [{
    key: "matches",
    /**
     * Whether this state matches a string.
     *
     * We maintain set of visited epsilon-states to avoid infinite loops
     * when an epsilon-transition goes eventually to itself.
     *
     * NOTE: this function is rather "educational", since we use DFA for strings
     * matching. DFA is built on top of NFA, and uses fast transition table.
     */
    value: function(n) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /* @__PURE__ */ new Set();
      if (a.has(this))
        return !1;
      if (a.add(this), n.length === 0) {
        if (this.accepting)
          return !0;
        var u = !0, i = !1, s = void 0;
        try {
          for (var o = this.getTransitionsOnSymbol(Gi)[Symbol.iterator](), c; !(u = (c = o.next()).done); u = !0) {
            var f = c.value;
            if (f.matches("", a))
              return !0;
          }
        } catch (D) {
          i = !0, s = D;
        } finally {
          try {
            !u && o.return && o.return();
          } finally {
            if (i)
              throw s;
          }
        }
        return !1;
      }
      var g = n[0], p = n.slice(1), h = this.getTransitionsOnSymbol(g), v = !0, S = !1, E = void 0;
      try {
        for (var d = h[Symbol.iterator](), m; !(v = (m = d.next()).done); v = !0) {
          var l = m.value;
          if (l.matches(p))
            return !0;
        }
      } catch (D) {
        S = !0, E = D;
      } finally {
        try {
          !v && d.return && d.return();
        } finally {
          if (S)
            throw E;
        }
      }
      var y = !0, b = !1, w = void 0;
      try {
        for (var _ = this.getTransitionsOnSymbol(Gi)[Symbol.iterator](), k; !(y = (k = _.next()).done); y = !0) {
          var O = k.value;
          if (O.matches(n, a))
            return !0;
        }
      } catch (D) {
        b = !0, w = D;
      } finally {
        try {
          !y && _.return && _.return();
        } finally {
          if (b)
            throw w;
        }
      }
      return !1;
    }
    /**
     * Returns an ε-closure for this state:
     * self + all states following ε-transitions.
     */
  }, {
    key: "getEpsilonClosure",
    value: function() {
      var n = this;
      return this._epsilonClosure || function() {
        var a = n.getTransitionsOnSymbol(Gi), u = n._epsilonClosure = /* @__PURE__ */ new Set();
        u.add(n);
        var i = !0, s = !1, o = void 0;
        try {
          for (var c = a[Symbol.iterator](), f; !(i = (f = c.next()).done); i = !0) {
            var g = f.value;
            if (!u.has(g)) {
              u.add(g);
              var p = g.getEpsilonClosure();
              p.forEach(function(h) {
                return u.add(h);
              });
            }
          }
        } catch (h) {
          s = !0, o = h;
        } finally {
          try {
            !i && c.return && c.return();
          } finally {
            if (s)
              throw o;
          }
        }
      }(), this._epsilonClosure;
    }
  }]), t;
}(I7), N7 = B7, uu = jp, jr = N7, D7 = au, He = D7.EPSILON;
function Mp(e) {
  var t = new jr(), r = new jr({
    accepting: !0
  });
  return new uu(t.addTransition(e, r), r);
}
function R7() {
  return Mp(He);
}
function x7(e, t) {
  return e.out.accepting = !1, t.out.accepting = !0, e.out.addTransition(He, t.in), new uu(e.in, t.out);
}
function j7(e) {
  for (var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  var a = !0, u = !1, i = void 0;
  try {
    for (var s = r[Symbol.iterator](), o; !(a = (o = s.next()).done); a = !0) {
      var c = o.value;
      e = x7(e, c);
    }
  } catch (f) {
    u = !0, i = f;
  } finally {
    try {
      !a && s.return && s.return();
    } finally {
      if (u)
        throw i;
    }
  }
  return e;
}
function M7(e, t) {
  var r = new jr(), n = new jr();
  return r.addTransition(He, e.in), r.addTransition(He, t.in), n.accepting = !0, e.out.accepting = !1, t.out.accepting = !1, e.out.addTransition(He, n), t.out.addTransition(He, n), new uu(r, n);
}
function L7(e) {
  for (var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  var a = !0, u = !1, i = void 0;
  try {
    for (var s = r[Symbol.iterator](), o; !(a = (o = s.next()).done); a = !0) {
      var c = o.value;
      e = M7(e, c);
    }
  } catch (f) {
    u = !0, i = f;
  } finally {
    try {
      !a && s.return && s.return();
    } finally {
      if (u)
        throw i;
    }
  }
  return e;
}
function F7(e) {
  var t = new jr(), r = new jr({
    accepting: !0
  });
  return t.addTransition(He, e.in), t.addTransition(He, r), e.out.accepting = !1, e.out.addTransition(He, r), r.addTransition(He, e.in), new uu(t, r);
}
function $7(e) {
  return e.in.addTransition(He, e.out), e.out.addTransition(He, e.in), e;
}
function U7(e) {
  return e.out.addTransition(He, e.in), e;
}
function H7(e) {
  return e.in.addTransition(He, e.out), e;
}
var Lp = {
  alt: j7,
  char: Mp,
  e: R7,
  or: L7,
  rep: $7,
  repExplicit: F7,
  plusRep: U7,
  questionRep: H7
};
function G7(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = Array(e.length); t < e.length; t++)
      r[t] = e[t];
    return r;
  } else
    return Array.from(e);
}
var W7 = nu, zr = Lp, q7 = zr.alt, z7 = zr.char, V7 = zr.or, Y7 = zr.rep, X7 = zr.plusRep, J7 = zr.questionRep;
function yt(e) {
  if (e && !B0[e.type])
    throw new Error(e.type + " is not supported in NFA/DFA interpreter.");
  return e ? B0[e.type](e) : "";
}
var B0 = {
  RegExp: function(t) {
    if (t.flags !== "")
      throw new Error("NFA/DFA: Flags are not supported yet.");
    return yt(t.body);
  },
  Alternative: function(t) {
    var r = (t.expressions || []).map(yt);
    return q7.apply(void 0, G7(r));
  },
  Disjunction: function(t) {
    return V7(yt(t.left), yt(t.right));
  },
  Repetition: function(t) {
    switch (t.quantifier.kind) {
      case "*":
        return Y7(yt(t.expression));
      case "+":
        return X7(yt(t.expression));
      case "?":
        return J7(yt(t.expression));
      default:
        throw new Error("Unknown repeatition: " + t.quantifier.kind + ".");
    }
  },
  Char: function(t) {
    if (t.kind !== "simple")
      throw new Error("NFA/DFA: Only simple chars are supported yet.");
    return z7(t.value);
  },
  Group: function(t) {
    return yt(t.expression);
  }
}, K7 = {
  /**
   * Builds an NFA from the passed regexp.
   */
  build: function(t) {
    var r = t;
    return t instanceof RegExp && (t = "" + t), typeof t == "string" && (r = W7.parse(t, {
      captureLocations: !0
    })), yt(r);
  }
}, Q7 = jp, N0 = _7, Z7 = K7, e9 = Lp, t9 = {
  /**
   * Export NFA and DFA classes.
   */
  NFA: Q7,
  DFA: N0,
  /**
   * Expose builders.
   */
  builders: e9,
  /**
   * Builds an NFA for the passed regexp.
   *
   * @param string | AST | RegExp:
   *
   *   a regular expression in different representations: a string,
   *   a RegExp object, or an AST.
   */
  toNFA: function(t) {
    return Z7.build(t);
  },
  /**
   * Builds DFA for the passed regexp.
   *
   * @param string | AST | RegExp:
   *
   *   a regular expression in different representations: a string,
   *   a RegExp object, or an AST.
   */
  toDFA: function(t) {
    return new N0(this.toNFA(t));
  },
  /**
   * Returns true if regexp accepts the string.
   */
  test: function(t, r) {
    return this.toDFA(t).matches(r);
  }
}, r9 = /* @__PURE__ */ function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}();
function n9(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var a9 = function() {
  function e(t, r) {
    var n = r.flags, a = r.groups, u = r.source;
    n9(this, e), this._re = t, this._groups = a, this.flags = n, this.source = u || t.source, this.dotAll = n.includes("s"), this.global = t.global, this.ignoreCase = t.ignoreCase, this.multiline = t.multiline, this.sticky = t.sticky, this.unicode = t.unicode;
  }
  return r9(e, [{
    key: "test",
    value: function(r) {
      return this._re.test(r);
    }
    /**
     * Facade wrapper for RegExp `compile` method.
     */
  }, {
    key: "compile",
    value: function(r) {
      return this._re.compile(r);
    }
    /**
     * Facade wrapper for RegExp `toString` method.
     */
  }, {
    key: "toString",
    value: function() {
      return this._toStringResult || (this._toStringResult = "/" + this.source + "/" + this.flags), this._toStringResult;
    }
    /**
     * Facade wrapper for RegExp `exec` method.
     */
  }, {
    key: "exec",
    value: function(r) {
      var n = this._re.exec(r);
      if (!this._groups || !n)
        return n;
      n.groups = {};
      for (var a in this._groups) {
        var u = this._groups[a];
        n.groups[a] = n[u];
      }
      return n;
    }
  }]), e;
}(), u9 = {
  RegExpTree: a9
}, i9 = W_, s9 = Sp, o9 = e7, D0 = nu, R0 = po, c9 = Ip, d9 = t9, f9 = u9, l9 = f9.RegExpTree, p9 = {
  /**
   * Parser module exposed.
   */
  parser: D0,
  /**
   * Expose finite-automaton module.
   */
  fa: d9,
  /**
   * `TransformResult` exposed.
   */
  TransformResult: R0.TransformResult,
  /**
   * Parses a regexp string, producing an AST.
   *
   * @param string regexp
   *
   *   a regular expression in different formats: string, AST, RegExp.
   *
   * @param Object options
   *
   *   parsing options for this parse call. Default are:
   *
   *     - captureLocations: boolean
   *     - any other custom options
   *
   * @return Object AST
   */
  parse: function(t, r) {
    return D0.parse("" + t, r);
  },
  /**
   * Traverses a RegExp AST.
   *
   * @param Object ast
   * @param Object | Array<Object> handlers
   *
   * Each `handler` is an object containing handler function for needed
   * node types. Example:
   *
   *   regexpTree.traverse(ast, {
   *     onChar(node) {
   *       ...
   *     },
   *   });
   *
   * The value for a node type may also be an object with functions pre and post.
   * This enables more context-aware analyses, e.g. measuring star height.
   */
  traverse: function(t, r, n) {
    return c9.traverse(t, r, n);
  },
  /**
   * Transforms a regular expression.
   *
   * A regexp can be passed in different formats (string, regexp or AST),
   * applying a set of transformations. It is a convenient wrapper
   * on top of "parse-traverse-generate" tool chain.
   *
   * @param string | AST | RegExp regexp - a regular expression;
   * @param Object | Array<Object> handlers - a list of handlers.
   *
   * @return TransformResult - a transformation result.
   */
  transform: function(t, r) {
    return R0.transform(t, r);
  },
  /**
   * Generates a RegExp string from an AST.
   *
   * @param Object ast
   *
   * Invariant:
   *
   *   regexpTree.generate(regexpTree.parse('/[a-z]+/i')); // '/[a-z]+/i'
   */
  generate: function(t) {
    return s9.generate(t);
  },
  /**
   * Creates a RegExp object from a regexp string.
   *
   * @param string regexp
   */
  toRegExp: function(t) {
    var r = this.compatTranspile(t);
    return new RegExp(r.getSource(), r.getFlags());
  },
  /**
   * Optimizes a regular expression by replacing some
   * sub-expressions with their idiomatic patterns.
   *
   * @param string regexp
   *
   * @return TransformResult object
   */
  optimize: function(t, r) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = n.blacklist;
    return o9.optimize(t, { whitelist: r, blacklist: a });
  },
  /**
   * Translates a regular expression in new syntax or in new format
   * into equivalent expressions in old syntax.
   *
   * @param string regexp
   *
   * @return TransformResult object
   */
  compatTranspile: function(t, r) {
    return i9.transform(t, r);
  },
  /**
   * Executes a regular expression on a string.
   *
   * @param RegExp|string re - a regular expression.
   * @param string string - a testing string.
   */
  exec: function(t, r) {
    if (typeof t == "string") {
      var n = this.compatTranspile(t), a = n.getExtra();
      a.namedCapturingGroups ? t = new l9(n.toRegExp(), {
        flags: n.getFlags(),
        source: n.getSource(),
        groups: a.namedCapturingGroups
      }) : t = n.toRegExp();
    }
    return t.exec(r);
  }
}, h9 = p9, m9 = h9;
const pt = /* @__PURE__ */ op(m9), g9 = [
  {
    regex: /IE (\d+)\.(\d+)/,
    family: "ie",
    maxVersion: [
      7,
      1 / 0,
      1 / 0
    ]
  },
  /**
   * IE can be in Compatability Mode (IE 7.0)
   * so we need to check Trident version
   */
  {
    regex: /Trident\/4\.0/,
    family: "ie",
    version: [
      8,
      0,
      0
    ]
  },
  {
    regex: /Trident\/5\.0/,
    family: "ie",
    version: [
      9,
      0,
      0
    ]
  },
  {
    regex: /Trident\/6\.0/,
    family: "ie",
    version: [
      10,
      0,
      0
    ]
  },
  {
    regex: /Trident\/[78]\.0/,
    family: "ie",
    version: [
      11,
      0,
      0
    ]
  },
  {
    regex: /Edge?\/(\d+)\.(\d+)(\.(\d+)|)/,
    family: "edge"
  },
  {
    regex: /Firefox\/(\d+)\.(\d+)(\.(\d+)|)/,
    family: "firefox"
  },
  {
    regex: /Chrom(ium|e)\/(\d+)\.(\d+)(\.(\d+)|)/,
    family: "chrome"
  },
  /**
   * Ignore Edge with EdgeHTML engine.
   */
  {
    regex: /Chrom(ium|e)\/(\d+)\.(\d+)(\.(\d+)|)([\d.]+$|.*Safari\/(?![\d.]+ Edge\/[\d.]+$))/,
    family: "chrome",
    maxVersion: [
      70,
      1 / 0,
      1 / 0
    ]
  },
  /**
   * Safari on iPad have desktop-like useragent
   * Some versions contains letter subversions
   * GNOME Web (X11) is based on WebKit and should be detected as Safari
   */
  {
    regex: /(Maci|X11).+ Version\/(\d+)\.(\d+)([.,](\d+)|)( \(\w+\)|)( Mobile\/\w+|) Safari\//,
    family: "safari"
  },
  /**
   * Presto Opera
   */
  {
    regex: /Opera\/9\.80.+Version\/(\d+)\.(\d+)(\.(\d+)|)/,
    family: "opera",
    maxVersion: [
      12,
      15,
      0
    ]
  },
  /**
   * Chromium based Opera
   */
  {
    regex: /Chrome.+OPR\/(\d+)\.(\d+)\.(\d+)/,
    family: "opera",
    minVersion: [
      15,
      0,
      0
    ]
  },
  {
    regex: /(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(\d+)[_.](\d+)([_.](\d+)|)/,
    family: "ios_saf"
  },
  /**
   * Ignore IE Mobile 11
   */
  {
    regex: /[^e] (CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(\d+)[_.](\d+)([_.](\d+)|)/,
    family: "ios_saf",
    version: [
      7,
      0,
      3
    ]
  },
  {
    regex: /Opera Mini/,
    family: "op_mini"
  },
  {
    regex: /Android Donut/,
    family: "android",
    version: [
      1,
      2,
      0
    ]
  },
  {
    regex: /Android Eclair/,
    family: "android",
    version: [
      2,
      1,
      0
    ]
  },
  {
    regex: /Android Froyo/,
    family: "android",
    version: [
      2,
      2,
      0
    ]
  },
  {
    regex: /Android Gingerbread/,
    family: "android",
    version: [
      2,
      3,
      0
    ]
  },
  {
    regex: /Android Honeycomb/,
    family: "android",
    version: [
      3,
      0,
      0
    ]
  },
  {
    regex: /Android:?[ /-](\d+)(\.(\d+)|)(\.(\d+)|)/,
    family: "android"
  },
  /**
   * Ignore IE Mobile 11
   */
  {
    regex: /Android:?[ /-](\d+)(\.(\d+)|)(\.(\d+)|);(?! ARM; Trident)/,
    family: "android",
    version: [
      4,
      0,
      0
    ]
  },
  {
    regex: /PlayBook.+RIM Tablet OS (\d+)\.(\d+)\.(\d+)/,
    family: "bb"
  },
  {
    regex: /(Black[bB]erry|BB10).+Version\/(\d+)\.(\d+)\.(\d+)/,
    family: "bb"
  },
  /**
   * Presto Opera Mobile
   */
  {
    regex: /Opera\/.+Opera Mobi.+Version\/(\d+)\.(\d+)/,
    family: "op_mob",
    maxVersion: [
      12,
      16,
      0
    ]
  },
  /**
   * Chromium based Opera Mobile
   */
  {
    regex: /Mobile Safari.+OPR\/(\d+)\.(\d+)\.(\d+)/,
    family: "op_mob",
    minVersion: [
      14,
      0,
      0
    ]
  },
  {
    regex: /Android.+Firefox\/(\d+)\.(\d+)(\.(\d+)|)/,
    family: "and_ff"
  },
  {
    regex: /Android.+Chrom(ium|e)\/(\d+)\.(\d+)(\.(\d+)|)/,
    family: "and_chr"
  },
  {
    regex: /IEMobile[ /](\d+)\.(\d+)/,
    family: "ie_mob"
  },
  {
    regex: /Android.+(UC? ?Browser|UCWEB|U3)[ /]?(\d+)\.(\d+)\.(\d+)/,
    family: "and_uc"
  },
  {
    regex: /SamsungBrowser\/(\d+)\.(\d+)/,
    family: "samsung"
  },
  {
    regex: /Android.+MQQBrowser\/(\d+)(\.(\d+)|)(\.(\d+)|)/,
    family: "and_qq"
  },
  {
    regex: /baidubrowser[/\s](\d+)(\.(\d+)|)(\.(\d+)|)/,
    family: "baidu"
  },
  {
    regex: /K[Aa][Ii]OS\/(\d+)\.(\d+)(\.(\d+)|)/,
    family: "kaios"
  }
];
function Wi(e) {
  return typeof e == "number" ? e : e.length === 1 ? e[0] : [
    e[0],
    e[e.length - 1]
  ];
}
var _e;
(function(e) {
  e[e.Major = 0] = "Major", e[e.Minor = 1] = "Minor", e[e.Patch = 2] = "Patch";
})(_e || (_e = {}));
function x0(e) {
  const t = Array.isArray(e) ? e : e.toString().split(".");
  if (t[0] === "all")
    return [
      1 / 0,
      0,
      0
    ];
  let r = null, n = null;
  const a = [
    0,
    0,
    0
  ];
  for (let u = 0; u < 3; u++)
    if (r = t[u], !(typeof r > "u")) {
      if (n = typeof r == "number" ? r : parseInt(r, 10), isNaN(n))
        return null;
      a[u] = n;
    }
  return a;
}
function y9(e, t) {
  let r = 0;
  const n = [];
  for (let a = 2; a >= 0; a--)
    if (e[a] !== t[a]) {
      r = a;
      break;
    }
  for (let a = e[r], u = t[r]; a <= u; a++)
    n.push(e.map((i, s) => s === r ? a : i));
  return n;
}
function j0(e, t, r) {
  const [n, a, u] = e, [i, s, o] = t, { ignoreMinor: c, ignorePatch: f } = r;
  if (i === 1 / 0)
    return !0;
  const g = !c;
  return g && !f && u < o || g && a < s ? !1 : n >= i;
}
function v9(e, t) {
  const { ignoreMinor: r, ignorePatch: n, allowZeroSubversions: a } = t;
  let u = r ? 1 : n ? 2 : 3;
  if (a)
    for (let i = u - 1; i > 0 && !(e[i] !== 0 || u === 1); i--)
      u--;
  return u;
}
function b9(e) {
  return e.reduce((t, r) => {
    const [n, a, u] = r.split(/ |-/), i = x0(a);
    return (i ? u ? y9(i, x0(u)) : [
      i
    ] : []).reduce((o, c) => (c && o.push({
      family: n,
      version: c
    }), o), t);
  }, []);
}
function _9(e = {}) {
  const { browsers: t, ...r } = e, n = u_(t, r);
  return b9(n);
}
function S9(e, t, r = 0) {
  const n = e.length;
  for (let a = r; a < n; a++)
    if (e[a] !== t[a])
      return !1;
  return !0;
}
function Fp(e) {
  if (e === null || typeof e != "object")
    return e;
  const t = Array.isArray(e) ? [] : {};
  let r;
  for (r in e)
    t[r] = Fp(e[r]);
  return t;
}
function iu(e) {
  return [].concat(...e);
}
function w9(e) {
  const t = /* @__PURE__ */ new Map();
  return e.forEach(({ family: r, version: n }) => {
    const a = t.get(r);
    if (a) {
      const u = n.join(".");
      a.every((i) => i.join(".") !== u) && a.push(n);
      return;
    }
    t.set(r, [
      n
    ]);
  }), t.forEach((r) => {
    r.sort((n, a) => {
      for (const u in n)
        if (n[u] !== a[u])
          return n[u] - a[u];
      return 0;
    });
  }), t;
}
function E9(e) {
  if (e.length < 2)
    return e;
  const t = e.length + 1, r = [];
  let n = null, a = e[0], u = [
    a[_e.Major]
  ], i = [
    a[_e.Minor]
  ], s = [
    a[_e.Patch]
  ], o = null;
  for (let c = 1; c < t; c++) {
    n = e[c - 1], a = e[c] || [];
    for (let f = _e.Major; f <= _e.Patch; f++) {
      if ((f === o || o === null) && n[f] + 1 === a[f] && S9(n, a, f + 1)) {
        o = f, f === _e.Major ? u.push(a[_e.Major]) : u = a[_e.Major], f === _e.Minor ? i.push(a[_e.Minor]) : i = a[_e.Minor], f === _e.Patch ? s.push(a[_e.Patch]) : s = a[_e.Patch];
        break;
      }
      if (o === f || n[f] !== a[f]) {
        r.push([
          Wi(u),
          Wi(i),
          Wi(s)
        ]), u = [
          a[_e.Major]
        ], i = [
          a[_e.Minor]
        ], s = [
          a[_e.Patch]
        ], o = null;
        break;
      }
    }
  }
  return r;
}
function C9(e) {
  return {
    type: "RegExp",
    body: e,
    flags: ""
  };
}
function Ct(...e) {
  const t = iu(e).filter(Boolean);
  return t.length === 1 ? t[0] : {
    type: "Alternative",
    expressions: t
  };
}
function Ze(e) {
  return {
    type: "Char",
    kind: "simple",
    value: String(e),
    codePoint: NaN
  };
}
function T9(e) {
  return {
    type: "Char",
    kind: "meta",
    value: e,
    codePoint: NaN
  };
}
function $p(e, t) {
  return {
    type: "ClassRange",
    from: e,
    to: t
  };
}
function As(...e) {
  return {
    type: "CharacterClass",
    expressions: iu(e).filter(Boolean)
  };
}
function k9(e) {
  return {
    type: "Quantifier",
    kind: e,
    greedy: !0
  };
}
function A9(e, t) {
  return {
    type: "Quantifier",
    kind: "Range",
    from: e,
    to: t,
    greedy: !0
  };
}
function Up(e) {
  return {
    type: "Group",
    capturing: !0,
    expression: e,
    number: null
  };
}
function O9(e, t) {
  return {
    type: "Repetition",
    expression: e,
    quantifier: t
  };
}
function I9(...e) {
  const t = iu(e).filter(Boolean);
  if (t.length === 1)
    return t[0];
  const r = {
    type: "Disjunction",
    left: null,
    right: t.pop()
  };
  return t.reduceRight((n, a, u) => u === 0 ? (n.left = a, n) : (n.left = {
    type: "Disjunction",
    left: null,
    right: a
  }, n.left), r), r;
}
function su(...e) {
  const t = I9(...e);
  return t.type === "Disjunction" ? Up(t) : t;
}
function Mr() {
  return T9("\\d");
}
function Nr(e = k9("+")) {
  return O9(Mr(), e);
}
function M0(e) {
  return Ct(Array.from(String(e), Ze));
}
function Ma(e) {
  if (e.type === "Group" && e.expression.type === "Repetition") {
    const { expression: t, quantifier: r } = e.expression;
    return t.type === "Char" && t.value === "\\d" && r.kind === "+" && r.greedy;
  }
  return !1;
}
function Ar(e, t) {
  return e && e.type === "Char" ? typeof t > "u" || t instanceof RegExp && t.test(e.value) || String(t) === e.value : !1;
}
function L0(e) {
  if (e.type === "CharacterClass" && e.expressions.length === 1) {
    const [t] = e.expressions;
    return t.type === "ClassRange" && Ar(t.from, /\d/) && Ar(t.to, /\d/);
  }
  return !1;
}
function F0(e) {
  return e.type !== "RegExp" && e.type !== "ClassRange" && e.type !== "Quantifier";
}
function Vr(e) {
  return typeof e == "string" ? pt.parse(e.replace(/^([^/])/, "/$1").replace(/([^/])$/, "$1/")) : e instanceof RegExp ? pt.parse(e) : e;
}
function P9(e) {
  return typeof e == "string" ? new RegExp(e) : new RegExp(pt.generate(e.body), e.flags);
}
function B9(e) {
  return typeof e == "string" ? e : e instanceof RegExp ? e.toString() : pt.generate(e);
}
const N9 = [
  "RegExp",
  "Disjunction",
  "Alternative",
  "Assertion",
  "Char",
  "CharacterClass",
  "ClassRange",
  "Backreference",
  "Group",
  "Repetition",
  "Quantifier"
];
function go(e) {
  const { every: t } = e;
  return t ? typeof t == "function" ? {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    "*": t,
    ...e
  } : N9.reduce((r, n) => {
    const a = e[n], u = a ? "pre" in a ? a.pre : a : null, i = a && "post" in a ? a.post : null;
    return r[n] = {
      pre(s) {
        return t.pre(s) !== !1 && u ? u(s) : !0;
      },
      post(s) {
        return t.post(s) !== !1 && i ? i(s) : !0;
      }
    }, r;
  }, {}) : e;
}
function D9(e) {
  const t = pt.optimize(Vr(B9(e))).getAST();
  return pt.traverse(t, {
    Group(r) {
      const { parent: n, node: a } = r, { expression: u } = a;
      a.capturing = !0, (n.type === "RegExp" || u.type !== "Disjunction" && n.type !== "Repetition" || u.type === "Disjunction" && n.type === "Disjunction") && r.replace(r.node.expression);
    }
  }), t;
}
function R9(e, t) {
  return Ar(e) && Ar(t) && e.value === t.value ? t : Ar(e, /\d/) && L0(t) && Number(t.expressions[0].from.value) - Number(e.value) === 1 ? {
    ...t,
    expressions: [
      {
        ...t.expressions[0],
        from: e
      }
    ]
  } : L0(e) && Ar(t, /\d/) && Number(t.value) - Number(e.expressions[0].to.value) === 1 ? {
    ...e,
    expressions: [
      {
        ...e.expressions[0],
        to: t
      }
    ]
  } : null;
}
function x9(e) {
  return e.reduce((t, r) => {
    const n = t[t.length - 1];
    if (n && r.type === "Alternative" && n.type === "Alternative" && r.expressions.length === n.expressions.length) {
      const a = n.expressions.reduceRight((u, i, s) => {
        if (!u)
          return u;
        const o = R9(i, r.expressions[s]);
        if (o)
          u.unshift(o);
        else
          return null;
        return u;
      }, []);
      a && (r.expressions = a, t.pop());
    }
    return t.push(r), t;
  }, []);
}
function Os(e) {
  return Array.from(e.toString(), Number);
}
function $0(e, t) {
  const r = e + +!t;
  return r === 0 ? Mr() : r === 9 ? Ze("9") : r > 9 ? null : As($p(Ze(r), Ze("9")));
}
function j9(e) {
  if (e === 0)
    return [
      Nr()
    ];
  const t = Os(e), r = t.length, n = Nr(A9(r + 1)), a = r - 1;
  if (e / Math.pow(10, a) === t[0])
    return [
      Ct($0(t[0], !0), Array.from({
        length: a
      }, Mr)),
      n
    ];
  const i = t.reduce((s, o, c) => {
    const f = r - c - 1, g = c === 0;
    let p = Ze("");
    const h = t.reduce((v, S, E) => {
      if (E < f)
        v.push(Ze(S));
      else if (p)
        if (E > f)
          v.push(Mr());
        else if (p = $0(S, g), p)
          v.push(p);
        else
          return [];
      return v;
    }, []);
    return h.length && s.push(h), s;
  }, []).map((s) => Ct(s));
  return i.push(n), i;
}
function br(e, t, r) {
  if (t < e)
    return null;
  const n = Ze(e), a = Ze(t), u = typeof r == "number" && r > 0 ? Array.from({
    length: r
  }, () => Ze(0)) : [], i = u.length ? (s) => Ct(u, s) : (s) => s;
  return e === t ? i(n) : e === 0 && t === 9 ? i(Mr()) : t - e === 1 ? i(As(n, a)) : i(As($p(n, a)));
}
function M9(e, t) {
  const r = [];
  let n = e, a = 1;
  do
    a *= 10, n < a && (r.push([
      n,
      Math.min(a - 1, t)
    ]), n = a);
  while (a <= t);
  return r;
}
function L9(e, t) {
  const r = e.length;
  if (r !== t.length || e[0] !== t[0])
    return null;
  let n = e[0].toString(), a = 0, u = 0, i = "", s = "";
  for (let o = 1; o < r; o++)
    a = e[o], u = t[o], a === u && i === "" && s === "" ? n += a : (i += a, s += u);
  return [
    n,
    parseInt(i, 10),
    parseInt(s, 10)
  ];
}
function Is(e, t, r = 0) {
  const n = Os(e), a = n.length;
  if (e < 10 && t < 10 || e === t) {
    const f = r - a;
    return [
      br(e, t, f)
    ];
  }
  const u = Os(t);
  if (a !== u.length) {
    const f = M9(e, t);
    return iu(f.map(([p, h]) => Is(p, h, r)));
  }
  const i = L9(n, u);
  if (Array.isArray(i)) {
    const [f, g, p] = i, h = a - f.length, v = Is(g, p, h);
    return [
      Ct(Array.from(f, Ze), su(v))
    ];
  }
  const s = Array.from({
    length: a - 1
  }), o = br(n[0] + 1, u[0] - 1), c = [
    ...s.map((f, g) => {
      const p = a - g - 1, h = +(g > 0);
      return Ct(n.map((v, S) => S < p ? Ze(v) : S > p ? br(0, 9) : br(v + h, 9)));
    }),
    // but output more readable
    ...o ? [
      Ct(o, Array.from({
        length: a - 1
      }, () => Mr()))
    ] : [],
    ...s.map((f, g) => {
      const p = a - g - 1, h = +(g > 0);
      return Ct(u.map((v, S) => S < p ? Ze(v) : S > p ? br(0, 9) : br(0, v - h)));
    })
  ];
  return x9(c);
}
function U0(e, t = 1 / 0) {
  if (e === 1 / 0)
    return Nr();
  const r = t === 1 / 0 ? j9(e) : Is(e, t);
  return su(r);
}
function F9(e, t, r, n) {
  const a = {
    ...n
  }, u = (o) => j0(o, e, a), i = (o) => j0(t, o, a), s = e && t ? (o) => u(o) && i(o) : e ? u : t ? i : () => !0;
  return r.filter(s);
}
function $9(e, t, r = g9) {
  const n = [];
  let a = "", u = !1;
  return r.forEach((i) => {
    const s = e.get(i.family);
    if (!s)
      return;
    let { version: o, minVersion: c, maxVersion: f } = i;
    o && (c = o, f = o);
    let g = F9(c, f, s, t);
    g.length && (a === i.family && u && (o = void 0, c = void 0, f = void 0, g = s, n.pop()), n.push({
      ...i,
      version: o,
      minVersion: c,
      maxVersion: f,
      requestVersions: s,
      matchedVersions: g
    })), u = !o && !c && !f, a = i.family;
  }), n;
}
function U9(e) {
  const t = e.map(({ regexAst: n }) => Up(n.body)), r = D9(C9(su(t)));
  return P9(r);
}
function H9(e) {
  const t = Vr(e);
  let r = 0;
  return pt.traverse(t, {
    Group(n) {
      Ma(n.node) && r++;
    }
  }), r;
}
function G9(e, t, r) {
  let n = Vr(e);
  const a = typeof r == "number" && r < t.length ? t.slice(0, r) : t.slice();
  return pt.traverse(n, go({
    every() {
      return !!a.length;
    },
    Group(u) {
      return Ma(u.node) && a.length ? (n === u.node ? n = a.shift() : u.replace(a.shift()), !1) : !0;
    }
  })), n;
}
function Hp(e, t) {
  const r = Vr(e), n = Math.min(H9(r), t || 1 / 0), a = [];
  let u = 0, i = !1;
  return pt.traverse(r, go({
    every: {
      pre({ node: s, parent: o }) {
        return s === r ? !0 : F0(s) ? (o === r && (i = !1), u < n) : !1;
      },
      post({ node: s, parent: o }) {
        s !== r && o === r && F0(s) && (i || u > 0 && u < n) && a.push(s);
      }
    },
    Group(s) {
      return Ma(s.node) && u < n ? (i = !0, u++, !1) : !0;
    }
  })), a.length === 1 && !Ma(a[0]) ? Hp(a[0], n) : a;
}
function W9(e, t) {
  const { ignoreMinor: r, ignorePatch: n, allowHigherVersions: a } = t, u = e[0] === 1 / 0 ? 0 : r ? 1 : n ? 2 : 3;
  if (a) {
    const s = [];
    let o = !0, c = 0, f = 0;
    const g = (p) => (h, v) => v >= u ? Nr() : (f = Array.isArray(h) ? h[0] : h, v < p ? M0(f) : v > p ? Nr() : U0(f + c));
    for (let p = u - 1; p >= 0; p--)
      o && !e[p] || (o = !1, s.push(e.map(g(p))), c = 1);
    return s;
  }
  return [
    e.map((s, o) => o >= u ? Nr() : Array.isArray(s) ? U0(s[0], s[1]) : M0(s))
  ];
}
function q9(e, t, r) {
  const { allowHigherVersions: n } = r, a = Vr(e), u = n && t.length ? [
    t[0]
  ] : t, i = u.reduce((c, f) => Math.max(c, v9(f, r)), 1), s = Hp(a, i), o = su(...u.map((c) => W9(c, r).map((f) => G9(Ct(Fp(s)), f, i))));
  return pt.traverse(a, go({
    every(c) {
      return s.length ? (c.node === s[0] && (s.length === 1 ? c.replace(o) : c.remove(), s.shift()), !0) : !1;
    }
  })), a;
}
function z9(e, t) {
  return e.map(({ regex: r, version: n, maxVersion: a, matchedVersions: u, ...i }) => {
    let s = Vr(r);
    return n || (s = q9(s, E9(u), {
      ...t,
      allowHigherVersions: !a && t.allowHigherVersions
    })), {
      regex: null,
      sourceRegex: r,
      regexAst: s,
      version: n,
      maxVersion: a,
      matchedVersions: u,
      ...i
    };
  });
}
const V9 = {
  ignoreMinor: !1,
  ignorePatch: !0,
  allowZeroSubversions: !1,
  allowHigherVersions: !1
};
function Y9(e = {}) {
  const t = {
    ...V9,
    ...e
  }, r = _9(t), n = w9(r), a = $9(n, t);
  return z9(a, t);
}
function X9(e = {}) {
  return U9(Y9(e));
}
class Yw {
  constructor(t) {
    $(this, "browserUARegExp", X9({
      browsers: [">1%", "last 2 versions", "not dead"],
      allowHigherVersions: !0
    }));
    $(this, "isSupported");
    this.options = t;
    const r = this.browserUARegExp.test(window.navigator.userAgent), n = "IntersectionObserver" in window;
    this.isSupported = r && n, o6({
      Vue: Ps,
      dsn: this.options.dsn,
      release: this.options.release,
      environment: this.options.environment,
      integrations: [
        f6({
          shouldCreateSpanForRequest(a) {
            return !a.includes("/quote/actualizeQuoteProduct");
          }
        }),
        I4({
          levels: ["error"]
        })
      ],
      attachStacktrace: !0,
      tracesSampleRate: this.options.tracesSampleRate ?? 1
    }), window.addEventListener("online", async () => {
      try {
        await yf(2e3);
      } catch (a) {
        console.error("Sentry flush failed on reconnect:", a);
      }
    }), Dv((a) => this.eventProcessor(a));
  }
  eventProcessor(t) {
    var s, o;
    let r = { ...t };
    const n = r.message || "";
    if (window.location.hostname === "localhost" || (((o = (s = r.exception) == null ? void 0 : s.values) == null ? void 0 : o.some(
      (c) => {
        var f, g;
        return (g = (f = c.stacktrace) == null ? void 0 : f.frames) == null ? void 0 : g.some(
          (p) => typeof p.filename == "string" && /^(chrome|moz|safari)-extension:\/\//.test(p.filename)
        );
      }
    )) ?? !1)) return null;
    this.isSupported || (r = { ...r, level: Ki.Warning });
    const i = r.request;
    if (i && typeof i.data == "object" && i.data !== null) {
      const c = { ...i.data };
      delete c.password, delete c.token, r = {
        ...r,
        request: { ...i, data: c }
      };
    }
    return n.includes("This could be due to syntax errors") && (r.exception = {
      values: [{ type: "SyntaxError", value: n }]
    }), r;
  }
  captureException(t, r) {
    kn((n) => {
      r && Object.entries(r).forEach(([a, u]) => {
        n.setExtra(a, u);
      }), t instanceof Error && n.setTag("error.type", t.name), In(t);
    });
  }
  captureMessage(t, r = Ki.Info) {
    is(t, r);
  }
  addBreadcrumb(t, r = {}) {
    Ht({ message: t, data: r });
  }
  async flush(t = 2e3) {
    await yf(t);
  }
}
var J9 = /* @__PURE__ */ ((e) => (e.A = "a", e.B = "b", e.C = "c", e))(J9 || {});
const qi = "Service must be initialized first";
class Xw {
  constructor() {
    $(this, "tests", []);
    $(this, "isReady", !1);
  }
  init(t) {
    this.tests = t, this.isReady = !0;
  }
  getAllTests() {
    if (!this.isReady) throw new Error(qi);
    return [...this.tests];
  }
  hasTest(t) {
    if (!this.isReady) throw new Error(qi);
    return this.tests.some((r) => r.slug === t);
  }
  getVariant(t) {
    var r;
    if (!this.isReady) throw new Error(qi);
    return (r = this.tests.find((n) => n.slug === t)) == null ? void 0 : r.variant;
  }
}
const zi = "Service must be initialized first", K9 = "Feature not found";
class Jw {
  constructor() {
    $(this, "config", {});
    $(this, "isReady", !1);
  }
  init(t) {
    this.config = t, this.isReady = !0;
  }
  getConfig() {
    if (!this.isReady) throw new Error(zi);
    return this.config;
  }
  hasFeature(t) {
    if (!this.isReady) throw new Error(zi);
    return t in this.config;
  }
  getFeatureValue(t) {
    if (!this.isReady) throw new Error(zi);
    if (!this.hasFeature(t)) throw new Error(K9);
    return this.config[t];
  }
}
export {
  Xw as AbService,
  J9 as AbVariant,
  jn as AbortError,
  qw as Analytics,
  dn as AnalyticsError,
  aw as ApiService,
  qe as Breakpoint,
  zw as CookieService,
  Jw as FeatureToggleService,
  Lw as KEY_ENTER,
  Fw as KEY_ESCAPE,
  $w as KEY_SPACE,
  Uw as KEY_TAB,
  Ao as NetworkError,
  R3 as SentryEnvironment,
  Yw as SentryService,
  Ki as SentrySeverity,
  Ue as ServiceName,
  dh as TimeoutError,
  nw as VueRenderError,
  zd as YandexMetrikaService,
  fw as addDaysToDate,
  lw as addMonthsToDate,
  Tw as addToDate,
  pw as addYearsToDate,
  Hw as debounce,
  cg as deferExecution,
  hw as formatDate,
  Nw as formatDateWithTimezone,
  xw as formatMoney,
  jw as formatPhone,
  dw as formatToISO,
  uw as getCalendarSpreadDates,
  Dw as getCurrentTimeZone,
  ww as getDateDifference,
  Ew as getDurationParts,
  sw as getEndOfDay,
  cw as getEndOfMonth,
  mw as getMonthIndex,
  iw as getStartOfDay,
  ow as getStartOfMonth,
  Ww as hasSlotContent,
  Aw as isDateAfter,
  Ow as isDateBefore,
  Iw as isDateEqual,
  Cw as isDateWithinRange,
  gw as isSameDay,
  yw as isSameMonth,
  vw as isSameYear,
  Pw as isValidDateString,
  gl as loadExternalScript,
  Sw as parseDate,
  Mw as pluralize,
  Rw as setBodyOverflow,
  Bw as setDateParts,
  bw as setMonthForDate,
  _w as setYearForDate,
  kw as subtractFromDate,
  Gw as throttle,
  tw as useTimer,
  rw as useViewport
};
